
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    // Styles
var $b0bd1bc71fece2bf$exports = {};
$b0bd1bc71fece2bf$exports = new URL("hercules.851e22fa.png", import.meta.url).toString();


// Theme switching utilities
// Shared between main app and storybook
const $5509607c007f20ee$var$darkModeQuery = matchMedia("(prefers-color-scheme: dark)");
function $5509607c007f20ee$export$fe979c3403443f94() {
    return $5509607c007f20ee$var$darkModeQuery.matches ? "dark" : "light";
}
function $5509607c007f20ee$export$da5ffdb7039764e9(theme) {
    // Beta: default to light theme until dark mode is fully tested
    // Revert this whole commit when the beta is over
    return theme || "light";
}
function $5509607c007f20ee$var$swapStylesheet(themeName) {
    const currentLink = document.getElementById("active-theme");
    const template = document.getElementById("theme-" + themeName);
    if (!currentLink || !template) return;
    const newLink = template.content.querySelector("link").cloneNode(true);
    newLink.id = "active-theme";
    newLink.onload = function() {
        currentLink.remove();
    };
    currentLink.id = "old-theme";
    currentLink.after(newLink);
}
var $5509607c007f20ee$var$currentTheme = $5509607c007f20ee$export$da5ffdb7039764e9(localStorage.getItem("theme"));
function $5509607c007f20ee$export$49e16ec648d05eb2(theme) {
    const resolved = $5509607c007f20ee$export$da5ffdb7039764e9(theme);
    if (resolved === $5509607c007f20ee$var$currentTheme) return;
    $5509607c007f20ee$var$currentTheme = resolved;
    $5509607c007f20ee$var$swapStylesheet(resolved);
}
function $5509607c007f20ee$export$90e4a8e35358a07e(theme) {
    if (theme === null) localStorage.removeItem("theme");
    else localStorage.setItem("theme", theme);
}
function $5509607c007f20ee$export$1a9c72ed86da409b(ports) {
    ports.setTheme.subscribe(function(theme) {
        $5509607c007f20ee$export$90e4a8e35358a07e(theme);
        $5509607c007f20ee$export$49e16ec648d05eb2(theme);
    });
    ports.configuredTheme.send(localStorage.getItem("theme"));
    ports.systemTheme.send($5509607c007f20ee$var$darkModeQuery.matches);
    $5509607c007f20ee$var$darkModeQuery.addEventListener("change", function(e) {
        ports.systemTheme.send(e.matches);
        if (!localStorage.getItem("theme")) $5509607c007f20ee$export$49e16ec648d05eb2(null);
    });
}


var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function e(n, e, t) {
        return t.a = n, t.f = e, t;
    }
    function F2(n) {
        return e(2, n, function(e) {
            return function(t) {
                return n(e, t);
            };
        });
    }
    function F3(n) {
        return e(3, n, function(e) {
            return function(t) {
                return function(r) {
                    return n(e, t, r);
                };
            };
        });
    }
    function F4(n) {
        return e(4, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return n(e, t, r, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return e(5, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return n(e, t, r, a, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return e(6, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return n(e, t, r, a, i, u);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return e(7, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return n(e, t, r, a, i, u, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return e(8, n, function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return n(e, t, r, a, i, u, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, e, t) {
        return 2 === n.a ? n.f(e, t) : n(e)(t);
    }
    function A3(n, e, t, r) {
        return 3 === n.a ? n.f(e, t, r) : n(e)(t)(r);
    }
    function A4(n, e, t, r, a) {
        return 4 === n.a ? n.f(e, t, r, a) : n(e)(t)(r)(a);
    }
    function A5(n, e, t, r, a, i) {
        return 5 === n.a ? n.f(e, t, r, a, i) : n(e)(t)(r)(a)(i);
    }
    function A6(n, e, t, r, a, i, u) {
        return 6 === n.a ? n.f(e, t, r, a, i, u) : n(e)(t)(r)(a)(i)(u);
    }
    function A7(n, e, t, r, a, i, u, c) {
        return 7 === n.a ? n.f(e, t, r, a, i, u, c) : n(e)(t)(r)(a)(i)(u)(c);
    }
    var t = F3(function(n, e, t) {
        for(var r = Array(n), a = 0; n > a; a++)r[a] = t(e + a);
        return r;
    }), r = F2(function(n, e) {
        for(var t = Array(n), r = 0; n > r && e.b; r++)t[r] = e.a, e = e.b;
        return t.length = r, d(t, e);
    }), a = F3(function(n, e, t) {
        for(var r = t.length - 1; r >= 0; r--)e = A2(n, t[r], e);
        return e;
    });
    function i(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function u(n, e) {
        for(var t, r = [], a = c(n, e, 0, r); a && (t = r.pop()); a = c(t.a, t.b, 0, r));
        return a;
    }
    function c(n, e, t, r) {
        if (t > 100) return r.push(d(n, e)), !0;
        if (n === e) return !0;
        if ("object" != typeof n || null === n || null === e) return "function" == typeof n && i(5), !1;
        for(var a in 0 > n.$ && (n = ut(n), e = ut(e)), n)if (!c(n[a], e[a], t + 1, r)) return !1;
        return !0;
    }
    var o = F2(u);
    function s(n, e, t) {
        if ("object" != typeof n) return n === e ? 0 : e > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, e.a)) || (t = s(n.b, e.b)) ? t : s(n.c, e.c);
        for(; n.b && e.b && !(t = s(n.a, e.a)); n = n.b, e = e.b);
        return t || (n.b ? 1 : e.b ? -1 : 0);
    }
    var f = F2(function(n, e) {
        var t = s(n, e);
        return 0 > t ? ft : t ? st : ot;
    }), l = 0;
    function d(n, e) {
        return {
            a: n,
            b: e
        };
    }
    function b(n, e, t) {
        return {
            a: n,
            b: e,
            c: t
        };
    }
    function h(n, e) {
        var t = {};
        for(var r in n)t[r] = n[r];
        for(var r in e)t[r] = e[r];
        return t;
    }
    function g(n, e) {
        if ("string" == typeof n) return n + e;
        if (!n.b) return e;
        var t = p(n.a, e);
        n = n.b;
        for(var r = t; n.b; n = n.b)r = r.b = p(n.a, e);
        return t;
    }
    var v = {
        $: 0
    };
    function p(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }
    var m = F2(p);
    function y(n) {
        for(var e = v, t = n.length; t--;)e = p(n[t], e);
        return e;
    }
    function $(n) {
        for(var e = []; n.b; n = n.b)e.push(n.a);
        return e;
    }
    var w = F3(function(n, e, t) {
        for(var r = []; e.b && t.b; e = e.b, t = t.b)r.push(A2(n, e.a, t.a));
        return y(r);
    }), k = F2(function(n, e) {
        return y($(e).sort(function(e, t) {
            return s(n(e), n(t));
        }));
    }), C = F2(function(n, e) {
        return y($(e).sort(function(e, t) {
            var r = A2(n, e, t);
            return r === ot ? 0 : r === ft ? -1 : 1;
        }));
    }), x = F2(function(n, e) {
        return n + e;
    }), j = F2(function(n, e) {
        var t = e % n;
        return 0 === n ? i(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), q = Math.ceil, S = Math.floor, I = Math.round, T = Math.log, A = F2(function(n, e) {
        return n && e;
    }), E = F2(function(n, e) {
        return n + e;
    }), N = F2(function(n, e) {
        return n + e;
    }), L = F3(function(n, e, t) {
        for(var r = t.length; r--;){
            var a = t[r], i = t.charCodeAt(r);
            56320 > i || i > 57343 || (a = t[--r] + a), e = A2(n, a, e);
        }
        return e;
    }), P = F2(function(n, e) {
        return e.split(n);
    }), D = F2(function(n, e) {
        return e.join(n);
    }), O = F3(function(n, e, t) {
        return t.slice(n, e);
    }), G = F2(function(n, e) {
        for(var t = e.length; t--;){
            var r = e[t], a = e.charCodeAt(t);
            if (56320 > a || a > 57343 || (r = e[--t] + r), !n(r)) return !1;
        }
        return !0;
    }), _ = F2(function(n, e) {
        return e.indexOf(n) > -1;
    }), F = F2(function(n, e) {
        return 0 === e.indexOf(n);
    }), R = F2(function(n, e) {
        return e.length >= n.length && e.lastIndexOf(n) === e.length - n.length;
    }), B = F2(function(n, e) {
        var t = n.length;
        if (1 > t) return v;
        for(var r = 0, a = []; (r = e.indexOf(n, r)) > -1;)a.push(r), r += t;
        return y(a);
    });
    function H(n) {
        return {
            $: 2,
            b: n
        };
    }
    var V = H(function(n) {
        return "number" != typeof n ? an("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? gt(n) : !isFinite(n) || n % 1 ? an("an INT", n) : gt(n);
    }), z = H(function(n) {
        return "boolean" == typeof n ? gt(n) : an("a BOOL", n);
    }), U = (H(function(n) {
        return "number" == typeof n ? gt(n) : an("a FLOAT", n);
    }), H(function(n) {
        return gt(n);
    })), W = H(function(n) {
        return "string" == typeof n ? gt(n) : n instanceof String ? gt(n + "") : an("a STRING", n);
    }), K = F2(function(n, e) {
        return {
            $: 6,
            d: n,
            b: e
        };
    });
    function Z(n, e) {
        return {
            $: 9,
            f: n,
            g: e
        };
    }
    var Y = F2(function(n, e) {
        return {
            $: 10,
            b: e,
            h: n
        };
    }), M = F2(function(n, e) {
        return Z(n, [
            e
        ]);
    }), J = F3(function(n, e, t) {
        return Z(n, [
            e,
            t
        ]);
    }), Q = F2(function(n, e) {
        try {
            return nn(n, JSON.parse(e));
        } catch (n) {
            return lt(A2(dt, "This is not valid JSON! " + n.message, e));
        }
    }), X = F2(function(n, e) {
        return nn(n, e);
    });
    function nn(n, e) {
        switch(n.$){
            case 2:
                return n.b(e);
            case 5:
                return null === e ? gt(n.c) : an("null", e);
            case 3:
                return tn(e) ? en(n.b, e, y) : an("a LIST", e);
            case 4:
                return tn(e) ? en(n.b, e, rn) : an("an ARRAY", e);
            case 6:
                var t = n.d;
                if ("object" != typeof e || null === e || !(t in e)) return an("an OBJECT with a field named `" + t + "`", e);
                var r = nn(n.b, e[t]);
                return sr(r) ? r : lt(A2(bt, t, r.a));
            case 7:
                var a = n.e;
                return tn(e) ? e.length > a ? (r = nn(n.b, e[a]), sr(r) ? r : lt(A2(ht, a, r.a))) : an("a LONGER array. Need index " + a + " but only see " + e.length + " entries", e) : an("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || tn(e)) return an("an OBJECT", e);
                var i = v;
                for(var u in e)if (e.hasOwnProperty(u)) {
                    if (r = nn(n.b, e[u]), !sr(r)) return lt(A2(bt, u, r.a));
                    i = p(d(u, r.a), i);
                }
                return gt(_t(i));
            case 9:
                for(var c = n.f, o = n.g, s = 0; o.length > s; s++){
                    if (r = nn(o[s], e), !sr(r)) return r;
                    c = c(r.a);
                }
                return gt(c);
            case 10:
                return r = nn(n.b, e), sr(r) ? nn(n.h(r.a), e) : r;
            case 11:
                for(var f = v, l = n.g; l.b; l = l.b){
                    if (r = nn(l.a, e), sr(r)) return r;
                    f = p(r.a, f);
                }
                return lt(vt(_t(f)));
            case 1:
                return lt(A2(dt, n.a, e));
            case 0:
                return gt(n.a);
        }
    }
    function en(n, e, t) {
        for(var r = e.length, a = Array(r), i = 0; r > i; i++){
            var u = nn(n, e[i]);
            if (!sr(u)) return lt(A2(ht, i, u.a));
            a[i] = u.a;
        }
        return gt(t(a));
    }
    function tn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function rn(n) {
        return A2(or, n.length, function(e) {
            return n[e];
        });
    }
    function an(n, e) {
        return lt(A2(dt, "Expecting " + n, e));
    }
    function un(n, e) {
        if (n === e) return !0;
        if (n.$ !== e.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === e.a;
            case 2:
                return n.b === e.b;
            case 5:
                return n.c === e.c;
            case 3:
            case 4:
            case 8:
                return un(n.b, e.b);
            case 6:
                return n.d === e.d && un(n.b, e.b);
            case 7:
                return n.e === e.e && un(n.b, e.b);
            case 9:
                return n.f === e.f && cn(n.g, e.g);
            case 10:
                return n.h === e.h && un(n.b, e.b);
            case 11:
                return cn(n.g, e.g);
        }
    }
    function cn(n, e) {
        var t = n.length;
        if (t !== e.length) return !1;
        for(var r = 0; t > r; r++)if (!un(n[r], e[r])) return !1;
        return !0;
    }
    var on = F2(function(n, e) {
        return JSON.stringify(e, null, n) + "";
    });
    function sn(n) {
        return n;
    }
    var fn = F3(function(n, e, t) {
        return t[n] = e, t;
    });
    function ln(n) {
        return {
            $: 0,
            a: n
        };
    }
    function dn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var bn = F2(function(n, e) {
        return {
            $: 3,
            b: n,
            d: e
        };
    }), hn = F2(function(n, e) {
        return {
            $: 4,
            b: n,
            d: e
        };
    }), gn = 0;
    function vn(n) {
        var e = {
            $: 0,
            e: gn++,
            f: n,
            g: null,
            h: []
        };
        return kn(e), e;
    }
    function pn(n) {
        return dn(function(e) {
            e(ln(vn(n)));
        });
    }
    function mn(n, e) {
        n.h.push(e), kn(n);
    }
    var yn = F2(function(n, e) {
        return dn(function(t) {
            mn(n, e), t(ln(l));
        });
    }), $n = !1, wn = [];
    function kn(n) {
        if (wn.push(n), !$n) {
            for($n = !0; n = wn.shift();)Cn(n);
            $n = !1;
        }
    }
    function Cn(n) {
        for(; n.f;){
            var e = n.f.$;
            if (0 === e || 1 === e) {
                for(; n.g && n.g.$ !== e;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === e) return void (n.f.c = n.f.b(function(e) {
                    n.f = e, kn(n);
                }));
                if (5 === e) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === e ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var xn = {};
    function jn(n, e, t, r, a) {
        return {
            b: n,
            c: e,
            d: t,
            e: r,
            f: a
        };
    }
    function qn(n, e) {
        var t = {
            g: e,
            h: void 0
        }, r = n.c, a = n.d, i = n.e, u = n.f;
        function c(n) {
            return A2(bn, c, {
                $: 5,
                b: function(e) {
                    var c = e.a;
                    return 0 === e.$ ? A3(a, t, c, n) : i && u ? A4(r, t, c.i, c.j, n) : A3(r, t, i ? c.i : c.j, n);
                }
            });
        }
        return t.h = vn(A2(bn, c, n.b));
    }
    var Sn = F2(function(n, e) {
        return dn(function(t) {
            n.g(e), t(ln(l));
        });
    }), In = F2(function(n, e) {
        return A2(yn, n.h, {
            $: 0,
            a: e
        });
    });
    function Tn(n) {
        return function(e) {
            return {
                $: 1,
                k: n,
                l: e
            };
        };
    }
    function An(n) {
        return {
            $: 2,
            m: n
        };
    }
    var En = F2(function(n, e) {
        return {
            $: 3,
            n: n,
            o: e
        };
    });
    function Nn(n, e, t) {
        var r = {};
        for(var a in Ln(!0, e, r, null), Ln(!1, t, r, null), n)mn(n[a], {
            $: "fx",
            a: r[a] || {
                i: v,
                j: v
            }
        });
    }
    function Ln(n, e, t, r) {
        switch(e.$){
            case 1:
                var a = e.k, i = function(n, e, t, r) {
                    function a(n) {
                        for(var e = t; e; e = e.q)n = e.p(n);
                        return n;
                    }
                    return A2(n ? xn[e].e : xn[e].f, a, r);
                }(n, a, r, e.l);
                return void (t[a] = function(n, e, t) {
                    return t = t || {
                        i: v,
                        j: v
                    }, n ? t.i = p(e, t.i) : t.j = p(e, t.j), t;
                }(n, i, t[a]));
            case 2:
                for(var u = e.m; u.b; u = u.b)Ln(n, u.a, t, r);
                return;
            case 3:
                return void Ln(n, e.o, t, {
                    p: e.n,
                    q: r
                });
        }
    }
    function Pn(n) {
        xn[n] && i(3);
    }
    function Dn(n, e) {
        return Pn(n), xn[n] = {
            e: On,
            r: e,
            a: Gn
        }, Tn(n);
    }
    var On = F2(function(n, e) {
        return e;
    });
    function Gn(n) {
        var e = [], t = xn[n].r, r = dn(function(n) {
            var e = setTimeout(function() {
                n(ln(l));
            }, 0);
            return function() {
                clearTimeout(e);
            };
        });
        return xn[n].b = r, xn[n].c = F3(function(n, a) {
            for(; a.b; a = a.b)for(var i = e, u = t(a.a), c = 0; i.length > c; c++)i[c](u);
            return r;
        }), {
            subscribe: function(n) {
                e.push(n);
            },
            unsubscribe: function(n) {
                var t = (e = e.slice()).indexOf(n);
                0 > t || e.splice(t, 1);
            }
        };
    }
    function _n(n, e) {
        return Pn(n), xn[n] = {
            f: Rn,
            r: e,
            a: Bn
        }, Tn(n);
    }
    var Fn, Rn = F2(function(n, e) {
        return function(t) {
            return n(e(t));
        };
    });
    function Bn(n, e) {
        var t = v, r = xn[n].r, a = ln(null);
        return xn[n].b = a, xn[n].c = F3(function(n, e) {
            return t = e, a;
        }), {
            send: function(n) {
                var a = A2(X, r, n);
                sr(a) || i(4);
                for(var u = a.a, c = t; c.b; c = c.b)e(c.a(u));
            }
        };
    }
    function Hn(n, e) {
        for(var t in e)t in n ? "init" == t ? i(6) : Hn(n[t], e[t]) : n[t] = e[t];
    }
    var Vn = "undefined" != typeof document ? document : {};
    function zn(n, e) {
        n.appendChild(e);
    }
    function Un(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Wn = F2(function(n, e) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 1,
                c: e,
                d: ee(t),
                e: a,
                f: n,
                b: i
            };
        });
    }), Kn = Wn(void 0);
    F2(function(n, e) {
        return F2(function(t, r) {
            for(var a = [], i = 0; r.b; r = r.b){
                var u = r.a;
                i += u.b.b || 0, a.push(u);
            }
            return i += a.length, {
                $: 2,
                c: e,
                d: ee(t),
                e: a,
                f: n,
                b: i
            };
        });
    })(void 0);
    var Zn, Yn = F2(function(n, e) {
        return {
            $: 4,
            j: n,
            k: e,
            b: 1 + (e.b || 0)
        };
    }), Mn = F2(function(n, e) {
        return {
            $: "a0",
            n: n,
            o: e
        };
    }), Jn = F2(function(n, e) {
        return {
            $: "a1",
            n: n,
            o: e
        };
    }), Qn = F2(function(n, e) {
        return {
            $: "a2",
            n: n,
            o: e
        };
    }), Xn = F2(function(n, e) {
        return {
            $: "a3",
            n: n,
            o: e
        };
    });
    function ne(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    function ee(n) {
        for(var e = {}; n.b; n = n.b){
            var t = n.a, r = t.$, a = t.n, i = t.o;
            if ("a2" !== r) {
                var u = e[r] || (e[r] = {});
                "a3" === r && "class" === a ? te(u, a, i) : u[a] = i;
            } else "className" === a ? te(e, a, i) : e[a] = i;
        }
        return e;
    }
    function te(n, e, t) {
        var r = n[e];
        n[e] = r ? r + " " + t : t;
    }
    function re(n, e) {
        var t = n.$;
        if (5 === t) return re(n.k || (n.k = n.m()), e);
        if (0 === t) return Vn.createTextNode(n.a);
        if (4 === t) {
            for(var r = n.k, a = n.j; 4 === r.$;)"object" != typeof a ? a = [
                a,
                r.j
            ] : a.push(r.j), r = r.k;
            var i = {
                j: a,
                p: e
            };
            return (u = re(r, i)).elm_event_node_ref = i, u;
        }
        if (3 === t) return ae(u = n.h(n.g), e, n.d), u;
        var u = n.f ? Vn.createElementNS(n.f, n.c) : Vn.createElement(n.c);
        Fn && "a" == n.c && u.addEventListener("click", Fn(u)), ae(u, e, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)zn(u, re(1 === t ? c[o] : c[o].b, e));
        return u;
    }
    function ae(n, e, t) {
        for(var r in t){
            var a = t[r];
            "a1" === r ? ie(n, a) : "a0" === r ? oe(n, e, a) : "a3" === r ? ue(n, a) : "a4" === r ? ce(n, a) : ("value" !== r && "checked" !== r || n[r] !== a) && (n[r] = a);
        }
    }
    function ie(n, e) {
        var t = n.style;
        for(var r in e)t[r] = e[r];
    }
    function ue(n, e) {
        for(var t in e){
            var r = e[t];
            void 0 !== r ? n.setAttribute(t, r) : n.removeAttribute(t);
        }
    }
    function ce(n, e) {
        for(var t in e){
            var r = e[t], a = r.f, i = r.o;
            void 0 !== i ? n.setAttributeNS(a, t, i) : n.removeAttributeNS(a, t);
        }
    }
    function oe(n, e, t) {
        var r = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var i = t[a], u = r[a];
            if (i) {
                if (u) {
                    if (u.q.$ === i.$) {
                        u.q = i;
                        continue;
                    }
                    n.removeEventListener(a, u);
                }
                u = se(e, i), n.addEventListener(a, u, Zn && {
                    passive: 2 > hr(i)
                }), r[a] = u;
            } else n.removeEventListener(a, u), r[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Zn = !0;
            }
        }));
    } catch (n) {}
    function se(n, e) {
        function t(e) {
            var r = t.q, a = nn(r.a, e);
            if (sr(a)) {
                for(var i, u = hr(r), c = a.a, o = u ? 3 > u ? c.a : c.bl : c, s = 1 == u ? c.b : 3 == u && c.ea, f = (s && e.stopPropagation(), (2 == u ? c.b : 3 == u && c.d6) && e.preventDefault(), n); i = f.j;){
                    if ("function" == typeof i) o = i(o);
                    else for(var l = i.length; l--;)o = i[l](o);
                    f = f.p;
                }
                f(o, s);
            }
        }
        return t.q = e, t;
    }
    function fe(n, e) {
        return n.$ == e.$ && un(n.a, e.a);
    }
    function le(n, e, t, r) {
        var a = {
            $: e,
            r: t,
            s: r,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function de(n, e, t, r) {
        if (n !== e) {
            var a = n.$, i = e.$;
            if (a !== i) {
                if (1 !== a || 2 !== i) return void le(t, 0, r, e);
                e = function(n) {
                    for(var e = n.e, t = e.length, r = Array(t), a = 0; t > a; a++)r[a] = e[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: r,
                        f: n.f,
                        b: n.b
                    };
                }(e), i = 1;
            }
            switch(i){
                case 5:
                    for(var u = n.l, c = e.l, o = u.length, s = o === c.length; s && o--;)s = u[o] === c[o];
                    if (s) return void (e.k = n.k);
                    e.k = e.m();
                    var f = [];
                    return de(n.k, e.k, f, 0), void (f.length > 0 && le(t, 1, r, f));
                case 4:
                    for(var l = n.j, d = e.j, b = !1, h = n.k; 4 === h.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        h.j
                    ] : l.push(h.j), h = h.k;
                    for(var g = e.k; 4 === g.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        g.j
                    ] : d.push(g.j), g = g.k;
                    return b && l.length !== d.length ? void le(t, 0, r, e) : ((b ? function(n, e) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== e[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || le(t, 2, r, d), void de(h, g, t, r + 1));
                case 0:
                    return void (n.a !== e.a && le(t, 3, r, e.a));
                case 1:
                    return void be(n, e, t, r, ge);
                case 2:
                    return void be(n, e, t, r, ve);
                case 3:
                    if (n.h !== e.h) return void le(t, 0, r, e);
                    var v = he(n.d, e.d);
                    v && le(t, 4, r, v);
                    var p = e.i(n.g, e.g);
                    return void (p && le(t, 5, r, p));
            }
        }
    }
    function be(n, e, t, r, a) {
        if (n.c === e.c && n.f === e.f) {
            var i = he(n.d, e.d);
            i && le(t, 4, r, i), a(n, e, t, r);
        } else le(t, 0, r, e);
    }
    function he(n, e, t) {
        var r;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in e) {
                var i = n[a], u = e[a];
                i === u && "value" !== a && "checked" !== a || "a0" === t && fe(i, u) || ((r = r || {})[a] = u);
            } else (r = r || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var c = he(n[a], e[a] || {}, a);
            c && ((r = r || {})[a] = c);
        }
        for(var o in e)o in n || ((r = r || {})[o] = e[o]);
        return r;
    }
    function ge(n, e, t, r) {
        var a = n.e, i = e.e, u = a.length, c = i.length;
        u > c ? le(t, 6, r, {
            v: c,
            i: u - c
        }) : c > u && le(t, 7, r, {
            v: u,
            e: i
        });
        for(var o = c > u ? u : c, s = 0; o > s; s++){
            var f = a[s];
            de(f, i[s], t, ++r), r += f.b || 0;
        }
    }
    function ve(n, e, t, r) {
        for(var a = [], i = {}, u = [], c = n.e, o = e.e, s = c.length, f = o.length, l = 0, d = 0, b = r; s > l && f > d;){
            var h = (q = c[l]).a, g = (S = o[d]).a, v = q.b, p = S.b, m = void 0, y = void 0;
            if (h !== g) {
                var $ = c[l + 1], w = o[d + 1];
                if ($) {
                    var k = $.a, C = $.b;
                    y = g === k;
                }
                if (w) {
                    var x = w.a, j = w.b;
                    m = h === x;
                }
                if (m && y) de(v, j, a, ++b), me(i, a, h, p, d, u), b += v.b || 0, ye(i, a, h, C, ++b), b += C.b || 0, l += 2, d += 2;
                else if (m) b++, me(i, a, g, p, d, u), de(v, j, a, b), b += v.b || 0, l += 1, d += 2;
                else if (y) ye(i, a, h, v, ++b), b += v.b || 0, de(C, p, a, ++b), b += C.b || 0, l += 2, d += 1;
                else {
                    if (!$ || k !== x) break;
                    ye(i, a, h, v, ++b), me(i, a, g, p, d, u), b += v.b || 0, de(C, j, a, ++b), b += C.b || 0, l += 2, d += 2;
                }
            } else de(v, p, a, ++b), b += v.b || 0, l++, d++;
        }
        for(; s > l;){
            var q;
            b++, ye(i, a, (q = c[l]).a, v = q.b, b), b += v.b || 0, l++;
        }
        for(; f > d;){
            var S, I = I || [];
            me(i, a, (S = o[d]).a, S.b, void 0, I), d++;
        }
        (a.length > 0 || u.length > 0 || I) && le(t, 8, r, {
            w: a,
            x: u,
            y: I
        });
    }
    var pe = "_elmW6BL";
    function me(n, e, t, r, a, i) {
        var u = n[t];
        if (!u) return i.push({
            r: a,
            A: u = {
                c: 0,
                z: r,
                r: a,
                s: void 0
            }
        }), void (n[t] = u);
        if (1 === u.c) {
            i.push({
                r: a,
                A: u
            }), u.c = 2;
            var c = [];
            return de(u.z, r, c, u.r), u.r = a, void (u.s.s = {
                w: c,
                A: u
            });
        }
        me(n, e, t + pe, r, a, i);
    }
    function ye(n, e, t, r, a) {
        var i = n[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var u = [];
                return de(r, i.z, u, a), void le(e, 9, a, {
                    w: u,
                    A: i
                });
            }
            ye(n, e, t + pe, r, a);
        } else {
            var c = le(e, 9, a, void 0);
            n[t] = {
                c: 1,
                z: r,
                r: a,
                s: c
            };
        }
    }
    function $e(n, e, t, r) {
        we(n, e, t, 0, 0, e.b, r);
    }
    function we(n, e, t, r, a, i, u) {
        for(var c = t[r], o = c.r; o === a;){
            var s = c.$;
            if (1 === s) $e(n, e.k, c.s, u);
            else if (8 === s) c.t = n, c.u = u, (f = c.s.w).length > 0 && we(n, e, f, 0, a, i, u);
            else if (9 === s) {
                c.t = n, c.u = u;
                var f, l = c.s;
                l && (l.A.s = n, (f = l.w).length > 0 && we(n, e, f, 0, a, i, u));
            } else c.t = n, c.u = u;
            if (!(c = t[++r]) || (o = c.r) > i) return r;
        }
        var d = e.$;
        if (4 === d) {
            for(var b = e.k; 4 === b.$;)b = b.k;
            return we(n, b, t, r, a + 1, i, n.elm_event_node_ref);
        }
        for(var h = e.e, g = n.childNodes, v = 0; h.length > v; v++){
            a++;
            var p = 1 === d ? h[v] : h[v].b, m = a + (p.b || 0);
            if (!(a > o || o > m || (c = t[r = we(g[v], p, t, r, a, m, u)]) && (o = c.r) <= i)) return r;
            a = m;
        }
        return r;
    }
    function ke(n, e) {
        for(var t = 0; e.length > t; t++){
            var r = e[t], a = r.t, i = Ce(a, r);
            a === n && (n = i);
        }
        return n;
    }
    function Ce(n, e) {
        switch(e.$){
            case 0:
                return function(n, e, t) {
                    var r = n.parentNode, a = re(e, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), r && a !== n && r.replaceChild(a, n), a;
                }(n, e.s, e.u);
            case 4:
                return ae(n, e.u, e.s), n;
            case 3:
                return n.replaceData(0, n.length, e.s), n;
            case 1:
                return ke(n, e.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = e.s : n.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, n;
            case 6:
                for(var t = e.s, r = 0; t.i > r; r++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = e.s).e, u = n.childNodes[r = t.v]; a.length > r; r++)n.insertBefore(re(a[r], e.u), u);
                return n;
            case 9:
                if (!(t = e.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = ke(n, t.w), n;
            case 8:
                return function(n, e) {
                    var t = e.s, r = function(n, e) {
                        if (n) {
                            for(var t = Vn.createDocumentFragment(), r = 0; n.length > r; r++){
                                var a = n[r].A;
                                zn(t, 2 === a.c ? a.s : re(a.z, e.u));
                            }
                            return t;
                        }
                    }(t.y, e);
                    n = ke(n, t.w);
                    for(var a = t.x, i = 0; a.length > i; i++){
                        var u = a[i], c = u.A, o = 2 === c.c ? c.s : re(c.z, e.u);
                        n.insertBefore(o, n.childNodes[u.r]);
                    }
                    return r && zn(n, r), n;
                }(n, e);
            case 5:
                return e.s(n);
            default:
                i(10);
        }
    }
    function xe(n) {
        if (3 === n.nodeType) return Un(n.textContent);
        if (1 !== n.nodeType) return Un("");
        for(var e = v, t = n.attributes, r = t.length; r--;){
            var a = t[r];
            e = p(A2(Xn, a.name, a.value), e);
        }
        var i = n.tagName.toLowerCase(), u = v, c = n.childNodes;
        for(r = c.length; r--;)u = p(xe(c[r]), u);
        return A3(Kn, i, e, u);
    }
    var je = F4(function(n, e, t, r) {
        return function(n, e, t, r, a, u) {
            var c = A2(X, n, e ? e.flags : void 0);
            sr(c) || i(2);
            var o = {}, s = (c = t(c.a)).a, f = u(d, s), l = function(n, e) {
                var t;
                for(var r in xn){
                    var a = xn[r];
                    a.a && ((t = t || {})[r] = a.a(r, e)), n[r] = qn(a, e);
                }
                return t;
            }(o, d);
            function d(n, e) {
                f(s = (c = A2(r, n, s)).a, e), Nn(o, c.b, a(s));
            }
            return Nn(o, c.b, a(s)), l ? {
                ports: l
            } : {};
        }(e, r, n.iG, n.jV, n.jP, function(e, t) {
            var r = n.d9 && n.d9(e), a = n.jY, i = Vn.title, u = Vn.body, c = xe(u);
            return function(n, e) {
                e(n);
                var t = 0;
                function r() {
                    t = 1 === t ? 0 : (qe(r), e(n), 1);
                }
                return function(a, i) {
                    n = a, i ? (e(n), 2 === t && (t = 1)) : (0 === t && qe(r), t = 2);
                };
            }(t, function(n) {
                Fn = r;
                var t = a(n), o = Kn("body")(v)(t.aD), s = function(n, e) {
                    var t = [];
                    return de(n, e, t, 0), t;
                }(c, o);
                u = function(n, e, t, r) {
                    return 0 === t.length ? n : ($e(n, e, t, r), ke(n, t));
                }(u, c, s, e), c = o, Fn = 0, i !== t.e && (Vn.title = i = t.e);
            });
        });
    }), qe = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Se() {
        return Er(Vn.location.href).a || i(1);
    }
    var Ie = F2(function(n, e) {
        return A2(Kr, Nr, dn(function() {
            history.pushState({}, "", e), n();
        }));
    }), Te = F2(function(n, e) {
        return A2(Kr, Nr, dn(function() {
            history.replaceState({}, "", e), n();
        }));
    }), Ae = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    });
    function Ee(n, e) {
        return dn(function(t) {
            qe(function() {
                var r = document.getElementById(n);
                t(r ? ln(e(r)) : {
                    $: 1,
                    a: vr(n)
                });
            });
        });
    }
    var Ne = F3(function(n, e, t) {
        return Ee(n, function(n) {
            return n.scrollLeft = e, n.scrollTop = t, l;
        });
    }), Le = F2(function(n, e) {
        var t = "g";
        n.iZ && (t += "m"), n.h5 && (t += "i");
        try {
            return mt(RegExp(e, t));
        } catch (n) {
            return yt;
        }
    }), Pe = F2(function(n, e) {
        return null !== e.match(n);
    }), De = F5(function(n, e, t, r, a) {
        for(var i = n.length, u = a.length >= e + i, c = 0; u && i > c;){
            var o = a.charCodeAt(e);
            u = n[c++] === a[e++] && (10 === o ? (t++, r = 1) : (r++, 55296 == (63488 & o) ? n[c++] === a[e++] : 1));
        }
        return b(u ? e : -1, t, r);
    }), Oe = F3(function(n, e, t) {
        return t.length > e ? 55296 == (63488 & t.charCodeAt(e)) ? n(t.substr(e, 2)) ? e + 2 : -1 : n(t[e]) ? "\n" === t[e] ? -2 : e + 1 : -1 : -1;
    }), Ge = F3(function(n, e, t) {
        return t.charCodeAt(e) === n;
    }), _e = F2(function(n, e) {
        for(; e.length > n; n++){
            var t = e.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), Fe = F3(function(n, e, t) {
        for(var r = 0; t.length > e; e++){
            var a = t.charCodeAt(e) - 48;
            if (0 > a || a >= n) break;
            r = n * r + a;
        }
        return d(e, r);
    }), Re = F2(function(n, e) {
        for(var t = 0; e.length > n; n++){
            var r = e.charCodeAt(n);
            if (48 > r || r > 57) {
                if (65 > r || r > 70) {
                    if (97 > r || r > 102) break;
                    t = 16 * t + r - 87;
                } else t = 16 * t + r - 55;
            } else t = 16 * t + r - 48;
        }
        return d(n, t);
    }), Be = F3(function(n, e, t) {
        return dn(function(r) {
            function a(n) {
                r(e(t.ir.a(n)));
            }
            var i = new XMLHttpRequest;
            i.addEventListener("error", function() {
                a(Qi);
            }), i.addEventListener("timeout", function() {
                a(eu);
            }), i.addEventListener("load", function() {
                a(function(n, e) {
                    return A2(e.status >= 200 && 300 > e.status ? Ji : Yi, function(n) {
                        return {
                            hB: n.responseURL,
                            jL: n.status,
                            jM: n.statusText,
                            M: He(n.getAllResponseHeaders())
                        };
                    }(e), n(e.response));
                }(t.ir.b, i));
            }), tu(t.bA) && function(n, e, t) {
                e.upload.addEventListener("progress", function(r) {
                    e.c || vn(A2(ru, n, d(t, nu({
                        jF: r.loaded,
                        dE: r.total
                    }))));
                }), e.addEventListener("progress", function(r) {
                    e.c || vn(A2(ru, n, d(t, Xi({
                        jr: r.loaded,
                        dE: r.lengthComputable ? mt(r.total) : yt
                    }))));
                });
            }(n, i, t.bA.a);
            try {
                i.open(t.aO, t.hB, !0);
            } catch (n) {
                return a(Mi(t.hB));
            }
            return function(n, e) {
                for(var t = e.M; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = e.ay.a || 0, n.responseType = e.ir.d, n.withCredentials = e.hY;
            }(i, t), t.aD.a && i.setRequestHeader("Content-Type", t.aD.a), i.send(t.aD.b), function() {
                i.c = !0, i.abort();
            };
        });
    });
    function He(n) {
        if (!n) return va;
        for(var e = va, t = n.split("\r\n"), r = t.length; r--;){
            var a = t[r], i = a.indexOf(": ");
            if (i > 0) {
                var u = a.substring(0, i), c = a.substring(i + 2);
                e = A3(du, u, function(n) {
                    return mt(tu(n) ? c + ", " + n.a : c);
                }, e);
            }
        }
        return e;
    }
    var Ve = F3(function(n, e, t) {
        return {
            $: 0,
            d: n,
            b: e,
            a: t
        };
    }), ze = F2(function(n, e) {
        return {
            $: 0,
            d: e.d,
            b: e.b,
            a: function(t) {
                return n(e.a(t));
            }
        };
    });
    function Ue(n) {
        return new DataView(n);
    }
    var We = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Ke = F2(function(n, e) {
        return dn(function() {
            var t = setInterval(function() {
                vn(e);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), Ze = H(function(n) {
        return "undefined" != typeof File && n instanceof File ? gt(n) : an("a FILE", n);
    }), Ye = F3(function(n, e, t) {
        return function(n, e, t, r) {
            return {
                $: 3,
                d: ee(n),
                g: e,
                h: t,
                i: r
            };
        }(e, {
            a: n,
            b: t
        }, Me, Je);
    });
    function Me(n) {
        return A2(nt, n, Vn.createElement("div"));
    }
    function Je(n, e) {
        return (n.b !== e.b || n.a !== e.a) && nt(e);
    }
    var Qe, Xe, nt = F2(function(n, e) {
        var t, r;
        return e.innerHTML = et(n.b, {
            highlight: function(n, e) {
                return !e && tu(t.eY) && (e = t.eY.a), "undefined" != typeof hljs && e && hljs.listLanguages().indexOf(e) >= 0 ? hljs.highlight(e, n, !0).value : n;
            },
            gfm: r = (t = n.a).ix.a,
            tables: r && r.jQ,
            breaks: r && r.h2,
            sanitize: t.jC,
            smartypants: t.jI
        }), e;
    }), et = (Xe = (Qe = {}).exports = {}, (function() {
        var n = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            fences: o,
            hr: /^( *[-*_]){3,} *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
            nptable: o,
            lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
            blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
            list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
            table: o,
            paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
            text: /^[^\n]+/
        };
        function e(e) {
            this.tokens = [], this.tokens.links = {}, this.options = e || f.defaults, this.rules = n.normal, this.options.gfm && (this.rules = this.options.tables ? n.tables : n.gfm);
        }
        n.bullet = /(?:[*+-]|\d+\.)/, n.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/, n.item = c(n.item, "gm")(/bull/g, n.bullet)(), n.list = c(n.list)(/bull/g, n.bullet)("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def", "\\n+(?=" + n.def.source + ")")(), n.blockquote = c(n.blockquote)("def", n.def)(), n._tag = "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b", n.html = c(n.html)("comment", /<!--[\s\S]*?-->/)("closed", /<(tag)[\s\S]+?<\/\1>/)("closing", /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g, n._tag)(), n.paragraph = c(n.paragraph)("hr", n.hr)("heading", n.heading)("lheading", n.lheading)("blockquote", n.blockquote)("tag", "<" + n._tag)("def", n.def)(), n.normal = s({}, n), n.gfm = s({}, n.normal, {
            fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
            paragraph: /^/,
            heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
        }), n.gfm.paragraph = c(n.paragraph)("(?!", "(?!" + n.gfm.fences.source.replace("\\1", "\\2") + "|" + n.list.source.replace("\\1", "\\3") + "|")(), n.tables = s({}, n.gfm, {
            nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
            table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
        }), e.rules = n, e.lex = function(n, t) {
            return new e(t).lex(n);
        }, e.prototype.lex = function(n) {
            return n = n.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), this.token(n, !0);
        }, e.prototype.token = function(e, t, r) {
            var a, i, u, c, o, s, f, l, d;
            for(e = e.replace(/^ +$/gm, ""); e;)if ((u = this.rules.newline.exec(e)) && (e = e.substring(u[0].length), u[0].length > 1 && this.tokens.push({
                type: "space"
            })), u = this.rules.code.exec(e)) e = e.substring(u[0].length), u = u[0].replace(/^ {4}/gm, ""), this.tokens.push({
                type: "code",
                text: this.options.pedantic ? u : u.replace(/\n+$/, "")
            });
            else if (u = this.rules.fences.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "code",
                lang: u[2],
                text: u[3] || ""
            });
            else if (u = this.rules.heading.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: u[1].length,
                text: u[2]
            });
            else if (t && (u = this.rules.nptable.exec(e))) {
                for(e = e.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].split(/ *\| */);
                this.tokens.push(s);
            } else if (u = this.rules.lheading.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "heading",
                depth: "=" === u[2] ? 1 : 2,
                text: u[1]
            });
            else if (u = this.rules.hr.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "hr"
            });
            else if (u = this.rules.blockquote.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "blockquote_start"
            }), u = u[0].replace(/^ *> ?/gm, ""), this.token(u, t, !0), this.tokens.push({
                type: "blockquote_end"
            });
            else if (u = this.rules.list.exec(e)) {
                for(e = e.substring(u[0].length), this.tokens.push({
                    type: "list_start",
                    ordered: (c = u[2]).length > 1
                }), a = !1, d = (u = u[0].match(this.rules.item)).length, l = 0; d > l; l++)f = (s = u[l]).length, ~(s = s.replace(/^ *([*+-]|\d+\.) +/, "")).indexOf("\n ") && (f -= s.length, s = s.replace(this.options.pedantic ? /^ {1,4}/gm : RegExp("^ {1," + f + "}", "gm"), "")), this.options.smartLists && l !== d - 1 && (c === (o = n.bullet.exec(u[l + 1])[0]) || c.length > 1 && o.length > 1 || (e = u.slice(l + 1).join("\n") + e, l = d - 1)), i = a || /\n\n(?!\s*$)/.test(s), l !== d - 1 && (a = "\n" === s.charAt(s.length - 1), i || (i = a)), this.tokens.push({
                    type: i ? "loose_item_start" : "list_item_start"
                }), this.token(s, !1, r), this.tokens.push({
                    type: "list_item_end"
                });
                this.tokens.push({
                    type: "list_end"
                });
            } else if (u = this.rules.html.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: this.options.sanitize ? "paragraph" : "html",
                pre: !this.options.sanitizer && ("pre" === u[1] || "script" === u[1] || "style" === u[1]),
                text: u[0]
            });
            else if (!r && t && (u = this.rules.def.exec(e))) e = e.substring(u[0].length), this.tokens.links[u[1].toLowerCase()] = {
                href: u[2],
                title: u[3]
            };
            else if (t && (u = this.rules.table.exec(e))) {
                for(e = e.substring(u[0].length), s = {
                    type: "table",
                    header: u[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: u[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: u[3].replace(/(?: *\| *)?\n$/, "").split("\n")
                }, l = 0; s.align.length > l; l++)s.align[l] = /^ *-+: *$/.test(s.align[l]) ? "right" : /^ *:-+: *$/.test(s.align[l]) ? "center" : /^ *:-+ *$/.test(s.align[l]) ? "left" : null;
                for(l = 0; s.cells.length > l; l++)s.cells[l] = s.cells[l].replace(/^ *\| *| *\| *$/g, "").split(/ *\| */);
                this.tokens.push(s);
            } else if (t && (u = this.rules.paragraph.exec(e))) e = e.substring(u[0].length), this.tokens.push({
                type: "paragraph",
                text: "\n" === u[1].charAt(u[1].length - 1) ? u[1].slice(0, -1) : u[1]
            });
            else if (u = this.rules.text.exec(e)) e = e.substring(u[0].length), this.tokens.push({
                type: "text",
                text: u[0]
            });
            else if (e) throw Error("Infinite loop on byte: " + e.charCodeAt(0));
            return this.tokens;
        };
        var t = {
            escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
            autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
            url: o,
            tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
            link: /^!?\[(inside)\]\(href\)/,
            reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
            nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
            strong: /^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
            em: /^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
            code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
            br: /^ {2,}\n(?!\s*$)/,
            del: o,
            text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
        };
        function r(n, e) {
            if (this.options = e || f.defaults, this.links = n, this.rules = t.normal, this.renderer = this.options.renderer || new a, this.renderer.options = this.options, !this.links) throw Error("Tokens array requires a `links` property.");
            this.options.gfm ? this.rules = this.options.breaks ? t.breaks : t.gfm : this.options.pedantic && (this.rules = t.pedantic);
        }
        function a(n) {
            this.options = n || {};
        }
        function i(n) {
            this.tokens = [], this.token = null, this.options = n || f.defaults, this.options.renderer = this.options.renderer || new a, this.renderer = this.options.renderer, this.renderer.options = this.options;
        }
        function u(n, e) {
            return n.replace(e ? /&/g : /&(?!#?\w+;)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        }
        function c(n, e) {
            return n = n.source, e = e || "", function t(r, a) {
                return r ? (a = (a = a.source || a).replace(/(^|[^\[])\^/g, "$1"), n = n.replace(r, a), t) : RegExp(n, e);
            };
        }
        function o() {}
        function s(n) {
            for(var e, t, r = 1; arguments.length > r; r++)for(t in e = arguments[r])Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
            return n;
        }
        function f(n, t, r) {
            if (r || "function" == typeof t) {
                r || (r = t, t = null);
                var a, c, o = (t = s({}, f.defaults, t || {})).highlight, l = 0;
                try {
                    a = e.lex(n, t);
                } catch (n) {
                    return r(n);
                }
                c = a.length;
                var d = function(n) {
                    if (n) return t.highlight = o, r(n);
                    var e;
                    try {
                        e = i.parse(a, t);
                    } catch (e) {
                        n = e;
                    }
                    return t.highlight = o, n ? r(n) : r(null, e);
                };
                if (!o || 3 > o.length) return d();
                if (delete t.highlight, !c) return d();
                for(; a.length > l; l++)!function(n) {
                    "code" !== n.type ? --c || d() : o(n.text, n.lang, function(e, t) {
                        return e ? d(e) : null == t || t === n.text ? --c || d() : (n.text = t, n.escaped = !0, void (--c || d()));
                    });
                }(a[l]);
            } else try {
                return t && (t = s({}, f.defaults, t)), i.parse(e.lex(n, t), t);
            } catch (n) {
                if (n.message += "\nPlease report this to https://github.com/chjj/marked.", (t || f.defaults).silent) return "<p>An error occured:</p><pre>" + u(n.message + "", !0) + "</pre>";
                throw n;
            }
        }
        t._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/, t._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/, t.link = c(t.link)("inside", t._inside)("href", t._href)(), t.reflink = c(t.reflink)("inside", t._inside)(), t.normal = s({}, t), t.pedantic = s({}, t.normal, {
            strong: /^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
        }), t.gfm = s({}, t.normal, {
            escape: c(t.escape)("])", "~|])")(),
            url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
            del: /^~~(?=\S)([\s\S]*?\S)~~/,
            text: c(t.text)("]|", "~]|")("|", "|https?://|")()
        }), t.breaks = s({}, t.gfm, {
            br: c(t.br)("{2,}", "*")(),
            text: c(t.gfm.text)("{2,}", "*")()
        }), r.rules = t, r.output = function(n, e, t) {
            return new r(e, t).output(n);
        }, r.prototype.output = function(n) {
            for(var e, t, r, a, i = ""; n;)if (a = this.rules.escape.exec(n)) n = n.substring(a[0].length), i += a[1];
            else if (a = this.rules.autolink.exec(n)) n = n.substring(a[0].length), "@" === a[2] ? (t = ":" === a[1].charAt(6) ? this.mangle(a[1].substring(7)) : this.mangle(a[1]), r = this.mangle("mailto:") + t) : r = t = u(a[1]), i += this.renderer.link(r, null, t);
            else if (this.inLink || !(a = this.rules.url.exec(n))) {
                if (a = this.rules.tag.exec(n)) !this.inLink && /^<a /i.test(a[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(a[0]) && (this.inLink = !1), n = n.substring(a[0].length), i += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(a[0]) : u(a[0]) : a[0];
                else if (a = this.rules.link.exec(n)) n = n.substring(a[0].length), this.inLink = !0, i += this.outputLink(a, {
                    href: a[2],
                    title: a[3]
                }), this.inLink = !1;
                else if ((a = this.rules.reflink.exec(n)) || (a = this.rules.nolink.exec(n))) {
                    if (n = n.substring(a[0].length), e = (a[2] || a[1]).replace(/\s+/g, " "), !(e = this.links[e.toLowerCase()]) || !e.href) {
                        i += a[0].charAt(0), n = a[0].substring(1) + n;
                        continue;
                    }
                    this.inLink = !0, i += this.outputLink(a, e), this.inLink = !1;
                } else if (a = this.rules.strong.exec(n)) n = n.substring(a[0].length), i += this.renderer.strong(this.output(a[2] || a[1]));
                else if (a = this.rules.em.exec(n)) n = n.substring(a[0].length), i += this.renderer.em(this.output(a[2] || a[1]));
                else if (a = this.rules.code.exec(n)) n = n.substring(a[0].length), i += this.renderer.codespan(u(a[2], !0));
                else if (a = this.rules.br.exec(n)) n = n.substring(a[0].length), i += this.renderer.br();
                else if (a = this.rules.del.exec(n)) n = n.substring(a[0].length), i += this.renderer.del(this.output(a[1]));
                else if (a = this.rules.text.exec(n)) n = n.substring(a[0].length), i += this.renderer.text(u(this.smartypants(a[0])));
                else if (n) throw Error("Infinite loop on byte: " + n.charCodeAt(0));
            } else n = n.substring(a[0].length), t = u(a[1]), i += this.renderer.link(r = t, null, t);
            return i;
        }, r.prototype.outputLink = function(n, e) {
            var t = u(e.href), r = e.title ? u(e.title) : null;
            return "!" !== n[0].charAt(0) ? this.renderer.link(t, r, this.output(n[1])) : this.renderer.image(t, r, u(n[1]));
        }, r.prototype.smartypants = function(n) {
            return this.options.smartypants ? n.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014\/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026") : n;
        }, r.prototype.mangle = function(n) {
            if (!this.options.mangle) return n;
            for(var e, t = "", r = n.length, a = 0; r > a; a++)e = n.charCodeAt(a), Math.random() > .5 && (e = "x" + e.toString(16)), t += "&#" + e + ";";
            return t;
        }, a.prototype.code = function(n, e, t) {
            if (this.options.highlight) {
                var r = this.options.highlight(n, e);
                null != r && r !== n && (t = !0, n = r);
            }
            return e ? '<pre><code class="' + this.options.langPrefix + u(e, !0) + '">' + (t ? n : u(n, !0)) + "\n</code></pre>\n" : "<pre><code>" + (t ? n : u(n, !0)) + "\n</code></pre>";
        }, a.prototype.blockquote = function(n) {
            return "<blockquote>\n" + n + "</blockquote>\n";
        }, a.prototype.html = function(n) {
            return n;
        }, a.prototype.heading = function(n, e, t) {
            return "<h" + e + ' id="' + this.options.headerPrefix + t.toLowerCase().replace(/[^\w]+/g, "-") + '">' + n + "</h" + e + ">\n";
        }, a.prototype.hr = function() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        }, a.prototype.list = function(n, e) {
            var t = e ? "ol" : "ul";
            return "<" + t + ">\n" + n + "</" + t + ">\n";
        }, a.prototype.listitem = function(n) {
            return "<li>" + n + "</li>\n";
        }, a.prototype.paragraph = function(n) {
            return "<p>" + n + "</p>\n";
        }, a.prototype.table = function(n, e) {
            return "<table>\n<thead>\n" + n + "</thead>\n<tbody>\n" + e + "</tbody>\n</table>\n";
        }, a.prototype.tablerow = function(n) {
            return "<tr>\n" + n + "</tr>\n";
        }, a.prototype.tablecell = function(n, e) {
            var t = e.header ? "th" : "td";
            return (e.align ? "<" + t + ' style="text-align:' + e.align + '">' : "<" + t + ">") + n + "</" + t + ">\n";
        }, a.prototype.strong = function(n) {
            return "<strong>" + n + "</strong>";
        }, a.prototype.em = function(n) {
            return "<em>" + n + "</em>";
        }, a.prototype.codespan = function(n) {
            return "<code>" + n + "</code>";
        }, a.prototype.br = function() {
            return this.options.xhtml ? "<br/>" : "<br>";
        }, a.prototype.del = function(n) {
            return "<del>" + n + "</del>";
        }, a.prototype.link = function(n, e, t) {
            if (this.options.sanitize) {
                try {
                    var r = decodeURIComponent((a = n, a.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(n, e) {
                        return "colon" === (e = e.toLowerCase()) ? ":" : "#" === e.charAt(0) ? "x" === e.charAt(1) ? String.fromCharCode(parseInt(e.substring(2), 16)) : String.fromCharCode(+e.substring(1)) : "";
                    }))).replace(/[^\w:]/g, "").toLowerCase();
                } catch (n) {
                    return "";
                }
                if (0 === r.indexOf("javascript:") || 0 === r.indexOf("vbscript:") || 0 === r.indexOf("data:")) return "";
            }
            var a, i = '<a href="' + n + '"';
            return e && (i += ' title="' + e + '"'), i + ">" + t + "</a>";
        }, a.prototype.image = function(n, e, t) {
            var r = '<img src="' + n + '" alt="' + t + '"';
            return e && (r += ' title="' + e + '"'), r + (this.options.xhtml ? "/>" : ">");
        }, a.prototype.text = function(n) {
            return n;
        }, i.parse = function(n, e, t) {
            return new i(e, t).parse(n);
        }, i.prototype.parse = function(n) {
            this.inline = new r(n.links, this.options, this.renderer), this.tokens = n.reverse();
            for(var e = ""; this.next();)e += this.tok();
            return e;
        }, i.prototype.next = function() {
            return this.token = this.tokens.pop();
        }, i.prototype.peek = function() {
            return this.tokens[this.tokens.length - 1] || 0;
        }, i.prototype.parseText = function() {
            for(var n = this.token.text; "text" === this.peek().type;)n += "\n" + this.next().text;
            return this.inline.output(n);
        }, i.prototype.tok = function() {
            switch(this.token.type){
                case "space":
                    return "";
                case "hr":
                    return this.renderer.hr();
                case "heading":
                    return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text);
                case "code":
                    return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
                case "table":
                    var n, e, t, r, a = "", i = "";
                    for(t = "", n = 0; this.token.header.length > n; n++)t += this.renderer.tablecell(this.inline.output(this.token.header[n]), {
                        header: !0,
                        align: this.token.align[n]
                    });
                    for(a += this.renderer.tablerow(t), n = 0; this.token.cells.length > n; n++){
                        for(e = this.token.cells[n], t = "", r = 0; e.length > r; r++)t += this.renderer.tablecell(this.inline.output(e[r]), {
                            header: !1,
                            align: this.token.align[r]
                        });
                        i += this.renderer.tablerow(t);
                    }
                    return this.renderer.table(a, i);
                case "blockquote_start":
                    for(i = ""; "blockquote_end" !== this.next().type;)i += this.tok();
                    return this.renderer.blockquote(i);
                case "list_start":
                    i = "";
                    for(var u = this.token.ordered; "list_end" !== this.next().type;)i += this.tok();
                    return this.renderer.list(i, u);
                case "list_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += "text" === this.token.type ? this.parseText() : this.tok();
                    return this.renderer.listitem(i);
                case "loose_item_start":
                    for(i = ""; "list_item_end" !== this.next().type;)i += this.tok();
                    return this.renderer.listitem(i);
                case "html":
                    var c = this.token.pre || this.options.pedantic ? this.token.text : this.inline.output(this.token.text);
                    return this.renderer.html(c);
                case "paragraph":
                    return this.renderer.paragraph(this.inline.output(this.token.text));
                case "text":
                    return this.renderer.paragraph(this.parseText());
            }
        }, o.exec = o, f.options = f.setOptions = function(n) {
            return s(f.defaults, n), f;
        }, f.defaults = {
            gfm: !0,
            tables: !0,
            breaks: !1,
            pedantic: !1,
            sanitize: !1,
            sanitizer: null,
            mangle: !0,
            smartLists: !1,
            silent: !1,
            highlight: null,
            langPrefix: "lang-",
            smartypants: !1,
            headerPrefix: "",
            renderer: new a,
            xhtml: !1
        }, f.Parser = i, f.parser = i.parse, f.Renderer = a, f.Lexer = e, f.lexer = e.lex, f.InlineLexer = r, f.inlineLexer = r.output, f.parse = f, void 0 !== Qe && "object" == typeof Xe ? Qe.exports = f : "function" == typeof define && define.amd ? define(function() {
            return f;
        }) : this.marked = f;
    }).call(function() {
        return this || ("undefined" != typeof window ? window : $parcel$global);
    }()), Qe.exports), tt = m, rt = a, at = F3(function(n, e, t) {
        var r = t.c, a = t.d, i = F2(function(e, t) {
            return A3(rt, e.$ ? n : i, t, e.a);
        });
        return A3(rt, i, A3(rt, n, e, a), r);
    }), it = F3(function(n, e, t) {
        for(;;){
            if (-2 === t.$) return e;
            var r = t.d, a = n, i = A3(n, t.b, t.c, A3(it, n, e, t.e));
            n = a, e = i, t = r;
        }
    }), ut = function(n) {
        return A3(it, F3(function(n, e, t) {
            return A2(tt, d(n, e), t);
        }), v, n);
    }, ct = function(n) {
        return A3(it, F3(function(n, e, t) {
            return A2(tt, n, t);
        }), v, n);
    }, ot = 1, st = 2, ft = 0, lt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dt = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), bt = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ht = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), gt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pt = x, mt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yt = {
        $: 1
    }, $t = G, wt = A, kt = on, Ct = function(n) {
        return n + "";
    }, xt = F2(function(n, e) {
        return A2(D, n, $(e));
    }), jt = F2(function(n, e) {
        return y(A2(P, n, e));
    }), qt = function(n) {
        return A2(xt, "\n    ", A2(jt, "\n", n));
    }, St = F3(function(n, e, t) {
        for(;;){
            if (!t.b) return e;
            var r = t.b, a = n, i = A2(n, t.a, e);
            n = a, e = i, t = r;
        }
    }), It = function(n) {
        return A3(St, F2(function(n, e) {
            return e + 1;
        }), 0, n);
    }, Tt = w, At = F3(function(n, e, t) {
        for(;;){
            if (s(n, e) >= 1) return t;
            var r = n, a = e - 1, i = A2(tt, e, t);
            n = r, e = a, t = i;
        }
    }), Et = F2(function(n, e) {
        return A3(At, n, e, v);
    }), Nt = F2(function(n, e) {
        return A3(Tt, n, A2(Et, 0, It(e) - 1), e);
    }), Lt = function(n) {
        var e = n.charCodeAt(0);
        return 55296 > e || e > 56319 ? e : 1024 * (e - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Pt = function(n) {
        var e = Lt(n);
        return e >= 97 && 122 >= e;
    }, Dt = function(n) {
        var e = Lt(n);
        return 90 >= e && e >= 65;
    }, Ot = function(n) {
        var e = Lt(n);
        return 57 >= e && e >= 48;
    }, Gt = function(n) {
        return Pt(n) || Dt(n) || Ot(n);
    }, _t = function(n) {
        return A3(St, tt, v, n);
    }, Ft = F2(function(n, e) {
        return "\n\n(" + Ct(n + 1) + ") " + qt(Rt(e));
    }), Rt = function(n) {
        return A2(Bt, n, v);
    }, Bt = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, r = n.b, a = function() {
                    var n, e, r = (e = (n = t).charCodeAt(0)) ? mt(55296 > e || e > 56319 ? d(n[0], n.slice(1)) : d(n[0] + n[1], n.slice(2))) : yt;
                    if (1 === r.$) return !1;
                    var a, i = r.a, u = i.b;
                    return (Pt(a = i.a) || Dt(a)) && A2($t, Gt, u);
                }();
                n = r, e = A2(tt, a ? "." + t : "['" + t + "']", e);
                continue n;
            case 1:
                r = n.b;
                var i = "[" + Ct(n.a) + "]";
                n = r, e = A2(tt, i, e);
                continue n;
            case 2:
                var u = n.a;
                if (u.b) {
                    if (u.b.b) {
                        var c = (e.b ? "The Json.Decode.oneOf at json" + A2(xt, "", _t(e)) : "Json.Decode.oneOf") + " failed in the following " + Ct(It(u)) + " ways:";
                        return A2(xt, "\n\n", A2(tt, c, A2(Nt, Ft, u)));
                    }
                    n = r = u.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (e.b ? " at json" + A2(xt, "", _t(e)) : "!");
            default:
                var o = n.a, s = n.b;
                return (c = e.b ? "Problem with the value at json" + A2(xt, "", _t(e)) + ":\n\n    " : "Problem with the given value:\n\n") + qt(A2(kt, 4, s)) + "\n\n" + o;
        }
    }), Ht = 32, Vt = F4(function(n, e, t, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: t,
            d: r
        };
    }), zt = [], Ut = q, Wt = F2(function(n, e) {
        return T(e) / T(n);
    }), Kt = Ut(A2(Wt, 2, Ht)), Zt = A4(Vt, 0, Kt, zt, zt), Yt = t, Mt = F2(function(n, e) {
        return n(e);
    }), Jt = F2(function(n, e) {
        return e(n);
    }), Qt = o, Xt = S, nr = function(n) {
        return n.length;
    }, er = F2(function(n, e) {
        return s(n, e) > 0 ? n : e;
    }), tr = r, rr = F2(function(n, e) {
        for(;;){
            var t = A2(tr, Ht, n), r = t.b, a = A2(tt, {
                $: 0,
                a: t.a
            }, e);
            if (!r.b) return _t(a);
            n = r, e = a;
        }
    }), ar = function(n) {
        return n.a;
    }, ir = F2(function(n, e) {
        for(;;){
            var t = Ut(e / Ht);
            if (1 === t) return A2(tr, Ht, n).a;
            n = A2(rr, n, v), e = t;
        }
    }), ur = F2(function(n, e) {
        if (e.u) {
            var t = e.u * Ht, r = Xt(A2(Wt, Ht, t - 1)), a = n ? _t(e.y) : e.y, i = A2(ir, a, e.u);
            return A4(Vt, nr(e.w) + t, A2(er, 5, r * Kt), i, e.w);
        }
        return A4(Vt, nr(e.w), Kt, zt, e.w);
    }), cr = F5(function(n, e, t, r, a) {
        for(;;){
            if (0 > e) return A2(ur, !1, {
                y: r,
                u: t / Ht | 0,
                w: a
            });
            var i = {
                $: 1,
                a: A3(Yt, Ht, e, n)
            };
            e -= Ht, r = A2(tt, i, r);
        }
    }), or = F2(function(n, e) {
        if (n > 0) {
            var t = n % Ht;
            return A5(cr, e, n - t - Ht, n, v, A3(Yt, t, n - t, e));
        }
        return Zt;
    }), sr = function(n) {
        return !n.$;
    }, fr = Y, lr = M, dr = J, br = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, gr = function(n) {
        return n;
    }, vr = gr, pr = F6(function(n, e, t, r, a, i) {
        return {
            iv: i,
            fK: e,
            bp: r,
            gL: t,
            gT: n,
            jq: a
        };
    }), mr = _, yr = function(n) {
        return n.length;
    }, $r = O, wr = F2(function(n, e) {
        return 1 > n ? e : A3($r, n, yr(e), e);
    }), kr = B, Cr = function(n) {
        return "" === n;
    }, xr = F2(function(n, e) {
        return 1 > n ? "" : A3($r, 0, n, e);
    }), jr = function(n) {
        for(var e = 0, t = n.charCodeAt(0), r = 43 == t || 45 == t ? 1 : 0, a = r; n.length > a; ++a){
            var i = n.charCodeAt(a);
            if (48 > i || i > 57) return yt;
            e = 10 * e + i - 48;
        }
        return a == r ? yt : mt(45 == t ? -e : e);
    }, qr = F5(function(n, e, t, r, a) {
        if (Cr(a) || A2(mr, "@", a)) return yt;
        var i = A2(kr, ":", a);
        if (i.b) {
            if (i.b.b) return yt;
            var u = i.a, c = jr(A2(wr, u + 1, a));
            if (1 === c.$) return yt;
            var o = c;
            return mt(A6(pr, n, A2(xr, u, a), o, e, t, r));
        }
        return mt(A6(pr, n, a, yt, e, t, r));
    }), Sr = F4(function(n, e, t, r) {
        if (Cr(r)) return yt;
        var a = A2(kr, "/", r);
        if (a.b) {
            var i = a.a;
            return A5(qr, n, A2(wr, i, r), e, t, A2(xr, i, r));
        }
        return A5(qr, n, "/", e, t, r);
    }), Ir = F3(function(n, e, t) {
        if (Cr(t)) return yt;
        var r = A2(kr, "?", t);
        if (r.b) {
            var a = r.a;
            return A4(Sr, n, mt(A2(wr, a + 1, t)), e, A2(xr, a, t));
        }
        return A4(Sr, n, yt, e, t);
    }), Tr = F2(function(n, e) {
        if (Cr(e)) return yt;
        var t = A2(kr, "#", e);
        if (t.b) {
            var r = t.a;
            return A3(Ir, n, mt(A2(wr, r + 1, e)), A2(xr, r, e));
        }
        return A3(Ir, n, yt, e);
    }), Ar = F, Er = function(n) {
        return A2(Ar, "http://", n) ? A2(Tr, 0, A2(wr, 7, n)) : A2(Ar, "https://", n) ? A2(Tr, 1, A2(wr, 8, n)) : yt;
    }, Nr = function() {
        for(;;);
    }, Lr = ln, Pr = Lr(0), Dr = F4(function(n, e, t, r) {
        if (r.b) {
            var a = r.a, i = r.b;
            if (i.b) {
                var u = i.a, c = i.b;
                if (c.b) {
                    var o = c.a, s = c.b;
                    if (s.b) {
                        var f = s.b;
                        return A2(n, a, A2(n, u, A2(n, o, A2(n, s.a, t > 500 ? A3(St, n, e, _t(f)) : A4(Dr, n, e, t + 1, f)))));
                    }
                    return A2(n, a, A2(n, u, A2(n, o, e)));
                }
                return A2(n, a, A2(n, u, e));
            }
            return A2(n, a, e);
        }
        return e;
    }), Or = F3(function(n, e, t) {
        return A4(Dr, n, e, 0, t);
    }), Gr = F2(function(n, e) {
        return A3(Or, F2(function(e, t) {
            return A2(tt, n(e), t);
        }), v, e);
    }), _r = bn, Fr = F2(function(n, e) {
        return A2(_r, function(e) {
            return Lr(n(e));
        }, e);
    }), Rr = F3(function(n, e, t) {
        return A2(_r, function(e) {
            return A2(_r, function(t) {
                return Lr(A2(n, e, t));
            }, t);
        }, e);
    }), Br = function(n) {
        return A3(Or, Rr(tt), Lr(v), n);
    }, Hr = Sn, Vr = F2(function(n, e) {
        var t = e;
        return pn(A2(_r, Hr(n), t));
    });
    xn.Task = jn(Pr, F3(function(n, e) {
        return A2(Fr, function() {
            return 0;
        }, Br(A2(Gr, Vr(n), e)));
    }), F3(function() {
        return Lr(0);
    }), F2(function(n, e) {
        return A2(Fr, n, e);
    }));
    var zr, Ur, Wr = Tn("Task"), Kr = F2(function(n, e) {
        return Wr(A2(Fr, n, e));
    }), Zr = K, Yr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Mr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Jr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qr = {
        $: 1
    }, Xr = {
        $: 0
    }, na = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ea = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ta = W, ra = A2(fr, function(n) {
        switch(n){
            case "User":
                return br(0);
            case "Organization":
                return br(1);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), aa = z, ia = dr(Jt), ua = F2(function(n, e) {
        return ia(A2(Zr, n, e));
    }), ca = Pe, oa = Le, sa = function(n) {
        return A2(oa, {
            h5: !1,
            iZ: !1
        }, n);
    }, fa = /.^/, la = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), da = A2(la, fa, sa("^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$")), ba = function(n) {
        return A2(ca, da, n) ? mt(n.toLowerCase()) : yt;
    }, ha = A2(fr, function(n) {
        var e = ba(n);
        return e.$ ? ea("Not a valid UUID") : br(e.a);
    }, ta), ga = {
        $: -2
    }, va = ga, pa = F5(function(n, e, t, r, a) {
        return {
            $: -1,
            a: n,
            b: e,
            c: t,
            d: r,
            e: a
        };
    }), ma = F5(function(n, e, t, r, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(pa, n, e, t, r, a);
            var i = r.d;
            return u = r.e, A5(pa, 0, r.b, r.c, A5(pa, 1, i.b, i.c, i.d, i.e), A5(pa, 1, e, t, u, a));
        }
        var u, c = a.b, o = a.c, s = a.d, f = a.e;
        return -1 !== r.$ || r.a ? A5(pa, n, c, o, A5(pa, 0, e, t, r, s), f) : A5(pa, 0, e, t, A5(pa, 1, r.b, r.c, r.d, u = r.e), A5(pa, 1, c, o, s, f));
    }), ya = f, $a = F3(function(n, e, t) {
        if (-2 === t.$) return A5(pa, 0, n, e, ga, ga);
        var r = t.a, a = t.b, i = t.c, u = t.d, c = t.e;
        switch(A2(ya, n, a)){
            case 0:
                return A5(ma, r, a, i, A3($a, n, e, u), c);
            case 1:
                return A5(pa, r, a, e, u, c);
            default:
                return A5(ma, r, a, i, u, A3($a, n, e, c));
        }
    }), wa = F3(function(n, e, t) {
        var r = A3($a, n, e, t);
        return -1 !== r.$ || r.a ? r : A5(pa, 1, r.b, r.c, r.d, r.e);
    }), ka = function(n) {
        return A3(St, F2(function(n, e) {
            return A3(wa, n.a, n.b, e);
        }), va, n);
    }, Ca = function(n) {
        return A2(lr, ka, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, xa = F6(function(n, e, t, r, a, i) {
        return {
            em: i,
            k: t,
            c: n,
            gm: a,
            ax: e,
            W: r
        };
    }), ja = X, qa = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Sa = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Ia = U, Ta = F3(function(n, e, t) {
        var r = Sa(y([
            A2(lr, mt, e),
            qa(t)
        ])), a = A2(Zr, n, Ia);
        return A2(fr, function(n) {
            var e = A2(ja, a, n);
            if (e.$) return br(t);
            var i = A2(ja, r, e.a);
            return i.$ ? ea(Rt(i.a)) : br(i.a);
        }, Ia);
    }), Aa = F3(function(n, e, t) {
        return ia(A3(Ta, n, e, t));
    }), Ea = A4(Aa, "adminPermission", aa, yt, A4(Aa, "newInstallationURL", ta, yt, A3(ua, "typ", ta, A3(ua, "displayName", ta, A3(ua, "slug", ta, A3(ua, "id", ha, br(xa))))))), Na = A2(fr, function(n) {
        switch(n){
            case "Member":
                return br(0);
            case "Admin":
                return br(1);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), La = F8(function(n, e, t, r, a, i, u, c) {
        return {
            ey: t,
            k: e,
            c: n,
            hn: u,
            ho: i,
            hp: a,
            hq: c,
            hy: r
        };
    }), Pa = A2(fr, function(n) {
        switch(n){
            case "Community":
                return br(0);
            case "Trial":
                return br(1);
            case "Active":
                return br(2);
            case "Cancelled":
                return br(3);
            case "External":
                return br(4);
            case "Enterprise":
                return br(5);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Da = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Oa = F3(function(n, e, t) {
        return {
            $: 0,
            a: n,
            b: e,
            c: t
        };
    }), Ga = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(Da, r.a, r.b);
            var a = r.a, i = r.c, u = n(r.b)(i);
            if (1 === u.$) {
                var c = u.a;
                return A2(Da, a || c, u.b);
            }
            return c = u.a, A3(Oa, a || c, u.b, u.c);
        };
    }), _a = Ga, Fa = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Ra = F4(function(n, e, t, r) {
        return {
            eN: e,
            id: r,
            gO: t,
            g8: n
        };
    }), Ba = {
        $: 0
    }, Ha = F2(function(n, e) {
        return A2(Fa, Ba, A4(Ra, n.g8, n.eN, e, n.h));
    }), Va = (zr = {
        $: 10
    }, function(n) {
        return u(yr(n.b), n.d) ? A3(Oa, !1, 0, n) : A2(Da, !1, A2(Ha, n, zr));
    }), za = Oe, Ua = F5(function(n, e, t, r, a) {
        for(;;){
            var i = A3(za, n, e, a.b);
            if (u(i, -1)) return A3(Oa, 0 > s(a.d, e), 0, {
                eN: r,
                h: a.h,
                i: a.i,
                d: e,
                g8: t,
                b: a.b
            });
            u(i, -2) ? (e += 1, t += 1, r = 1) : (e = i, r += 1);
        }
    }), Wa = function(n) {
        return function(e) {
            return A5(Ua, n, e.d, e.g8, e.eN, e);
        };
    }, Ka = F2(function(n) {
        return n;
    }), Za = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(Da, r.a, r.b);
            var a = r.b, i = r.c;
            return A3(Oa, r.a, A2(n, A3($r, e.d, i.d, e.b), a), i);
        };
    }), Ya = function(n) {
        return A2(Za, Ka, n);
    }, Ma = function(n) {
        return function(n) {
            return function(e) {
                return A2(Da, !1, A2(Ha, e, n));
            };
        }({
            $: 12,
            a: n
        });
    }, Ja = I, Qa = function(n) {
        return function(e) {
            return A3(Oa, !1, n, e);
        };
    }, Xa = Qa, ni = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return yt;
        var e = +n;
        return e == e ? mt(e) : yt;
    }, ei = A2(_a, function(n) {
        if (yr(n) > 9) return Ma("Expected at most 9 digits, but got " + Ct(yr(n)));
        var e = ni("0." + n);
        return e.$ ? Ma('Invalid float: "' + n + '"') : Xa(Ja(1e3 * e.a));
    }, Ya(Wa(Ot))), ti = gr, ri = F6(function(n, e, t, r, a, i) {
        return ti(n + 60 * e * 60000 + 60 * (t - i) * 1e3 + 1e3 * r + a);
    }), ai = F3(function(n, e, t) {
        var r = e, a = t;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(Da, t.a, t.b);
            var i = t.a, u = t.b, c = a(t.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(Da, i || o, c.b);
            }
            o = c.a;
            var s = c.c;
            return A3(Oa, i || o, A2(n, u, c.b), s);
        };
    }), ii = F2(function(n, e) {
        return A3(ai, Ka, n, e);
    }), ui = ii, ci = F2(function(n, e) {
        return A3(ai, Mt, n, e);
    }), oi = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), si = F3(function(n, e, t) {
        n: for(;;){
            if (t.b) {
                var r = t.b, a = (0, t.a)(n);
                if (a.$) {
                    var i;
                    if ((i = a).a) return i;
                    e = A2(oi, e, i.b), t = r;
                    continue n;
                }
                return a;
            }
            return A2(Da, !1, e);
        }
    }), fi = function(n) {
        return function(e) {
            return A3(si, e, Ba, n);
        };
    }, li = fi, di = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bi = N, hi = {
        $: 11
    }, gi = F2(function(n, e) {
        return function(t) {
            var r = A3(za, n, t.d, t.b);
            return u(r, -1) ? A2(Da, !1, A2(Ha, t, e)) : u(r, -2) ? A3(Oa, !0, 0, {
                eN: 1,
                h: t.h,
                i: t.i,
                d: t.d + 1,
                g8: t.g8 + 1,
                b: t.b
            }) : A3(Oa, !0, 0, {
                eN: t.eN + 1,
                h: t.h,
                i: t.i,
                d: r,
                g8: t.g8,
                b: t.b
            });
        };
    }), vi = function(n) {
        return A2(gi, n, hi);
    }, pi = F4(function(n, e, t, r) {
        for(;;){
            var a = t(e)(r);
            if (a.$) return i = a.a, A2(Da, n || i, a.b);
            var i = a.a, u = a.b, c = a.c;
            if (u.$) return A3(Oa, n || i, u.a, c);
            n = n || i, e = u.a, r = c;
        }
    }), mi = F2(function(n, e) {
        return function(t) {
            return A4(pi, !1, n, e, t);
        };
    }), yi = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = t(e);
            if (r.$) return A2(Da, r.a, r.b);
            var a = r.c;
            return A3(Oa, r.a, n(r.b), a);
        };
    }), $i = yi, wi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ki = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ci = function(n) {
        return n.$ ? wi(n.a) : ki(n.a);
    }, xi = F2(function(n, e) {
        return A2(mi, n, function(n) {
            return A2($i, Ci, e(n));
        });
    }), ji = function(n) {
        return A2(xi, "", function(e) {
            if (u(yr(e), n)) {
                var t = jr(e);
                return t.$ ? Ma('Invalid integer: "' + e + '"') : A2($i, di, Xa(t.a));
            }
            return A2($i, function(n) {
                return {
                    $: 0,
                    a: A2(bi, e, n)
                };
            }, Ya(vi(Ot)));
        });
    }, qi = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Si = De, Ii = function(n) {
        return !n;
    }, Ti = function(n) {
        var e = n.a, t = n.b, r = !Cr(e);
        return function(n) {
            var a = A5(Si, e, n.d, n.g8, n.eN, n.b), i = a.a, c = a.b, o = a.c;
            return u(i, -1) ? A2(Da, !1, A2(Ha, n, t)) : A3(Oa, r, 0, {
                eN: o,
                h: n.h,
                i: n.i,
                d: i,
                g8: c,
                b: n.b
            });
        };
    }, Ai = Ti, Ei = function(n) {
        return Ai(A2(qi, n, {
            $: 8,
            a: n
        }));
    }, Ni = function(n) {
        return Ma("Invalid day: " + Ct(n));
    }, Li = j, Pi = function(n) {
        return !(A2(Li, 4, n) || !A2(Li, 100, n) && A2(Li, 400, n));
    }, Di = function(n) {
        var e = n - 1;
        return (e / 4 | 0) - (e / 100 | 0) + (e / 400 | 0);
    }, Oi = A2(_a, function(n) {
        var e = n.a, t = n.b, r = n.c;
        if (0 > r) return Ni(r);
        var a = function(n) {
            var a = 31536e6 * (e - 1970), i = 864e5 * ((3 > t || !Pi(e) ? r - 1 : r) + (Di(e) - Di(1970)));
            return Xa(n + a + i);
        };
        switch(t){
            case 1:
                return r > 31 ? Ni(r) : a(0);
            case 2:
                return r > 29 || 29 === r && !Pi(e) ? Ni(r) : a(26784e5);
            case 3:
                return r > 31 ? Ni(r) : a(50976e5);
            case 4:
                return r > 30 ? Ni(r) : a(7776e6);
            case 5:
                return r > 31 ? Ni(r) : a(10368e6);
            case 6:
                return r > 30 ? Ni(r) : a(130464e5);
            case 7:
                return r > 31 ? Ni(r) : a(156384e5);
            case 8:
                return r > 31 ? Ni(r) : a(183168e5);
            case 9:
                return r > 30 ? Ni(r) : a(209952e5);
            case 10:
                return r > 31 ? Ni(r) : a(235872e5);
            case 11:
                return r > 30 ? Ni(r) : a(262656e5);
            case 12:
                return r > 31 ? Ni(r) : a(288576e5);
            default:
                return Ma('Invalid month: "' + Ct(t) + '"');
        }
    }, A2(ci, A2(ci, A2(ci, Xa(F3(function(n, e, t) {
        return b(n, e, t);
    })), ji(4)), li(y([
        A2(ci, A2(ui, Xa(gr), Ei("-")), ji(2)),
        ji(2)
    ]))), li(y([
        A2(ci, A2(ui, Xa(gr), Ei("-")), ji(2)),
        ji(2)
    ])))), Gi = (Ur = F3(function(n, e, t) {
        return n * (60 * e) + t;
    }), A2(ci, Xa(gr), li(y([
        A2($i, function() {
            return 0;
        }, Ei("Z")),
        A2(ci, A2(ci, A2(ci, Xa(Ur), li(y([
            A2($i, function() {
                return 1;
            }, Ei("+")),
            A2($i, function() {
                return -1;
            }, Ei("-"))
        ]))), ji(2)), li(y([
            A2(ci, A2(ui, Xa(gr), Ei(":")), ji(2)),
            ji(2),
            Xa(0)
        ]))),
        A2(ui, Xa(0), Va)
    ])))), _i = A2(_a, function(n) {
        return li(y([
            A2(ci, A2(ci, A2(ci, A2(ci, A2(ci, A2(ui, Xa(ri(n)), Ei("T")), ji(2)), li(y([
                A2(ci, A2(ui, Xa(gr), Ei(":")), ji(2)),
                ji(2)
            ]))), li(y([
                A2(ci, A2(ui, Xa(gr), Ei(":")), ji(2)),
                ji(2)
            ]))), li(y([
                A2(ci, A2(ui, Xa(gr), Ei(".")), ei),
                Xa(0)
            ]))), A2(ui, Gi, Va)),
            A2(ui, Xa(A6(ri, n, 0, 0, 0, 0, 0)), Va)
        ]));
    }, Oi), Fi = F3(function(n, e, t) {
        return {
            eN: e,
            gO: t,
            g8: n
        };
    }), Ri = function(n) {
        return A3(Fi, n.g8, n.eN, n.gO);
    }, Bi = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                return e;
            case 1:
                var t = n.b;
                n = n.a, e = A2(tt, t, e);
                continue n;
            default:
                var r = n.b;
                n = n.a, e = A2(Bi, r, e);
                continue n;
        }
    }), Hi = F2(function(n, e) {
        var t = n({
            eN: 1,
            h: v,
            i: 1,
            d: 0,
            g8: 1,
            b: e
        });
        return t.$ ? lt(A2(Bi, t.b, v)) : gt(t.b);
    }), Vi = F2(function(n, e) {
        var t = A2(Hi, n, e);
        return t.$ ? lt(A2(Gr, Ri, t.a)) : gt(t.a);
    }), zi = A2(fr, function(n) {
        var e = function(n) {
            return A2(Vi, _i, n);
        }(n);
        return e.$ ? ea("Invalid ISO date: " + n) : br(e.a);
    }, ta), Ui = A4(Aa, "subscriptionUpdateUrl", ta, yt, A4(Aa, "subscriptionCancelUrl", ta, yt, A4(Aa, "subscriptionCancelledOn", zi, yt, A4(Aa, "subscriptionStartedOn", zi, yt, A4(Aa, "trialStartedOn", zi, yt, A3(ua, "billingStatus", Pa, A3(ua, "displayName", ta, A3(ua, "id", ha, br(La))))))))), Wi = A4(Aa, "installationIsSelection", aa, yt, A4(Aa, "manageInstallationURL", ta, yt, A4(Aa, "sourceHostingSites", Ca(Ea), yt, A4(Aa, "membershipRole", Na, yt, A3(ua, "isInstallable", aa, A3(ua, "isInstalled", aa, A4(Aa, "organization", Ui, yt, A3(ua, "imageURL", ta, A3(ua, "displayName", ta, A3(ua, "typ", ra, A3(ua, "slug", ta, A3(ua, "sourceHostingSiteSlug", ta, A3(ua, "id", ha, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            k: a,
                                                            c: n,
                                                            T: i,
                                                            fU: d,
                                                            db: o,
                                                            dc: c,
                                                            gc: l,
                                                            gf: s,
                                                            gA: u,
                                                            ax: t,
                                                            hf: e,
                                                            hg: f,
                                                            W: r
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Ki = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Zi = F2(function(n, e) {
        return e.$ ? yt : mt(n(e.a));
    }), Yi = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Mi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ji = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Qi = {
        $: 2
    }, Xi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eu = {
        $: 1
    }, tu = function(n) {
        return !n.$;
    }, ru = In, au = F2(function(n, e) {
        n: for(;;){
            if (-2 === e.$) return yt;
            var t = e.c, r = e.d, a = e.e;
            switch(A2(ya, n, e.b)){
                case 0:
                    e = r;
                    continue n;
                case 1:
                    return mt(t);
                default:
                    e = a;
                    continue n;
            }
        }
    }), iu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var e = n.d, t = n.e;
                return u = t.b, c = t.c, r = t.d, f = t.e, A5(pa, 1, n.b, n.c, A5(pa, 0, e.b, e.c, e.d, e.e), A5(pa, 0, u, c, r, f));
            }
            var r, a = n.d, i = n.e, u = i.b, c = i.c, o = (r = i.d).d, s = r.e, f = i.e;
            return A5(pa, 0, r.b, r.c, A5(pa, 1, n.b, n.c, A5(pa, 0, a.b, a.c, a.d, a.e), o), A5(pa, 1, u, c, s, f));
        }
        return n;
    }, uu = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var e = n.d, t = n.e;
                return s = t.b, f = t.c, l = t.d, d = t.e, A5(pa, 1, r = n.b, a = n.c, A5(pa, 0, e.b, e.c, e.d, c = e.e), A5(pa, 0, s, f, l, d));
            }
            var r = n.b, a = n.c, i = n.d, u = i.d, c = i.e, o = n.e, s = o.b, f = o.c, l = o.d, d = o.e;
            return A5(pa, 0, i.b, i.c, A5(pa, 1, u.b, u.c, u.d, u.e), A5(pa, 1, r, a, c, A5(pa, 0, s, f, l, d)));
        }
        return n;
    }, cu = F7(function(n, e, t, r, a, i, u) {
        if (-1 !== i.$ || i.a) {
            n: for(;;){
                if (-1 === u.$ && 1 === u.a) {
                    if (-1 === u.d.$) {
                        if (1 === u.d.a) return uu(e);
                        break n;
                    }
                    return uu(e);
                }
                break n;
            }
            return e;
        }
        return A5(pa, t, i.b, i.c, i.d, A5(pa, 0, r, a, i.e, u));
    }), ou = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var e = n.a, t = n.b, r = n.c, a = n.d, i = a.d, u = n.e;
            if (1 === a.a) {
                if (-1 !== i.$ || i.a) {
                    var c = iu(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ma, c.a, c.b, c.c, ou(c.d), o);
                    }
                    return ga;
                }
                return A5(pa, e, t, r, ou(a), u);
            }
            return A5(pa, e, t, r, ou(a), u);
        }
        return ga;
    }, su = F2(function(n, e) {
        if (-2 === e.$) return ga;
        var t = e.a, r = e.b, a = e.c, i = e.d, u = e.e;
        if (0 > s(n, r)) {
            if (-1 === i.$ && 1 === i.a) {
                var c = i.d;
                if (-1 !== c.$ || c.a) {
                    var o = iu(e);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(ma, o.a, o.b, o.c, A2(su, n, o.d), f);
                    }
                    return ga;
                }
                return A5(pa, t, r, a, A2(su, n, i), u);
            }
            return A5(pa, t, r, a, A2(su, n, i), u);
        }
        return A2(fu, n, A7(cu, n, e, t, r, a, i, u));
    }), fu = F2(function(n, e) {
        if (-1 === e.$) {
            var t = e.a, r = e.b, a = e.c, i = e.d, c = e.e;
            if (u(n, r)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(ma, t, o.b, o.c, i, ou(c)) : ga;
            }
            return A5(ma, t, r, a, i, A2(su, n, c));
        }
        return ga;
    }), lu = F2(function(n, e) {
        var t = A2(su, n, e);
        return -1 !== t.$ || t.a ? t : A5(pa, 1, t.b, t.c, t.d, t.e);
    }), du = F3(function(n, e, t) {
        var r = e(A2(au, n, t));
        return r.$ ? A2(lu, n, t) : A3(wa, n, r.a, t);
    }), bu = {
        $: 0
    }, hu = F3(function(n, e, t) {
        var r = n(e);
        return r.$ ? t : A2(tt, r.a, t);
    }), gu = F2(function(n, e) {
        return A3(Or, hu(n), v, e);
    }), vu = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), pu = gu(function(n) {
        var e = n.b;
        return A2(Zi, vu(n.a), e);
    }), mu = F2(function(n, e) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    n -= 1, e = e.b;
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), yu = F3(function(n, e, t) {
        return A2(xt, e, A2(jt, n, t));
    }), $u = F2(function(n, e) {
        return A2(mu, 1, A2(jt, "/", A3(St, F2(function(n, e) {
            return A3(yu, "{" + n.a + "}", n.b, e);
        }), n, e)));
    }), wu = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ku = function(n) {
        return encodeURIComponent(n);
    }, Cu = F2(function(n, e) {
        return A2(wu, ku(n), ku(e));
    }), xu = gu(function(n) {
        var e = n.b;
        return A2(Zi, Cu(n.a), e);
    }), ju = F7(function(n, e, t, r, a, i, u) {
        return {
            a3: "http://localhost",
            aD: A2(la, bu, i),
            bR: u,
            M: pu(a),
            aO: n,
            cd: A2($u, e, t),
            cf: xu(r),
            ay: yt,
            bA: yt
        };
    }), qu = F2(function(n, e) {
        return A7(ju, "GET", "/api/v1/accounts", v, y([
            d("site", A2(Zi, gr, n)),
            d("name", A2(Zi, gr, e))
        ]), v, yt, Ki(Wi));
    }), Su = F5(function(n, e, t, r, a) {
        return {
            eq: n,
            fu: r,
            fv: e,
            f7: t,
            gI: a
        };
    }), Iu = A3(ua, "personalAccounts", Ki(Wi), A3(ua, "forges", Ki(Ea), A3(ua, "licensedTo", ta, A3(ua, "frontendBaseUrl", ta, A3(ua, "apiBaseUrl", ta, br(Su)))))), Tu = A7(ju, "GET", "/api/v1/client/info", v, v, v, yt, Iu), Au = An, Eu = F5(function(n, e, t, r, a) {
        return {
            aJ: r,
            aP: t,
            az: e,
            bC: a,
            aX: n
        };
    }), Nu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(tt, n.a, Nu(n.b)) : v;
    }, Lu = F2(function(n, e) {
        return mt(1 === e.$ ? y([
            n
        ]) : A2(tt, n, e.a));
    }), Pu = function(n) {
        try {
            return mt(decodeURIComponent(n));
        } catch (n) {
            return yt;
        }
    }, Du = F2(function(n, e) {
        var t = A2(jt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var r = t.b.a, a = Pu(t.a);
            if (1 === a.$) return e;
            var i = a.a, u = Pu(r);
            return 1 === u.$ ? e : A3(du, i, Lu(u.a), e);
        }
        return e;
    }), Ou = F2(function(n, e) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var e = n.a, t = e.az;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return mt(e.bC);
                    }
                    return mt(e.bC);
                }
                return yt;
            }
        }(n(A5(Eu, v, function(n) {
            var e = A2(jt, "/", n);
            return Nu(e.b && "" === e.a ? e.b : e);
        }(e.bp), 1 === (t = e.jq).$ ? va : A3(Or, Du, va, A2(jt, "&", t.a)), e.iv, gr)));
    }), Gu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _u = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Fu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ru = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Hu = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Vu = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Uu = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Wu = {
        $: 0
    }, Ku = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Zu = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Yu = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Mu = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Ju = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Qu = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Xu = {
        $: 20
    }, nc = {
        $: 19
    }, ec = {
        $: 18
    }, tc = function(n) {
        return {
            $: 10,
            a: n
        };
    }, rc = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ac = function(n) {
        return {
            $: 25,
            a: n
        };
    }, ic = {
        $: 24
    }, uc = F2(function(n, e) {
        return e.$ ? yt : n(e.a);
    }), cc = E, oc = function(n) {
        for(var e = n.length, t = Array(e), r = 0; e > r;){
            var a = n.charCodeAt(r);
            55296 > a || a > 56319 ? (t[e - r] = n[r], r++) : (t[e - r] = n[r + 1], t[e - ++r] = n[r - 1], r++);
        }
        return t.join("");
    };
    function sc() {
        return F3(function(n, e, t) {
            n: for(;;){
                if (!t.b) return A2(tt, oc(e), n);
                switch(t.a){
                    case '"':
                        var r = t.b;
                        return A3(fc(), n, e, r);
                    case "\\":
                        if (t.b.b) {
                            var a = t.b, i = a.a;
                            return r = a.b, A3(sc(), n, A2(cc, i, e), r);
                        }
                        break n;
                    default:
                        break n;
                }
            }
            return i = t.a, r = t.b, A3(sc(), n, A2(cc, i, e), r);
        });
    }
    function fc() {
        return F3(function(n, e, t) {
            if (!t.b) return "" !== e ? A2(tt, oc(e), n) : n;
            switch(t.a){
                case ".":
                    var r = t.b;
                    return A3(fc(), A2(tt, oc(e), n), "", r);
                case '"':
                    return r = t.b, A3(sc(), n, "", r);
                default:
                    var a = t.a;
                    return r = t.b, A3(fc(), n, A2(cc, a, e), r);
            }
        });
    }
    var lc = sc();
    sc = function() {
        return lc;
    };
    var dc = fc();
    fc = function() {
        return dc;
    };
    var bc = F3(function(n, e, t) {
        return e(n(t));
    }), hc = L, gc = function(n) {
        return A3(hc, tt, v, n);
    }, vc = A2(bc, gc, A2(bc, A2(dc, v, ""), _t)), pc = F2(function(n, e) {
        return A5(Eu, e.aX, e.az, e.aP, e.aJ, n(e.bC));
    }), mc = F2(function(n, e) {
        var t = e;
        return function(e) {
            var r = e.aJ, a = e.aP, i = e.az, u = e.aX;
            return A2(Gr, pc(e.bC), t(A5(Eu, u, i, a, r, n)));
        };
    }), yc = F2(function(n, e) {
        return function(n) {
            var t = n.bC, r = n.aJ, a = n.aP, i = n.az, u = n.aX;
            if (i.b) {
                var c = i.a, o = i.b, s = e(c);
                if (s.$) return v;
                var f = s.a;
                return y([
                    A5(Eu, A2(tt, c, u), o, a, r, t(f))
                ]);
            }
            return v;
        };
    }), $c = A2(yc, "STRING", Pu), wc = A2(mc, vc, $c), kc = A2(yc, "NUMBER", jr), Cc = F2(function(n, e) {
        return function(t) {
            return e(A2(la, v, A2(au, n, t)));
        };
    }), xc = function(n) {
        return A2(Cc, n, function(n) {
            return n.b && !n.b.b ? jr(n.a) : yt;
        });
    }, jc = F2(function(n, e) {
        return e.b ? A3(Or, tt, e, n) : n;
    }), qc = function(n) {
        return A3(Or, jc, v, n);
    }, Sc = F2(function(n, e) {
        return qc(A2(Gr, n, e));
    }), Ic = function(n) {
        return function(e) {
            return A2(Sc, function(n) {
                return n(e);
            }, n);
        };
    }, Tc = y([
        0,
        1,
        2,
        3
    ]), Ac = function(n) {
        switch(n){
            case 0:
                return "config";
            case 1:
                return "legacy";
            case 2:
                return "onPush";
            default:
                return "onSchedule";
        }
    }, Ec = function(n) {
        return n.b ? mt(n.a) : yt;
    }, Nc = F3(function(n, e, t) {
        return Ec(A2(gu, function(e) {
            return u(n(e), t) ? mt(e) : yt;
        }, e));
    }), Lc = A2(Nc, Ac, Tc), Pc = function(n) {
        return A2(Cc, n, function(n) {
            return n.b && !n.b.b ? ba(n.a) : yt;
        });
    }, Dc = F2(function(n, e) {
        var t = n, r = e;
        return function(n) {
            return A2(Sc, r, t(n));
        };
    }), Oc = F2(function(n, e) {
        return A2(Dc, n, function(n) {
            var e = n;
            return function(n) {
                var t = n.aP;
                return y([
                    A5(Eu, n.aX, n.az, t, n.aJ, (0, n.bC)(e(t)))
                ]);
            };
        }(e));
    }), Gc = function(n) {
        return function(e) {
            var t = e.bC, r = e.aJ, a = e.aP, i = e.az, c = e.aX;
            if (i.b) {
                var o = i.a, s = i.b;
                return u(o, n) ? y([
                    A5(Eu, A2(tt, o, c), s, a, r, t)
                ]) : v;
            }
            return v;
        };
    }, _c = y([
        0,
        1,
        2,
        4,
        3
    ]), Fc = function(n) {
        switch(n){
            case 0:
                return "nix-darwin";
            case 1:
                return "nixops";
            case 2:
                return "terraform";
            case 3:
                return "manually";
            default:
                return "nixos";
        }
    }, Rc = A2(Nc, Fc, _c), Bc = y([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]), Hc = function(n) {
        switch(n){
            case 0:
                return "pick-os";
            case 1:
                return "deploy";
            case 2:
                return "cachix";
            case 3:
                return "token";
            case 4:
                return "configure";
            case 5:
                return "target";
            default:
                return "test";
        }
    }, Vc = A2(Nc, Hc, Bc), zc = function(n) {
        return A2(Cc, n, function(n) {
            return n.b && !n.b.b ? mt(n.a) : yt;
        });
    }, Uc = function(n) {
        return y([
            n
        ]);
    }, Wc = Ic(y([
        A2(mc, F2(function(n, e) {
            return {
                C: A2(uc, Rc, e),
                G: A2(la, 0, A2(uc, Vc, n))
            };
        }), A2(Oc, A2(Oc, Uc, zc("step")), zc("deployMethod"))),
        A2(mc, {
            C: yt,
            G: 0
        }, Gc("pick-os")),
        A2(mc, {
            C: mt(0),
            G: 1
        }, Gc("darwin")),
        A2(mc, {
            C: mt(0),
            G: 2
        }, Gc("darwin-cachix")),
        A2(mc, {
            C: mt(0),
            G: 6
        }, Gc("darwin-test")),
        A2(mc, {
            C: mt(1),
            G: 6
        }, Gc("linux-test")),
        A2(mc, {
            C: mt(1),
            G: 2
        }, Gc("linux-cachix")),
        A2(mc, {
            C: mt(1),
            G: 3
        }, Gc("generate-token")),
        A2(mc, {
            C: mt(1),
            G: 4
        }, Gc("bootstrap")),
        A2(mc, {
            C: mt(1),
            G: 5
        }, Gc("target")),
        A2(mc, {
            C: mt(1),
            G: 1
        }, Gc("deploy")),
        A2(mc, {
            C: mt(1),
            G: 6
        }, Gc("nixops-test"))
    ])), Kc = A2(yc, "STRING", mt), Zc = Kc, Yc = A2(yc, "UUID", ba), Mc = Ic(y([
        A2(mc, Wu, Gc("dashboard")),
        A2(mc, F3(function(n, e, t) {
            return function(n) {
                return {
                    $: 12,
                    a: n
                };
            }({
                fs: n,
                c8: e,
                hc: t
            });
        }), A2(Dc, Gc("dashboard"), A2(Dc, Gc("installation-return"), A2(Oc, A2(Oc, Yc, xc("installation_id")), zc("setup_action"))))),
        A2(mc, F2(function(n, e) {
            return Ru({
                cq: e,
                dC: n
            });
        }), A2(Dc, Gc("accounts"), A2(Dc, Zc, A2(Dc, Kc, Gc("settings"))))),
        A2(mc, F4(function(n, e, t, r) {
            return Fu({
                cq: e,
                eZ: !1,
                a9: t,
                dC: n,
                eb: 0,
                dS: r
            });
        }), A2(Dc, Gc("accounts"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("derivations"), A2(Oc, $c, Pc("via-job"))))))),
        A2(mc, F4(function(n, e, t, r) {
            return Fu({
                cq: e,
                eZ: !1,
                a9: t,
                dC: n,
                eb: 1,
                dS: r
            });
        }), A2(Dc, Gc("accounts"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("derivations"), A2(Dc, $c, A2(Oc, Gc("log"), Pc("via-job")))))))),
        A2(mc, F4(function(n, e, t, r) {
            return Fu({
                cq: e,
                eZ: !0,
                a9: t,
                dC: n,
                eb: 0,
                dS: r
            });
        }), A2(Dc, Gc("accounts"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("dependencies"), A2(Oc, $c, Pc("via-job"))))))),
        A2(mc, F2(function(n, e) {
            return _u({
                cq: e,
                ia: 0,
                dC: n
            });
        }), A2(Dc, Gc("accounts"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("default-cluster"), Gc("tasks")))))),
        A2(mc, F2(function(n, e) {
            return zu({
                cq: e,
                dC: n
            });
        }), A2(Dc, Gc("agents"), A2(Dc, Zc, Kc))),
        A2(mc, F3(function(n, e, t) {
            return Bu({
                cq: e,
                fL: t,
                dC: n
            });
        }), A2(Dc, Gc("agents"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("agent"), Kc))))),
        A2(mc, F3(function(n, e, t) {
            return Vu({
                cq: e,
                dC: n,
                bw: t
            });
        }), A2(Dc, Gc("agents"), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Gc("setup"), Wc))))),
        A2(mc, F2(function(n, e) {
            return Hu({
                cq: e,
                dC: n
            });
        }), A2(Dc, Gc("agents"), A2(Dc, Zc, A2(Dc, Kc, Gc("setup"))))),
        A2(mc, F2(function(n, e) {
            return Uu({
                cq: e,
                dC: n
            });
        }), A2(Oc, A2(Oc, Gc("billing"), zc("site")), zc("account"))),
        A2(mc, function(n) {
            return {
                $: 9,
                a: {
                    ga: A2(la, "", n)
                }
            };
        }, A2(Dc, Gc("settings"), A2(Dc, Gc("cli"), A2(Oc, Gc("authorize"), zc("token"))))),
        A2(mc, ec, Gc("settings")),
        A2(mc, nc, A2(Dc, Gc("settings"), Gc("notifications"))),
        A2(mc, Xu, A2(Dc, Gc("settings"), Gc("appearance"))),
        A2(mc, ic, Gc("terms")),
        A2(mc, Zu({}), A2(Dc, Gc("install"), Gc("gitlab"))),
        A2(mc, function(n) {
            return Ku({
                c8: n
            });
        }, A2(Dc, Gc("install"), A2(Dc, Gc("gitlab"), A2(Dc, Gc("continue"), Yc)))),
        A2(mc, function(n) {
            return ac({
                gV: n
            });
        }, A2(Oc, Gc("signin"), zc("redirect"))),
        A2(mc, F2(function(n, e) {
            return Gu({
                cq: e,
                dC: n
            });
        }), A2(Dc, Zc, Kc)),
        A2(mc, F3(function(n, e, t) {
            return tc({
                cq: e,
                gC: yt,
                br: t,
                dC: n
            });
        }), A2(Dc, Zc, A2(Dc, Kc, Kc))),
        A2(mc, F3(function(n, e, t) {
            return rc({
                cq: e,
                br: t,
                dC: n
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, Gc("states"))))),
        A2(mc, F4(function(n, e, t, r) {
            return tc({
                cq: e,
                gC: r,
                br: t,
                dC: n
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Oc, Gc("jobs"), xc("page")))))),
        A2(mc, F4(function(n, e, t, r) {
            return Yu({
                cq: e,
                ab: r,
                br: t,
                dC: n
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Dc, Gc("jobs"), kc))))),
        A2(mc, F5(function(n, e, t, r, a) {
            return Mu({
                cq: e,
                ew: a,
                ab: r,
                br: t,
                dC: n
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Dc, Gc("jobs"), A2(Dc, kc, A2(Oc, Gc("compare"), Pc("baseId")))))))),
        A2(mc, F5(function(n, e, t, r, a) {
            return Ju({
                cq: e,
                a2: a,
                ab: r,
                br: t,
                dC: n,
                eb: 0
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Dc, Gc("jobs"), A2(Dc, kc, A2(Dc, Gc("effects"), wc))))))),
        A2(mc, F5(function(n, e, t, r, a) {
            return Ju({
                cq: e,
                a2: a,
                ab: r,
                br: t,
                dC: n,
                eb: 1
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Dc, Gc("jobs"), A2(Dc, kc, A2(Dc, Gc("effects"), A2(Dc, wc, Gc("log"))))))))),
        A2(mc, F5(function(n, e, t, r, a) {
            return Qu({
                cq: e,
                n: a,
                br: t,
                dC: n,
                W: A2(uc, Lc, r)
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, A2(Dc, Gc("jobs"), A2(Oc, A2(Oc, Gc("latest"), zc("type")), zc("name"))))))),
        A2(mc, F3(function(n, e, t) {
            return Qu({
                cq: e,
                n: yt,
                br: t,
                dC: n,
                W: yt
            });
        }), A2(Dc, Zc, A2(Dc, Kc, A2(Dc, Kc, Gc("status")))))
    ])), Jc = function(n) {
        return A2(la, {
            $: 23,
            a: {
                hB: n
            }
        }, A2(Ou, Mc, n));
    }, Qc = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Xc = Qc, no = dn(function(n) {
        n(ln(A2(Xc, -(new Date).getTimezoneOffset(), v)));
    }), eo = Au(v), to = d({
        cQ: 0
    }, eo), ro = En, ao = F3(function(n, e, t) {
        return n(e(t));
    }), io = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, co = {
        $: 2
    }, oo = {
        $: 1
    }, so = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fo = Q, lo = F2(function(n, e) {
        var t = A2(fo, n, e);
        return t.$ ? lt(so(Rt(t.a))) : gt(t.a);
    }), bo = F2(function(n, e) {
        switch(e.$){
            case 0:
                return lt(uo(e.a));
            case 1:
                return lt(oo);
            case 2:
                return lt(co);
            case 3:
                return lt(io(e.a.jL));
            default:
                var t = e.b;
                if (Cr(t)) {
                    var r = A2(fo, n, "{}");
                    return r.$ ? A2(lo, n, t) : gt(r.a);
                }
                return A2(lo, n, t);
        }
    }), ho = F2(function(n, e) {
        return A3(Ve, "", gr, A2(bc, e, n));
    }), go = F2(function(n, e) {
        return e.$ ? lt(n(e.a)) : gt(e.a);
    }), vo = F3(function(n, e, t) {
        return A2(ho, e, A2(ao, go(n), bo(t)));
    }), po = function(n) {
        return n.a + "=" + n.b;
    }, mo = function(n) {
        return n.b ? "?" + A2(xt, "&", A2(Gr, po, n)) : "";
    }, yo = F3(function(n, e, t) {
        return n + "/" + (A2(xt, "/", e) + mo(t));
    }), $o = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wo = F2(function(n, e) {
        return {
            g_: n,
            hm: e
        };
    }), ko = Lr(A2(wo, va, v)), Co = function(n) {
        return dn(function(e) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, e(ln(l));
        });
    }, xo = pn, jo = F3(function(n, e, t) {
        n: for(;;){
            if (e.b) {
                var r = e.a, a = e.b;
                if (r.$) {
                    var i = r.a;
                    return A2(_r, function(e) {
                        var r = i.bA;
                        return A3(jo, n, a, 1 === r.$ ? t : A3(wa, r.a, e, t));
                    }, xo(A3(Be, n, Hr(n), i)));
                }
                var u = r.a, c = A2(au, u, t);
                if (1 === c.$) {
                    e = a;
                    continue n;
                }
                return A2(_r, function() {
                    return A3(jo, n, a, A2(lu, u, t));
                }, Co(c.a));
            }
            return Lr(t);
        }
    }), qo = F4(function(n, e, t, r) {
        return A2(_r, function(n) {
            return Lr(A2(wo, n, t));
        }, A3(jo, n, e, r.g_));
    }), So = F4(function(n, e, t, r) {
        var a = r.b;
        return u(e, r.a) ? mt(A2(Hr, n, a(t))) : yt;
    }), Io = F3(function(n, e, t) {
        return A2(_r, function() {
            return Lr(t);
        }, Br(A2(gu, A3(So, n, e.a, e.b), t.hm)));
    }), To = F2(function(n, e) {
        if (e.$) {
            var t = e.a;
            return $o({
                hY: t.hY,
                aD: t.aD,
                ir: A2(ze, n, t.ir),
                M: t.M,
                aO: t.aO,
                ay: t.ay,
                bA: t.bA,
                hB: t.hB
            });
        }
        return {
            $: 0,
            a: e.a
        };
    }), Ao = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    });
    xn.Http = jn(ko, qo, Io, To, F2(function(n, e) {
        return A2(Ao, e.a, A2(bc, e.b, n));
    }));
    var Eo, No = Tn("Http"), Lo = Tn("Http"), Po = function(n) {
        return No($o({
            hY: !1,
            aD: n.aD,
            ir: n.ir,
            M: n.M,
            aO: n.aO,
            ay: n.ay,
            bA: n.bA,
            hB: n.hB
        }));
    }, Do = F2(function(n, e) {
        var t = e;
        return Po({
            aD: t.aD,
            ir: n(t.bR),
            M: t.M,
            aO: t.aO,
            ay: t.ay,
            bA: t.bA,
            hB: A3(yo, t.a3, t.cd, t.cf)
        });
    }), Oo = F3(function(n, e, t) {
        return A2(Do, A2(vo, n, e), t);
    }), Go = F2(function(n, e) {
        return A3(Oo, gr, n, e);
    }), _o = F2(function(n, e) {
        return h(e, {
            a3: n
        });
    }), Fo = F3(function(n, e, t) {
        return A2(Go, t, A2(_o, n, e));
    }), Ro = F3(function(n, e, t) {
        var r = Jc(e), a = to.b;
        return d({
            aZ: 0,
            hV: Qr,
            bI: 0,
            r: Xr,
            a4: to.a,
            h9: Qr,
            c_: n,
            iK: t,
            ci: r,
            ck: !1,
            by: 2,
            jS: yt,
            hB: e,
            hD: Qr
        }, Au(y([
            A3(Fo, n.hZ, A2(qu, yt, yt), Mr),
            A3(Fo, n.hZ, Tu, Jr),
            A2(ro, Yr, a),
            A2(Kr, na, no)
        ])));
    }), Bo = V, Ho = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Vo = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zo = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Uo = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Wo = An, Ko = _n("configuredTheme", Sa(y([
        qa(yt),
        A2(lr, mt, ta)
    ]))), Zo = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Yo = F2(function(n, e) {
        return {
            gQ: e,
            hu: n
        };
    }), Mo = Lr(A2(Yo, va, va)), Jo = F2(function(n, e) {
        var t = n.a, r = n.b, a = A2(au, t, e);
        return A3(wa, t, 1 === a.$ ? y([
            r
        ]) : A2(tt, r, a.a), e);
    }), Qo = F3(function(n, e, t) {
        for(;;){
            if (-2 === t.$) return e;
            var r = t.e, a = n, i = A3(n, t.b, t.c, A3(Qo, n, e, t.d));
            n = a, e = i, t = r;
        }
    }), Xo = F6(function(n, e, t, r, a, i) {
        var u = A3(Qo, F3(function(r, a, i) {
            n: for(;;){
                var u = i.a, c = i.b;
                if (u.b) {
                    var o = u.a, f = o.a, l = o.b, b = u.b;
                    if (0 > s(f, r)) {
                        i = d(b, A3(n, f, l, c));
                        continue n;
                    }
                    return s(f, r) > 0 ? d(u, A3(t, r, a, c)) : d(b, A4(e, f, l, a, c));
                }
                return d(u, A3(t, r, a, c));
            }
        }), d(ut(r), i), a), c = u.a, o = u.b;
        return A3(St, F2(function(e, t) {
            return A3(n, e.a, e.b, t);
        }), o, c);
    }), ns = Ke, es = F3(function(n, e, t) {
        if (e.b) {
            var r = e.a, a = e.b, i = xo(A2(ns, r, A2(ru, n, r)));
            return A2(_r, function(e) {
                return A3(es, n, a, A3(wa, r, e, t));
            }, i);
        }
        return Lr(t);
    }), ts = F3(function(n, e, t) {
        var r = t.gQ, a = F3(function(n, e, t) {
            var r = t.c;
            return b(t.a, t.b, A2(_r, function() {
                return r;
            }, Co(e)));
        }), i = A3(St, Jo, va, e), u = A6(Xo, F3(function(n, e, t) {
            var r = t.b, a = t.c;
            return b(A2(tt, n, t.a), r, a);
        }), F4(function(n, e, t, r) {
            var a = r.c;
            return b(r.a, A3(wa, n, t, r.b), a);
        }), a, i, r, b(v, va, Lr(0))), c = u.a, o = u.b;
        return A2(_r, function(n) {
            return Lr(A2(Yo, i, n));
        }, A2(_r, function() {
            return A3(es, n, c, o);
        }, u.c));
    }), rs = (Eo = ti, dn(function(n) {
        n(ln(Eo(Date.now())));
    }));
    xn.Time = jn(Mo, ts, F3(function(n, e, t) {
        var r = A2(au, e, t.hu);
        if (1 === r.$) return Lr(t);
        var a = r.a;
        return A2(_r, function() {
            return Lr(t);
        }, A2(_r, function(e) {
            return Br(A2(Gr, function(t) {
                return A2(Hr, n, t(e));
            }, a));
        }, rs));
    }), 0, F2(function(n, e) {
        return A2(Zo, e.a, A2(ao, n, e.b));
    }));
    var as, is, us, cs, os, ss, fs, ls, ds, bs, hs, gs, vs, ps, ms, ys = Tn("Time"), $s = F2(function(n, e) {
        return ys(A2(Zo, n, e));
    }), ws = En, ks = Wo(v), Cs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xs = function(n) {
        return {
            $: 3,
            a: n
        };
    }, js = function(n) {
        return {
            $: 12,
            a: n
        };
    }, qs = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ss = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Is = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ts = function(n) {
        return {
            $: 19,
            a: n
        };
    }, As = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Es = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ns = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Ls = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Ps = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ds = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Os = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Gs = {
        $: 7
    }, _s = {
        $: 8
    }, Fs = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Rs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bs = {
        $: 0
    }, Hs = F2(function(n, e) {
        switch(e.$){
            case 3:
                return n(e.a);
            case 2:
                return Rs(e.a);
            case 0:
                return Bs;
            default:
                return Qr;
        }
    }), Vs = function(n) {
        return A2(Hs, function(e) {
            return A2(Hs, function(n) {
                return Fs({
                    cq: e,
                    ih: n
                });
            }, n.ih.ie);
        }, n.cq);
    }, zs = F2(function(n, e) {
        var t = Vs(e);
        return 3 === t.$ ? 5 === t.a.ih.V ? ks : Wo(y([
            A2($s, 5e3, function() {
                return Gs;
            }),
            A2($s, 1e3, function() {
                return _s;
            })
        ])) : ks;
    }), Us = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ws = F2(function() {
        return A2($s, 5e3, Us);
    }), Ks = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Zs = _n("paddleSubscriptionSucceeded", Ia), Ys = F2(function() {
        return ks;
    }), Ms = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Js = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qs = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xs = function() {
        return A2($s, 3e3, Qs);
    }, nf = A2(bc, ut, Sc(function(n) {
        var e = n.b, t = ba(n.a);
        return t.$ ? v : y([
            d(t.a, e)
        ]);
    })), ef = F2(function() {
        return ks;
    }), tf = F2(function() {
        return ks;
    }), rf = {
        $: 1
    }, af = {
        $: 2
    }, uf = F2(function() {
        return Wo(y([
            A2($s, 1e3, function() {
                return rf;
            }),
            A2($s, 3e4, function() {
                return af;
            })
        ]));
    }), cf = function(n) {
        return {
            $: 10,
            a: n
        };
    }, of = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sf = {
        $: 8
    }, ff = {
        $: 9
    }, lf = function(n) {
        return A2(Hs, function(e) {
            return A2(Hs, function(t) {
                return A2(Hs, function(n) {
                    return Fs({
                        cq: e,
                        j: t,
                        as: n.b
                    });
                }, n.aN);
            }, n.j.ie);
        }, n.cq);
    }, df = F2(function(n, e) {
        var t = lf(e);
        return 3 === t.$ ? 4 === t.a.j.V ? ks : Wo(y([
            A2($s, 5e3, function() {
                return sf;
            }),
            A2($s, 1e3, function() {
                return ff;
            })
        ])) : ks;
    }), bf = F2(function() {
        return ks;
    }), hf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vf = A2(bc, ut, Sc(function(n) {
        var e = n.b, t = ba(n.a);
        return t.$ ? v : y([
            d(t.a, e)
        ]);
    })), pf = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), mf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yf = F2(function(n, e) {
        return Lo(A2(Ao, n, e));
    }), $f = F2(function(n, e) {
        var t = e.gC;
        switch(t.$){
            case 10:
                return A2(ws, Cs, A2(zs, n, t.a));
            case 2:
                return A2(ws, xs, A2(Ws, n, t.a));
            case 6:
                return A2(ws, Ns, A2(df, n, t.a));
            case 7:
                return A2(ws, Ls, A2(bf, n, t.a));
            case 9:
            case 13:
            case 15:
            case 14:
            case 12:
            case 16:
            case 17:
            case 18:
                return ks;
            case 11:
                return A2(ws, qs, A2(Ys, n, t.a));
            case 0:
                return A2(ws, Ss, function(n) {
                    var e = A2(Gr, function(n) {
                        var e = n.a;
                        return A2(ws, function(n) {
                            return Ms({
                                bF: e,
                                bG: n
                            });
                        }, Xs());
                    }, nf(n.hV));
                    return Wo(A2(tt, A2($s, 3e3, Js), e));
                }(t.a));
            case 1:
                return A2(ws, Ds, function(n) {
                    var e = A2(Gr, function(n) {
                        var e = n.a;
                        return A2(ws, function(n) {
                            return hf({
                                bF: e,
                                bG: n
                            });
                        }, Xs());
                    }, vf(n.hV));
                    return Wo(A2(tt, A2($s, 3e3, gf), e));
                }(t.a));
            case 3:
                return A2(ws, Os, function(n) {
                    var e;
                    return Wo(A2(tt, A2($s, 1e4, mf), 2 === (e = n.z).$ ? A2(Gr, function(n) {
                        return A2(yf, n, pf(n));
                    }, ct(e.a)) : v));
                }(t.a));
            case 4:
                return A2(ws, Ps, A2($s, 5e3, cf));
            case 5:
                return A2(ws, Es, A2($s, 3e4, of));
            case 8:
                return A2(ws, js, Zs(Ks));
            case 19:
                return A2(ws, As, A2(uf, n, t.a));
            case 20:
                return A2(ws, Ts, A2(tf, n, t.a));
            default:
                return A2(ws, Is, A2(ef, n, t.a));
        }
    }), wf = _n("systemTheme", aa), kf = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Cf = function(n) {
        return {
            $: 10,
            a: n
        };
    }, xf = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jf = F2(function(n, e) {
        return A3(Ve, "arraybuffer", Ue, A2(bc, e, n));
    }), qf = F2(function(n, e) {
        switch(e.$){
            case 0:
                return lt(uo(e.a));
            case 1:
                return lt(oo);
            case 2:
                return lt(co);
            case 3:
                return lt(io(e.a.jL));
            default:
                return A2(go, so, n(e.b));
        }
    }), Sf = function(n) {
        return A2(jf, n, qf(function() {
            return gt(0);
        }));
    }, If = function(n) {
        return 1 === n.$ ? Rs(n.a) : Fs(n.a);
    }, Tf = function(n) {
        return A2(Kr, Nr, dn(function() {
            try {
                Ae.location = n;
            } catch (n) {
                Vn.location.reload(!1);
            }
        }));
    }, Af = F2(function(n, e) {
        switch(e.$){
            case 3:
                return Fs(n(e.a));
            case 1:
                return Qr;
            case 0:
                return Bs;
            default:
                return Rs(e.a);
        }
    }), Ef = Ie, Nf = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Lf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pf = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Df = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Of = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Gf = function(n) {
        return {
            $: 11,
            a: n
        };
    }, _f = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ff = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Rf = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Bf = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Hf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Vf = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zf = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Uf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Wf = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Kf = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Zf = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Yf = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Mf = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Jf = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Qf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nl = F2(function(n, e) {
        return A3(Or, F2(function(e, t) {
            return n(e) ? A2(tt, e, t) : t;
        }), v, e);
    }), el = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), tl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rl = {
        $: 1
    }, al = {
        $: 0
    }, il = {
        $: 13
    }, ul = {
        $: 0
    }, cl = function(n) {
        return {
            $: 14,
            a: n
        };
    }, ol = {
        $: 3
    }, sl = {
        $: 15
    }, fl = {
        C: yt,
        G: 0
    }, ll = tl(fl), dl = F2(function(n, e) {
        for(;;){
            if (!e.b) return yt;
            var t = e.a, r = e.b;
            if (n(t)) return mt(t);
            e = r;
        }
    }), bl = F2(function(n, e) {
        return A2(dl, function(n) {
            return u(n.ax, e);
        }, n.hV);
    }), hl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gl = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), vl = va, pl = F2(function(n, e) {
        return Ec(A2(nl, function(n) {
            return u(n.hf, e.dC) && u(n.ax, e.cq);
        }, n.hV));
    }), ml = {
        ie: Qr,
        ao: Qr
    }, yl = function(n) {
        return d(n, eo);
    }, $l = F3(function(n, e, t) {
        return A2(Go, t, A2(_o, n.c_.hZ, e));
    }), wl = F3(function(n, e, t) {
        return A3($l, n, A2(qu, mt(e.dC), mt(e.cq)), A2(ao, t, If));
    }), kl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Cl = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), xl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jl = function(n) {
        return n;
    }, ql = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/cancel", y([
            d("accountId", n),
            d("derivationPath", e)
        ]), v, v, yt, br(0));
    }), Sl = F3(function(n, e, t) {
        return {
            e6: t,
            c: n,
            f8: e
        };
    }), Il = F3(function(n, e, t) {
        return {
            fN: n,
            gl: e,
            ht: t
        };
    }), Tl = A3(ua, "t", ta, A3(ua, "ms", Bo, A3(ua, "i", Bo, br(Il)))), Al = A3(ua, "done", aa, A3(ua, "lines", Ki(Tl), A3(ua, "id", ha, br(Sl)))), El = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, Nl = F5(function(n, e, t, r, a) {
        return A7(ju, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/log/lines", y([
            d("accountId", n),
            d("derivationPath", e)
        ]), y([
            d("logId", mt(t)),
            d("iMin", A2(Zi, Ct, r)),
            d("verbosity", A2(Zi, El, a))
        ]), v, yt, Al);
    }), Ll = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/retry", y([
            d("accountId", n),
            d("derivationPath", e)
        ]), v, v, yt, br(0));
    }), Pl = F2(function(n, e) {
        return "/" + (A2(xt, "/", n) + mo(e));
    }), Dl = F2(function(n, e) {
        return A2(Pl, A2(Gr, ku, n), e);
    }), Ol = sa("^[a-zA-Z_][a-zA-Z0-9_'-]*$"), Gl = 1 === Ol.$ ? function() {
        return !1;
    } : ca(Ol.a), _l = A2(bc, Gr(function(n) {
        return Gl(n) ? n : function(n) {
            return '"' + A3(yu, '"', '\\"', A3(yu, "\\", "\\\\", n)) + '"';
        }(n);
    }), xt(".")), Fl = F2(function(n, e) {
        return A2(wu, ku(n), Ct(e));
    }), Rl = function(n) {
        return 1 === n.$ ? v : y([
            n.a
        ]);
    }, Bl = F2(function(n, e) {
        return A2(Gr, n, Rl(e));
    }), Hl = function(n) {
        var e, t, r, a = function(n) {
            return y([
                "accounts",
                n.dC,
                n.cq
            ]);
        };
        switch(n.$){
            case 0:
                return A2(Pl, y([
                    "dashboard"
                ]), v);
            case 1:
                return A2(Pl, y([
                    (u = n.a).dC,
                    u.cq
                ]), v);
            case 2:
                return A2(Pl, g(a(u = n.a), y([
                    "settings"
                ])), v);
            case 3:
                if ((u = n.a).eZ) return A2(Dl, g(a(u), y([
                    "dependencies",
                    u.a9
                ])), A2(Bl, A2(ao, Cu("via-job"), jl), u.dS));
                var i = u.eb;
                return A2(Dl, g(a(u), y(i ? [
                    "derivations",
                    u.a9,
                    "log"
                ] : [
                    "derivations",
                    u.a9
                ])), A2(Bl, A2(ao, Cu("via-job"), jl), u.dS));
            case 6:
                return A2(Pl, y([
                    "agents",
                    (u = n.a).dC,
                    u.cq
                ]), v);
            case 4:
                return A2(Pl, g(a(u = n.a), y([
                    "default-cluster",
                    "tasks"
                ])), v);
            case 5:
                return A2(Pl, y([
                    "agents",
                    (u = n.a).dC,
                    u.cq,
                    "agent",
                    u.fL
                ]), v);
            case 7:
                return A2(Pl, y([
                    "agents",
                    (u = n.a).dC,
                    u.cq,
                    "setup"
                ]), v);
            case 8:
                return A2(Pl, y([
                    "agents",
                    (u = n.a).dC,
                    u.cq,
                    "setup"
                ]), (r = u.bw, g(A2(Bl, A2(ao, Cu("deployMethod"), Fc), r.C), y([
                    A2(Cu, "step", Hc(r.G))
                ]))));
            case 9:
                var u = n.a;
                return A2(Pl, y([
                    "settings",
                    "cli",
                    "authorize"
                ]), y([
                    A2(Cu, "token", u.ga)
                ]));
            case 10:
                var c = (u = n.a).gC;
                if (1 === c.$) return A2(Pl, y([
                    u.dC,
                    u.cq,
                    u.br
                ]), v);
                var o = c.a;
                return A2(Pl, y([
                    u.dC,
                    u.cq,
                    u.br,
                    "jobs"
                ]), y([
                    A2(Fl, "page", o)
                ]));
            case 11:
                return A2(Pl, y([
                    (u = n.a).dC,
                    u.cq,
                    u.br,
                    "states"
                ]), v);
            case 13:
                return A2(Pl, y([
                    (u = n.a).dC,
                    u.cq,
                    u.br,
                    "jobs",
                    Ct(u.ab)
                ]), v);
            case 15:
                return A2(Pl, y([
                    (u = n.a).dC,
                    u.cq,
                    u.br,
                    "jobs",
                    Ct(u.ab),
                    "compare"
                ]), (t = u.ew).$ ? v : y([
                    A2(Cu, "baseId", t.a)
                ]));
            case 16:
                return A2(Pl, y((u = n.a).eb ? [
                    u.dC,
                    u.cq,
                    u.br,
                    "jobs",
                    Ct(u.ab),
                    "effects",
                    ku(_l(u.a2)),
                    "log"
                ] : [
                    u.dC,
                    u.cq,
                    u.br,
                    "jobs",
                    Ct(u.ab),
                    "effects",
                    ku(_l(u.a2))
                ]), v);
            case 14:
                return A2(Pl, y([
                    (u = n.a).dC,
                    u.cq,
                    u.br,
                    "jobs",
                    "latest"
                ]), g(A2(Bl, A2(ao, Cu("type"), Ac), u.W), A2(Bl, Cu("name"), u.n)));
            case 17:
                return u = n.a, A2(Pl, y([
                    "billing"
                ]), g(A2(Bl, Cu("site"), u.dC), A2(Bl, Cu("account"), u.cq)));
            case 18:
                return A2(Pl, y([
                    "settings"
                ]), v);
            case 19:
                return A2(Pl, y([
                    "settings",
                    "notifications"
                ]), v);
            case 20:
                return A2(Pl, y([
                    "settings",
                    "appearance"
                ]), v);
            case 23:
                return A2(Pl, v, v);
            case 24:
                return A2(Pl, y([
                    "terms"
                ]), v);
            case 12:
                return A2(Pl, y([
                    "dashboard",
                    "installation-return",
                    (u = n.a).fs
                ]), y([
                    A2(Fl, "installation_id", A2(la, 0, u.c8)),
                    A2(Cu, "setup_action", A2(la, "", u.hc))
                ]));
            case 21:
                return A2(Pl, y([
                    "install",
                    "gitlab"
                ]), v);
            case 22:
                return A2(Pl, y([
                    "install",
                    "gitlab",
                    "continue",
                    n.a.c8
                ]), v);
            default:
                return u = n.a, A2(Pl, y([
                    "signin"
                ]), (e = u.gV).$ ? v : y([
                    A2(Cu, "redirect", e.a)
                ]));
        }
    }, Vl = F2(function(n, e) {
        return A2(Ef, n, Hl(e));
    }), zl = F2(function(n, e) {
        return A3(Qo, F3(function(n, e, t) {
            return A2(lu, n, t);
        }), n, e);
    }), Ul = F2(function(n, e) {
        return A2(zl, n, e);
    }), Wl = A2(bc, Gr(function(n) {
        var e = n.a;
        return d(e, d(e, n.b));
    }), A2(bc, ka, gr)), Kl = function(n) {
        return n.b;
    }, Zl = F2(function(n, e) {
        return A2(Zi, Kl, A2(au, n, e));
    }), Yl = function(n) {
        return function(e) {
            var t = e.b;
            return d(n(e.a), t);
        };
    }, Ml = {
        $: 12
    }, Jl = hn, Ql = F2(function(n, e) {
        return Wr(A2(Jl, A2(ao, A2(ao, Lr, n), lt), A2(_r, A2(ao, A2(ao, Lr, n), gt), e)));
    }), Xl = Ne, nd = F2(function(n, e) {
        return A2(Ql, function() {
            return e;
        }, A2(_r, function(e) {
            return A3(Xl, n, 0, e.jD.iz);
        }, function(n) {
            return Ee(n, function(n) {
                return {
                    jD: {
                        hR: n.scrollWidth,
                        iz: n.scrollHeight
                    },
                    hK: {
                        hS: n.scrollLeft,
                        hT: n.scrollTop,
                        hR: n.clientWidth,
                        iz: n.clientHeight
                    }
                };
            });
        }(n)));
    }), ed = F3(function(n, e, t) {
        return n ? A2(nd, e, t) : eo;
    }), td = F2(function(n, e) {
        return A3(ed, A2(la, !0, A2(au, e, n.aT)), e, Ml);
    }), rd = F2(function(n, e) {
        if (3 !== n.ie.$) return h(n, {
            ie: e,
            ao: Bs
        });
        switch(e.$){
            case 3:
                return h(n, {
                    ie: e,
                    ao: Bs
                });
            case 1:
                return h(n, {
                    ao: Qr
                });
            default:
                return h(n, {
                    ao: Bs
                });
        }
    }), ad = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return mt(n.a);
            }
            return yt;
        }
    }, id = F2(function(n, e) {
        var t = function() {
            var e = ad(n.f8);
            if (e.$) return function() {
                return !0;
            };
            var t = e.a;
            return function(n) {
                return s(n.fN, t.fN) > 0;
            };
        }();
        return {
            e6: n.e6 || e.e6,
            c: n.c,
            f8: g(n.f8, A2(nl, t, e.f8))
        };
    }), ud = F2(function(n, e) {
        if (3 === n.$) {
            var t = n.a;
            return mt(Fs(e.$ || 3 !== e.a.$ ? t : A2(id, e.a.a, t)));
        }
        return 1 === e.$ || 1 === e.a.$ ? mt(n) : e;
    }), cd = function(n) {
        return A3(it, F3(function(n, e, t) {
            return A2(tt, e, t);
        }), v, n);
    }, od = function(n) {
        return cd(n);
    }, sd = F2(function(n, e) {
        return 3 === e.$ ? e.a : n;
    }), fd = A2(bc, Af(mt), sd(yt)), ld = F3(function(n, e, t) {
        var r = t, a = A2(bc, Zi(Kl), A2(bc, e, Zi(function(e) {
            return d(n, e);
        })));
        return A3(du, n, a, r);
    }), dd = F3(function(n, e, t) {
        var r = A3(St, F2(function(e, t) {
            var r = t.b, a = A2(n, t.a, e);
            return d(a.a, A2(tt, a.b, r));
        }), d(e, v), t);
        return d(r.a, _t(r.b));
    }), bd = F3(function(n, e, t) {
        var r = A3(dd, F2(function(e, t) {
            var r, a = t.a;
            return d((r = A3(n, e, a, t.b)).a, d(a, r.b));
        }), e, od(t));
        return d(r.a, Wl(r.b));
    }), hd = F2(function(n, e) {
        var t = A3(bd, F3(function(e, t, r) {
            var a = A2(n, t, r), i = a.a;
            return d(A2(tt, a.b, e), i);
        }), v, e);
        return d(t.b, Au(t.a));
    }), gd = F2(function(n, e) {
        return 3 === n.$ ? n.a.e6 ? eo : e(A2(Zi, function(n) {
            return n.fN;
        }, ad(n.a.f8))) : eo;
    }), vd = F3(function(n, e, t) {
        var r = A2(hd, F2(function(r, a) {
            return d(a, A2(gd, a, function(a) {
                return A3($l, n, A5(Nl, e.c, ku(t.a9), r, a, yt), A2(ao, Cl(r), If));
            }));
        }), t.al);
        return d(t, r.b);
    }), pd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, md = F2(function(n, e) {
        return {
            dq: e,
            f: n
        };
    }), yd = F5(function(n, e, t, r, a) {
        return {
            fH: t,
            af: n,
            bm: e,
            gW: a,
            dE: r
        };
    }), $d = A4(Aa, "references", Ki(ta), yt, A3(ua, "size", Bo, A3(ua, "hash", ta, A3(ua, "outputPath", ta, A3(ua, "outputName", ta, br(yd)))))), wd = function(n) {
        return Sa(y([
            A2(lr, mt, n),
            br(yt)
        ]));
    }, kd = A3(ua, "outputs", wd(Ki($d)), A3(ua, "time", zi, br(md))), Cd = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), xd = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), jd = F2(function(n, e) {
        return {
            dO: e,
            f: n
        };
    }), qd = A4(Aa, "technicalError", ta, yt, A3(ua, "time", zi, br(jd))), Sd = F2(function(n, e) {
        return {
            eG: e,
            f: n
        };
    }), Id = F6(function(n, e, t, r, a, i) {
        return {
            k: t,
            c: n,
            T: a,
            n: e,
            dC: i,
            W: r
        };
    }), Td = F3(function(n, e, t) {
        return {
            k: t,
            c: n,
            n: e
        };
    }), Ad = A3(ua, "displayName", ta, A3(ua, "name", ta, A3(ua, "id", ha, br(Td)))), Ed = A3(ua, "site", Ad, A3(ua, "imageURL", ta, A3(ua, "typ", ra, A3(ua, "displayName", ta, A3(ua, "name", ta, A3(ua, "id", ha, br(Id))))))), Nd = A4(Aa, "byUser", Ed, yt, A3(ua, "time", zi, br(Sd))), Ld = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Pd = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Dd = F3(function(n, e, t) {
        return {
            g$: t,
            g0: e,
            f: n
        };
    }), Od = F5(function(n, e, t, r, a) {
        return {
            c: n,
            ab: t,
            dt: a,
            br: e,
            V: r
        };
    }), Gd = A2(fr, function(n) {
        switch(n){
            case "Queued":
                return br(0);
            case "Evaluating":
                return br(1);
            case "Building":
                return br(2);
            case "Effects":
                return br(3);
            case "Done":
                return br(4);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), _d = A2(fr, function(n) {
        switch(n){
            case "Pending":
                return br(0);
            case "Failure":
                return br(1);
            case "Success":
                return br(2);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Fd = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            c: n,
            T: a,
            ar: i,
            n: e,
            bn: t
        };
    }), Rd = A3(ua, "isPublic", aa, A4(Aa, "imageURL", ta, yt, A3(ua, "displayName", ta, A3(ua, "owner", Ed, A3(ua, "name", ta, A3(ua, "id", ha, br(Fd))))))), Bd = A3(ua, "phase", Gd, A3(ua, "status", _d, A3(ua, "index", Bo, A3(ua, "project", Rd, A3(ua, "id", ha, br(Od)))))), Hd = A4(Aa, "requeuedForAgent", ta, yt, A4(Aa, "requeuedForEvalOfJob", Bd, yt, A3(ua, "time", zi, br(Dd)))), Vd = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), zd = F4(function(n, e, t, r) {
        return {
            a_: t,
            di: e,
            hj: r,
            f: n
        };
    }), Ud = A3(ua, "streamable", aa, A4(Aa, "agentHostname", ta, yt, A3(ua, "logId", ha, A3(ua, "time", zi, br(zd))))), Wd = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Kd = A4(Aa, "HasCancelledForReset", Pd, yt, A4(Aa, "HasCancelled", Ld, yt, A4(Aa, "Built", kd, yt, A4(Aa, "ForceCancelled", Nd, yt, A4(Aa, "Cancelled", Cd, yt, A4(Aa, "Succeeded", Wd, yt, A4(Aa, "Failed", qd, yt, A4(Aa, "Reset", Vd, yt, A4(Aa, "Started", Ud, yt, A4(Aa, "DependencyFailed", xd, yt, A4(Aa, "Queued", Hd, yt, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    eF: o,
                                                    cA: u,
                                                    cM: e,
                                                    cZ: a,
                                                    fq: c,
                                                    fE: s,
                                                    fF: f,
                                                    dv: n,
                                                    g4: r,
                                                    dI: t,
                                                    dK: i
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Zd = F4(function(n, e, t, r) {
        return {
            a9: e,
            cN: n,
            af: t,
            bm: r
        };
    }), Yd = A2(fr, function(n) {
        switch(n){
            case "NotPlanned":
                return br(0);
            case "Waiting":
                return br(1);
            case "Building":
                return br(2);
            case "BuildFailure":
                return br(3);
            case "DependencyFailure":
                return br(4);
            case "BuildSuccess":
                return br(5);
            case "Cancelled":
                return br(6);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Md = A3(ua, "outputPath", ta, A3(ua, "outputName", ta, A3(ua, "derivationPath", ta, A3(ua, "derivationStatus", Yd, br(Zd))))), Jd = F2(function(n, e) {
        return {
            af: n,
            bm: e
        };
    }), Qd = A4(Aa, "outputPath", ta, yt, A3(ua, "outputName", ta, br(Jd))), Xd = F6(function(n, e, t, r, a, i) {
        return {
            eQ: a,
            fx: r,
            f9: i,
            bl: t,
            dw: e,
            g6: n
        };
    }), nb = A3(ua, "link", ta, A4(Aa, "committer", Wi, yt, A3(ua, "gitCommitterName", ta, A3(ua, "message", ta, A3(ua, "ref", ta, A3(ua, "revision", ta, br(Xd))))))), eb = F2(function(n, e) {
        return {
            fy: n,
            fR: e
        };
    }), tb = F7(function(n, e, t, r, a, i, u) {
        return {
            fJ: u,
            c3: r,
            df: i,
            dw: e,
            gZ: a,
            g5: n,
            dG: t
        };
    }), rb = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            c: n,
            T: a,
            ar: i,
            n: e,
            bn: t
        };
    }), ab = A3(ua, "isPublic", aa, A4(Aa, "imageURL", ta, yt, A3(ua, "displayName", ta, A3(ua, "owner", Ed, A3(ua, "name", ta, A3(ua, "id", ha, br(rb))))))), ib = A4(Aa, "historyURL", ta, yt, A4(Aa, "jobs", Ki(Bd), yt, A4(Aa, "repo", ab, yt, A3(ua, "httpURL", ta, A3(ua, "sshURL", ta, A3(ua, "ref", ta, A3(ua, "rev", ta, br(tb)))))))), ub = A4(Aa, "IgnoreMe", br(v), yt, A4(Aa, "GitInput", ib, yt, br(eb))), cb = A2(fr, function(n) {
        switch(n){
            case "Config":
                return br(0);
            case "Legacy":
                return br(1);
            case "OnPush":
                return br(2);
            case "OnSchedule":
                return br(3);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), ob = A3(ua, "mayRerun", aa, A3(ua, "mayCancel", aa, A4(Aa, "cancelledBy", ha, yt, A4(Aa, "startedBy", ha, yt, A4(Aa, "rerunOfIndex", Bo, yt, A4(Aa, "rerunOf", ha, yt, A4(Aa, "jobName", ta, yt, A3(ua, "jobType", cb, A3(ua, "extraInputs", Ca(ub), A3(ua, "source", nb, A3(ua, "evaluationId", ha, A3(ua, "effectsStatus", _d, A3(ua, "derivationStatus", _d, A3(ua, "evaluationStatus", _d, A3(ua, "jobStatus", _d, A3(ua, "isCancelled", aa, A3(ua, "jobPhase", Gd, A4(Aa, "endTime", zi, yt, A3(ua, "startTime", zi, A3(ua, "repoId", ha, A3(ua, "forgeName", ta, A3(ua, "ownerName", ta, A3(ua, "repoName", ta, A3(ua, "index", Bo, A3(ua, "projectId", ha, A3(ua, "id", ha, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return function(v) {
                                                                        return function(p) {
                                                                            return function(m) {
                                                                                return function(y) {
                                                                                    return function($) {
                                                                                        return function(w) {
                                                                                            return function(k) {
                                                                                                return function(C) {
                                                                                                    return function(x) {
                                                                                                        return function(j) {
                                                                                                            return {
                                                                                                                eI: C,
                                                                                                                cN: b,
                                                                                                                e7: h,
                                                                                                                e8: o,
                                                                                                                fh: g,
                                                                                                                fj: d,
                                                                                                                fn: p,
                                                                                                                ft: i,
                                                                                                                c: n,
                                                                                                                ab: t,
                                                                                                                fW: f,
                                                                                                                f_: y,
                                                                                                                f$: s,
                                                                                                                f0: l,
                                                                                                                f1: m,
                                                                                                                bk: x,
                                                                                                                gd: j,
                                                                                                                dr: a,
                                                                                                                U: e,
                                                                                                                dx: u,
                                                                                                                dy: r,
                                                                                                                g1: $,
                                                                                                                g2: w,
                                                                                                                dF: v,
                                                                                                                dH: c,
                                                                                                                hh: k
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))), sb = A3(ua, "isPublic", aa, A4(Aa, "imageURL", ta, yt, A3(ua, "displayName", ta, A3(ua, "slug", ta, A3(ua, "name", ta, A3(ua, "ownerSlug", ta, A3(ua, "siteSlug", ta, A3(ua, "enabled", aa, A3(ua, "repoId", ha, A3(ua, "ownerId", ha, A3(ua, "owner", Ed, A3(ua, "id", ha, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        k: s,
                                                        bf: a,
                                                        c: n,
                                                        T: f,
                                                        ar: l,
                                                        n: c,
                                                        bn: e,
                                                        bo: t,
                                                        gB: u,
                                                        dx: r,
                                                        dD: i,
                                                        ax: o
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), fb = A4(Aa, "dummy", Kd, yt, A3(ua, "mayCancel", aa, A3(ua, "mayRestart", aa, A3(ua, "events", Ki(Ki(Kd)), A3(ua, "usedInProjects", Ki(sb), A3(ua, "outputs", Ki(Qd), A3(ua, "inputDerivations", Ki(Md), A3(ua, "requiredSystemFeatures", Ki(ta), A3(ua, "platform", ta, A4(Aa, "viaProject", sb, yt, A4(Aa, "viaJob", ob, yt, A3(ua, "status", Yd, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        cR: l,
                                                        cV: o,
                                                        c5: i,
                                                        bk: f,
                                                        ge: s,
                                                        dq: u,
                                                        bq: r,
                                                        bs: a,
                                                        V: n,
                                                        hC: c,
                                                        hI: e,
                                                        hJ: t
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), lb = F3(function(n, e, t) {
        return A7(ju, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}", y([
            d("accountId", n),
            d("derivationPath", e)
        ]), y([
            d("via-job", A2(Zi, jl, t))
        ]), v, yt, fb);
    }), db = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : yl(t);
    }), bb = F2(function(n, e) {
        return A3(db, function(n) {
            return n.cq;
        }, function(t) {
            return d(h(e, {
                ih: A2(rd, e.ih, Qr)
            }), A3($l, n, A3(lb, t.c, ku(e.a9), e.ci.dS), A2(ao, pd, If)));
        }, e);
    }), hb = F2(function(n, e) {
        return A2(bc, yl, function() {
            switch(e.$){
                case 12:
                    return Yl(function(n) {
                        return n;
                    });
                case 0:
                    var t = A2(Hs, function(n) {
                        return n.b && !n.b.b ? Fs(n.a) : Rs(so("Could not load account"));
                    }, r = e.a);
                    return A2(bc, Yl(function(n) {
                        return h(n, {
                            cq: t
                        });
                    }), gl(bb(n)));
                case 7:
                    return gl(bb(n));
                case 8:
                    return gl(function(e) {
                        return A3(db, function(n) {
                            return n.cq;
                        }, function(t) {
                            return A3(vd, n, t, e);
                        }, e);
                    });
                case 1:
                    var r = e.a;
                    return A2(bc, Yl(function(n) {
                        return h(n, {
                            ih: A2(rd, n.ih, r)
                        });
                    }), gl(function(e) {
                        return A3(db, Vs, function(t) {
                            var a, i = 1 === (a = fd(r)).$ ? vl : Wl(A2(Sc, function(n) {
                                return A2(Gr, function(n) {
                                    return d(n.di, n.di);
                                }, Rl(n.dI));
                            }, qc(a.a.cV))), u = od(A2(Ul, i, e.al)), c = A2(Gr, function(r) {
                                var a = r.b;
                                return A3($l, n, A5(Nl, t.cq.c, ku(e.a9), a, yt, yt), A2(ao, Cl(a), If));
                            }, u);
                            return d(e, Au(c));
                        }, e);
                    }));
                case 2:
                    var a = e.a;
                    return gl(function(e) {
                        var t = h(e.ci, {
                            eb: a
                        });
                        return d(h(e, {
                            ci: t
                        }), A2(Vl, n.iK, Fu(t)));
                    });
                case 3:
                    return gl(function(e) {
                        return A2(gl, bb(n), A3(db, Vs, function(t) {
                            return d(h(e, {
                                ch: Qr
                            }), A3($l, n, A2(Ll, t.cq.c, ku(e.a9)), A2(ao, xl, If)));
                        }, e));
                    });
                case 4:
                    var i = e.a;
                    return Yl(function(n) {
                        return h(n, {
                            ch: i
                        });
                    });
                case 5:
                    return gl(function(e) {
                        return A2(gl, bb(n), A3(db, Vs, function(t) {
                            return d(h(e, {
                                bN: Qr
                            }), A3($l, n, A2(ql, t.cq.c, ku(e.a9)), A2(ao, kl, If)));
                        }, e));
                    });
                case 6:
                    return i = e.a, Yl(function(n) {
                        return h(n, {
                            bN: i
                        });
                    });
                case 9:
                    var c = e.a;
                    return i = e.b, gl(function(n) {
                        var e = h(n, {
                            al: A3(ld, c, ud(i), n.al)
                        });
                        return d(e, u(A2(Zi, Af(A2(ao, It, function(n) {
                            return n.f8;
                        })), A2(Zl, c, n.al)), A2(Zi, Af(A2(ao, It, function(n) {
                            return n.f8;
                        })), A2(Zl, c, e.al))) ? eo : A2(td, n, c));
                    });
                case 10:
                    c = e.a;
                    var o = e.b;
                    return A2(bc, Yl(function(n) {
                        return h(n, {
                            aT: A3(wa, c, o, n.aT)
                        });
                    }), gl(function(n) {
                        return d(n, A2(td, n, c));
                    }));
                default:
                    c = e.a;
                    var s = e.b;
                    return A2(bc, Yl(function(n) {
                        return h(n, {
                            ca: A3(du, c, function(n) {
                                return u(n, mt(s)) ? yt : mt(s);
                            }, n.ca)
                        });
                    }), gl(function(n) {
                        return d(n, eo);
                    }));
            }
        }());
    }), gb = F2(function(n, e) {
        return A2(gl, function(t) {
            var r = A2(pl, n, e);
            return r.$ ? d(t, A3(wl, n, e, hl)) : A3(hb, n, hl(Fs(y([
                r.a
            ]))), t);
        }, yl({
            cq: Qr,
            dT: e.cq,
            bN: Bs,
            ih: ml,
            a9: e.a9,
            al: vl,
            ca: va,
            ch: Bs,
            ci: e,
            aT: va,
            dC: e.dC
        }));
    }), vb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pb = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mb = F3(function(n, e, t) {
        return {
            cr: t,
            eu: n,
            cL: e
        };
    }), yb = F3(function(n, e, t) {
        return {
            el: n,
            fY: e,
            dF: t
        };
    }), $b = A4(Aa, "source", Ad, yt, A3(ua, "isPrimary", aa, A3(ua, "address", ta, br(yb)))), wb = F2(function(n, e) {
        return {
            cq: n,
            hb: e
        };
    }), kb = F2(function(n, e) {
        return {
            gu: e,
            gv: n
        };
    }), Cb = A2(fr, function(n) {
        switch(n){
            case "Ignore":
                return br(0);
            case "All":
                return br(1);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), xb = A4(Aa, "notificationEmail", ta, yt, A4(Aa, "notificationLevel", Cb, yt, br(kb))), jb = A3(ua, "setting", xb, A3(ua, "account", Ed, br(wb))), qb = A3(ua, "accountOverrides", Ki(jb), A4(Aa, "defaultSetting", xb, yt, A3(ua, "authorizedEmails", Ki($b), br(mb)))), Sb = A7(ju, "GET", "/api/v1/accounts/me/settings/notifications", v, v, v, yt, qb), Ib = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tb = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ab = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Eb = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Nb = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Lb = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pb = function(n) {
        return A7(ju, "POST", "/api/v1/accounts/{accountId}/gitlab/deinstall", y([
            d("accountId", n)
        ]), v, v, yt, br(0));
    }, Db = A3(ua, "enableNewRepos", aa, br(function(n) {
        return {
            cU: n
        };
    })), Ob = sn, Gb = F2(function(n, e) {
        return d(n, e);
    }), _b = F2(function(n, e) {
        return Zi(A2(ao, Gb(n), e));
    }), Fb = function(n) {
        return y([
            A3(_b, "enableNewRepos", Ob, n.cU)
        ]);
    }, Rb = function(n) {
        return A3(St, F2(function(n, e) {
            return A3(fn, n.a, n.b, e);
        }), {}, n);
    }, Bb = A2(ao, Rb, gu(gr)), Hb = A2(ao, Bb, Fb), Vb = function(n) {
        return A2(We, "application/json", A2(kt, 0, n));
    }, zb = F2(function(n, e) {
        return A7(ju, "PATCH", "/api/v1/accounts/{accountId}/settings", y([
            d("accountId", n)
        ]), v, v, A2(Zi, Vb, mt(Hb(e))), Db);
    }), Ub = F3(function(n, e, t) {
        return A3(Qo, F3(function(t, r, a) {
            return A3(fn, n(t), e(r), a);
        }), {}, t);
    }), Wb = F3(function(n, e, t) {
        return mt(d(n, e(t)));
    }), Kb = sn, Zb = function(n) {
        return n ? "All" : "Ignore";
    }, Yb = A2(ao, Kb, Zb), Mb = function(n) {
        return y([
            A3(_b, "notificationLevel", Yb, n.gv),
            A3(_b, "notificationEmail", Kb, n.gu)
        ]);
    }, Jb = A2(ao, Bb, Mb), Qb = function(n) {
        return y([
            A3(_b, "defaultSetting", Jb, n.cL),
            A3(Wb, "accountOverrides", A2(Ub, gr, Jb), n.cr)
        ]);
    }, Xb = A2(ao, Bb, Qb), nh = function(n) {
        return A7(ju, "PATCH", "/api/v1/accounts/me/settings/notifications", v, v, v, A2(Zi, Vb, mt(Xb(n))), qb);
    }, eh = {
        cr: va,
        cL: yt
    }, th = F2(function(n, e) {
        return A2(Zi, function(n) {
            return n.hb;
        }, A2(uc, A2(bc, function(n) {
            return n.cr;
        }, dl(function(n) {
            return u(n.cq.c, e.c);
        })), fd(n.Z)));
    }), rh = F2(function(n, e) {
        return 1 === e.$ ? Rs(n) : Fs(e.a);
    }), ah = F2(function(n, e) {
        return A2(rh, so("Could not match account forge name"), A2(dl, function(e) {
            return u(e.ax, n);
        }, e));
    }), ih = F2(function(n, e) {
        return A2(Hs, function(t) {
            return A2(Hs, function(e) {
                return A2(Hs, function(n) {
                    return Fs({
                        cq: t,
                        ai: e,
                        fr: n
                    });
                }, A2(ah, t.hf, n.h9.fu));
            }, e.ai);
        }, e.cq);
    }), uh = F2(function(n, e) {
        var t = d(n, e);
        return 3 === t.b.$ ? Fs(t.b.a) : 3 === t.a.$ ? Fs(t.a.a) : t.b;
    }), ch = function(n) {
        return 3 === n.$;
    }, oh = F2(function(n, e) {
        return 1 === e.$ ? n : e;
    }), sh = A2(Kr, Nr, dn(function() {
        Vn.location.reload(false);
    })), fh = F2(function(n, e) {
        return A5(pa, 1, n, e, ga, ga);
    }), lh = F2(function(n, e) {
        switch(e.$){
            case 3:
                var t = n(e.a), r = t.b;
                return d(Fs(t.a), r);
            case 0:
                return d(Bs, eo);
            case 1:
                return d(Qr, eo);
            default:
                return d(Rs(e.a), eo);
        }
    }), dh = F3(function(n, e, t) {
        var r = d(t, eo), a = d(fd(A2(ih, n, t)), e);
        n: for(;;)switch(a.b.$){
            case 0:
                var i = A2(lh, function(e) {
                    return d(e, A3($l, n, A7(ju, "GET", "/api/v1/accounts/{accountId}/settings", y([
                        d("accountId", e.c)
                    ]), v, v, yt, Db), A2(ao, Ib, If)));
                }, A2(Hs, function(n) {
                    return n.b && !n.b.b ? Fs(n.a) : Rs(so("Could not load account"));
                }, a.b.a)), u = i.b;
                return d(h(t, {
                    cq: i.a
                }), u);
            case 1:
                return d(h(t, {
                    ai: a.b.a
                }), eo);
            case 3:
                if (a.a.$) break n;
                var c = a.a.a, o = a.b.a;
                return d(h(t, {
                    b_: Qr
                }), A3($l, n, A2(zb, c.cq.c, {
                    cU: mt(o)
                }), A2(ao, Lb, If)));
            case 2:
                return d(h(t, {
                    ai: A2(uh, t.ai, p = a.b.a),
                    b_: A2(Af, function() {
                        return 0;
                    }, p)
                }), eo);
            case 4:
                if (a.a.$) break n;
                return c = a.a.a, d(h(t, {
                    bW: Qr
                }), A3($l, n, A7(ju, "POST", "/api/v1/accounts/{accountId}/disable-all-projects", y([
                    d("accountId", c.cq.c)
                ]), v, v, yt, Bo), A2(ao, Tb, If)));
            case 5:
                return d(h(t, {
                    bW: p = a.b.a
                }), eo);
            case 6:
                return d(h(t, {
                    Z: p = a.b.a
                }), eo);
            case 8:
                return d(h(t, {
                    dm: a.b.a
                }), eo);
            case 7:
                var s = a.b.a, f = t.cq;
                if (3 === f.$) {
                    var l = f.a;
                    return d(h(t, {
                        dn: s,
                        b8: Qr
                    }), A3($l, n, nh(h(eh, {
                        cr: A2(fh, l.c, {
                            gu: s,
                            gv: A2(oh, A2(uc, function(n) {
                                return n.gv;
                            }, A2(th, t, l)), t.dp)
                        })
                    })), A2(ao, Eb, If)));
                }
                return r;
            case 9:
                return d(h(t, {
                    b8: g = a.b.a,
                    Z: A2(uh, t.Z, g)
                }), eo);
            case 11:
                return d(h(t, {
                    $7: a.b.a
                }), eo);
            case 10:
                s = a.b.a;
                var b = t.cq;
                return 3 === b.$ ? (l = b.a, d(h(t, {
                    dp: s,
                    b9: Qr
                }), A3($l, n, nh(h(eh, {
                    cr: A2(fh, l.c, {
                        gu: A2(oh, A2(uc, function(n) {
                            return n.gu;
                        }, A2(th, t, l)), t.dn),
                        gv: s
                    })
                })), A2(ao, Nb, If)))) : r;
            case 12:
                var g;
                return d(h(t, {
                    b9: g = a.b.a,
                    Z: A2(uh, t.Z, g)
                }), eo);
            case 13:
                if (a.a.$) break n;
                return c = a.a.a, d(t, A3($l, n, a.b.a ? A7(ju, "POST", "/api/v1/accounts/{accountId}/gitlab/install", y([
                    d("accountId", c.cq.c)
                ]), v, v, yt, br(0)) : Pb(c.cq.c), A2(ao, Ab, If)));
            default:
                if (a.a.$) break n;
                var p;
                return d(h(t, {
                    c6: p = a.b.a
                }), ch(p) ? sh : eo);
        }
        return r;
    }), bh = F2(function(n, e) {
        var t, r = {
            cq: Qr,
            ai: Qr,
            bW: Bs,
            b_: Bs,
            c6: Bs,
            dm: 0,
            dn: yt,
            b8: Bs,
            $7: 0,
            dp: yt,
            b9: Bs,
            Z: Qr
        }, a = (t = A2(pl, n, e)).$ ? d(r, A3($l, n, A2(qu, mt(e.dC), mt(e.cq)), A2(ao, vb, If))) : A3(dh, n, vb(Fs(y([
            t.a
        ]))), r);
        return d(a.a, Au(y([
            a.b,
            A3($l, n, Sb, A2(ao, pb, If))
        ])));
    }), hh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gh = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), vh = function(n) {
        return d(n, eo);
    }, ph = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mh = A3(ua, "labels", Ca(Ia), A3(ua, "concurrentTasks", Bo, A3(ua, "available", aa, A4(Aa, "revocation", zi, yt, A4(Aa, "lastSeen", zi, yt, A3(ua, "creation", zi, A3(ua, "substituters", Ki(ta), A3(ua, "pushCaches", Ki(ta), A3(ua, "cachixPushCaches", Ki(ta), A3(ua, "systemFeatures", Ki(ta), A3(ua, "platforms", Ki(ta), A3(ua, "nixVersion", ta, A3(ua, "agentVersion", ta, A3(ua, "hostname", ta, A3(ua, "description", ta, A3(ua, "clusterJoinTokenId", ha, A3(ua, "id", ha, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return function(v) {
                                                                        return {
                                                                            a0: a,
                                                                            ev: h,
                                                                            eH: o,
                                                                            eM: e,
                                                                            eR: g,
                                                                            eT: l,
                                                                            v: t,
                                                                            fL: r,
                                                                            c: n,
                                                                            f4: v,
                                                                            f5: d,
                                                                            gr: i,
                                                                            gK: u,
                                                                            gU: s,
                                                                            g7: b,
                                                                            hr: f,
                                                                            hs: c
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), yh = function(n) {
        return A7(ju, "GET", "/api/v1/accounts/{accountId}/agentSessions", y([
            d("accountId", n)
        ]), v, v, yt, Ki(mh));
    }, $h = F3(function(n, e, t) {
        return d(h(e, {
            aB: A2(uh, e.aB, Qr)
        }), A3($l, n, yh(t.c), A2(ao, ph, If)));
    }), wh = F2(function(n, e) {
        var t = fd(e.cq);
        return t.$ ? vh(e) : A3($h, n, e, t.a);
    }), kh = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return vh(h(t, {
                    cq: A2(Hs, function(n) {
                        return n.b && !n.b.b ? Fs(n.a) : Rs(so("Could not load account"));
                    }, e.a)
                }));
            case 1:
                var r = A2(lh, function(n) {
                    return d(A2(nl, function(n) {
                        return u(n.fL, t.ci.fL);
                    }, n), eo);
                }, e.a), a = r.b;
                return d(h(t, {
                    aB: r.a
                }), a);
            default:
                return A2(wh, n, t);
        }
    }), Ch = F2(function(n, e) {
        var t = function(t) {
            var r = A2(pl, n, e);
            return r.$ ? d(t, A3(wl, n, e, hh)) : A3(kh, n, hh(Fs(y([
                r.a
            ]))), t);
        }, r = {
            cq: Qr,
            aB: Qr,
            ci: e
        };
        return A2(gh, wh(n), A2(gh, t, vh(r)));
    }), xh = function(n) {
        return {
            $: 9,
            a: n
        };
    }, jh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qh = A7(ju, "GET", "/api/v1/api/organizations", v, v, v, yt, Ki(Ui)), Sh = F2(function(n, e) {
        return {
            ej: e,
            gq: n
        };
    }), Ih = A3(ua, "activeUsers", Ki(Wi), A4(Aa, "nextPayment", zi, yt, br(Sh))), Th = F2(function(n, e) {
        return d({
            cq: e,
            cz: Bs,
            cF: Bs,
            bP: Bs,
            n: "",
            cb: Qr,
            gG: Bs,
            dJ: !1
        }, Au(A2(tt, A3($l, n, qh, A2(bc, If, jh)), A2(Gr, function(e) {
            return A3($l, n, A7(ju, "GET", "/api/v1/api/organizations/{organizationId}/billing", y([
                d("organizationId", e.c)
            ]), v, v, yt, Ih), A2(bc, If, xh));
        }, Rl(e.gA)))));
    }), Ah = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Eh = F2(function(n, e) {
        return {
            I: e,
            v: n
        };
    }), Nh = A3(ua, "creationTime", zi, A3(ua, "description", ta, br(Eh))), Lh = F2(function(n, e) {
        var t = {
            cw: Qr,
            bO: !1,
            a7: Bs,
            ci: e
        }, r = A3($l, n, A7(ju, "GET", "/api/v1/auth/cli/authorization/request/{browserToken}", y([
            d("browserToken", e.ga)
        ]), v, v, yt, Nh), A2(ao, Ah, If));
        return d(t, r);
    }), Ph = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Dh = F2(function(n, e) {
        return {
            df: e,
            br: n
        };
    }), Oh = A3(ua, "jobs", Ki(ob), A3(ua, "project", sb, br(Dh))), Gh = F5(function(n, e, t, r, a) {
        return A7(ju, "GET", "/api/v1/jobs", v, y([
            d("site", A2(Zi, gr, n)),
            d("account", A2(Zi, gr, e)),
            d("project", A2(Zi, gr, t)),
            d("index", A2(Zi, Ct, r)),
            d("latest", A2(Zi, Ct, a))
        ]), v, yt, Ki(Oh));
    }), _h = F2(function(n, e) {
        var t = e.bD;
        if (1 === t.$) {
            var r = t.a;
            return A3($l, n, A5(Gh, mt(r.hf), mt(r.ax), yt, yt, mt(1)), A2(bc, If, Ph(n.ci)));
        }
        return A3($l, n, A5(Gh, yt, yt, yt, yt, mt(1)), A2(bc, If, Ph(n.ci)));
    }), Fh = F2(function(n, e) {
        var t = {
            hV: va,
            aR: Qr,
            bD: e
        };
        return d(t, A2(_h, n, t));
    }), Rh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bh = F6(function(n, e, t, r, a, i) {
        return {
            k: r,
            fe: i,
            fr: a,
            c1: e,
            c: n,
            n: t
        };
    }), Hh = F2(function(n, e) {
        return {
            fc: n,
            bl: e
        };
    }), Vh = A3(ua, "message", ta, A3(ua, "errorTags", Ki(ta), br(Hh))), zh = A3(ua, "errors", Ki(Vh), A4(Aa, "forge", Ad, yt, A3(ua, "displayName", ta, A3(ua, "name", ta, A3(ua, "gitlabURL", ta, A3(ua, "id", ha, br(Bh))))))), Uh = F2(function(n, e) {
        return d({
            bU: Bs,
            k: "",
            ac: Qr,
            aq: Bs,
            n: "",
            ci: e
        }, A3($l, n, A7(ju, "GET", "/api/v1/gitlab/installation/{installationId}", y([
            d("installationId", e.c8)
        ]), v, v, yt, zh), A2(ao, Rh, If)));
    }), Wh = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Kh = A3(ua, "items", Ki(zh), br(function(n) {
        return {
            bh: n
        };
    })), Zh = A7(ju, "GET", "/api/v1/gitlab/installations", v, v, v, yt, Kh), Yh = F2(function(n) {
        return d({
            c1: "https://",
            c6: Bs,
            c7: Qr,
            aQ: "",
            aW: "",
            aA: !1
        }, A3($l, n, Zh, A2(ao, Wh, If)));
    }), Mh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jh = F4(function(n, e, t, r) {
        return {
            cq: e,
            fZ: t,
            g9: r,
            dC: n
        };
    }), Qh = A4(Aa, "secondsSinceInstallationWebHookComplete", Bo, yt, A3(ua, "isProcessingInstallationWebHook", aa, A4(Aa, "account", Wi, yt, A3(ua, "site", Ea, br(Jh))))), Xh = F2(function(n, e) {
        return A7(ju, "GET", "/api/v1/sites/{forgeId}/installation/{installationId}/status", y([
            d("forgeId", n),
            d("installationId", Ct(e))
        ]), v, v, yt, Qh);
    }), ng = F2(function(n, e) {
        return A3($l, n, A2(Xh, e.ci.fs, A2(la, 0, e.ci.c8)), A2(ao, Mh, If));
    }), eg = F2(function(n, e) {
        var t = {
            ci: e,
            aU: ml
        };
        return d(t, A2(ng, n, t));
    }), tg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rg = F2(function(n, e) {
        return {
            ie: n,
            ao: e
        };
    }), ag = va, ig = F3(function(n, e, t) {
        return A3($l, n, yh(e.c), A2(bc, If, t));
    }), ug = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cg = F2(function(n, e) {
        return A3($l, n, A5(Gh, mt(e.dD), mt(e.H), mt(e.br), mt(e.au), yt), ug);
    }), og = F2(function(n, e) {
        var t, r = {
            H: e.cq,
            a1: Qr,
            bM: Bs,
            a6: A2(bl, n, e.cq),
            ak: Qr,
            aF: !1,
            b$: yt,
            b0: !0,
            aG: 3,
            aH: A2(rg, Qr, Bs),
            as: A2(rg, Qr, Bs),
            at: Bs,
            au: e.ab,
            br: e.br,
            bt: Bs,
            ci: e,
            bu: Bs,
            aa: ag,
            dD: e.dC
        }, a = 1 === (t = r.a6).$ ? eo : A3(ig, n, t.a, tg);
        return d(r, Au(y([
            A2(cg, n, r),
            a
        ])));
    }), sg = F3(function(n, e, t) {
        return e.$ ? d(t, eo) : A2(n, e.a, t);
    }), fg = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), lg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dg = function(n) {
        return !n.$;
    }, bg = F3(function(n, e, t) {
        return d(h(t, {
            aj: dg(t.aj) ? Qr : t.aj
        }), A3($l, n, A7(ju, "GET", "/api/v1/jobs/{jobId}", y([
            d("jobId", e)
        ]), v, v, yt, ob), A2(ao, lg, If)));
    }), hg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gg = function(n) {
        if (n.b) {
            var e = n.a.df;
            return e.b ? Fs(e.a) : Rs(io(404));
        }
        return Rs(io(404));
    }, vg = F2(function(n, e) {
        var t = e.ci;
        return d(h(e, {
            am: dg(e.am) ? Qr : e.am
        }), A3($l, n, A5(Gh, mt(t.dC), mt(t.cq), mt(t.br), mt(t.ab), mt(1)), A2(ao, A2(ao, hg, Hs(gg)), If)));
    }), pg = F2(function(n, e) {
        var t = {
            er: va,
            aj: Bs,
            a5: Bs,
            bV: Bs,
            b1: yt,
            am: Bs,
            ci: e
        };
        return A2(fg, A2(sg, bg(n), e.ew), A2(vg, n, t));
    }), mg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $g = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), wg = function(n) {
        return d(n, eo);
    }, kg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Cg = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), xg = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/jobs/{jobId}/effects/{attribute}/cancel", y([
            d("jobId", n),
            d("attribute", e)
        ]), v, v, yt, br(0));
    }), jg = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, qg = F5(function(n, e, t, r, a) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}/log/lines", y([
            d("jobId", n),
            d("attribute", e)
        ]), y([
            d("logId", mt(t)),
            d("iMin", A2(Zi, Ct, r)),
            d("verbosity", A2(Zi, jg, a))
        ]), v, yt, Al);
    }), Sg = function(n) {
        return function(e) {
            var t = e.b;
            return d(n(e.a), t);
        };
    }, Ig = {
        $: 13
    }, Tg = F2(function(n, e) {
        return A3(ed, A2(la, !0, A2(au, e, n.aT)), e, Ig);
    }), Ag = F2(function(n, e) {
        var t = A3(bd, F3(function(e, t, r) {
            var a = A2(n, t, r), i = a.a;
            return d(A2(tt, a.b, e), i);
        }), v, e);
        return d(t.b, Au(t.a));
    }), Eg = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : wg(t);
    }), Ng = F2(function(n, e) {
        var t = A3(Eg, function(n) {
            return n.aN;
        }, function(t) {
            var r = t.b, a = A2(Ag, F2(function(t, a) {
                return d(a, A2(gd, a, function(a) {
                    return A3($l, n, A5(qg, r.c, ku(_l(e.ci.a2)), t, a, yt), A2(ao, Cg(t), If));
                }));
            }), e.al);
            return d(e, a.b);
        }, e);
        return d(e, t.b);
    }), Lg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pg = F6(function(n, e, t, r, a, i) {
        return {
            cA: i,
            cM: e,
            cZ: r,
            dv: n,
            dI: t,
            dK: a
        };
    }), Dg = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Og = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Gg = F2(function(n, e) {
        return {
            dO: e,
            f: n
        };
    }), _g = A4(Aa, "technicalError", ta, yt, A3(ua, "time", zi, br(Gg))), Fg = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Rg = F4(function(n, e, t, r) {
        return {
            a_: t,
            a0: r,
            di: e,
            f: n
        };
    }), Bg = A3(ua, "agentVersion", ta, A3(ua, "agentHostname", ta, A3(ua, "logId", ha, A3(ua, "time", zi, br(Rg))))), Hg = A3(ua, "time", zi, br(function(n) {
        return {
            f: n
        };
    })), Vg = A4(Aa, "Cancelled", Dg, yt, A4(Aa, "Succeeded", Hg, yt, A4(Aa, "Failed", _g, yt, A4(Aa, "Started", Bg, yt, A4(Aa, "DependencyFailed", Og, yt, A4(Aa, "Queued", Fg, yt, br(Pg))))))), zg = F2(function(n, e) {
        return {
            et: e,
            as: n
        };
    }), Ug = A3(ua, "attributePath", Ki(ta), A3(ua, "job", Bd, br(zg))), Wg = A2(fr, function(n) {
        switch(n){
            case "Waiting":
                return br(0);
            case "Running":
                return br(1);
            case "Failed":
                return br(2);
            case "DependencyFailed":
                return br(3);
            case "Successful":
                return br(4);
            case "Cancelled":
                return br(5);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Kg = A4(Aa, "dummy", Vg, yt, A3(ua, "mayCancel", aa, A3(ua, "waitingForJobs", Ki(Bd), A3(ua, "waitingForEffects", Ki(Ug), A3(ua, "events", Ki(Ki(Vg)), A3(ua, "inputDerivations", Ki(Md), A3(ua, "requiredSystemFeatures", Ki(ta), A3(ua, "platform", ta, A3(ua, "projectId", ha, A3(ua, "jobId", ha, A3(ua, "status", Wg, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    cR: f,
                                                    cV: u,
                                                    c5: i,
                                                    de: e,
                                                    bk: s,
                                                    bq: r,
                                                    U: t,
                                                    bs: a,
                                                    V: n,
                                                    hL: c,
                                                    hM: o
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Zg = F2(function(n, e) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}", y([
            d("jobId", n),
            d("attribute", e)
        ]), v, v, yt, Kg);
    }), Yg = F2(function(n, e) {
        return A3(Eg, function(n) {
            return n.aN;
        }, function(t) {
            var r = t.b;
            return d(h(e, {
                j: A2(rd, e.j, Qr)
            }), A3($l, n, A2(Zg, r.c, ku(_l(e.ci.a2))), A2(ao, Lg, If)));
        }, e);
    }), Mg = F2(function(n, e) {
        return A2(bc, wg, function() {
            switch(e.$){
                case 13:
                case 4:
                    return Sg(function(n) {
                        return n;
                    });
                case 0:
                    var t = A2(Hs, function(n) {
                        return n.b && !n.b.b ? Fs(n.a) : Rs(so("Could not load account"));
                    }, a = e.a);
                    return A2(bc, Sg(function(n) {
                        return h(n, {
                            cq: t
                        });
                    }), $g(Yg(n)));
                case 1:
                    var r = A2(Hs, function(n) {
                        if (n.b && !n.b.b) {
                            var e = n.a, t = e.df;
                            return t.b && !t.b.b ? Fs(d(e.br, t.a)) : Rs(so("Could not load job"));
                        }
                        return Rs(so("Could not load project"));
                    }, a = e.a);
                    return A2(bc, Sg(function(n) {
                        return h(n, {
                            aN: r
                        });
                    }), $g(Yg(n)));
                case 8:
                    return $g(Yg(n));
                case 9:
                    return $g(Ng(n));
                case 2:
                    var a = e.a;
                    return A2(bc, Sg(function(n) {
                        return h(n, {
                            j: A2(rd, n.j, a)
                        });
                    }), $g(function(e) {
                        return A3(Eg, lf, function(t) {
                            var r, i = 1 === (r = fd(a)).$ ? vl : Wl(A2(Sc, function(n) {
                                return A2(Gr, function(n) {
                                    return d(n.di, n.di);
                                }, Rl(n.dI));
                            }, qc(r.a.cV))), u = od(A2(Ul, i, e.al)), c = A2(Gr, function(r) {
                                var a = r.b;
                                return A3($l, n, A5(qg, t.as.c, ku(_l(e.ci.a2)), a, yt, yt), A2(ao, Cg(a), If));
                            }, u);
                            return d(e, Au(c));
                        }, e);
                    }));
                case 3:
                    var i = e.a;
                    return $g(function(e) {
                        var t = h(e.ci, {
                            eb: i
                        });
                        return d(h(e, {
                            ci: t
                        }), A2(Vl, n.iK, Ju(t)));
                    });
                case 5:
                    var c = e.a;
                    return Sg(function(n) {
                        return h(n, {
                            ch: c
                        });
                    });
                case 6:
                    return $g(function(e) {
                        return A2($g, Yg(n), A3(Eg, lf, function(t) {
                            return d(h(e, {
                                ch: Qr
                            }), A3($l, n, A2(xg, t.as.c, ku(_l(e.ci.a2))), A2(ao, kg, If)));
                        }, e));
                    });
                case 7:
                    return c = e.a, Sg(function(n) {
                        return h(n, {
                            bN: c
                        });
                    });
                case 10:
                    var o = e.a;
                    return c = e.b, $g(function(n) {
                        var e = h(n, {
                            al: A3(ld, o, ud(c), n.al)
                        });
                        return d(e, u(A2(Zi, Af(A2(ao, It, function(n) {
                            return n.f8;
                        })), A2(Zl, o, n.al)), A2(Zi, Af(A2(ao, It, function(n) {
                            return n.f8;
                        })), A2(Zl, o, e.al))) ? eo : A2(Tg, n, o));
                    });
                case 11:
                    o = e.a;
                    var s = e.b;
                    return A2(bc, Sg(function(n) {
                        return h(n, {
                            aT: A3(wa, o, s, n.aT)
                        });
                    }), $g(function(n) {
                        return d(n, A2(Tg, n, o));
                    }));
                default:
                    o = e.a;
                    var f = e.b;
                    return A2(bc, Sg(function(n) {
                        return h(n, {
                            ca: A3(du, o, function(n) {
                                return u(n, mt(f)) ? yt : mt(f);
                            }, n.ca)
                        });
                    }), $g(function(n) {
                        return d(n, eo);
                    }));
            }
        }());
    }), Jg = F2(function(n, e) {
        return A2($g, function(e) {
            return d(e, A3($l, n, A5(Gh, mt(e.dC), mt(e.dT), mt(e.ci.br), mt(e.ci.ab), yt), A2(ao, yg, If)));
        }, A2($g, function(t) {
            var r = A2(pl, n, e);
            return r.$ ? d(t, A3(wl, n, e, mg)) : A3(Mg, n, mg(Fs(y([
                r.a
            ]))), t);
        }, wg({
            cq: Qr,
            dT: e.cq,
            bN: Bs,
            j: ml,
            aN: Qr,
            al: vl,
            ca: va,
            ch: Bs,
            ci: e,
            aT: va,
            dC: e.dC
        })));
    }), Qg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xg = F2(function(n, e) {
        return {
            bh: n,
            dl: e
        };
    }), nv = A3(ua, "more", aa, A3(ua, "items", Ki(ob), br(Xg))), ev = function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return A7(ju, "GET", "/api/v1/site/{site}/account/{account}/project/{project}/jobs", y([
                                                    d("site", n),
                                                    d("account", e),
                                                    d("project", t)
                                                ]), g(y([
                                                    d("ref", A2(Zi, gr, r)),
                                                    d("rev", A2(Zi, gr, a)),
                                                    d("name", A2(Zi, gr, u)),
                                                    d("success", A2(Zi, function(n) {
                                                        return n ? "true" : "false";
                                                    }, c)),
                                                    d("offsetId", A2(Zi, jl, o)),
                                                    d("offsetIndex", A2(Zi, Ct, s)),
                                                    d("limit", A2(Zi, Ct, f))
                                                ]), A2(Gr, function(n) {
                                                    return d("handler", mt(function(n) {
                                                        switch(n){
                                                            case 0:
                                                                return "Config";
                                                            case 1:
                                                                return "Legacy";
                                                            case 2:
                                                                return "OnPush";
                                                            default:
                                                                return "OnSchedule";
                                                        }
                                                    }(n)));
                                                }, i)), v, yt, nv);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, tv = F2(function(n, e) {
        var t;
        return A3($l, n, ev(e.dC)(e.cq)(e.br)(mt("HEAD"))(yt)(y(1 === (t = e.W).$ ? [
            1,
            0
        ] : [
            t.a
        ]))(e.n)(yt)(yt)(yt)(mt(1)), A2(ao, Qg, If));
    }), rv = F2(function(n, e) {
        return d({
            d7: Qr,
            ci: e
        }, A2(tv, n, e));
    }), av = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iv = F2(function(n) {
        return d({
            bH: va,
            eh: va,
            cH: 0,
            cI: yt,
            bS: Bs,
            cJ: 0,
            cK: yt,
            bT: Bs,
            Z: Qr
        }, function(n) {
            return A3($l, n, Sb, A2(ao, av, If));
        }(n));
    }), uv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cv = F4(function(n, e, t, r) {
        return {
            I: t,
            v: e,
            c: n,
            hE: r
        };
    }), ov = A3(ua, "userId", ha, A3(ua, "creationTime", zi, A3(ua, "description", ta, A3(ua, "id", ha, br(cv))))), sv = A3(ua, "cliTokens", Ki(ov), br(function(n) {
        return {
            eL: n
        };
    })), fv = A7(ju, "GET", "/api/v1/auth/cli/tokens", v, v, v, yt, sv), lv = function(n) {
        return A3($l, n, fv, A2(ao, uv, If));
    }, dv = F2(function(n) {
        return d({
            cC: Qr,
            aE: va
        }, lv(n));
    }), bv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hv = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), gv = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), vv = F2(function(n, e) {
        var t = A2(Zi, function(n) {
            return 25 * n + 1;
        }, e.ci.gC);
        return A3($l, n, ev(e.ci.dC)(e.ci.cq)(e.ci.br)(yt)(yt)(v)(yt)(yt)(yt)(t)(mt(25)), A2(bc, If, gv(t)));
    }), pv = F2(function(n, e) {
        return A3($l, n, ev(e.ci.dC)(e.ci.cq)(e.ci.br)(yt)(yt)(v)(yt)(yt)(yt)(yt)(mt(25)), A2(bc, If, gv(yt)));
    }), mv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yv = F3(function(n, e, t) {
        return A7(ju, "GET", "/api/v1/site/{site}/account/{account}/project/{project}", y([
            d("site", n),
            d("account", e),
            d("project", t)
        ]), v, v, yt, sb);
    }), $v = F2(function(n, e) {
        return A3($l, n, A3(yv, e.ci.dC, e.ci.cq, e.ci.br), A2(bc, If, mv));
    }), wv = function(n) {
        return {
            $: 6,
            a: n
        };
    }, kv = function(n) {
        return y([
            A3(_b, "enabled", Ob, n.bf)
        ]);
    }, Cv = A2(ao, Bb, kv), xv = F2(function(n, e) {
        return A7(ju, "PATCH", "/api/v1/projects/{projectId}", y([
            d("projectId", n)
        ]), v, v, A2(Zi, Vb, mt(Cv(e))), sb);
    }), jv = function(n) {
        return 1 !== n.$;
    }, qv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sv = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Iv = function(n) {
        return y([
            A3(Wb, "description", Kb, n.v)
        ]);
    }, Tv = A2(ao, Bb, Iv), Av = F2(function(n, e) {
        return {
            gi: n,
            bz: e
        };
    }), Ev = F4(function(n, e, t, r) {
        return {
            I: t,
            v: r,
            c: n,
            bo: e
        };
    }), Nv = A3(ua, "description", ta, A3(ua, "creationTime", zi, A3(ua, "ownerId", ha, A3(ua, "id", ha, br(Ev))))), Lv = A3(ua, "token", ta, A3(ua, "metadata", Nv, br(Av))), Pv = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/accounts/{accountId}/clusterJoinTokens", y([
            d("accountId", n)
        ]), v, v, A2(Zi, Vb, mt(Tv(e))), Lv);
    }), Dv = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ov = F2(function(n, e) {
        return {
            bh: n,
            dl: e
        };
    }), Gv = F3(function(n, e, t) {
        return {
            eE: e,
            cS: t,
            ff: n
        };
    }), _v = F6(function(n, e, t, r, a, i) {
        return {
            a$: i,
            I: t,
            a9: r,
            c: n,
            bw: e,
            dL: a
        };
    }), Fv = A2(fr, function(n) {
        switch(n){
            case "Ready":
                return br(0);
            case "Dispatched":
                return br(1);
            case "Cancelling":
                return br(2);
            case "Resetting":
                return br(3);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Rv = A4(Aa, "agentName", ta, yt, A3(ua, "system", ta, A4(Aa, "derivationPath", ta, yt, A3(ua, "creationTime", zi, A3(ua, "state", Fv, A3(ua, "id", ha, br(_v))))))), Bv = F6(function(n, e, t, r, a, i) {
        return {
            a$: i,
            I: t,
            cS: r,
            c: n,
            bw: e,
            dL: a
        };
    }), Hv = A4(Aa, "agentName", ta, yt, A3(ua, "system", ta, A4(Aa, "effect", Ug, yt, A3(ua, "creationTime", zi, A3(ua, "state", Fv, A3(ua, "id", ha, br(Bv))))))), Vv = F5(function(n, e, t, r, a) {
        return {
            a$: a,
            I: t,
            c: n,
            as: r,
            bw: e
        };
    }), zv = A4(Aa, "agentName", ta, yt, A4(Aa, "job", Bd, yt, A3(ua, "creationTime", zi, A3(ua, "state", Fv, A3(ua, "id", ha, br(Vv)))))), Uv = A4(Aa, "Effect", Hv, yt, A4(Aa, "Build", Rv, yt, A4(Aa, "Evaluation", zv, yt, br(Gv)))), Wv = A3(ua, "more", aa, A3(ua, "items", Ki(Uv), br(Ov))), Kv = function(n) {
        switch(n){
            case 0:
                return "Ready";
            case 1:
                return "Dispatched";
            case 2:
                return "Cancelling";
            default:
                return "Resetting";
        }
    }, Zv = F3(function(n, e, t) {
        return A7(ju, "GET", "/api/v1/accounts/{accountId}/default-cluster/tasks", y([
            d("accountId", n)
        ]), y([
            d("state", A2(Zi, Kv, e)),
            d("limit", A2(Zi, Ct, t))
        ]), v, yt, Wv);
    }), Yv = F2(function(n, e) {
        return A3($l, n, A3(Zv, e.c, yt, yt), A2(bc, If, Dv));
    }), Mv = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, {
                    a1: e.a
                }), eo);
            case 1:
                return d(t, Au(A2(tt, A3(ig, n, t.cq, qv), u(t.eb, ol) ? y([
                    A2(Yv, n, t.cq)
                ]) : v)));
            case 2:
            case 6:
                return d(t, A2(Vl, n.iK, r = e.a));
            case 5:
                var r = e.b;
                return d(h(t, {
                    eb: e.a
                }), A2(Vl, n.iK, r));
            case 3:
                return d(t, A3($l, n, A2(Pv, t.cq.c, {
                    v: "Generated for getting started"
                }), A2(bc, If, Sv)));
            case 4:
                return d(h(t, {
                    cu: e.a
                }), eo);
            default:
                return d(h(t, {
                    dN: e.a
                }), eo);
        }
    }), Jv = F3(function(n, e, t) {
        switch(e.$){
            case 7:
                return d(t, A2(Vl, n.iK, e.a));
            case 0:
                return d(h(t, {
                    bn: A2(Hs, function(n) {
                        return n.b && !n.b.b ? Fs(n.a) : Rs(so("Could not load account"));
                    }, e.a)
                }), eo);
            case 1:
                return d(h(t, {
                    br: a = e.a
                }), eo);
            case 2:
                var r = e.a, a = e.b;
                return d(h(t, {
                    df: u(jv(r), jv(t.ci.gC)) ? a : t.df,
                    bi: 1 === r.$ ? A2(oh, t.bi, fd(a)) : t.bi
                }), eo);
            case 3:
                return d(t, Au(y([
                    A2(vv, n, t)
                ])));
            case 4:
                var i = e.a.bG, c = e.a.bF, o = A2(au, c, t.hV);
                if (1 === o.$) return d(t, eo);
                var s = A3(Mv, n, i, o.a), f = s.a, l = s.b;
                return d(h(t, {
                    hV: A3(du, c, function() {
                        return mt(f);
                    }, t.hV)
                }), A2(ro, function(n) {
                    return hf({
                        bF: c,
                        bG: n
                    });
                }, l));
            case 5:
                var b = e.a.gF, g = e.a.c;
                return d(h(t, {
                    cc: Qr
                }), A3($l, n, A2(xv, g, b), A2(ao, wv, If)));
            case 6:
                var v = e.a;
                return d(h(t, {
                    cc: A2(Af, function() {
                        return 0;
                    }, v),
                    br: ch(v) ? v : t.br
                }), function(n) {
                    return A2(Kr, gr, Lr(n));
                }(gf(ti(0))));
            default:
                return d(h(t, {
                    bB: !t.bB
                }), eo);
        }
    }), Qv = F2(function(n, e) {
        return A2(hv, function(e) {
            return d(e, Au(g(y([
                A2(vv, n, e),
                A2($v, n, e)
            ]), e.ci.gC.$ ? v : y([
                A2(pv, n, e)
            ]))));
        }, A2(hv, function(t) {
            var r = A2(pl, n, e);
            return r.$ ? d(t, A3(wl, n, e, bv)) : A3(Jv, n, bv(Fs(y([
                r.a
            ]))), t);
        }, d({
            hV: va,
            df: Qr,
            bi: yt,
            bn: Qr,
            cc: Bs,
            br: Qr,
            ci: e,
            bB: !1
        }, eo)));
    }), Xv = {
        $: 0
    }, np = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ep = F3(function(n, e, t) {
        return A7(ju, "GET", "/api/v1/projects", v, y([
            d("site", A2(Zi, gr, n)),
            d("account", A2(Zi, gr, e)),
            d("project", A2(Zi, gr, t))
        ]), v, yt, Ki(sb));
    }), tp = F2(function(n, e) {
        return A3($l, n, A3(ep, mt(e.ci.dC), mt(e.ci.cq), mt(e.ci.br)), A2(ao, np, If));
    }), rp = F2(function(n, e) {
        var t = {
            ce: Qr,
            ci: e,
            bx: A2(rg, Qr, Bs),
            z: Xv
        };
        return d(t, Au(y([
            A2(tp, n, t)
        ])));
    }), ap = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), ip = function(n) {
        return {
            $: 13,
            a: n
        };
    }, up = F3(function(n, e, t) {
        var r = function(e) {
            var r = A2(Fh, n, t(e)), a = r.b;
            return d(_f(r.a), A2(ro, Ss, a));
        }, a = A2(bl, n, e.cq);
        return 1 === a.$ ? d(A2(ap, e.cq, r), A3($l, n, A2(qu, mt(e.dC), mt(e.cq)), A2(bc, If, ip))) : r(a.a);
    }), cp = F2(function(n, e) {
        var t, r, a = n.hD;
        if (a.$) {
            var i = a.a;
            switch(e.$){
                case 23:
                    return d(il, eo);
                case 0:
                    var u = A2(Fh, n, al);
                    return $ = u.b, d(_f(u.a), A2(ro, Ss, $));
                case 11:
                    return function(n) {
                        var e = n.b;
                        return d(Xf(n.a), A2(ro, Os, e));
                    }(A2(rp, n, w = e.a));
                case 1:
                    return A3(up, n, w = e.a, function(n) {
                        return A2(el, n, ul);
                    });
                case 2:
                    return function(n) {
                        var e = n.b;
                        return d(Pf(n.a), A2(ro, Lf, e));
                    }(A2(bh, n, w = e.a));
                case 3:
                    return function(n) {
                        var e = n.b;
                        return d(Nf(n.a), A2(ro, Cs, e));
                    }(A2(gb, n, w = e.a));
                case 4:
                    return A3(up, n, w = e.a, function(n) {
                        return A2(el, n, ol);
                    });
                case 5:
                    return function(n) {
                        var e = n.b;
                        return d(Df(n.a), A2(ro, xs, e));
                    }(A2(Ch, n, w = e.a));
                case 10:
                    return function(n) {
                        var e = n.b;
                        return d(Qf(n.a), A2(ro, Ds, e));
                    }(A2(Qv, n, w = e.a));
                case 6:
                    return A3(up, n, w = e.a, function(n) {
                        return A2(el, n, rl);
                    });
                case 7:
                    return A3(up, n, w = e.a, function(n) {
                        return A2(el, n, ll);
                    });
                case 8:
                    return A3(up, n, w = e.a, function(n) {
                        return A2(el, n, tl(w.bw));
                    });
                case 9:
                    var c = A2(Lh, n, w = e.a);
                    return $ = c.b, d(Gf(c.a), A2(ro, qs, $));
                case 13:
                    var o = A2(og, n, w = e.a);
                    return $ = o.b, d(Uf(o.a), A2(ro, Ps, $));
                case 15:
                    var s = A2(pg, n, w = e.a);
                    return $ = s.b, d(Hf(s.a), A2(ro, Es, $));
                case 16:
                    var f = A2(Jg, n, w = e.a);
                    return $ = f.b, d(Vf(f.a), A2(ro, Ns, $));
                case 14:
                    var l = A2(rv, n, w = e.a);
                    return $ = l.b, d(zf(l.a), A2(ro, Ls, $));
                case 17:
                    w = e.a;
                    var b = A2(uc, bl(n), w.cq);
                    if (1 === b.$) return d(il, eo);
                    var h = A2(Th, n, b.a);
                    return $ = h.b, d(Of(h.a), A2(ro, js, $));
                case 24:
                    return d(sl, eo);
                case 18:
                    var g = A2(dv, n, i);
                    return $ = g.b, d(Jf(g.a), A2(ro, Mf, $));
                case 19:
                    var v = A2(iv, n, i);
                    return $ = v.b, d(Yf(v.a), A2(ro, Zf, $));
                case 20:
                    var p = d({}, eo);
                    return $ = p.b, d(Kf(p.a), A2(ro, Wf, $));
                case 12:
                    var m = A2(eg, n, w = e.a);
                    return $ = m.b, d(Bf(m.a), A2(ro, As, $));
                case 21:
                    return function(n) {
                        var e = n.b;
                        return d(Rf(n.a), A2(ro, Ts, e));
                    }(A2(Yh, n, w = e.a));
                case 22:
                    return function(n) {
                        var e = n.b;
                        return d(Ff(n.a), A2(ro, Is, e));
                    }(A2(Uh, n, w = e.a));
                default:
                    return d(cl(w = e.a), eo);
            }
        } else switch(e.$){
            case 23:
                return d(il, eo);
            case 24:
                return d(sl, eo);
            case 1:
                return A3(up, n, w = e.a, function(n) {
                    return A2(el, n, ul);
                });
            case 3:
                return r = (t = A2(gb, n, w = e.a)).b, d(Nf(t.a), A2(ro, Cs, r));
            case 10:
                return function(n) {
                    var e = n.b;
                    return d(Qf(n.a), A2(ro, Ds, e));
                }(A2(Qv, n, w = e.a));
            case 11:
                return function(n) {
                    var e = n.b;
                    return d(Xf(n.a), A2(ro, Os, e));
                }(A2(rp, n, w = e.a));
            case 13:
                var y = A2(og, n, w = e.a), $ = y.b;
                return d(Uf(y.a), A2(ro, Ps, $));
            case 14:
                return function(n) {
                    var e = n.b;
                    return d(zf(n.a), A2(ro, Ls, e));
                }(A2(rv, n, w = e.a));
            case 16:
                return function(n) {
                    var e = n.b;
                    return d(Vf(n.a), A2(ro, Ns, e));
                }(A2(Jg, n, w = e.a));
            case 21:
                return function(n) {
                    var e = n.b;
                    return d(Rf(n.a), A2(ro, Ts, e));
                }(A2(Yh, n, w = e.a));
            case 22:
                return function(n) {
                    var e = n.b;
                    return d(Ff(n.a), A2(ro, Is, e));
                }(A2(Uh, n, w = e.a));
            case 25:
                var w;
                return d(cl(w = e.a), eo);
            default:
                return d(cl({
                    gV: mt(Hl(e))
                }), eo);
        }
    }), op = F2(function(n, e) {
        var t = d(n, e);
        n: for(;;)switch(t.a.$){
            case 6:
                switch(t.b.$){
                    case 7:
                    case 1:
                        return u((r = t.a.a).dC, (a = t.b.a).dC) && u(r.cq, a.cq);
                    default:
                        break n;
                }
            case 7:
                switch(t.b.$){
                    case 6:
                    case 1:
                        return u((r = t.a.a).dC, (a = t.b.a).dC) && u(r.cq, a.cq);
                    default:
                        break n;
                }
            case 8:
                switch(t.b.$){
                    case 8:
                    case 1:
                    case 6:
                        return u((r = t.a.a).dC, (a = t.b.a).dC) && u(r.cq, a.cq);
                    default:
                        break n;
                }
            case 1:
                if (6 === t.b.$) return u((r = t.a.a).dC, (a = t.b.a).dC) && u(r.cq, a.cq);
                break n;
            case 3:
                var r, a;
                if (3 === t.b.$) return u((r = t.a.a).dC, (a = t.b.a).dC) && u(r.cq, a.cq) && u(r.a9, a.a9) && u(r.dS, a.dS) && u(r.eZ, a.eZ);
                break n;
            default:
                break n;
        }
        return !1;
    }), sp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lp = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), dp = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/api/organizations/{organizationId}/accounts/{accountId}", y([
            d("organizationId", n),
            d("accountId", e)
        ]), v, v, yt, br(0));
    }), bp = F2(function(n, e) {
        return {
            gS: e,
            hB: n
        };
    }), hp = A3(ua, "productId", Bo, A3(ua, "url", ta, br(bp))), gp = A2(bc, jl, Kb), vp = function(n) {
        return y([
            A3(Wb, "displayName", Kb, n.k),
            A3(Wb, "primaryAccountId", gp, n.gM)
        ]);
    }, pp = A2(ao, Bb, vp), mp = sn, yp = Dn("paddleSubscribe", function(n) {
        return Rb(y([
            d("passthrough", Kb(n.gE)),
            d("paymentLink", Kb(n.gG)),
            d("product", mp(n.gR))
        ]));
    }), $p = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, {
                    cb: a = e.a
                }), eo);
            case 8:
                return d(h(t, {
                    n: e.a
                }), eo);
            case 1:
                var r = e.a;
                return 3 > yr(r.k) ? d(h(t, {
                    bP: A2(rh, so("Name should have at least 3 characters"), yt)
                }), eo) : d(t, A3($l, n, A7(ju, "POST", "/api/v1/api/organizations", v, v, v, A2(Zi, Vb, mt(pp(r))), Ui), A2(bc, If, sp)));
            case 3:
                return d(t, A3($l, n, A2(dp, e.a, e.b), A2(bc, If, fp)));
            case 2:
                return d(h(t, {
                    bP: a = e.a
                }), ch(a) ? sh : eo);
            case 4:
                var a;
                return d(h(t, {
                    cF: a = e.a
                }), ch(a) ? sh : eo);
            case 5:
                var i = e.a;
                return d(h(t, {
                    gG: Qr
                }), A3($l, n, A7(ju, "POST", "/api/v1/api/organizations/{organizationId}/paymentLink", y([
                    d("organizationId", i.c)
                ]), v, v, yt, hp), A2(bc, If, lp(i))));
            case 6:
                i = e.a;
                var u = e.b, c = function() {
                    if (3 === u.$) {
                        var n = u.a;
                        return yp({
                            gE: i.c,
                            gG: n.hB,
                            gR: n.gS
                        });
                    }
                    return eo;
                }();
                return d(h(t, {
                    gG: u
                }), c);
            case 7:
                return d(h(t, {
                    dJ: !0
                }), eo);
            default:
                return d(h(t, {
                    cz: e.a
                }), eo);
        }
    }), wp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, {
                    bO: !t.bO
                }), eo);
            case 2:
                return d(h(t, {
                    a7: Qr
                }), A3($l, n, A7(ju, "POST", "/api/v1/auth/cli/authorization/request/{browserToken}/confirm", y([
                    d("browserToken", t.ci.ga)
                ]), v, v, yt, br(0)), A2(ao, wp, If)));
            case 1:
                return d(t, A2(Vl, n.iK, Wu));
            case 3:
                return d(h(t, {
                    cw: e.a
                }), eo);
            default:
                return d(h(t, {
                    a7: e.a
                }), eo);
        }
    }), Cp = F4(function(n, e, t, r) {
        return d({
            cq: e,
            cu: Bs,
            a1: Qr,
            dC: e.hf,
            eb: t,
            dN: Bs,
            ef: r
        }, Au(A2(tt, A3(ig, n, e, qv), u(t, ol) ? y([
            A2(Yv, n, e)
        ]) : v)));
    }), xp = F3(function(n, e, t) {
        switch(e.$){
            case 3:
                return d(t, A2(Vl, n.iK, e.a));
            case 0:
                var r = e.b;
                if (!u(e.a, n.ci)) return d(t, eo);
                switch(r.$){
                    case 3:
                        var a = r.a, i = function(e) {
                            var r = function() {
                                var r = A2(au, e.c, t.hV);
                                if (1 === r.$) {
                                    var a = t.bD;
                                    return a.$ ? A4(Cp, n, e, a.b, 0) : A4(Cp, n, e, ul, 1);
                                }
                                return d(r.a, eo);
                            }();
                            return b(e.c, r.a, r.b);
                        }, c = ka(A2(Gr, function(n) {
                            return d(n.c, v);
                        }, n.hV)), o = A3(Or, F2(function(n, e) {
                            var t, r = (t = A2(au, n.br.bo, e)).$ ? v : t.a;
                            return A3(wa, n.br.bo, A2(tt, n, r), e);
                        }), c, a), s = (k = t.bD).$ ? y([
                            k.a
                        ]) : n.hV;
                        return d(h(t, {
                            hV: A3(Or, function(n) {
                                return A2(wa, n.a, n.b);
                            }, va, w = A2(Gr, i, s)),
                            aR: Fs(o)
                        }), Au(A2(Gr, function(n) {
                            var e = n.a;
                            return A2(ro, function(n) {
                                return Ms({
                                    bF: e,
                                    bG: n
                                });
                            }, n.c);
                        }, w)));
                    case 2:
                        return d(h(t, {
                            aR: Rs(r.a)
                        }), eo);
                    case 0:
                        return d(h(t, {
                            aR: Bs
                        }), eo);
                    default:
                        return d(h(t, {
                            aR: Qr
                        }), eo);
                }
            case 1:
                return d(t, A2(_h, n, t));
            default:
                var f = e.a.bG, l = e.a.bF, g = A2(au, l, t.hV);
                if (1 === g.$) return d(t, eo);
                var p = A3(Mv, n, f, g.a), m = p.a, $ = p.b;
                return d(h(t, {
                    hV: A3(du, l, function() {
                        return mt(m);
                    }, t.hV)
                }), A2(ro, function(n) {
                    return Ms({
                        bF: l,
                        bG: n
                    });
                }, $));
        }
        var w, k;
    }), jp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sp = function(n) {
        return y([
            A3(_b, "name", Kb, n.n),
            A3(_b, "displayName", Kb, n.k)
        ]);
    }, Ip = A2(ao, Bb, Sp), Tp = F2(function(n, e) {
        return A7(ju, "PATCH", "/api/v1/gitlab/installation/{installationId}", y([
            d("installationId", n)
        ]), v, v, A2(Zi, Vb, mt(Ip(e))), zh);
    }), Ap = F2(function(n, e) {
        return A3($l, n, A2(Tp, e.ci.c8, {
            k: mt(e.k),
            n: mt(e.n)
        }), A2(ao, qp, If));
    }), Ep = F2(function(n, e) {
        return u(e.n, n.n) && u(e.k, n.k);
    }), Np = F2(function(n, e) {
        return function(n) {
            var e = n.aq;
            switch(e.$){
                case 3:
                    return !A2(Ep, n, e.a);
                case 2:
                default:
                    return !1;
                case 0:
                    var t = n.ac;
                    return 3 === t.$ && !A2(Ep, n, t.a);
            }
        }(e) ? d(h(e, {
            aq: Qr
        }), A2(Ap, n, e)) : d(e, eo);
    }), Lp = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, 3 === e.a.$ ? {
                    k: (a = e.a.a).k,
                    ac: Fs(a),
                    n: a.n
                } : {
                    ac: a = e.a
                }), eo);
            case 1:
                if (3 === e.a.$) {
                    var r = h(t, {
                        ac: Fs(a = e.a.a),
                        aq: Fs(a)
                    });
                    return A2(Np, n, r);
                }
                return r = h(t, {
                    aq: a = e.a
                }), A2(Np, n, r);
            case 2:
                return d(h(t, {
                    bU: Qr
                }), A3($l, n, A7(ju, "DELETE", "/api/v1/gitlab/installation/{installationId}", y([
                    d("installationId", t.ci.c8)
                ]), v, v, yt, br(0)), A2(ao, jp, If)));
            case 4:
                if (e.a) return r = h(t, {
                    k: e.b
                }), A2(Np, n, r);
                r = h(t, {
                    n: e.b
                });
                return A2(Np, n, r);
            case 3:
                var a;
                return d(h(t, {
                    bU: a = e.a
                }), eo);
            default:
                return d(h(t, {
                    aq: Qr
                }), A2(Ap, n, t));
        }
    }), Pp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Dp = function(n) {
        return y([
            A3(Wb, "gitlabURL", Kb, n.c1),
            A3(Wb, "gitlabAdminUsername", Kb, n.fA),
            A3(Wb, "gitlabAdminPassword", Kb, n.fz)
        ]);
    }, Op = A2(ao, Bb, Dp), Gp = F2(function(n, e) {
        var t = A2(fo, n, e);
        return t.$ ? lt(so(Rt(t.a))) : gt(t.a);
    }), _p = F2(function(n, e) {
        if (Cr(e)) {
            var t = A2(fo, n, "{}");
            return t.$ ? A2(Gp, n, e) : gt(t.a);
        }
        return A2(Gp, n, e);
    }), Fp = F2(function(n, e) {
        return e.$ ? lt(e.a) : gt(n(e.a));
    }), Rp = F2(function(n, e) {
        switch(e.$){
            case 0:
                return lt(uo(e.a));
            case 1:
                return lt(oo);
            case 2:
                return lt(co);
            case 3:
                return lt(io(e.a.jL));
            default:
                return A2(n, e.a, e.b);
        }
    }), Bp = A2(ho, function(n) {
        return n.a;
    }, gt), Hp = F2(function(n, e) {
        var t, r, a, i, u, c, o;
        return A2(ro, A2(ao, Pp, If), (t = {
            jd: function(n) {
                if (3 === n.$) {
                    var e = n.b;
                    return 400 === n.a.jL ? mt(A2(Fp, lt, A2(_p, A2(Zr, "message", ta), e))) : yt;
                }
                return yt;
            },
            jh: function(n) {
                return gt(n);
            },
            jv: (o = {
                fz: e.aQ,
                fA: e.aW,
                c1: e.c1
            }, A7(ju, "POST", "/api/v1/gitlab/installation", v, v, v, A2(Zi, Vb, mt(Op(o))), zh)),
            jH: n
        }, a = t.jh, i = t.jd, c = u = t.jv, A2(ro, function(n) {
            var e = i(n);
            return e.$ ? A2(Fp, a, A2(Rp, F2(function(n, e) {
                return A2(_p, c.bR, e);
            }), n)) : e.a;
        }, Po({
            aD: (r = A2(_o, t.jH.c_.hZ, u)).aD,
            ir: Bp,
            M: r.M,
            aO: r.aO,
            ay: r.ay,
            bA: r.bA,
            hB: A3(yo, r.a3, r.cd, r.cf)
        }))));
    }), Vp = F3(function(n, e, t) {
        return {
            c1: n,
            aQ: t,
            aW: e
        };
    }), zp = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Up = zp, Wp = F2(function(n, e) {
        var t = e.b;
        return A2(Up, n(e.a), A2(Gr, n, t));
    }), Kp = F4(function(n, e, t, r) {
        return A2(ao, A2(ao, A2(ao, go(Wp(e)), Fp(t)), r), n);
    }), Zp = function(n) {
        return A2(Kp, n, gr);
    }, Yp = function(n) {
        return A2(Zp, n, gr);
    }, Mp = function(n) {
        return A2(tt, n.a, n.b);
    }, Jp = F2(function(n, e) {
        return A2(bc, Mp, A2(Or, n, e));
    }), Qp = F2(function(n, e) {
        var t = F2(function(n, e) {
            return A2(Up, n, Mp(e));
        });
        return A3(Jp, t, e, n);
    }), Xp = F4(function(n, e, t, r) {
        var a = e(r);
        if (1 === a.$) {
            var i = a.a, u = t(r);
            return lt(1 === u.$ ? A2(Qp, i, u.a) : i);
        }
        var c = a.a, o = t(r);
        return 1 === o.$ ? lt(o.a) : gt(A2(n, c, o.a));
    }), nm = F2(function(n, e) {
        return A2(Xp, Jt, A2(Yp, n, e));
    }), em = function(n) {
        return A3(Kp, gr, n, gr);
    }, tm = function(n) {
        return A2(Up, n, v);
    }, rm = A2(ao, lt, tm), am = gt, im = F4(function(n, e, t, r) {
        return n(r) ? am(t(r)) : rm(e);
    }), um = A3(im, A2(ao, Ii, Cr), 0, gr), cm = A2(ao, Ka, gt), om = (as = function(n) {
        return em(function(e) {
            return d(n, e);
        });
    }, is = function(n) {
        return "https://" === n || "http://" === n ? lt(tm("please enter a valid URL")) : A2(Ar, "https://", n) || A2(Ar, "http://", n) ? gt(n) : lt(tm("please enter a URL that starts with http:// or https://"));
    }, us = A2(em, function() {
        return "must not be empty";
    }, um), A3(nm, function(n) {
        return n.aQ;
    }, A2(as, "GitLab Admin Password", us), A3(nm, function(n) {
        return n.aW;
    }, A2(as, "GitLab Admin Username", us), A3(nm, function(n) {
        return n.c1;
    }, A2(as, "GitLab URL", is), cm(Vp))))), sm = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(t, eo);
            case 1:
                switch(e.a){
                    case 0:
                        return d(h(t, {
                            c1: e.b
                        }), eo);
                    case 1:
                        return d(h(t, {
                            aW: e.b
                        }), eo);
                    default:
                        return d(h(t, {
                            aQ: e.b
                        }), eo);
                }
            case 2:
                var r = om(t);
                if (r.$) return d(h(t, {
                    aA: !0
                }), eo);
                var a = r.a;
                return d(h(t, {
                    c6: Qr,
                    aA: !1
                }), A2(Hp, n, a));
            case 3:
                return d(h(t, {
                    c6: i = e.a
                }), 3 !== i.$ || i.a.$ ? eo : A2(Vl, n.iK, Ku({
                    c8: i.a.a.c
                })));
            default:
                var i;
                return d(h(t, {
                    c7: i = e.a
                }), eo);
        }
    }), fm = function(n) {
        var e;
        return n.fZ || !(e = n.g9).$ && e.a >= 120;
    }, lm = Te, dm = F2(function(n, e) {
        return A2(lm, n, Hl(e));
    }), bm = function(n) {
        return Gu({
            cq: n.ax,
            dC: n.hf
        });
    }, hm = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                var r = e.a;
                return d(h(t, {
                    aU: A2(rd, t.aU, r)
                }), function() {
                    if (3 === r.$) {
                        var e = r.a;
                        if (fm(e)) return eo;
                        var t = e.cq;
                        return t.$ ? eo : A2(dm, n.iK, bm(t.a));
                    }
                    return eo;
                }());
            case 1:
                return d(t, A2(ng, n, t));
            default:
                var a = t.aU.ie;
                return 3 === a.$ && fm(a.a) ? d(t, eo) : d(t, A2(Vl, n.iK, Wu));
        }
    }), gm = function(n) {
        return {
            $: 14,
            a: n
        };
    }, vm = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), pm = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mm = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ym = {
        $: 20
    }, $m = function(n) {
        return {
            $: 12,
            a: n
        };
    }, wm = function(n) {
        return {
            $: 9,
            a: n
        };
    }, km = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), Cm = F2(function(n, e) {
        return {
            a8: n,
            fo: e
        };
    }), xm = F2(function(n, e) {
        return {
            a9: e,
            V: n
        };
    }), jm = A3(ua, "derivationPath", ta, A3(ua, "status", Yd, br(xm))), qm = A3(ua, "failedDependencies", Ki(ta), A3(ua, "derivation", jm, br(Cm))), Sm = A3(ua, "nodes", Ki(qm), br(function(n) {
        return {
            gt: n
        };
    })), Im = F2(function(n, e) {
        return {
            bq: n,
            bs: e
        };
    }), Tm = A3(ua, "requiredSystemFeatures", Ki(ta), A3(ua, "platform", ta, br(Im))), Am = F3(function(n, e, t) {
        return {
            bp: n,
            W: t,
            bC: e
        };
    }), Em = A2(fr, function(n) {
        switch(n){
            case "Regular":
                return br(0);
            case "MustFail":
                return br(1);
            case "MayFail":
                return br(2);
            case "DependenciesOnly":
                return br(3);
            case "Effect":
                return br(4);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Nm = F2(function(n, e) {
        return {
            e9: e,
            gx: n
        };
    }), Lm = F4(function(n, e, t, r) {
        return {
            fa: t,
            fb: n,
            fd: e,
            hx: r
        };
    }), Pm = A4(Aa, "trace", ta, yt, A4(Aa, "errorDerivation", ta, yt, A4(Aa, "errorType", ta, yt, A3(ua, "errorMessage", ta, br(Lm))))), Dm = A4(Aa, "Error", Pm, yt, A4(Aa, "Ok", jm, yt, br(Nm))), Om = A3(ua, "typ", Em, A3(ua, "value", Dm, A3(ua, "path", Ki(ta), br(Am)))), Gm = F3(function(n, e, t) {
        return {
            a8: e,
            ab: n,
            af: t
        };
    }), _m = A3(ua, "outputName", ta, A3(ua, "derivation", jm, A3(ua, "index", Bo, br(Gm)))), Fm = F3(function(n, e, t) {
        return {
            bp: n,
            W: t,
            bC: e
        };
    }), Rm = A3(ua, "typ", Em, A3(ua, "value", jm, A3(ua, "path", Ki(ta), br(Fm)))), Bm = F3(function(n, e, t) {
        return {
            ab: n,
            bl: t,
            W: e
        };
    }), Hm = A2(fr, function(n) {
        switch(n){
            case "Error":
                return br(0);
            case "Trace":
                return br(1);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Vm = A3(ua, "message", ta, A3(ua, "typ", Hm, A3(ua, "index", Bo, br(Bm)))), zm = A3(ua, "unmetAgentRequirements", Ki(Tm), A3(ua, "derivationsCancelledCount", Bo, A3(ua, "derivationsBuildSuccessCount", Bo, A3(ua, "derivationsDependencyFailureCount", Bo, A3(ua, "derivationsBuildFailureCount", Bo, A3(ua, "derivationsBuildingCount", Bo, A3(ua, "derivationsWaitingCount", Bo, A3(ua, "derivations", Ca(Yd), A4(Aa, "evaluationLog", ha, yt, A3(ua, "evaluationDependencies", Ki(_m), A3(ua, "ifdAttributes", Ki(Rm), A3(ua, "attributes", Ki(Om), A3(ua, "messages", Ki(Vm), A3(ua, "agentVersion", ta, A3(ua, "agentHostname", ta, A3(ua, "id", ha, br(function(n) {
        return function(e) {
            return function(t) {
                return function(r) {
                    return function(a) {
                        return function(i) {
                            return function(u) {
                                return function(c) {
                                    return function(o) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(h) {
                                                                return function(g) {
                                                                    return {
                                                                        a_: e,
                                                                        a0: t,
                                                                        cv: a,
                                                                        e_: o,
                                                                        e$: l,
                                                                        e0: b,
                                                                        e1: f,
                                                                        e2: h,
                                                                        e3: d,
                                                                        e4: s,
                                                                        fg: u,
                                                                        fi: c,
                                                                        c: n,
                                                                        fP: i,
                                                                        gh: r,
                                                                        hz: g
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))), Um = F3(function(n, e, t) {
        return {
            de: n,
            gy: e,
            gz: t
        };
    }), Wm = F2(function(n, e) {
        return {
            da: e,
            n: n
        };
    }), Km = A3(ua, "isFlake", aa, A3(ua, "name", ta, br(Wm))), Zm = F4(function(n, e, t, r) {
        return {
            da: e,
            gb: r,
            n: n,
            hP: t
        };
    }), Ym = F4(function(n, e, t, r) {
        return {
            eV: r,
            eW: t,
            fM: e,
            gj: n
        };
    }), Mm = A2(fr, function(n) {
        switch(n){
            case "Mon":
                return br(0);
            case "Tue":
                return br(1);
            case "Wed":
                return br(2);
            case "Thu":
                return br(3);
            case "Fri":
                return br(4);
            case "Sat":
                return br(5);
            case "Sun":
                return br(6);
            default:
                return ea("Unknown type: " + n);
        }
    }, ta), Jm = A4(Aa, "dayOfMonth", Ki(Bo), yt, A4(Aa, "dayOfWeek", Ki(Mm), yt, A3(ua, "hour", Ki(Bo), A3(ua, "minute", Bo, br(Ym))))), Qm = A3(ua, "mainExists", aa, A3(ua, "when", Jm, A3(ua, "isFlake", aa, A3(ua, "name", ta, br(Zm))))), Xm = A3(ua, "onSchedule", Ca(Qm), A3(ua, "onPush", Ca(Km), A3(ua, "jobId", ha, br(Um)))), ny = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/jobs/{jobId}/on-schedule/{jobName}/run", y([
            d("jobId", n),
            d("jobName", e)
        ]), v, v, yt, ob);
    }), ey = F2(function(n, e) {
        return A7(ju, "POST", "/api/v1/jobs/{jobId}/rerun", y([
            d("jobId", n)
        ]), y([
            d("rebuildFailures", A2(Zi, function(n) {
                return n ? "true" : "false";
            }, e))
        ]), v, yt, ob);
    }), ty = F2(function(n, e) {
        var t = A2(Zi, n, e);
        return !t.$ && t.a ? e : yt;
    }), ry = F2(function(n, e) {
        return A3(wa, n, 0, e);
    }), ay = function(n) {
        return A2(Zi, function(n) {
            return n.b;
        }, fd(n.as.ie));
    }, iy = function(n) {
        return 1 === n.$;
    }, uy = F2(function(n, e) {
        return function(n) {
            return !iy(n.ao);
        }(n) ? d(h(n, {
            ao: Qr
        }), e) : d(n, eo);
    }), cy = F2(function(n, e) {
        return A2(lu, n, e);
    }), oy = F2(function(n, e) {
        return {
            $: 19,
            a: n,
            b: e
        };
    }), sy = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, fy = F4(function(n, e, t, r) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/evaluation/log/lines", y([
            d("jobId", n)
        ]), y([
            d("logId", mt(e)),
            d("iMin", A2(Zi, Ct, t)),
            d("verbosity", A2(Zi, sy, r))
        ]), v, yt, Al);
    }), ly = F2(function(n, e) {
        var t = e.as.ie;
        if (3 === t.$) {
            var r = t.a, a = r.b;
            return d(e, Au(A2(Gr, function(t) {
                return A3($l, n, A4(fy, a.c, t, e.aF ? function(n) {
                    return 3 === n.$ ? A2(Zi, function(n) {
                        return n.fN;
                    }, ad(n.a.f8)) : yt;
                }(e.ak) : yt, mt(e.aG)), A2(bc, If, oy(e.aG)));
            }, Rl(r.c.fi))));
        }
        return d(e, eo);
    }), dy = F2(function(n, e) {
        if (3 === n.$) {
            var t = n.a;
            return Fs(3 === e.$ ? A2(id, e.a, t) : t);
        }
        return 1 === e.$ ? n : e;
    }), by = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(t, A2(Vl, n.iK, e.a));
            case 1:
                var r = e.b, a = (s = e.a).df;
                if (a.b) {
                    var i = a.a;
                    return A2(km, function(e) {
                        return i.f1 ? d(h(e, {
                            at: Bs
                        }), eo) : d(h(e, {
                            at: e.at.$ ? e.at : Qr
                        }), A3($l, n, A7(ju, "GET", "/api/v1/jobs/{jobId}/handlers", y([
                            d("jobId", i.c)
                        ]), v, v, yt, Xm), A2(bc, If, mm)));
                    }, A2(km, function(e) {
                        return function(n) {
                            return 3 === n.$ && n.a.e6;
                        }(e.ak) ? d(e, eo) : A2(ly, n, e);
                    }, d(h(t, {
                        as: A2(rd, t.as, A2(Af, function(n) {
                            return b(s.br, i, n);
                        }, If(r)))
                    }), eo)));
                }
                return d(t, eo);
            case 2:
                return d(h(t, {
                    at: e.a
                }), eo);
            case 5:
                var c = function(n) {
                    return ka(A2(Gr, function(n) {
                        return d(n.a8.a9, d(n.a8, n.fo));
                    }, n.gt));
                };
                return d(h(t, {
                    aH: A2(rd, t.aH, A2(Af, c, e.a))
                }), eo);
            case 8:
                return d(t, A3($l, n, A2(Ll, e.a.bF, ku(e.a.a9)), wm));
            case 6:
                return d(h(t, {
                    aa: A2(ry, e.a.bp, t.aa)
                }), eo);
            case 7:
                return d(h(t, {
                    aa: A2(cy, e.a.bp, t.aa)
                }), eo);
            case 9:
            default:
                return d(t, eo);
            case 4:
                var o = A2(sd, v, If(r = e.a));
                if (o.b) {
                    var s, f = (s = o.a).df;
                    if (f.b) {
                        var l = f.a, g = A2(uy, t.as, A3($l, n, A7(ju, "GET", "/api/v1/jobs/{jobId}/evaluation", y([
                            d("jobId", l.c)
                        ]), v, v, yt, zm), vm(s))), p = (i = g.a, g.b), m = A2(uy, t.aH, A3($l, n, A7(ju, "GET", "/api/v1/jobs/{jobId}/derivations/failed", y([
                            d("jobId", l.c)
                        ]), v, v, yt, Sm), A2(bc, If, pm))), $ = m.b;
                        return d(h(t, {
                            aH: m.a,
                            as: i
                        }), Au(y([
                            p,
                            $
                        ])));
                    }
                    return d(h(t, {
                        as: A2(rd, t.as, Rs(uo("No such job number exists")))
                    }), eo);
                }
                return d(h(t, {
                    as: A2(rd, t.as, Rs(uo("No such repository exists")))
                }), eo);
            case 3:
                return d(h(t, {
                    a1: e.a
                }), eo);
            case 10:
                return d(t, A2(cg, n, t));
            case 11:
                var w = ay(t);
                return w.$ ? d(t, eo) : (i = w.a, d(h(t, {
                    bt: Qr
                }), A3($l, n, A2(ey, i.c, mt(!0)), A2(bc, If, $m))));
            case 12:
                var k = d(h(t, {
                    bt: A = e.a
                }), eo);
                if (3 === A.$) {
                    var C = A.a, x = t.as.ie;
                    if (3 === x.$) {
                        var j = x.a.a;
                        return d(h(t, {
                            as: ml,
                            bt: A
                        }), A2(Vl, n.iK, Yu({
                            cq: t.H,
                            ab: C.ab,
                            br: j.ax,
                            dC: t.dD
                        })));
                    }
                    return k;
                }
                return k;
            case 15:
                var q = e.a, S = ay(t);
                return S.$ ? d(t, eo) : (i = S.a, d(h(t, {
                    bu: Qr
                }), A3($l, n, A2(ny, i.c, q), A2(bc, If, $m))));
            case 16:
                if (k = d(h(t, {
                    bu: A = e.a
                }), eo), 3 === A.$) {
                    C = A.a;
                    var I = t.as.ie;
                    return 3 === I.$ ? (j = I.a.a, d(h(t, {
                        bu: A
                    }), A2(Vl, n.iK, Yu({
                        cq: t.H,
                        ab: C.ab,
                        br: j.ax,
                        dC: t.dD
                    })))) : k;
                }
                return k;
            case 13:
                var T = ay(t);
                return T.$ ? d(t, eo) : (i = T.a, d(h(t, {
                    bM: Qr
                }), A3($l, n, function(n) {
                    return A7(ju, "POST", "/api/v1/jobs/{jobId}/cancel", y([
                        d("jobId", n)
                    ]), v, v, yt, br(0));
                }(i.c), A2(bc, If, gm))));
            case 14:
                var A;
                return d(h(t, {
                    bM: A = e.a
                }), eo);
            case 17:
                return d(h(t, {
                    b0: P = e.a
                }), eo);
            case 18:
                var E = e.a;
                return d(h(t, {
                    b$: u(t.b$, mt(E)) ? yt : mt(E)
                }), eo);
            case 21:
                var N = e.a;
                return A2(km, ly(n), d(h(t, {
                    aF: !1,
                    aG: N
                }), eo));
            case 19:
                N = e.a;
                var L = e.b, P = t.aF ? A2(dy, L, t.ak) : L, D = !u(A2(Af, A2(ao, It, function(n) {
                    return n.f8;
                }), t.ak), A2(Af, A2(ao, It, function(n) {
                    return n.f8;
                }), P)), O = A2(ty, function() {
                    return D;
                }, A2(Zi, function(n) {
                    return n.c;
                }, fd(P)));
                return u(N, t.aG) ? d(h(t, {
                    ak: P,
                    aF: !0
                }), O.$ ? eo : A3(ed, t.b0, "evaluation_log", ym)) : d(t, eo);
        }
    }), hy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gy = F4(function(n, e, t, r) {
        return {
            en: e,
            cv: t,
            ex: n,
            fQ: r
        };
    }), vy = F2(function(n, e) {
        return {
            bp: n,
            bC: e
        };
    }), py = F2(function(n, e) {
        return {
            ct: e,
            cy: n
        };
    }), my = A4(Aa, "after", Om, yt, A4(Aa, "before", Om, yt, br(py))), yy = A3(ua, "value", my, A3(ua, "path", Ki(ta), br(vy))), $y = F2(function(n, e) {
        return {
            ct: e,
            cy: n
        };
    }), wy = F2(function(n, e) {
        return {
            a8: n,
            af: e
        };
    }), ky = A3(ua, "outputName", ta, A3(ua, "derivation", jm, br(wy))), Cy = A4(Aa, "after", ky, yt, A4(Aa, "before", ky, yt, br($y))), xy = A3(ua, "ifds", Ki(Cy), A3(ua, "attributes", Ki(yy), A3(ua, "afterId", ha, A3(ua, "beforeId", ha, br(gy))))), jy = F2(function(n, e) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/evaluation/compare/{baseJobId}", y([
            d("jobId", n),
            d("baseJobId", e)
        ]), v, v, yt, xy);
    }), qy = F2(function(n, e) {
        var t = d(e.ci.ew, e.am);
        if (t.a.$ || 3 !== t.b.$) return d(e, eo);
        var r = t.a.a, a = t.b.a;
        return d(h(e, {
            bV: Qr
        }), A3($l, n, A2(jy, a.c, r), A2(ao, hy, If)));
    }), Sy = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Iy = F3(function(n, e, t) {
        var r = t.ci;
        return d(h(t, {
            a5: Qr
        }), A3($l, n, A5(Gh, mt(r.dC), mt(r.cq), mt(r.br), mt(e), mt(1)), A2(ao, A2(ao, Sy, Hs(gg)), If)));
    }), Ty = F3(function(n, e, t) {
        switch(e.$){
            case 7:
            case 0:
                return d(t, eo);
            case 1:
                return d(h(t, {
                    bV: r = e.a
                }), eo);
            case 2:
                var r = e.a;
                return A2(fg, qy(n), d(h(t, {
                    am: r
                }), eo));
            case 3:
                return d(h(t, {
                    aj: r = e.a
                }), eo);
            case 4:
                return d(h(t, {
                    b1: e.a
                }), eo);
            case 5:
                return A2(fg, A2(Iy, n, e.a), d(t, eo));
            default:
                var a = e.a;
                if (3 === a.$) {
                    var i = a.a, u = t.ci;
                    return A2(fg, qy(n), d(h(t, {
                        aj: a,
                        a5: Bs,
                        ci: h(u, {
                            ew: mt(i.c)
                        })
                    }), A2(Vl, n.iK, Mu(h(u, {
                        ew: mt(i.c)
                    })))));
                }
                return d(h(t, {
                    a5: a
                }), eo);
        }
    }), Ay = F3(function(n, e, t) {
        if (e.$) {
            if (3 === e.a.$) {
                var r = e.a.a.bh;
                return d(t, A2(dm, n.iK, r.b ? Yu({
                    cq: t.ci.cq,
                    ab: r.a.ab,
                    br: t.ci.br,
                    dC: t.ci.dC
                }) : tc({
                    cq: t.ci.cq,
                    gC: yt,
                    br: t.ci.br,
                    dC: t.ci.dC
                })));
            }
            return d(h(t, {
                d7: e.a
            }), eo);
        }
        return d(t, eo);
    }), Ey = F2(function(n, e) {
        return b(e, eo, mt(n));
    }), Ny = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), Ly = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), Py = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Dy = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Oy = {
        gu: yt,
        gv: yt
    }, Gy = function(n) {
        var e;
        return h(n, {
            cL: (e = A2(la, Oy, n.cL), mt(1 === e.gv.$ ? h(e, {
                gv: mt(1)
            }) : e))
        });
    }, _y = F2(function(n, e) {
        return A2(la, {
            gu: yt,
            gv: yt
        }, A2(uc, function(n) {
            return A2(Zi, function(n) {
                return n.hb;
            }, Ec(A2(nl, function(n) {
                return u(n.cq.c, e);
            }, n.cr)));
        }, fd(n.Z)));
    }), Fy = F2(function(n, e) {
        return A2(la, {
            cT: 0,
            bZ: yt,
            bd: Bs,
            dg: 0,
            b4: yt,
            bj: Bs
        }, A2(au, e, n.bH));
    }), Ry = F3(function(n, e, t) {
        return h(t, {
            bH: A3(wa, n, e, t.bH)
        });
    }), By = F3(function(n, e, t) {
        return A3(Ry, n, e(A2(Fy, t, n)), t);
    }), Hy = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, {
                    Z: A2(Af, Gy, e.a)
                }), eo);
            case 1:
                var r = e.b;
                return d(A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        cT: r
                    });
                }, t), eo);
            case 2:
                return r = e.b, d(A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        dg: r
                    });
                }, t), eo);
            case 3:
                var a = e.b;
                return d(i = A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        bZ: mt(a),
                        bd: Qr
                    });
                }, t), A3($l, n, nh(h(eh, {
                    cr: A2(fh, c, function(n) {
                        return {
                            gu: a,
                            gv: A2(la, A2(_y, i, c).gv, n.b4)
                        };
                    }(A2(Fy, i, c)))
                })), A2(ao, Ny({
                    bF: c
                }), If)));
            case 5:
                return d(A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        bZ: yt,
                        bd: A2(Af, function() {
                            return 0;
                        }, s)
                    });
                }, h(t, {
                    Z: A2(uh, t.Z, s = e.b)
                })), eo);
            case 4:
                var i, u = e.b;
                return d(i = A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        b4: mt(u),
                        bj: Qr
                    });
                }, t), A3($l, n, nh(h(eh, {
                    cr: A2(fh, c, function(n) {
                        return {
                            gu: A2(la, A2(_y, i, c).gu, n.bZ),
                            gv: u
                        };
                    }(A2(Fy, i, c)))
                })), A2(ao, Ly({
                    bF: c
                }), If)));
            case 6:
                var c;
                return d(A3(By, c = e.a.bF, function(n) {
                    return h(n, {
                        b4: yt,
                        bj: A2(Af, function() {
                            return 0;
                        }, s)
                    });
                }, h(t, {
                    Z: A2(uh, t.Z, s = e.b)
                })), eo);
            case 8:
                return d(h(t, {
                    cH: r = e.a
                }), eo);
            case 7:
                return d(h(t, {
                    cI: o = e.a,
                    bS: Qr
                }), A3($l, n, nh(h(eh, {
                    cL: mt({
                        gu: o,
                        gv: A2(oh, A2(uc, function(n) {
                            return n.gv;
                        }, A2(uc, function(n) {
                            return n.cL;
                        }, fd(t.Z))), t.cK)
                    })
                })), A2(ao, Py, If)));
            case 9:
                return d(h(t, {
                    bS: s = e.a,
                    Z: A2(uh, t.Z, s)
                }), eo);
            case 11:
                return d(h(t, {
                    cJ: r = e.a
                }), eo);
            case 10:
                var o;
                return d(h(t, {
                    cK: o = e.a,
                    bT: Qr
                }), A3($l, n, nh(h(eh, {
                    cL: mt({
                        gu: A2(oh, A2(uc, function(n) {
                            return n.gu;
                        }, A2(uc, function(n) {
                            return n.cL;
                        }, fd(t.Z))), t.cI),
                        gv: o
                    })
                })), A2(ao, Dy, If)));
            default:
                var s;
                return d(h(t, {
                    bT: s = e.a,
                    Z: A2(uh, t.Z, s)
                }), eo);
        }
    }), Vy = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), zy = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(h(t, {
                    cC: e.a
                }), eo);
            case 1:
                return d(h(t, {
                    aE: A3(wa, r = e.a, Qr, t.aE)
                }), A3($l, n, A7(ju, "POST", "/api/v1/auth/cli/tokens/{cliTokenId}/revoke", y([
                    d("cliTokenId", r)
                ]), v, v, yt, br(0)), A2(ao, Vy(r), If)));
            default:
                var r;
                return d(h(t, {
                    aE: A3(wa, r = e.a, e.b, t.aE)
                }), lv(n));
        }
    }), Uy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wy = {
        $: 1
    }, Ky = {
        $: 2
    }, Zy = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yy = F2(function(n, e) {
        return {
            $: 8,
            a: n,
            b: e
        };
    }), My = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jy = F2(function(n, e) {
        var t = e.b, r = n(e.a);
        return d(r.a, Au(y([
            t,
            r.b
        ])));
    }), Qy = We(""), Xy = F3(function(n, e, t) {
        return 0 > s(t, n) ? n : s(t, e) > 0 ? e : t;
    }), n$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, e$ = F2(function(n, e) {
        return {
            U: n,
            hi: e
        };
    }), t$ = F3(function(n, e, t) {
        return {
            n: e,
            U: n,
            hH: t
        };
    }), r$ = F8(function(n, e, t, r, a, i, u, c) {
        return {
            I: r,
            as: a,
            n: e,
            U: n,
            hd: u,
            dE: c,
            hA: i,
            hG: t
        };
    }), a$ = A4(Aa, "size", Bo, yt, A4(Aa, "sha256", ta, yt, A4(Aa, "uploader", Wi, yt, A4(Aa, "job", ob, yt, A3(ua, "creationTime", zi, A3(ua, "version", Bo, A3(ua, "name", ta, A3(ua, "projectId", ha, br(r$))))))))), i$ = A3(ua, "versions", Ki(a$), A3(ua, "name", ta, A3(ua, "projectId", ha, br(t$)))), u$ = A3(ua, "stateFiles", Ca(i$), A3(ua, "projectId", ha, br(e$))), c$ = A2(bc, function(n) {
        return n.ce;
    }, Hs(function(n) {
        return n.b && !n.b.b ? Fs(n.a) : Rs(so("Project not found"));
    })), o$ = F3(function(n, e, t) {
        var r = n(t);
        return 3 === r.$ ? e(r.a) : d(t, eo);
    }), s$ = F2(function(n, e) {
        return A3(o$, c$, function(t) {
            return d(e, A3($l, n, A7(ju, "GET", "/api/v1/projects/{projectId}/states", y([
                d("projectId", t.c)
            ]), v, v, yt, u$), A2(ao, n$, If)));
        }, e);
    }), f$ = F2(function(n, e) {
        if (-2 === e.$) return ga;
        var t = e.b, r = e.d, a = e.e;
        return A5(pa, e.a, t, A2(n, t, e.c), A2(f$, n, r), A2(f$, n, a));
    }), l$ = function(n) {
        return n.name;
    }, d$ = F3(function(n, e, t) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    var r = e.a;
                    n -= 1, e = e.b, t = A2(tt, r, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), b$ = F2(function(n, e) {
        return _t(A3(d$, n, e, v));
    }), h$ = F3(function(n, e, t) {
        if (e > 0) {
            var r = d(e, t);
            n: for(;;){
                e: for(;;){
                    if (!r.b.b) return t;
                    if (!r.b.b.b) {
                        if (1 === r.a) break n;
                        break e;
                    }
                    switch(r.a){
                        case 1:
                            break n;
                        case 2:
                            var a = r.b;
                            return y([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (r.b.b.b.b) {
                                var i = r.b, u = i.b;
                                return y([
                                    i.a,
                                    u.a,
                                    u.b.a
                                ]);
                            }
                            break e;
                        default:
                            if (r.b.b.b.b && r.b.b.b.b.b) {
                                var c = r.b, o = c.b, s = o.b, f = s.b, l = f.b;
                                return A2(tt, c.a, A2(tt, o.a, A2(tt, s.a, A2(tt, f.a, n > 1e3 ? A2(b$, e - 4, l) : A3(h$, n + 1, e - 4, l)))));
                            }
                            break e;
                    }
                }
                return t;
            }
            return y([
                r.b.a
            ]);
        }
        return v;
    }), g$ = F2(function(n, e) {
        return A3(h$, 0, n, e);
    }), v$ = F2(function(n, e) {
        return A3(Or, F2(function(e, t) {
            return A3(du, n(e), A2(bc, Zi(tt(e)), A2(bc, la(y([
                e
            ])), mt)), t);
        }), va, e);
    }), p$ = function(n) {
        return -2 === n.$;
    }, m$ = Tt(Gb), y$ = function(n) {
        var e = function(n) {
            return n.b.$ ? v : y([
                d(n.a, n.b.a)
            ]);
        }, t = function(n) {
            return 1 === n.b.$ ? y([
                d(n.a, n.b.a)
            ]) : v;
        }, r = A2(f$, F2(function(n, e) {
            return e.b && !e.b.b ? "" === e.a.a ? lt("Name must not be empty") : gt(e.a) : lt("Duplicate name");
        }), A2(v$, function(n) {
            return n.a;
        }, A2(m$, n.Y, n.aI))), a = ka(A2(Sc, e, ut(r))), i = ka(A2(Sc, t, ut(r)));
        return p$(i) ? gt(A2(f$, F2(function(n, e) {
            return e.b;
        }), a)) : lt(i);
    }, $$ = F3(function(n, e, t) {
        switch(e.$){
            case 0:
                return d(t, A2(Vl, n.iK, e.a));
            case 1:
                return A2(s$, n, t);
            case 2:
                var r = e.a;
                return A2(Jy, s$(n), d(h(t, {
                    ce: r
                }), eo));
            case 3:
                return d(h(t, {
                    bx: A2(rd, t.bx, r = e.a)
                }), eo);
            case 6:
                var a = e.a;
                return d(h(t, {
                    z: Uy({
                        aI: a,
                        Y: A2(Gr, l$, a)
                    })
                }), eo);
            case 9:
                var i = e.a, u = e.b;
                return d(h(t, {
                    z: function() {
                        var n = t.z;
                        if (1 === n.$) {
                            var e = n.a;
                            return Uy(h(e, {
                                Y: g(A2(g$, i, e.Y), A2(tt, u, A2(mu, i + 1, e.Y)))
                            }));
                        }
                        return n;
                    }()
                }), eo);
            case 10:
                return i = e.a, d(h(t, {
                    z: function() {
                        var n = t.z;
                        if (1 === n.$) {
                            var e = n.a;
                            return 1 === It(e.Y) ? Xv : Uy(h(e, {
                                aI: g(A2(g$, i, e.aI), A2(mu, i + 1, e.aI)),
                                Y: g(A2(g$, i, e.Y), A2(mu, i + 1, e.Y))
                            }));
                        }
                        return n;
                    }()
                }), eo);
            case 5:
            case 11:
                return d(h(t, {
                    z: Xv
                }), eo);
            case 4:
                return A3(o$, c$, function(e) {
                    var r = t.z;
                    if (1 === r.$) {
                        var a = y$(r.a);
                        if (a.$) return d(t, eo);
                        var i = a.a;
                        return d(h(t, {
                            z: My(A2(f$, F2(function() {
                                return Zy(0);
                            }), i))
                        }), Au(A2(Gr, function(t) {
                            var r, a = t.a;
                            return r = {
                                a3: n.c_.hZ,
                                aD: Qy(t.b),
                                jg: Yy(a),
                                U: e.c,
                                cj: a
                            }, Po({
                                aD: r.aD,
                                ir: Sf(r.jg),
                                M: A2(gu, gr, v),
                                aO: "PUT",
                                ay: mt(3e4),
                                bA: mt(r.cj),
                                hB: A3(yo, r.a3, y([
                                    "api",
                                    "v1",
                                    "projects",
                                    r.U,
                                    "state",
                                    r.cj,
                                    "data"
                                ]), A2(gu, gr, v))
                            });
                        }, ut(i))));
                    }
                    return d(t, eo);
                }, t);
            case 7:
                var c = e.a, o = e.b;
                if (o.$) return d(t, eo);
                var s = o.a, f = t.z;
                if (2 === f.$) {
                    var l = f.a;
                    return d(h(t, {
                        z: My(A3(du, c, Zi(function(n) {
                            return n.$ ? n : Zy(function(n) {
                                return n.dE ? A3(Xy, 0, 1, n.jF / n.dE) : 1;
                            }(s));
                        }), l))
                    }), eo);
                }
                return d(t, eo);
            case 8:
                var b = e.b, p = t.z;
                return 2 === p.$ ? A2(Jy, function(e) {
                    return b.$ ? d(e, eo) : A2(s$, n, e);
                }, d(h(t, {
                    z: My(A3(wa, e.a, b.$ ? Ky : Wy, l = p.a))
                }), eo)) : d(t, eo);
            default:
                return d(t, eo);
        }
    }), w$ = F3(function(n, e, t) {
        var r = d(t, eo);
        switch(e.$){
            case 0:
                var a = e.a, i = A2(cp, n, a), c = i.a, o = i.b;
                return A2(op, t.ci, a) ? d(h(t, {
                    ci: a
                }), eo) : d(h(t, {
                    gC: c,
                    ci: a
                }), o);
            case 2:
                var s = e.a, f = t.gC;
                if (10 === f.$) {
                    var l = A3(hb, n, s, f.a);
                    return o = l.b, d(h(t, {
                        gC: Nf(Q = l.a)
                    }), A2(ro, Cs, o));
                }
                return d(t, eo);
            case 3:
                var b = t.gC;
                if (2 === b.$) {
                    var g = A3(kh, n, e.a, b.a), v = g.b;
                    return d(h(t, {
                        gC: Df(g.a)
                    }), A2(ro, xs, v));
                }
                return d(t, eo);
            case 10:
                s = e.a;
                var p = t.gC;
                if (6 === p.$) {
                    var m = A3(Mg, n, s, p.a);
                    return o = m.b, d(h(t, {
                        gC: Vf(Q = m.a)
                    }), A2(ro, Ns, o));
                }
                return d(t, eo);
            case 11:
                s = e.a;
                var $ = t.gC;
                if (7 === $.$) {
                    var w = A3(Ay, n, s, $.a);
                    return o = w.b, d(h(t, {
                        gC: zf(Q = w.a)
                    }), A2(ro, Ls, o));
                }
                return r;
            case 1:
                var k = e.a, C = t.gC;
                if (9 === C.$) {
                    var x = A3(dh, n, k, C.a);
                    return o = x.b, d(h(t, {
                        gC: Pf(Q = x.a)
                    }), A2(ro, Lf, o));
                }
                return r;
            case 12:
                s = e.a;
                var j = t.gC;
                if (8 === j.$) {
                    var q = A3($p, n, s, j.a);
                    return o = q.b, d(h(t, {
                        gC: Of(Q = q.a)
                    }), A2(ro, js, o));
                }
                return d(t, eo);
            case 4:
                k = e.a;
                var S = t.gC;
                if (11 === S.$) {
                    var I = A3(kp, n, k, S.a);
                    return o = I.b, d(h(t, {
                        gC: Gf(Q = I.a)
                    }), A2(ro, qs, o));
                }
                return d(t, eo);
            case 5:
                s = e.a;
                var T = t.gC;
                if (T.$) return d(t, eo);
                var A = A3(xp, n, s, T.a);
                return o = A.b, d(h(t, {
                    gC: _f(Q = A.a)
                }), A2(ro, Ss, o));
            case 6:
                s = e.a;
                var E = t.gC;
                if (1 === E.$) {
                    var N = A3(Jv, n, s, E.a);
                    return o = N.b, d(h(t, {
                        gC: Qf(Q = N.a)
                    }), A2(ro, Ds, o));
                }
                return d(t, eo);
            case 7:
                s = e.a;
                var L = t.gC;
                if (3 === L.$) {
                    var P = A3($$, n, s, L.a);
                    return o = P.b, d(h(t, {
                        gC: Xf(Q = P.a)
                    }), A2(ro, Os, o));
                }
                return d(t, eo);
            case 8:
                s = e.a;
                var D = t.gC;
                if (4 === D.$) {
                    var O = A3(by, n, s, D.a);
                    return o = O.b, d(h(t, {
                        gC: Uf(Q = O.a)
                    }), A2(ro, Ps, o));
                }
                return d(t, eo);
            case 9:
                var G = t.gC;
                if (5 === G.$) {
                    var _ = A3(Ty, n, e.a, G.a);
                    return v = _.b, d(h(t, {
                        gC: Hf(_.a)
                    }), A2(ro, Es, v));
                }
                return d(t, eo);
            case 13:
                var F = e.a, R = t.gC;
                if (12 === R.$) {
                    var B = R.a, H = R.b;
                    if (3 === F.$) {
                        var V = A2(nl, function(n) {
                            return u(n.ax, B);
                        }, F.a);
                        if (V.b) {
                            var z = H(V.a), U = z.b;
                            return d(h(t, {
                                gC: z.a
                            }), U);
                        }
                        return r;
                    }
                    return r;
                }
                return r;
            case 14:
                s = e.a;
                var W = t.gC;
                if (16 === W.$) {
                    var K = A3(zy, n, s, W.a);
                    return o = K.b, d(h(t, {
                        gC: Jf(Q = K.a)
                    }), A2(ro, Mf, o));
                }
                return d(t, eo);
            case 15:
                s = e.a;
                var Z = t.gC;
                if (17 === Z.$) {
                    var Y = A3(Hy, n, s, Z.a);
                    return o = Y.b, d(h(t, {
                        gC: Yf(Q = Y.a)
                    }), A2(ro, Zf, o));
                }
                return d(t, eo);
            case 16:
                s = e.a;
                var M = t.gC;
                if (18 === M.$) {
                    var J = A2(Ey, s, M.a), Q = J.a, X = J.b, nn = J.c, en = nn.$ ? eo : A2(Kr, gr, Lr({
                        $: 17,
                        a: nn.a
                    }));
                    return d(h(t, {
                        gC: Kf(Q)
                    }), Au(y([
                        A2(ro, Wf, X),
                        en
                    ])));
                }
                return d(t, eo);
            case 17:
                return d(t, eo);
            case 18:
                s = e.a;
                var tn = t.gC;
                if (19 === tn.$) {
                    var rn = A3(hm, n, s, tn.a);
                    return o = rn.b, d(h(t, {
                        gC: Bf(Q = rn.a)
                    }), A2(ro, As, o));
                }
                return d(t, eo);
            case 19:
                s = e.a;
                var an = t.gC;
                if (20 === an.$) {
                    var un = A3(sm, n, s, an.a);
                    return o = un.b, d(h(t, {
                        gC: Rf(Q = un.a)
                    }), A2(ro, Ts, o));
                }
                return d(t, eo);
            default:
                s = e.a;
                var cn = t.gC;
                if (21 === cn.$) {
                    var on = A3(Lp, n, s, cn.a);
                    return o = on.b, d(h(t, {
                        gC: Ff(Q = on.a)
                    }), A2(ro, Is, o));
                }
                return d(t, eo);
        }
    }), k$ = F2(function(n, e) {
        switch(e.$){
            case 0:
                return h(n, {
                    ig: e.a
                });
            case 1:
                return h(n, {
                    ci: e.a
                });
            default:
                return h(n, {
                    hV: e.a
                });
        }
    }), C$ = F2(function(n, e) {
        var t = n.r;
        if (1 === t.$) {
            var r = t.b, a = A2(k$, t.a, {
                $: 1,
                a: n.ci
            }), i = A3(w$, a, e, r), u = i.b;
            return d(h(n, {
                r: A2(kf, a, i.a)
            }), A2(ro, Vo, u));
        }
        return d(n, eo);
    }), x$ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, j$ = {
        $: 0
    }, q$ = F2(function(n, e) {
        return 3 === e.$ && u(e.a, n);
    }), S$ = q$(401), I$ = F2(function(n, e) {
        var t = A2(cp, n, e);
        return d({
            gC: t.a,
            ci: e
        }, t.b);
    }), T$ = F5(function(n, e, t, r, a) {
        var i = {
            hV: a,
            h9: r,
            ig: ti(n.c_.ig),
            c_: n.c_,
            iK: n.iK,
            ci: n.ci,
            jS: e,
            hD: t
        }, u = A2(I$, i, n.ci), c = u.b;
        return d(h(n, {
            r: A2(kf, i, u.a)
        }), A2(ro, Vo, c));
    }), A$ = function(n) {
        var e = n.jS;
        if (1 === e.$) return d(n, eo);
        var t = e.a, r = n.h9;
        switch(r.$){
            case 3:
                var a = r.a, i = n.hV;
                switch(i.$){
                    case 3:
                        var u = a.gI;
                        return u.b ? A5(T$, n, t, {
                            $: 1,
                            a: u.a
                        }, a, i.a) : A5(T$, n, t, j$, a, v);
                    case 2:
                        return S$(c = i.a) ? A5(T$, n, t, j$, a, v) : d(h(n, {
                            r: x$(c)
                        }), eo);
                    default:
                        return d(n, eo);
                }
            case 2:
                var c;
                return d(h(n, {
                    r: x$(c = r.a)
                }), eo);
            default:
                return d(n, eo);
        }
    }, E$ = F3(function(n, e, t) {
        return t.$ ? n : e(t.a);
    }), N$ = Dn("setTheme", function(n) {
        return A3(E$, null, Kb, n);
    }), L$ = F2(function(n, e) {
        return 1 === n.$ ? e : e + ":" + Ct(n.a);
    }), P$ = F3(function(n, e, t) {
        return 1 === e.$ ? t : g(t, g(n, e.a));
    }), D$ = function(n) {
        return A3(P$, "#", n.iv, A3(P$, "?", n.jq, g(A2(L$, n.gL, g(n.gT ? "https://" : "http://", n.fK)), n.bp)));
    }, O$ = F3(function(n, e, t) {
        return 1 === e.$ ? d(h(t, {
            cQ: e.a
        }), eo) : d(t, 1 === n.$ ? A2(Vl, n.a.iK, Gu(e.a)) : eo);
    }), G$ = F2(function(n, e) {
        switch(n.$){
            case 0:
                var t = n.a;
                return t.$ ? d(e, "" === t.a ? eo : Tf(r = t.a)) : 23 === Jc(r = t.a).$ ? d(e, Tf(D$(r))) : d(h(e, {
                    aZ: (j = e.aZ, 2 === j ? 3 : j)
                }), A2(Ef, e.iK, D$(r)));
            case 1:
                var r, a = Jc(r = n.a);
                return A2(C$, h(e, {
                    ci: a,
                    hB: r
                }), {
                    $: 0,
                    a: a
                });
            case 10:
                return d(e, Tf("/"));
            case 4:
                var i = n.a;
                if (17 === i.$) {
                    var u = i.a, c = function() {
                        switch(u){
                            case 0:
                                return mt("light");
                            case 1:
                                return mt("dark");
                            default:
                                return yt;
                        }
                    }();
                    return d(h(e, {
                        by: u
                    }), N$(c));
                }
                return A2(C$, e, i);
            case 3:
                return A$(h(e, {
                    hV: (C = If(f = n.a), k = C, x = 2 === k.$ && function(n) {
                        return 25 === n.$;
                    }(e.ci) ? Fs(v) : C, x)
                }));
            case 2:
                return A$(h(e, {
                    h9: If(f = n.a),
                    hD: A2(Hs, function(n) {
                        return n.$ ? Rs(so("Not logged in")) : Fs(n.a);
                    }, A2(Af, function(n) {
                        return Ec(n.gI);
                    }, If(f)))
                }));
            case 5:
                var o = A3(O$, e.r, n.a, e.a4), s = o.b;
                return d(h(e, {
                    a4: o.a
                }), A2(ro, Yr, s));
            case 7:
                var f = n.a, l = e.r;
                if (1 === l.$) {
                    var b = l.a, g = l.b;
                    if (3 === f.$) {
                        var p = A2(k$, b, {
                            $: 2,
                            a: f.a
                        });
                        return d(h(e, {
                            r: A2(kf, p, g)
                        }), eo);
                    }
                    return d(e, eo);
                }
                return d(e, eo);
            case 6:
                var m = e.r;
                return 1 === m.$ ? (g = m.b, p = A2(k$, b = m.a, function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(n.a)), d(h(e, {
                    bI: e.bI + 1,
                    r: A2(kf, p, g)
                }), 4 > e.bI ? A3($l, b, A2(qu, yt, yt), A2(bc, If, xf)) : eo)) : d(e, eo);
            case 8:
                return d(h(e, {
                    jS: mt(n.a)
                }), eo);
            case 9:
                return d(e, Po({
                    aD: bu,
                    ir: Sf((w = {
                        a3: e.c_.hZ,
                        jg: A2(bc, If, Cf)
                    }).jg),
                    M: A2(gu, gr, v),
                    aO: "POST",
                    ay: mt(3e4),
                    bA: yt,
                    hB: A3(yo, w.a3, y([
                        "api",
                        "auth",
                        "sign-out"
                    ]), A2(gu, gr, v))
                }));
            case 11:
                return d(h(e, {
                    aZ: n.a
                }), eo);
            case 12:
                var $ = n.a;
                return d(h(e, {
                    by: u = function() {
                        n: for(; !$.$;)switch($.a){
                            case "light":
                                return 0;
                            case "dark":
                                return 1;
                            default:
                                break n;
                        }
                        return 2;
                    }()
                }), eo);
            default:
                return d(h(e, {
                    ck: n.a
                }), eo);
        }
        var w, k, C, x, j;
    }), _$ = F2(function(n, e) {
        return A2(Qn, n, Kb(e));
    }), F$ = _$("className"), R$ = Kn("div"), B$ = Yn, H$ = B$, V$ = Un, z$ = V$, U$ = Kn("a"), W$ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, K$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Z$ = Kn("i"), Y$ = function(n) {
        return {
            h8: n.h8,
            iE: n.iE,
            aM: !1,
            b6: function(n) {
                return A3(n, Z$, y([
                    F$("dropdown icon")
                ]), v);
            },
            jf: n.jf,
            ji: n.ji,
            cg: !1,
            dQ: 0
        };
    }, M$ = F2(function(n, e) {
        return h(e, {
            aM: n
        });
    }), J$ = F2(function(n, e) {
        return h(e, {
            b6: n
        });
    }), Q$ = function(n) {
        return n.b;
    }, X$ = function(n) {
        return F$(A2(xt, " ", A2(Gr, ar, A2(nl, Q$, n))));
    }, nw = Jn, ew = nw, tw = A2(ew, "position", "absolute"), rw = A2(ew, "visibility", "hidden"), aw = A2(ew, "visibility", "visible"), iw = F5(function(n, e, t, r, a) {
        return A2(n, r ? A2(tt, a.$9, g(y([
            aw,
            tw
        ]), e)) : g(y([
            rw,
            tw
        ]), e), t);
    }), uw = Mn, cw = F2(function(n, e) {
        return A2(uw, n, {
            $: 0,
            a: e
        });
    }), ow = F2(function(n, e) {
        var t = 1 === e || 3 === e, r = t ? 1 === e ? 2 : 0 : e, a = 1 === e || 2 === e, i = a || t, u = {
            h4: A2(ao, n.ji, function(n) {
                return n ? a ? e : 1 : a ? 3 : e;
            }),
            $9: X$(v),
            iE: n.iE,
            dQ: function() {
                switch(n.dQ){
                    case 0:
                        return 0;
                    case 1:
                        return 1;
                    default:
                        return 2;
                }
            }()
        };
        return {
            bX: a,
            ba: t,
            bb: i,
            dZ: r,
            bY: u
        };
    }), sw = F5(function(n, e, t, r, a) {
        var i = A2(ow, n, e);
        return n.cg ? A2(t, A2(tt, X$(y([
            d("menu", !0)
        ])), r), a) : A5(iw, t, g(A2(tt, X$(y([
            d("menu", !0),
            d("active", !0),
            d("visible", i.bb),
            d("hiden", !i.bb),
            d("animating", i.ba),
            d("transition", !0),
            d("slide", i.ba),
            d("down", i.ba),
            d("in", 1 === e),
            d("out", 3 === e)
        ])), i.ba ? y([
            A2(cw, "animationend", br(n.ji(i.dZ)))
        ]) : v), r), a, i.bX, i.bY);
    }), fw = F3(function(n, e, t) {
        return A2(n, A2(tt, F$("item"), e), t);
    }), lw = F2(function(n, e) {
        return A2(Qn, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), ne(e));
    }), dw = lw, bw = A2(ew, "display", "inline-block"), hw = F2(function(n, e) {
        return {
            fX: n,
            gD: e
        };
    }), gw = F2(function(n, e) {
        return br(u(n, e));
    }), vw = F2(function(n, e) {
        return A2(lr, la(n), wd(e));
    }), pw = function(n) {
        return A3(dr, hw, A2(vw, !1, A2(fr, gw(n), A2(Zr, "dropdownId", ta))), A2(Zr, "parentElement", wd(A2(lr, gr, A2(fr, function() {
            return pw(n);
        }, br(0))))));
    }, mw = function(n) {
        for(;;){
            if (n.fX) return br(!0);
            var e = n.gD;
            if (1 === e.$) return br(!1);
            n = e.a;
        }
    }, yw = F2(function(n, e) {
        return A2(lr, e.h4, A2(vw, !1, A2(fr, mw, A2(Zr, "relatedTarget", pw(e.iE)))));
    }), $w = A2(Zr, "keyCode", Bo), ww = F2(function(n, e) {
        return A2(lr, e.h4, A2(fr, A2(ao, A2(ao, A2(ao, br, wt(n)), Ii), Qt(27)), $w));
    }), kw = A2(ew, "outline", "none"), Cw = A2(ew, "position", "relative"), xw = F5(function(n, e, t, r, a) {
        var i, u = y(1 === a.dQ ? [
            A2(cw, "mouseout", A2(yw, r, a)),
            A2(cw, "focusout", A2(yw, r, a))
        ] : [
            A2(cw, "focusout", A2(yw, r, a))
        ]);
        return A2(n, g(y([
            A2(cw, "keydown", A2(ww, r, a))
        ]), g(u, g(y([
            (i = a.iE, A2(dw, "dropdownId", Kb(i))),
            A2(Xn, "tabIndex", Ct(-1)),
            Cw,
            bw,
            kw
        ]), e))), A2(Gr, function(n) {
            return A2(n, r, a);
        }, t));
    }), jw = F2(function(n, e) {
        return A2(uw, n, {
            $: 3,
            a: e
        });
    }), qw = function(n) {
        return A2(cw, "focus", br(n));
    }, Sw = F5(function(n, e, t, r, a) {
        return A2(n, g(function() {
            var n;
            switch(a.dQ){
                case 0:
                    return y([
                        A2(jw, "click", br({
                            bl: a.h4(!r),
                            d6: !0,
                            ea: !0
                        }))
                    ]);
                case 1:
                    return y([
                        (n = a.h4(!0), A2(cw, "mouseenter", br(n))),
                        qw(a.h4(!0))
                    ]);
                default:
                    return y([
                        qw(a.h4(!0))
                    ]);
            }
        }(), e), t);
    }), Iw = F5(function(n, e, t, r, a) {
        var i = A2(ow, n, e);
        return n.cg ? A2(t, r, a) : A5(Sw, t, r, a, i.bX, i.bY);
    }), Tw = F5(function(n, e, t, r, a) {
        var i = A2(ow, n, e), u = A2(tt, X$(y([
            d("ui", !0),
            d("dropdown", !0),
            d("active", i.bb),
            d("visible", i.bb),
            d("disabled", n.cg)
        ])), A2(tt, A2(ew, "position", "relative"), r));
        return A5(xw, t, u, A2(Gr, function(n) {
            return F2(function() {
                return n;
            });
        }, A2(tt, A5(Iw, n, e, R$, y([
            A2(ew, "position", "absolute"),
            A2(ew, "width", "100%"),
            A2(ew, "height", "100%"),
            A2(ew, "left", "0%"),
            A2(ew, "top", "0%")
        ]), v), a)), i.bX, i.bY);
    }), Aw = F3(function(n, e, t) {
        return t({
            iQ: A2(sw, n, e),
            iR: A2(Tw, n, e),
            iS: fw,
            iT: A2(Iw, n, e)
        });
    }), Ew = Kn("input"), Nw = function(n) {
        return A2(cw, "click", br(n));
    }, Lw = _$("type"), Pw = F5(function(n, e, t, r, a) {
        return A3(Aw, {
            iE: n.iE,
            ji: n.ji,
            cg: n.cg,
            dQ: n.dQ
        }, e.io, function(i) {
            var u = i.iS, c = i.iQ, o = i.iT;
            return A3(i.iR, t, A2(tt, X$(y([
                d("selection", !n.aM),
                d("inline", n.aM)
            ])), r), y([
                A3(o, Ew, y([
                    Lw("hidden")
                ]), v),
                A3(a, F3(function(e, t, r) {
                    return A3(o, e, A2(tt, X$(y([
                        d("text", n.aM)
                    ])), t), r);
                }), !1, e.jE),
                n.b6(o),
                A3(c, R$, y([
                    Nw(n.ji(3))
                ]), A2(Gr, function(e) {
                    return A3(a, A2(ao, u, F3(function(t, r, a) {
                        return A2(t, A2(tt, Nw(n.jf(e)), r), a);
                    })), !0, e);
                }, n.h8))
            ]));
        });
    }), Dw = function(n) {
        return y([
            n
        ]);
    }, Ow = function(n) {
        var e;
        return A2(_$, "href", /^javascript:/i.test((e = n).replace(/\s/g, "")) ? "" : e);
    }, Gw = function(n) {
        return Ow(A3(yu, "\\", "%5C", Hl(n)));
    }, _w = F2(function(n, e) {
        return A2(mr, "?", n) ? n + "&" + e : n + "?" + e;
    }), Fw = Kn("img"), Rw = function(n) {
        return A2(_$, "src", ne(n));
    }, Bw = function(n) {
        return A2(Xn, "width", Ct(n));
    }, Hw = F2(function(n, e) {
        var t = 3 * e;
        return "" === n.T ? function(n) {
            var e = n.W, t = n.dE;
            return A2(Z$, y([
                F$("ui icon middle aligned"),
                A2(ew, "margin-right", "10px"),
                X$(y([
                    d("user", !e),
                    d("group", 1 === e)
                ])),
                A2(ew, "width", Ct(t))
            ]), v);
        }({
            dE: e,
            W: n.W
        }) : A2(Fw, y([
            Rw(A2(_w, n.T, "size=" + Ct(t))),
            Bw(e),
            F$("ui image middle aligned rounded"),
            A2(ew, "margin-right", "10px")
        ]), v);
    }), Vw = F3(function(n, e, t) {
        var r = F3(function(e, t, r) {
            var a = function() {
                var e, t = (e = r.cq, A2(dl, function(n) {
                    return u(n.ax, e);
                }, n));
                if (1 === t.$) return y([
                    z$(r.cq)
                ]);
                var a = t.a;
                return y([
                    A2(Hw, a, 30),
                    z$(a.k)
                ]);
            }(), i = t ? a : v;
            return A3(e, R$, y([
                F$("text")
            ]), i);
        }), a = A2(J$, function(n) {
            return A3(n, Z$, y([
                F$("caret square down outline large icon")
            ]), v);
        }, A2(M$, !0, Y$({
            h8: A2(gu, function(n) {
                return u(n.ax, t.cq) && u(n.hf, t.dC) ? yt : mt({
                    cq: n.ax,
                    dC: n.hf
                });
            }, n),
            iE: "selectAccount",
            jf: K$,
            ji: W$
        }))), i = A2(la, v, A2(Zi, Dw, A2(Zi, function(n) {
            return A2(Hw, n, 30);
        }, A2(dl, function(n) {
            return u(n.hf, t.dC) && u(n.ax, t.cq);
        }, n)))), c = A2(U$, y([
            Gw(Gu({
                cq: t.cq,
                dC: t.dC
            })),
            A2(ew, "margin-right", "15px")
        ]), g(i, y([
            z$(t.cq)
        ])));
        return A2(R$, v, y([
            c,
            A5(Pw, a, {
                io: e.cQ,
                jE: {
                    cq: t.cq,
                    dC: t.dC
                }
            }, R$, v, r)
        ]));
    }), zw = F3(function(n, e, t) {
        switch(n.$){
            case 0:
            case 1:
                return A2(R$, y([
                    F$("ui loader inline active")
                ]), v);
            case 2:
                return A2(R$, v, v);
            default:
                return A3(Vw, n.a, e, t);
        }
    }), Uw = function(n) {
        return A2(la, n, Ec(_t(A2(nl, A2(ao, Ii, Cr), A2(jt, "/", n)))));
    }, Ww = F2(function(n, e) {
        return h(e, {
            cP: n
        });
    }), Kw = {
        cP: z$("/"),
        dE: 3
    }, Zw = F2(function(n, e) {
        return h(e, {
            dE: n
        });
    }), Yw = A2(Ww, A2(Z$, y([
        F$("right angle icon divider")
    ]), v), A2(Zw, 4, Kw)), Mw = F2(function(n, e) {
        return {
            q: e,
            c9: n
        };
    }), Jw = F2(function(n, e) {
        if (e.b) {
            var t = e.a, r = e.b, a = F2(function(e, t) {
                return A2(tt, n, A2(tt, e, t));
            });
            return A2(tt, t, A3(Or, a, v, r));
        }
        return v;
    }), Qw = function(n) {
        return X$(y([
            d("mini", !n),
            d("tiny", 1 === n),
            d("small", 2 === n),
            d("medium", 3 === n),
            d("large", 4 === n),
            d("big", 5 === n),
            d("huge", 7 === n),
            d("massive", 6 === n)
        ]));
    }, Xw = Kn("span"), nk = F2(function(n, e) {
        var t = function(n) {
            return A2(R$, y([
                X$(y([
                    d("section", !0),
                    d("active", n.c9)
                ]))
            ]), y([
                n.q
            ]));
        }, r = A2(Xw, y([
            F$("divider")
        ]), y([
            n.cP
        ]));
        return A2(R$, y([
            F$("ui breadcrumb"),
            Qw(n.dE)
        ]), A2(Jw, r, A2(Gr, t, e)));
    }), ek = F2(function(n, e) {
        return A2(nk, n, A2(Gr, function(n) {
            return A2(Mw, !1, n);
        }, e));
    }), tk = F3(function(n, e, t) {
        var r = function(n) {
            return A2(U$, y([
                Gw(tc({
                    cq: n.cq,
                    gC: yt,
                    br: n.br,
                    dC: n.dC
                }))
            ]), y([
                z$(n.br)
            ]));
        }, a = function(n) {
            return A2(U$, y([
                Gw(Mu(n))
            ]), y([
                z$("Compare")
            ]));
        }, i = function(n) {
            return A2(U$, y([
                Gw(Yu({
                    cq: n.cq,
                    ab: n.ab,
                    br: n.br,
                    dC: n.dC
                }))
            ]), y([
                z$("Job #" + Ct(n.ab))
            ]));
        }, u = function(n) {
            return A2(U$, y([
                Gw(Ju(n))
            ]), y([
                z$("Effect " + _l(n.a2))
            ]));
        }, c = function(n) {
            return A2(U$, y([
                Gw(Fu(n))
            ]), y([
                z$("Derivation " + Uw(n.a9))
            ]));
        }, o = y([
            A2(U$, y([
                Gw(ec)
            ]), y([
                z$("Personal Settings")
            ]))
        ]), s = g(o, y([
            A2(U$, y([
                Gw(nc)
            ]), y([
                z$("Notifications")
            ]))
        ])), f = g(o, y([
            A2(U$, y([
                Gw(Xu)
            ]), y([
                z$("Appearance")
            ]))
        ])), l = function() {
            switch(n.$){
                case 0:
                    return Qr;
                case 2:
                    return Rs(n.a);
                default:
                    return Fs(n.a.hV);
            }
        }(), b = function(n) {
            return A3(zw, l, t, n);
        }, h = function(n) {
            return y([
                b({
                    cq: n.cq,
                    dC: n.dC
                })
            ]);
        }, p = function(n) {
            return g(h(n), y([
                r(n)
            ]));
        }, m = function(n) {
            return g(p(n), y([
                i(n)
            ]));
        }, $ = function() {
            switch(e.$){
                case 1:
                case 6:
                    return h(t = e.a);
                case 3:
                    return g(function(e) {
                        if (1 === n.$) {
                            var t = n.b.gC;
                            if (10 === t.$) {
                                var r = t.a.ih.ie;
                                if (3 === r.$) {
                                    var a = r.a, i = d(a.hI, a.hJ);
                                    return i.a.$ || i.b.$ ? h(e) : m({
                                        cq: e.cq,
                                        ab: i.a.a.ab,
                                        br: i.b.a.ax,
                                        dC: e.dC
                                    });
                                }
                                return h(e);
                            }
                            return h(e);
                        }
                        return h(e);
                    }(t = e.a), y([
                        c(t)
                    ]));
                case 2:
                    return g(h(t = e.a), y([
                        z$("Settings")
                    ]));
                case 4:
                    return g(h(t = e.a), y([
                        z$("Tasks")
                    ]));
                case 5:
                    return function(n) {
                        return g(function(n) {
                            return g(h(n), y([
                                A2(U$, y([
                                    Gw(zu({
                                        cq: n.cq,
                                        dC: n.dC
                                    }))
                                ]), y([
                                    z$("Agents")
                                ]))
                            ]));
                        }(n), y([
                            A2(U$, y([
                                Gw(Bu({
                                    cq: n.cq,
                                    fL: n.fL,
                                    dC: n.dC
                                }))
                            ]), y([
                                z$(n.fL)
                            ]))
                        ]));
                    }(t = e.a);
                case 10:
                case 14:
                    return p(t = e.a);
                case 11:
                    return g(p(t = e.a), y([
                        z$("State files")
                    ]));
                case 13:
                    return m(t = e.a);
                case 15:
                    return function(n) {
                        return g(m(n), y([
                            a(n)
                        ]));
                    }(t = e.a);
                case 16:
                    return g(m(t = e.a), y([
                        u(t)
                    ]));
                case 7:
                case 8:
                    return g(h(t = e.a), y([
                        z$("Agent setup")
                    ]));
                case 17:
                    var t;
                    return g(A2(Bl, b, A2(uc, function(n) {
                        return A2(Zi, function(e) {
                            return {
                                cq: n,
                                dC: e
                            };
                        }, t.dC);
                    }, (t = e.a).cq)), y([
                        z$("Billing")
                    ]));
                case 9:
                    return y([
                        z$("Personal Settings"),
                        z$("CLI Authorization Request")
                    ]);
                case 0:
                case 24:
                case 23:
                case 12:
                default:
                    return v;
                case 18:
                    return o;
                case 19:
                    return s;
                case 20:
                    return f;
                case 21:
                case 22:
                    return y([
                        z$("Install"),
                        z$("GitLab")
                    ]);
            }
        }();
        return $.b ? A2(ek, Yw, $) : A2(Xw, v, v);
    }), rk = function(n) {
        switch(n){
            case "github":
                return F$("black");
            case "gitlab":
                return F$("orange");
            default:
                return X$(v);
        }
    }, ak = F2(function(n, e) {
        return A2(Z$, g(y([
            F$("ui icon"),
            F$(n)
        ]), e), v);
    }), ik = Kn("p"), uk = F2(function(n, e) {
        return u(n.fu, v) ? A2(R$, v, y([
            A2(ik, v, y([
                z$("No Forges have been installed yet.")
            ])),
            A2(U$, y([
                F$("ui button primary"),
                Gw(Zu({}))
            ]), y([
                A2(ak, "gitlab", v),
                z$("Install GitLab")
            ]))
        ])) : A2(R$, v, A2(Gr, function(n) {
            return A2(U$, y([
                F$("ui button"),
                rk(n.W),
                Ow("/api/auth/" + n.W + "/start/" + n.c + (e.$ ? "" : "?redirect=" + ku(e.a)))
            ]), y([
                A2(ak, n.W, v),
                z$(n.k)
            ]));
        }, n.fu));
    }), ck = Kn("h1"), ok = F2(function(n, e) {
        return y([
            A2(R$, y([
                A2(ew, "display", "flex"),
                A2(ew, "justify-content", "center"),
                A2(ew, "margin-top", "10vh")
            ]), y([
                A2(R$, y([
                    F$("ui compact padded segment")
                ]), y([
                    A2(ck, v, y([
                        z$("Welcome to Hercules CI")
                    ])),
                    A2(ik, v, y([
                        z$("Please sign in to continue.")
                    ])),
                    A2(uk, n, e)
                ]))
            ]))
        ]);
    }), sk = function(n) {
        return Uw(n.a9);
    }, fk = function(n) {
        return 1 === n.hD.$;
    }, lk = F2(function(n, e) {
        return h(e, {
            cv: n
        });
    }), dk = function(n) {
        return F$(function() {
            switch(n){
                case 0:
                    return "blue";
                case 1:
                    return "teal";
                case 2:
                    return "yellow";
                case 3:
                    return "red";
                case 4:
                    return "green";
                case 5:
                    return "orange";
                default:
                    return "grey";
            }
        }());
    }, bk = function(n) {
        switch(n){
            case 0:
                return F$("mini");
            case 1:
                return F$("tiny");
            case 2:
                return F$("small");
            case 3:
                return F$("");
            case 4:
                return F$("large");
            case 5:
                return F$("big");
            case 7:
                return F$("huge");
            default:
                return F$("massive");
        }
    }, hk = F2(function(n, e) {
        return A2(Z$, qc(y([
            n.cv,
            y([
                X$(y([
                    d("link", n.f9),
                    d("icon", !0)
                ])),
                bk(n.dE),
                F$(function() {
                    switch(e){
                        case 14:
                            return "dropbox";
                        case 46:
                            return "warning";
                        case 47:
                            return "warning sign";
                        case 3:
                            return "arrow right";
                        case 2:
                            return "left arrow";
                        case 34:
                            return "search";
                        case 29:
                            return "plus";
                        case 24:
                            return "info";
                        case 45:
                            return "user";
                        case 8:
                            return "check circle outline";
                        case 20:
                            return "help";
                        case 9:
                            return "chevron up";
                        case 43:
                            return "trash";
                        case 44:
                            return "upload";
                        case 13:
                            return "download";
                        case 18:
                            return "fork";
                        case 39:
                            return "star";
                        case 19:
                            return "github";
                        case 25:
                            return "legal";
                        case 21:
                            return "hide";
                        case 0:
                            return "alarm";
                        case 1:
                            return "align justify";
                        case 35:
                            return "settings";
                        case 11:
                            return "close";
                        case 32:
                            return "remove";
                        case 33:
                            return "retweet";
                        case 30:
                            return "print";
                        case 16:
                            return "file outline";
                        case 7:
                            return "caret down";
                        case 15:
                            return "dropdown";
                        case 38:
                            return "sort up";
                        case 37:
                            return "sort down";
                        case 36:
                            return "sort";
                        case 27:
                            return "pencil alternative";
                        case 17:
                            return "filter";
                        case 22:
                            return "image outline";
                        case 12:
                            return "dot circle outline";
                        case 26:
                            return "pause circle outline";
                        case 42:
                            return "times circle outline";
                        case 10:
                            return "circle outline";
                        case 6:
                            return "camera";
                        case 4:
                            return "arrows alternate";
                        case 31:
                            return "question circle outline";
                        case 5:
                            return "calendar";
                        case 28:
                            return "play";
                        case 40:
                            return "stop";
                        case 41:
                            return "stopwatch";
                        default:
                            return "industry";
                    }
                }())
            ])
        ])), v);
    }), gk = {
        cv: v,
        f9: !1,
        dE: 3
    }, vk = F3(function(n, e, t) {
        var r, a, i, c = function() {
            var n = e.iy;
            if (1 === n.$) return v;
            var t = n.a;
            return y([
                A2(R$, y([
                    F$("header")
                ]), y([
                    z$(t)
                ]))
            ]);
        }(), o = 1 === (r = e.cD).$ ? v : y([
            A2(hk, A2(lk, y([
                Nw(r.a)
            ]), gk), 11)
        ]), s = g(c, t);
        return A2(R$, qc(y([
            y([
                F$("ui message"),
                X$(y([
                    d("icon", !u(e.iD, yt))
                ]))
            ]),
            (i = e.cE, i.$ ? v : y([
                dk(i.a)
            ])),
            n
        ])), g(o, 1 === (a = e.iD).$ ? s : g(o, y([
            A2(hk, gk, a.a),
            A2(R$, y([
                F$("contents")
            ]), s)
        ]))));
    }), pk = vk(y([
        F$("error")
    ])), mk = {
        cD: yt,
        cE: yt,
        iy: yt,
        iD: yt
    }, yk = F3(function(n, e, t) {
        var r = y([
            z$("sign in")
        ]);
        return function() {
            switch(e.$){
                case 0:
                    return A2(tt, z$("A request could not be made due to a bad url (" + e.a + ")"), t);
                case 1:
                    return A2(tt, z$("We made a request but it timed out."), t);
                case 2:
                    return A2(tt, z$("A network error occurred. Are you connected to the Internet?"), t);
                case 3:
                    switch(e.a){
                        case 401:
                            return n ? A2(tt, z$("Authentication error."), t) : A2(tt, z$("You need to "), g(r, A2(tt, z$("."), t)));
                        case 403:
                            return n ? A2(tt, z$("Permission denied."), t) : A2(tt, z$("Permission denied. You may want to "), g(r, A2(tt, z$("."), t)));
                        case 404:
                            return n ? A2(tt, z$("Not found."), t) : A2(tt, z$("Not found. If you're looking for something private, please "), g(r, A2(tt, z$("."), t)));
                        case 500:
                            return A2(tt, z$("We made a request but the service encountered an error. (500)"), t);
                        case 502:
                            return A2(tt, z$("We're having trouble reaching the service. (502)"), t);
                        default:
                            return A2(tt, z$("Unexpected error. (" + Ct(e.a) + ")"), t);
                    }
                default:
                    return A2(tt, z$("We got a response we don't understand. Sometimes this can be fixed by refreshing the page."), t);
            }
        }();
    }), $k = F2(function(n, e) {
        return A2(pk, mk, A3(yk, n, e, v));
    }), wk = _$("title"), kk = F2(function(n, e) {
        return A2(Z$, y([
            F$("ui icon big " + n),
            wk(e)
        ]), v);
    }), Ck = F2(function(n, e) {
        return A2(Z$, g(y([
            F$("icons"),
            A2(ew, "margin", "0 0.35rem 0 0"),
            A2(ew, "padding", "0 0.2rem 0 0.2rem")
        ]), e), y([
            A2(Z$, A2(tt, F$("icon circle outline"), n), v),
            A2(Z$, A2(tt, F$("icon small minus"), n), v)
        ]));
    }), xk = Ck(y([
        F$("grey")
    ])), jk = function(n) {
        switch(n){
            case 0:
                return "Not Planned";
            case 1:
                return "Queued";
            case 2:
                return "Building";
            case 5:
                return "Build succeeded";
            case 3:
                return "Build failed";
            case 4:
                return "Build failed due to dependencies";
            default:
                return "Cancelled";
        }
    }, qk = function(n) {
        var e = jk(n);
        switch(n){
            case 0:
                return A2(kk, "grey minus", e);
            case 1:
                return A2(kk, "spinner loading", e);
            case 2:
                return A2(kk, "sun outline loading", e);
            case 5:
                return A2(kk, "check green circle", e);
            case 3:
                return A2(kk, "times red circle", e);
            case 4:
                return A2(kk, "times red circle outline", e);
            default:
                return xk(y([
                    F$("big"),
                    wk(e)
                ]));
        }
    }, Sk = function(n) {
        return n.cV.b ? jk(n.V) : "No build planned";
    }, Ik = F2(function(n, e) {
        return 1 > n ? e : A3($r, 0, -n, e);
    }), Tk = R, Ak = function(n) {
        var e;
        return function(n) {
            return A2(Tk, ".drv", n) ? A2(Ik, 4, n) : n;
        }((e = Uw(n.a9), "-" === A3($r, 32, 33, e) && A2($t, Gt, A3($r, 0, 32, e)) ? A2(wr, 33, e) : e));
    }, Ek = function(n) {
        switch(n.$){
            case 0:
                return d(yt, Bs);
            case 1:
                return d(yt, Qr);
            case 2:
                return d(mt(n.a), Rs(0));
            default:
                return d(yt, Fs(n.a));
        }
    }, Nk = F2(function(n, e) {
        return 1 === n.$ ? e : A2(tt, n.a, e);
    }), Lk = A2(Or, Nk, v), Pk = Kn("h3"), Dk = Kn("table"), Ok = Kn("tbody"), Gk = Kn("td"), _k = Kn("th"), Fk = Kn("thead"), Rk = Kn("tr"), Bk = function(n) {
        switch(n){
            case 0:
            case 4:
            case 5:
                return 0;
            default:
                return 1;
        }
    }, Hk = F3(function(n, e, t) {
        return Fu({
            cq: n.dT,
            eZ: !1,
            a9: e,
            dC: n.ci.dC,
            eb: A2(la, 0, A2(Zi, Bk, t)),
            dS: n.ci.dS
        });
    }), Vk = F3(function(n, e, t) {
        return A2(U$, y([
            Gw(A3(Hk, n, e, t))
        ]), y([
            z$(e)
        ]));
    }), zk = F2(function(n, e) {
        var t = A2(Gr, function(e) {
            var t;
            return A2(Rk, v, y([
                A2(Gk, y([
                    F$("center aligned")
                ]), y([
                    qk(e.cN)
                ])),
                A2(Gk, v, y([
                    A3(Vk, n, e.a9, mt(e.cN))
                ])),
                A2(Gk, v, y([
                    (t = e.af, "out" === t ? A2(Xw, y([
                        F$("ui text grey")
                    ]), y([
                        z$(t)
                    ])) : z$(t))
                ])),
                A2(Gk, v, y([
                    z$(e.bm)
                ]))
            ]));
        }, e.ih.c5);
        return A2(Dk, y([
            F$("ui unstackable table")
        ]), y([
            A2(Fk, v, y([
                A2(Rk, y([
                    F$("center aligned")
                ]), y([
                    A2(_k, y([
                        F$("one wide")
                    ]), y([
                        z$("Status")
                    ])),
                    A2(_k, y([
                        F$("six wide")
                    ]), y([
                        z$("Derivation")
                    ])),
                    A2(_k, y([
                        F$("one wide")
                    ]), y([
                        z$("Output")
                    ])),
                    A2(_k, y([
                        F$("six wide")
                    ]), y([
                        z$("Output path")
                    ]))
                ]))
            ])),
            A2(Ok, v, t)
        ]));
    }), Uk = Kn("code"), Wk = function(n) {
        return A2(Xn, "colspan", Ct(n));
    }, Kk = Kn("strong"), Zk = F2(function(n, e) {
        var t, r = It(e.ih.dq), a = 1 === r ? "Output" : "Outputs", i = A2(Gr, function(n) {
            var e, t, i = n.b;
            return A2(Rk, v, g(1 === n.a ? y([
                A2(Gk, y([
                    (t = r, A2(Xn, "rowspan", Ct(t)))
                ]), y([
                    A2(Kk, v, y([
                        z$(a)
                    ]))
                ]))
            ]) : v, y([
                A2(Gk, v, y([
                    A2(Kk, v, y([
                        A2(Uk, v, y([
                            z$(i.af)
                        ]))
                    ]))
                ])),
                A2(Gk, v, (e = i.bm, y(1 === e.$ ? [
                    z$("floating")
                ] : [
                    A2(Uk, v, y([
                        z$(e.a)
                    ]))
                ])))
            ])));
        }, A2(m$, A2(Et, 1, r), e.ih.dq));
        return A2(Dk, y([
            F$("ui structured collapsing table")
        ]), y([
            A2(Ok, v, g(y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Kk, v, y([
                            z$("Derivation path")
                        ]))
                    ])),
                    A2(Gk, v, y([
                        A2(Uk, v, y([
                            z$(n.a9)
                        ]))
                    ]))
                ])),
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Kk, v, y([
                            z$("Platform")
                        ]))
                    ])),
                    A2(Gk, v, y([
                        A2(Uk, v, y([
                            z$(e.ih.bq)
                        ]))
                    ]))
                ])),
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Kk, v, y([
                            z$("Required system features")
                        ]))
                    ])),
                    A2(Gk, v, (t = e.ih.bs, t.b ? A2(Jw, z$(", "), A2(Gr, function(n) {
                        return A2(Uk, v, y([
                            z$(n)
                        ]));
                    }, t)) : y([
                        A2(Z$, v, y([
                            z$("(none)")
                        ]))
                    ])))
                ]))
            ]), i))
        ]));
    }), Yk = F2(function(n, e) {
        for(;;){
            if (!e.b) return !1;
            var t = e.b;
            if (n(e.a)) return !0;
            e = t;
        }
    }), Mk = function(n) {
        var e, t, r, a, i = n.dq;
        return i.$ ? v : (t = A2(Sc, function(n) {
            var e, t;
            return A2(tt, A2(Rk, v, y([
                A2(Gk, v, y([
                    A2(Uk, v, y([
                        z$(n.af)
                    ]))
                ])),
                A2(Gk, v, y([
                    z$(Ct(n.dE))
                ])),
                A2(Gk, v, (t = n.gW, t.$ || t.a.b ? v : y([
                    A2(Z$, v, y([
                        z$("(none)")
                    ]))
                ])))
            ])), 1 === (e = n.gW).$ ? v : A2(Gr, function(n) {
                return A2(Rk, v, y([
                    A2(Gk, v, v),
                    A2(Gk, v, v),
                    A2(Gk, v, y([
                        z$(n)
                    ]))
                ]));
            }, e.a));
        }, e = i.a), r = A2(Yk, A2(bc, function(n) {
            return n.gW;
        }, jv), e) ? "References" : "", a = A2(Rk, v, y([
            A2(Gk, y([
                Wk(3)
            ]), y([
                A2(Z$, v, y([
                    z$("(none)")
                ]))
            ]))
        ])), y([
            A2(Pk, v, y([
                z$("Outputs")
            ])),
            A2(Dk, y([
                F$("ui unstackable table")
            ]), y([
                A2(Fk, v, y([
                    A2(Rk, v, y([
                        A2(_k, y([
                            F$("two wide")
                        ]), y([
                            z$("Output")
                        ])),
                        A2(_k, y([
                            F$("one wide")
                        ]), y([
                            z$("Size")
                        ])),
                        A2(_k, y([
                            F$("nine wide")
                        ]), y([
                            z$(r)
                        ]))
                    ]))
                ])),
                A2(Ok, v, u(e, v) ? y([
                    a
                ]) : t)
            ]))
        ]));
    }, Jk = F2(function(n, e) {
        var t = A2(uc, function(n) {
            return n.eF;
        }, A2(dl, function(n) {
            return jv(n.eF);
        }, qc(_t(e.ih.cV))));
        return A2(Sc, Mk, Rl(t));
    }), Qk = Kn("li"), Xk = Kn("ul"), nC = F2(function(n, e) {
        return y([
            A2(Pk, v, y([
                z$("Usage")
            ])),
            A2(ik, v, y([
                z$("This exact derivation is part of the following projects:")
            ])),
            A2(Xk, v, A2(Gr, function(e) {
                return A2(Qk, v, y([
                    A2(U$, y([
                        Gw(tc({
                            cq: n.ci.cq,
                            gC: yt,
                            br: e.ax,
                            dC: e.dD
                        }))
                    ]), y([
                        z$(e.k)
                    ]))
                ]));
            }, e.ih.hC))
        ]);
    }), eC = F2(function(n, e) {
        return g(y([
            A2(Zk, n, e),
            A2(Pk, v, y([
                z$("Inputs")
            ])),
            A2(zk, n, e)
        ]), g(A2(Jk, n, e), A2(nC, n, e)));
    }), tC = Ck(y([
        F$("red")
    ])), rC = F2(function(n, e) {
        return u(n.dC, e.dC) && u(n.cq, mt(e.cq)) ? u(n.br, mt(e.br)) ? A2(U$, y([
            Gw(Yu(e))
        ]), y([
            z$("#" + Ct(e.ab))
        ])) : A2(U$, y([
            Gw(Yu(e))
        ]), y([
            z$(e.br + "#" + Ct(e.ab))
        ])) : A2(U$, y([
            Gw(Yu(e))
        ]), y([
            z$(e.cq + "/" + e.br + "#" + Ct(e.ab))
        ]));
    }), aC = function(n) {
        return A2(R$, y([
            F$("event")
        ]), y([
            A2(R$, y([
                F$("label")
            ]), n.N),
            A2(R$, y([
                F$("content")
            ]), A2(tt, A2(R$, y([
                F$("summary")
            ]), n.Q), A2(tt, A2(R$, y([
                F$("meta")
            ]), n.O), Rl(A2(Zi, R$(y([
                F$("extra")
            ])), n.K)))))
        ]));
    }, iC = F3(function(n, e, t) {
        return n > 0 ? A3(iC, n >> 1, g(e, e), 1 & n ? g(t, e) : t) : t;
    }), uC = F2(function(n, e) {
        return A3(iC, n, e, "");
    }), cC = F3(function(n, e, t) {
        return g(A2(uC, n - yr(t), function(n) {
            return A2(cc, n, "");
        }(e)), t);
    }), oC = F2(function(n, e) {
        return Xt(n / e);
    }), sC = function(n) {
        return n;
    }, fC = F3(function(n, e, t) {
        for(;;){
            if (!t.b) return e + n;
            var r = t.a, a = t.b;
            if (0 > s(r.jK, e)) return e + r.d;
            t = a;
        }
    }), lC = F2(function(n, e) {
        var t = n.b;
        return A3(fC, n.a, A2(oC, e, 6e4), t);
    }), dC = function(n) {
        var e = A2(oC, n, 1440) + 719468, t = (0 > e ? e - 146096 : e) / 146097 | 0, r = e - 146097 * t, a = (r - (r / 1460 | 0) + (r / 36524 | 0) - (r / 146096 | 0)) / 365 | 0, i = r - (365 * a + (a / 4 | 0) - (a / 100 | 0)), u = (5 * i + 2) / 153 | 0, c = u + (10 > u ? 3 : -9);
        return {
            eU: i - ((153 * u + 2) / 5 | 0) + 1,
            gk: c,
            hU: a + 400 * t + (c > 2 ? 0 : 1)
        };
    }, bC = F2(function(n, e) {
        return dC(A2(lC, n, e)).eU;
    }), hC = F2(function(n, e) {
        return A2(Li, 24, A2(oC, A2(lC, n, e), 60));
    }), gC = F2(function(n, e) {
        return A2(Li, 60, A2(lC, n, e));
    }), vC = F2(function(n, e) {
        switch(dC(A2(lC, n, e)).gk){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), pC = F2(function(n, e) {
        return A2(Li, 60, A2(oC, e, 1e3));
    }), mC = F2(function(n, e) {
        return dC(A2(lC, n, e)).hU;
    }), yC = F2(function(n, e) {
        return Ct(A2(mC, n, e)) + "-" + A3(cC, 2, "0", Ct(function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(vC, n, e)))) + "-" + A3(cC, 2, "0", Ct(A2(bC, n, e))) + " " + A3(cC, 2, "0", Ct(A2(hC, n, e))) + ":" + A3(cC, 2, "0", Ct(A2(gC, n, e))) + ":" + A3(cC, 2, "0", Ct(A2(pC, n, e)));
    }), $C = A2(Qc, 0, v), wC = F2(function(n, e) {
        return A2(Xw, y([
            wk(A2(yC, $C, e) + " UTC")
        ]), y([
            z$(A2(yC, n, e))
        ]));
    }), kC = F2(function(n, e) {
        var t = e.dO;
        if (1 === t.$) return aC({
            K: yt,
            N: y([
                A2(Z$, y([
                    F$("ui icon red circle times")
                ]), v)
            ]),
            O: y([
                A2(wC, n, e.f)
            ]),
            Q: y([
                z$("Failed")
            ])
        });
        var r = t.a;
        return aC({
            K: mt(y([
                A2(R$, y([
                    F$("ui message error")
                ]), y([
                    A2(ik, v, y([
                        z$(r)
                    ]))
                ]))
            ])),
            N: y([
                A2(Z$, y([
                    F$("ui icon red circle bolt")
                ]), v)
            ]),
            O: y([
                A2(wC, n, e.f)
            ]),
            Q: y([
                z$("Technical error")
            ])
        });
    }), CC = F2(function(n, e) {
        return {
            $: 11,
            a: n,
            b: e
        };
    }), xC = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), jC = F5(function(n, e, t, r, a) {
        return A7(ju, "GET", "/api/v1/accounts/{accountId}/derivations/{derivationPath}/log/raw", y([
            d("accountId", n),
            d("derivationPath", e)
        ]), y([
            d("logId", mt(t)),
            d("iMin", A2(Zi, Ct, r)),
            d("verbosity", A2(Zi, El, a))
        ]), v, yt, ta);
    }), qC = Kn("iframe"), SC = F3(function(n, e, t) {
        return A2(Pl, y([
            "api",
            "v1",
            "accounts",
            n,
            "derivations",
            ku(e),
            "log"
        ]), y([
            A2(Cu, "logId", t)
        ]));
    }), IC = function(n) {
        return A3(yo, n.a3, n.cd, n.cf);
    }, TC = Kn("button"), AC = function(n) {
        switch(n){
            case 0:
            case 1:
                return 0;
            case 2:
            case 3:
                return 1;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, EC = {
        o: 0,
        p: 0,
        bE: 0
    }, NC = function(n) {
        switch(n){
            case 0:
                return "default";
            case 1:
                return "black";
            case 2:
                return "red";
            case 3:
                return "green";
            case 4:
                return "yellow";
            case 5:
                return "blue";
            case 6:
                return "magenta";
            case 7:
                return "cyan";
            case 8:
                return "white";
            case 9:
                return "b-black";
            case 10:
                return "b-red";
            case 11:
                return "b-green";
            case 12:
                return "b-yellow";
            case 13:
                return "b-blue";
            case 14:
                return "b-magenta";
            case 15:
                return "b-cyan";
            default:
                return "b-white";
        }
    }, LC = function(n) {
        return function(n) {
            switch(n){
                case 0:
                    return "";
                case 1:
                    return "bold ";
                default:
                    return "faint ";
            }
        }(n.bE) + "fg-" + NC(n.p) + " bg-" + NC(n.o);
    }, PC = d(LC(EC), EC), DC = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, OC = y([
        A2(R$, y([
            F$("ui placeholder fluid")
        ]), y([
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v)
        ]))
    ]), GC = F3(function(n, e, t) {
        var r = A2(Vi, n, t);
        return r.$ ? e(r.a) : Xa(r.a);
    }), _C = {
        $: 1
    }, FC = Fe, RC = Re, BC = F2(function(n, e) {
        return {
            eN: e.eN + (n - e.d),
            h: e.h,
            i: e.i,
            d: n,
            g8: e.g8,
            b: e.b
        };
    }), HC = _e, VC = Ge, zC = F2(function(n, e) {
        if (A3(VC, 101, n, e) || A3(VC, 69, n, e)) {
            var t = n + 1, r = A3(VC, 43, t, e) || A3(VC, 45, t, e) ? t + 1 : t, a = A2(HC, r, e);
            return u(r, a) ? -a : a;
        }
        return n;
    }), UC = F2(function(n, e) {
        return A2(zC, A3(VC, 46, n, e) ? A2(HC, n + 1, e) : n, e);
    }), WC = F5(function(n, e, t, r, a) {
        var i = r.a, c = r.b;
        if (1 === e.$) return A2(Da, !0, A2(Ha, a, e.a));
        var o = e.a;
        return u(t, i) ? A2(Da, 0 > s(a.d, t), A2(Ha, a, n)) : A3(Oa, !0, o(c), A2(BC, i, a));
    }), KC = F4(function(n, e, t, r) {
        return A2(Fa, Ba, A4(Ra, n, e, t, r));
    }), ZC = F6(function(n, e, t, r, a, i) {
        var c = a.a, o = A2(UC, c, i.b);
        if (0 > o) return A2(Da, !0, A4(KC, i.g8, i.eN - (o + i.d), n, i.h));
        if (u(i.d, o)) return A2(Da, !1, A2(Ha, i, e));
        if (u(c, o)) return A5(WC, n, t, i.d, a, i);
        if (1 === r.$) return A2(Da, !0, A2(Ha, i, n));
        var s = r.a, f = ni(A3($r, i.d, o, i.b));
        return 1 === f.$ ? A2(Da, !0, A2(Ha, i, n)) : A3(Oa, !0, s(f.a), A2(BC, o, i));
    }), YC = F2(function(n, e) {
        var t;
        return t = {
            ez: lt(e),
            fm: n,
            fp: lt(e),
            fI: lt(e),
            fV: gt(gr),
            iH: e,
            gw: lt(e)
        }, function(n) {
            if (A3(VC, 48, n.d, n.b)) {
                var e = n.d + 1, r = e + 1;
                return A3(VC, 120, e, n.b) ? A5(WC, t.iH, t.fI, r, A2(RC, r, n.b), n) : A3(VC, 111, e, n.b) ? A5(WC, t.iH, t.gw, r, A3(FC, 8, r, n.b), n) : A3(VC, 98, e, n.b) ? A5(WC, t.iH, t.ez, r, A3(FC, 2, r, n.b), n) : A6(ZC, t.iH, t.fm, t.fV, t.fp, d(e, 0), n);
            }
            return A6(ZC, t.iH, t.fm, t.fV, t.fp, A3(FC, 10, n.d, n.b), n);
        };
    }), MC = A2(YC, _C, _C), JC = F2(function(n, e) {
        return e;
    }), QC = F2(function(n, e) {
        return A3(ai, JC, n, e);
    }), XC = F5(function(n, e, t, r, a) {
        return A2(QC, e, fi(y([
            A2(QC, r, A2(QC, e, A2(yi, function(n) {
                return ki(A2(tt, n, a));
            }, t))),
            A2(yi, function() {
                return wi(_t(a));
            }, n)
        ])));
    }), nx = F4(function(n, e, t, r) {
        return fi(y([
            A2(yi, function(n) {
                return ki(A2(tt, n, r));
            }, A2(ii, e, A2(ii, n, A2(ii, t, n)))),
            A2(yi, function() {
                return wi(_t(r));
            }, Qa(0))
        ]));
    }), ex = F5(function(n, e, t, r, a) {
        var i = A2(yi, function() {
            return wi(_t(a));
        }, n);
        return A2(QC, e, fi(y([
            A2(QC, r, A2(QC, e, fi(y([
                A2(yi, function(n) {
                    return ki(A2(tt, n, a));
                }, t),
                i
            ])))),
            i
        ])));
    }), tx = F5(function(n, e, t, r, a) {
        var i = function(i) {
            switch(a){
                case 0:
                    return A2(mi, y([
                        i
                    ]), A4(XC, n, e, t, r));
                case 1:
                    return A2(mi, y([
                        i
                    ]), A4(ex, n, e, t, r));
                default:
                    return A2(ii, A2(QC, e, A2(QC, r, A2(QC, e, A2(mi, y([
                        i
                    ]), A3(nx, e, t, r))))), n);
            }
        };
        return fi(y([
            A2(Ga, i, t),
            A2(yi, function() {
                return v;
            }, n)
        ]));
    }), rx = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    }, ax = function(n) {
        return A2(qi, n, {
            $: 0,
            a: n
        });
    }, ix = (cs = Ya(Wa(function() {
        return !0;
    })), os = li(y([
        (ds = A2($i, F2(function(n, e) {
            return d(qc(n), e);
        }), (hs = {
            iq: "m",
            iJ: li(y([
                A2($i, function(n) {
                    return y([
                        n
                    ]);
                }, MC),
                Xa(v)
            ])),
            jG: ";",
            jJ: Xa(0),
            jK: "[",
            jT: 0
        }, function(n) {
            return A2(QC, Ti(n.jK), A2(QC, n.jJ, A5(tx, Ti(n.iq), n.jJ, n.iJ, Ti(n.jG), n.jT)));
        }({
            iq: ax(hs.iq),
            iJ: hs.iJ,
            jG: ax(hs.jG),
            jJ: hs.jJ,
            jK: ax(hs.jK),
            jT: rx(hs.jT)
        }))), bs = ds, function(n) {
            var e = bs(n);
            return 1 === e.$ ? A2(Da, !1, e.b) : A3(Oa, !1, e.b, e.c);
        }),
        A2($i, F2(function(n, e) {
            return d(v, "\u2B11" + e);
        }), (ls = "[1G", function(n) {
            var e = n.a, t = n.b, r = !Cr(e);
            return function(n) {
                var a = A5(Si, e, n.d, n.g8, n.eN, n.b), i = a.a, c = a.b, o = a.c;
                return u(i, -1) || A3(za, function(n) {
                    return Gt(n) || "_" === n;
                }, i, n.b) >= 0 ? A2(Da, !1, A2(Ha, n, t)) : A3(Oa, r, 0, {
                    eN: o,
                    h: n.h,
                    i: n.i,
                    d: i,
                    g8: c,
                    b: n.b
                });
            };
        }(A2(qi, ls, {
            $: 9,
            a: ls
        })))),
        A2(ui, Xa(function(n) {
            return d(v, n);
        }), cs)
    ])), ss = A2(_a, A2(GC, os, function() {
        return Xa(function(n) {
            return d(v, n);
        });
    }), Ya(A2(ui, A2(ui, A2(ui, vi(function(n) {
        return "[" === n;
    }), Wa(function(n) {
        return n >= "0" && "?" >= n;
    })), Wa(function(n) {
        return n >= "!" && "/" >= n;
    })), vi(function(n) {
        return n >= "@" && "~" >= n;
    })))), A2(ci, ss, cs)), ux = F2(function(n, e) {
        var t = e.b, r = function() {
            switch(n){
                case 0:
                    return {
                        o: 0,
                        p: 0,
                        bE: 0
                    };
                case 1:
                    return h(t, {
                        bE: 1
                    });
                case 2:
                    return h(t, {
                        bE: 2
                    });
                case 30:
                    return h(t, {
                        p: 1
                    });
                case 40:
                    return h(t, {
                        o: 1
                    });
                case 31:
                    return h(t, {
                        p: 2
                    });
                case 41:
                    return h(t, {
                        o: 2
                    });
                case 32:
                    return h(t, {
                        p: 3
                    });
                case 42:
                    return h(t, {
                        o: 3
                    });
                case 33:
                    return h(t, {
                        p: 4
                    });
                case 43:
                    return h(t, {
                        o: 4
                    });
                case 34:
                    return h(t, {
                        p: 5
                    });
                case 44:
                    return h(t, {
                        o: 5
                    });
                case 35:
                    return h(t, {
                        p: 6
                    });
                case 45:
                    return h(t, {
                        o: 6
                    });
                case 36:
                    return h(t, {
                        p: 7
                    });
                case 46:
                    return h(t, {
                        o: 7
                    });
                case 37:
                    return h(t, {
                        p: 8
                    });
                case 47:
                    return h(t, {
                        o: 8
                    });
                case 39:
                    return h(t, {
                        p: 0
                    });
                case 49:
                    return h(t, {
                        o: 0
                    });
                case 90:
                    return h(t, {
                        p: 9
                    });
                case 100:
                    return h(t, {
                        o: 9
                    });
                case 91:
                    return h(t, {
                        p: 10
                    });
                case 101:
                    return h(t, {
                        o: 10
                    });
                case 92:
                    return h(t, {
                        p: 11
                    });
                case 102:
                    return h(t, {
                        o: 11
                    });
                case 93:
                    return h(t, {
                        p: 12
                    });
                case 103:
                    return h(t, {
                        o: 12
                    });
                case 94:
                    return h(t, {
                        p: 13
                    });
                case 104:
                    return h(t, {
                        o: 13
                    });
                case 95:
                    return h(t, {
                        p: 14
                    });
                case 105:
                    return h(t, {
                        o: 14
                    });
                case 96:
                    return h(t, {
                        p: 15
                    });
                case 106:
                    return h(t, {
                        o: 15
                    });
                case 97:
                    return h(t, {
                        p: 16
                    });
                case 107:
                    return h(t, {
                        o: 16
                    });
                default:
                    return t;
            }
        }();
        return d(LC(r), r);
    }), cx = F2(function(n, e) {
        return n.b ? A3(St, ux, e, n) : PC;
    }), ox = F2(function(n, e) {
        return A2(Xw, y([
            F$(n.a)
        ]), y([
            z$(e)
        ]));
    }), sx = F2(function(n, e) {
        var t = A2(Vi, ix, n);
        if (1 === t.$) return {
            eK: A2(tt, A2(ox, e.an, n), e.eK),
            an: e.an
        };
        var r = t.a, a = r.b, i = A2(cx, r.a, e.an);
        return {
            eK: A2(tt, A2(ox, i, a), e.eK),
            an: i
        };
    }), fx = F2(function(n, e) {
        var t;
        return h(t = A3(St, sx, {
            eK: v,
            an: e
        }, n), {
            eK: _t(t.eK)
        });
    }), lx = F2(function(n, e) {
        var t = A2(jt, "\x1b", e);
        if (t.b) {
            var r = t.a, a = t.b;
            if (A2(Ar, "\x1b", e)) return A2(fx, A2(tt, r, a), n);
            var i = A2(fx, a, n);
            return {
                eK: A2(tt, A2(ox, n, r), i.eK),
                an: i.an
            };
        }
        return {
            eK: v,
            an: n
        };
    }), dx = function(n) {
        return y([
            F$("clickable"),
            Nw(n)
        ]);
    }, bx = function(n) {
        var e = A2(Li, 1e3, n);
        return A3(cC, 4, " ", Ct(n / 1e3 | 0)) + "." + A3(cC, 3, "0", Ct(e)) + " ";
    }, hx = F5(function(n, e, t, r, a) {
        return 1 === t.$ ? A2(R$, y([
            F$("line")
        ]), A2(tt, A2(Xw, y([
            F$("time")
        ]), y([
            z$(bx(r.gl))
        ])), a)) : t.a ? A2(R$, A2(tt, F$("line"), dx(e(r.fN))), A2(tt, A2(Xw, y([
            F$("time"),
            A2(ew, "color", "blue")
        ]), y([
            z$(bx(r.gl))
        ])), A2(tt, A2(Xw, y([
            A2(ew, "color", "blue")
        ]), y([
            u(n, mt(r.fN)) ? z$("\u21F2  ") : z$("\u21F1 ")
        ])), a))) : A2(R$, A2(tt, F$("line"), u(n, mt(r.fN)) ? v : y([
            F$("log-collapsed")
        ])), A2(tt, A2(Xw, y([
            F$("time"),
            A2(ew, "visibility", "hidden")
        ]), y([
            z$(bx(r.gl))
        ])), a));
    }), gx = F4(function(n, e, t, r) {
        if (t.b) {
            if (t.b.b) return A3(St, F2(function(t, r) {
                var a = t.a, i = t.b, u = A2(lx, r.an, i.ht);
                return {
                    f8: A2(tt, A5(hx, n, e, mt(a), i, u.eK), r.f8),
                    an: u.an
                };
            }), r, A2(Nt, F2(function(n, e) {
                return d(u(n, It(t) - 1), e);
            }), t));
            var a = t.a;
            if (A2(mr, "\x1b", a.ht)) {
                var i = A2(lx, r.an, a.ht);
                return {
                    f8: A2(tt, A5(hx, n, e, yt, a, i.eK), r.f8),
                    an: i.an
                };
            }
            return {
                f8: A2(tt, A5(hx, n, e, yt, a, y([
                    z$(a.ht)
                ])), r.f8),
                an: r.an
            };
        }
        return r;
    }), vx = _$("id"), px = F3(function(n, e, t) {
        return y([
            A2(R$, g(y([
                A2(ew, "padding", "1em 0 1em 0"),
                vx(e)
            ]), A2(nl, function() {
                return n;
            }, y([
                A2(ew, "overflow-y", "scroll"),
                A2(ew, "scroll-behavior", "smooth"),
                A2(ew, "height", "50vh")
            ]))), t)
        ]);
    }), mx = function(n) {
        return A2(mr, "\r", n.ht) ? A2(Gr, function(e) {
            return h(n, {
                ht: e
            });
        }, A2(nl, function(n) {
            return "" !== n;
        }, A2(jt, "\r", n.ht))) : y([
            n
        ]);
    }, yx = _$("target"), $x = function(n) {
        switch(n){
            case 0:
                return "Error";
            case 1:
                return "Warn";
            case 2:
                return "Notice";
            case 3:
                return "Info";
            case 4:
                return "Talkative";
            case 5:
                return "Chatty";
            case 6:
                return "Debug";
            default:
                return "Vomit";
        }
    }, wx = F2(function(n, e) {
        return A2(Qn, n, Ob(e));
    }), kx = wx("checked"), Cx = wx("disabled"), xx = _$("htmlFor"), jx = Kn("label"), qx = F2(function(n, e) {
        return A3(Or, Zr, e, n);
    }), Sx = A2(qx, y([
        "target",
        "checked"
    ]), aa), Ix = function(n) {
        var e, t = iy(n.iY.eP);
        return A2(tt, A2(R$, y([
            F$("ui toggle checkbox")
        ]), y([
            A2(Ew, y([
                Lw("checkbox"),
                F$("hidden"),
                (e = n.ib, A2(cw, "change", A2(lr, e, Sx))),
                kx(n.iY.jt),
                vx(n.iB),
                Cx(t)
            ]), v),
            A2(jx, y([
                xx(n.iB)
            ]), A2(tt, A2(Z$, y([
                F$("ui icon loading spinner"),
                A2(ew, "visibility", t ? "visible" : "hidden")
            ]), v), n.j_))
        ])), function() {
            var e = n.iY.eP;
            switch(e.$){
                case 1:
                case 0:
                default:
                    return v;
                case 2:
                    return y([
                        A2($k, !0, e.a)
                    ]);
            }
        }());
    }, Tx = F3(function(n, e, t) {
        return A2(pk, h(mk, {
            iy: mt(e)
        }), A3(yk, n, t, v));
    }), Ax = F2(function(n, e) {
        var t, r, a, i = A2(la, 3, e.jW), c = jv(e.jW), o = 3 === (t = e.iN).$ && !t.a.e6, s = A2(nl, function() {
            return o;
        }, y([
            A2(R$, y([
                F$("ui basic segment")
            ]), Ix({
                ib: n.je,
                iB: "scroll-to-bottom-" + n.c,
                iY: (r = e.aT, {
                    eP: Fs(0),
                    jt: r
                }),
                j_: y([
                    z$("Auto scroll")
                ])
            }))
        ])), f = y([
            A2(R$, y([
                F$("ui basic segment")
            ]), y([
                A2(U$, y([
                    F$("ui labeled icon button fluid"),
                    Ow(e.im(i)),
                    yx("_blank"),
                    A2(_$, "download", "")
                ]), y([
                    A2(Z$, y([
                        F$("download icon")
                    ]), v),
                    z$("Download log")
                ]))
            ]))
        ]), l = function(e) {
            return u(e, i) ? F$("disabled") : Nw(n.ja(e));
        }, b = A2(nl, function() {
            return c;
        }, y([
            A2(R$, y([
                F$("ui basic segment")
            ]), y([
                A2(R$, y([
                    F$("ui labeled stackable buttons")
                ]), y([
                    A2(TC, y([
                        F$("ui left attached icon button"),
                        X$(y([
                            d("disabled", !i)
                        ]))
                    ]), y([
                        A2(Z$, y([
                            F$("minus icon"),
                            l(AC(i))
                        ]), v)
                    ])),
                    A2(TC, y([
                        F$("ui label"),
                        A2(ew, "border-radius", "0px"),
                        A2(ew, "margin-left", "0"),
                        A2(ew, "margin-right", "0"),
                        A2(ew, "width", "7rem")
                    ]), y([
                        z$($x(i))
                    ])),
                    A2(TC, y([
                        F$("ui right attached icon button"),
                        X$(y([
                            d("disabled", 7 === i)
                        ]))
                    ]), y([
                        A2(Z$, y([
                            F$("plus icon"),
                            l(DC(i))
                        ]), v)
                    ]))
                ]))
            ]))
        ]));
        return A3(px, 3 !== (a = e.iN).$ || function(n) {
            return !(n.e6 && 20 > It(n.f8));
        }(a.a), n.c, y([
            A2(R$, y([
                F$("log")
            ]), y([
                A2(R$, y([
                    F$("sticky-controls ui compact segments")
                ]), g(b, g(s, f))),
                A2(R$, e.iI ? v : y([
                    A2(ew, "opacity", "50%")
                ]), function() {
                    var t = e.iN;
                    switch(t.$){
                        case 3:
                            var r = t.a, a = r.f8;
                            if (a.b) {
                                var c = a;
                                return _t(A3(St, A2(gx, e.jn, n.jc), {
                                    f8: v,
                                    an: PC
                                }, A2(Gr, mx, c)).f8);
                            }
                            return r.e6 ? u(e.jW, yt) ? y([
                                A2(Z$, v, y([
                                    z$("(did not produce log output)")
                                ]))
                            ]) : y(e.iI ? [
                                A2(Z$, v, y([
                                    z$("(did not produce log output at " + $x(i) + " level)")
                                ]))
                            ] : [
                                A2(R$, y([
                                    F$("ui placeholder")
                                ]), y([
                                    A2(R$, y([
                                        F$("line")
                                    ]), v)
                                ]))
                            ]) : v;
                        case 1:
                            return OC;
                        case 0:
                            return v;
                        default:
                            return y([
                                A3(Tx, e.dd, "Could not retrieve log", t.a)
                            ]);
                    }
                }())
            ]))
        ]));
    }), Ex = F5(function(n, e, t, r, a) {
        if (r.hj) return i = A2(la, Qr, A2(Zl, r.di, e.al)), A2(Ax, {
            c: r.di,
            ja: function() {
                return Ml;
            },
            jc: CC(r.di),
            je: xC(r.di)
        }, {
            im: function() {
                return IC(A2(_o, n.hZ, A5(jC, t.cq.c, ku(e.a9), r.di, yt, yt)));
            },
            dd: n.dd,
            iI: !0,
            iN: i,
            jn: A2(au, r.di, e.ca),
            aT: A2(la, !0, A2(au, r.di, e.aT)),
            jW: yt
        });
        var i;
        return y([
            A2(qC, y([
                Rw(A3(SC, t.cq.c, e.a9, r.di) + "&v=" + Ct(a)),
                F$("log")
            ]), y([
                z$("Loading log...")
            ]))
        ]);
    }), Nx = F5(function(n, e, t, r, a) {
        return g(A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    A2(Z$, y([
                        F$("ui icon green circle check")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Succeeded")
                ])
            });
        }, Rl(a.dK)), g(A2(Gr, function(t) {
            return aC({
                K: A2(Zi, function(n) {
                    return y([
                        A2(ik, v, g(y([
                            z$("A rebuild was necessary because the output was missing from the cache when demanded by the evaluation of "),
                            A2(rC, {
                                cq: mt(e.ci.cq),
                                br: yt,
                                dC: e.dC
                            }, {
                                cq: e.ci.cq,
                                ab: n.ab,
                                br: n.br.n,
                                dC: e.dC
                            })
                        ]), qc(Rl(A2(Zi, function(n) {
                            return y([
                                z$(" on agent "),
                                A2(Uk, v, y([
                                    z$(n)
                                ])),
                                z$(".")
                            ]);
                        }, t.g$)))))
                    ]);
                }, t.g0),
                N: y([
                    A2(Z$, y([
                        F$("ui icon ellipsis horizontal")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, t.f)
                ]),
                Q: y([
                    z$("Queued")
                ])
            });
        }, Rl(a.dv)), g(A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    A2(Z$, y([
                        F$("ui icon orange ellipsis horizontal")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Reset")
                ])
            });
        }, Rl(a.g4)), g(A2(Gr, function(a) {
            return aC({
                K: mt(g(A2(Gr, function(n) {
                    return A2(ik, v, y([
                        z$("Agent: "),
                        A2(Uk, v, y([
                            z$(n)
                        ]))
                    ]));
                }, Rl(a.a_)), A5(Ex, n, e, t, a, r))),
                N: y([
                    A2(Z$, y([
                        F$("ui icon sun outline")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, a.f)
                ]),
                Q: y([
                    z$("Created")
                ])
            });
        }, Rl(a.dI)), g(A2(Gr, function(e) {
            return A2(kC, n.jS, e);
        }, Rl(a.cZ)), g(A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    A2(Z$, y([
                        F$("ui icon times red circle outline")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Dependency failed")
                ])
            });
        }, Rl(a.cM)), g(A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    xk(y([
                        A2(ew, "margin-left", "0.4rem")
                    ]))
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Cancelled")
                ])
            });
        }, Rl(a.cA)), g(A2(Gr, function(e) {
            return aC({
                K: A2(Zi, function(n) {
                    return y([
                        z$("Requested by @" + n.dC.n + "/" + n.n)
                    ]);
                }, e.eG),
                N: y([
                    tC(y([
                        A2(ew, "margin-left", "0.4rem")
                    ]))
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Cancelled by user")
                ])
            });
        }, Rl(a.fq)), g(A2(Gr, function(e) {
            return aC({
                K: function() {
                    var n = A2(la, v, e.dq);
                    if (n.b) {
                        var t = A3(St, pt, 0, A2(Gr, function(n) {
                            return n.dE;
                        }, n));
                        return mt(y([
                            z$("Size before compression: "),
                            z$(Ct(t)),
                            z$(" bytes")
                        ]));
                    }
                    return yt;
                }(),
                N: y([
                    A2(Z$, y([
                        F$("ui icon green circle")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Built on agent")
                ])
            });
        }, Rl(a.eF)), g(A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    xk(y([
                        A2(ew, "margin-left", "0.4rem")
                    ]))
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Cancellation complete")
                ])
            });
        }, Rl(a.fE)), A2(Gr, function(e) {
            return aC({
                K: yt,
                N: y([
                    xk(y([
                        A2(ew, "margin-left", "0.4rem")
                    ]))
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Cancellation for reset complete")
                ])
            });
        }, Rl(a.fF))))))))))));
    }), Lx = F4(function(n, e, t, r) {
        return A2(R$, y([
            F$("ui feed")
        ]), A2(Sc, A4(Nx, n, e, t, It(r)), r));
    }), Px = F3(function(n, e, t) {
        var r = _t(t.ih.cV);
        if (r.b) {
            if (r.b.b) {
                var a = r.a, i = r.b;
                return A2(tt, A2(R$, y([
                    F$("ui vertical segment")
                ]), y([
                    A4(Lx, n, e, t, a)
                ])), A2(Gr, function(r) {
                    return A2(R$, y([
                        F$("ui vertical segment")
                    ]), y([
                        A2(Pk, v, y([
                            z$("Previous attempt")
                        ])),
                        A4(Lx, n, e, t, r)
                    ]));
                }, i));
            }
            return y([
                A4(Lx, n, e, t, r.a)
            ]);
        }
        return y([
            z$("No events / No events yet")
        ]);
    }), Dx = {
        $: 5
    }, Ox = {
        $: 3
    }, Gx = function(n) {
        return TC(A2(tt, F$("ui button"), g(iy(n.eP) ? y([
            F$("loading")
        ]) : y([
            Nw(n.eO)
        ]), n.cv)));
    }, _x = F3(function(n, e, t) {
        return g(A2(Gr, function(n) {
            return A2(Gx, {
                cv: y([
                    F$("primary fluid")
                ]),
                eO: Ox,
                eP: e
            }, y([
                A2(Z$, y([
                    F$("ui icon redo alternative")
                ]), v),
                z$(n)
            ]));
        }, function(n) {
            if (!n.ih.ge) return v;
            switch(n.ih.V){
                case 3:
                    return y([
                        "Restart build"
                    ]);
                case 4:
                    return y([
                        "Restart recursively"
                    ]);
                case 2:
                    return y([
                        "Reset build"
                    ]);
                default:
                    return v;
            }
        }(n)), n.ih.bk ? y([
            A2(Gx, {
                cv: y([
                    F$("red basic fluid"),
                    wk("Kill and do not rebuild until explicitly requested")
                ]),
                eO: Dx,
                eP: t
            }, y([
                A2(Z$, y([
                    F$("ui icon times")
                ]), v),
                z$("Cancel")
            ]))
        ]) : v);
    }), Fx = F4(function(n, e, t, r) {
        var a, i = Fu(h(n.ci, {
            eb: e
        }));
        return A2(R$, A2(tt, Nw({
            $: 2,
            a: e
        }), g((a = u(n.ci.eb, e), A2(nl, function() {
            return a;
        }, y([
            F$("active")
        ]))), t)), y([
            A2(U$, y([
                Gw(i)
            ]), r)
        ]));
    }), Rx = F3(function(n, e, t) {
        var r, a = Ek(e.ch), i = a.a, u = a.b, c = Ek(e.bN), o = c.a, s = c.b, f = A2(Gr, $k(n.dd), Lk(y([
            i,
            o
        ])));
        return A2(R$, v, g(y(e.ci.eZ ? [
            A2(ck, y([
                F$("ui large header")
            ]), y([
                z$("Dependencies of " + Ak(e))
            ]))
        ] : [
            A2(R$, y([
                A2(ew, "float", "right"),
                A2(ew, "width", "14em")
            ]), A3(_x, t, u, s)),
            A2(ck, y([
                F$("ui large header")
            ]), y([
                (r = t.ih, r.cV.b ? qk(r.V) : A2(kk, "", "")),
                z$(Sk(t.ih))
            ]))
        ]), A2(tt, A2(R$, v, f), g(e.ci.eZ ? v : y([
            A2(R$, y([
                F$("ui big top attached tabular small menu")
            ]), g(y([
                A4(Fx, e, 0, y([
                    F$("item right")
                ]), y([
                    A2(Z$, y([
                        F$("ui icon info circle black")
                    ]), v),
                    z$("Info")
                ]))
            ]), A2(nl, function() {
                return !!t.ih.V;
            }, y([
                A4(Fx, e, 1, y([
                    F$("item ")
                ]), y([
                    A2(Z$, y([
                        F$("ui icon clipboard list black")
                    ]), v),
                    z$("Log")
                ]))
            ]))))
        ]), y([
            A2(R$, y([
                F$("ui bottom attached active tab segment")
            ]), e.ci.eb ? A3(Px, n, e, t) : A2(eC, e, t))
        ])))));
    }), Bx = F2(function(n, e) {
        var t = Vs(e);
        switch(t.$){
            case 3:
                return A3(Rx, n, e, t.a);
            case 2:
                return A2($k, n.dd, t.a);
            default:
                return function(n) {
                    return z$("Loading " + n.a9);
                }(e);
        }
    }), Hx = F2(function(n, e) {
        return {
            q: A2(Bx, {
                hZ: n.c_.hZ,
                dd: fk(n),
                jS: n.jS
            }, e),
            e: sk(e)
        };
    }), Vx = function(n) {
        return Gw(Uu({
            cq: mt(n.ax),
            dC: mt(n.hf)
        }));
    }, zx = function(n) {
        var e = A2(mC, $C, n), t = function() {
            switch(A2(vC, $C, n)){
                case 0:
                    return "01";
                case 1:
                    return "02";
                case 2:
                    return "03";
                case 3:
                    return "04";
                case 4:
                    return "05";
                case 5:
                    return "06";
                case 6:
                    return "07";
                case 7:
                    return "08";
                case 8:
                    return "09";
                case 9:
                    return "10";
                case 10:
                    return "11";
                default:
                    return "12";
            }
        }(), r = A2(bC, $C, n), a = 10 > r ? "0" + Ct(r) : Ct(r);
        return Ct(e) + "-" + t + "-" + a;
    }, Ux = function(n) {
        return n.$ ? "unknown" : zx(n.a);
    }, Wx = function(n) {
        switch(n.ey){
            case 0:
                return A2(ik, v, y([
                    z$("You are on the free community plan.")
                ]));
            case 1:
                return A2(ik, v, y([
                    z$("Your free trial is active since " + Ux(n.hy) + ".")
                ]));
            case 2:
                return A2(ik, v, y([
                    z$("Your subscription is active since " + Ux(n.hp) + ".")
                ]));
            case 3:
                return A2(ik, v, y([
                    z$("Your subscription is cancelled since " + Ux(n.ho) + ".")
                ]));
            case 4:
                return A2(ik, v, y([
                    z$("Your subscription is active but not managed via the dashboard. For questions, contact support@hercules-ci.com.")
                ]));
            default:
                return A2(ik, v, y([
                    z$("You are using Hercules CI Enterprise, which is billed at the instance level. For questions, contact support@hercules-ci.com.")
                ]));
        }
    }, Kx = {
        $: 4
    }, Zx = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Yx = F3(function(n, e, t) {
        switch(t.$){
            case 0:
                return A2(R$, v, v);
            case 1:
                return A2(R$, y([
                    F$("ui icon message")
                ]), y([
                    A2(Z$, y([
                        F$("notched circle loading icon")
                    ]), v),
                    A2(R$, y([
                        F$("content")
                    ]), y([
                        A2(R$, y([
                            F$("header")
                        ]), y([
                            z$("Loading")
                        ])),
                        A2(ik, v, y([
                            z$("We are disabling all repos for this account.")
                        ]))
                    ]))
                ]));
            case 3:
                var r = t.a;
                return A2(R$, y([
                    F$("ui icon positive message")
                ]), y([
                    A2(Z$, y([
                        F$("notched check icon")
                    ]), v),
                    A2(R$, y([
                        F$("content")
                    ]), y([
                        A2(R$, y([
                            F$("header")
                        ]), y([
                            z$("Done")
                        ])),
                        A2(ik, v, y([
                            z$("We have disabled all " + Ct(r) + " known repos in " + e.cq.ax + ".")
                        ]))
                    ]))
                ]));
            default:
                var a = t.a;
                return A2(R$, y([
                    F$("ui icon negative message")
                ]), y([
                    A2(Z$, y([
                        F$("notched exclamation icon")
                    ]), v),
                    A2(R$, y([
                        F$("content")
                    ]), y([
                        A2(R$, y([
                            F$("header")
                        ]), y([
                            z$("Error")
                        ])),
                        A2(ik, v, A3(yk, n, a, v))
                    ]))
                ]));
        }
    }), Mx = F3(function(n, e, t) {
        var r = n.dd;
        return y([
            A2(ik, v, y([
                z$("Enabling a repository only has an effect when it contains a "),
                A2(Uk, v, y([
                    z$("flake.nix")
                ])),
                z$(", "),
                A2(Uk, v, y([
                    z$("nix/ci.nix")
                ])),
                z$(", "),
                A2(Uk, v, y([
                    z$("ci.nix")
                ])),
                z$(" or "),
                A2(Uk, v, y([
                    z$("default.nix")
                ])),
                z$(" file. Repositories without any of these files are ignored. "),
                A2(Uk, v, y([
                    z$("flake.nix")
                ])),
                z$("is ignored when all "),
                A2(Uk, v, y([
                    z$("x86_64-linux")
                ])),
                z$(" agents are older than "),
                A2(Uk, v, y([
                    z$("0.9")
                ])),
                z$(".")
            ])),
            A2(ik, v, Ix({
                ib: Zx,
                iB: "enableNewRepos",
                iY: {
                    eP: e.b_,
                    jt: t.ai.cU
                },
                j_: y([
                    z$("Enable new repositories when they are added.")
                ])
            })),
            A2(R$, y([
                F$("ui segment")
            ]), y([
                A2(ik, v, y([
                    z$("This disables building of all repositories in " + t.cq.ax + ". This action can not be reversed by itself; repositories must be re-enabled one by one.")
                ])),
                A2(TC, y([
                    F$("ui button negative basic"),
                    Nw(Kx)
                ]), y([
                    z$("Disable all repositories")
                ])),
                A3(Yx, r, t, e.bW)
            ]))
        ]);
    }), Jx = A2(Z$, y([
        F$("ui small icon external link"),
        A2(ew, "vertical-align", "text-bottom"),
        A2(ew, "margin", "2pt"),
        A2(ew, "text-decoration", "none")
    ]), v), Qx = F3(function(n, e, t) {
        var r, a = n.dd, i = t.cq.dc, u = i ? "Uninstall" : "Install", c = Ek(e.c6), o = c.a, s = c.b;
        return y([
            A2(Pk, v, y([
                z$("GitLab integration settings")
            ])),
            A2(ik, v, y([
                z$("You must be a Group Owner on GitLab to enable / disable the integration.")
            ])),
            A2(ik, v, y([
                A2(R$, v, A2(Gr, $k(a), Rl(o))),
                A2(Gx, {
                    cv: y([
                        X$(y([
                            d("primary", !i),
                            d("red", i)
                        ]))
                    ]),
                    eO: (r = !i, {
                        $: 13,
                        a: r
                    }),
                    eP: s
                }, y([
                    z$(u)
                ]))
            ]))
        ]);
    }), Xx = F3(function(n, e, t) {
        return "gitlab" !== t.fr.W ? v : A3(Qx, n, e, t);
    }), nj = F3(function(n, e, t) {
        var r = t.cq.fU;
        if (1 === r.$) return A3(Xx, n, e, t);
        var a = r.a;
        return A2(tt, A2(Pk, v, y([
            z$("Installation on " + t.cq.hf)
        ])), a ? g(y([
            A2(ik, v, y([
                z$("The integration only has access to a limited number of repositories via " + t.cq.hf + ". This means only admins can add new repositories.")
            ])),
            A2(ik, v, y([
                z$("If you install github on all repositories, non-admins can enable and disable Hercules CI on repositories where they have write permission.")
            ]))
        ]), A2(Gr, function(n) {
            return A2(ik, v, y([
                A2(U$, y([
                    F$("ui button primary"),
                    Ow(n)
                ]), y([
                    z$("Configure access or add repositories")
                ]))
            ]));
        }, Rl(t.cq.gc))) : A2(tt, A2(ik, v, y([
            z$("The integration is enabled for all repositories. Non-admins can enable and disable Hercules CI on repositories where they have write permission.")
        ])), A2(Gr, function(n) {
            return A2(ik, v, y([
                A2(U$, y([
                    F$("ui button primary"),
                    Ow(n)
                ]), y([
                    z$("Configure repository access"),
                    Jx
                ]))
            ]));
        }, Rl(t.cq.gc))));
    }), ej = F3(function(n, e, t) {
        var r = n.dd;
        return A2(R$, v, g(A3(nj, {
            dd: r
        }, e, t), A2(tt, A2(Pk, v, y([
            z$("Newly added repositories")
        ])), g(A3(Mx, {
            dd: r
        }, e, t), A2(tt, A2(Pk, v, y([
            z$("Billing")
        ])), function(n) {
            var e = A2(U$, y([
                F$("ui primary button"),
                Vx(n)
            ]), y([
                z$("Configure")
            ])), t = n.gA;
            if (t.$) return y([
                A2(ik, v, y([
                    z$("Start a trial or add this account to an existing organization.")
                ])),
                e
            ]);
            var r = t.a;
            return y([
                A2(ik, v, y([
                    z$("This account is billed as part of "),
                    A2(Z$, v, y([
                        z$(r.k)
                    ]))
                ])),
                Wx(r),
                e
            ]);
        }(t.cq))))));
    }), tj = {
        q: A2(R$, y([
            F$("ui segment")
        ]), y([
            A2(R$, y([
                F$("ui placeholder")
            ]), y([
                A2(R$, y([
                    F$("line")
                ]), v),
                A2(R$, y([
                    F$("line")
                ]), v),
                A2(R$, y([
                    F$("line")
                ]), v)
            ]))
        ])),
        e: "Account settings"
    }, rj = function(n) {
        return {
            $: 7,
            a: n
        };
    }, aj = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ij = function(n) {
        return {
            $: 10,
            a: n
        };
    }, uj = function(n) {
        return {
            $: 11,
            a: n
        };
    }, cj = F4(function(n, e, t, r) {
        if (1 === r.$) return A3(e, R$, v, y(n ? [
            A2(Z$, v, y([
                z$("please select")
            ]))
        ] : [
            A2(Z$, v, y([
                z$("default")
            ]))
        ]));
        var a = r.a;
        return A3(e, R$, y([
            wk(a)
        ]), y([
            z$(a)
        ]));
    }), oj = F3(function(n, e, t) {
        return A3(n, R$, v, y(1 === t.$ ? [
            A2(Z$, v, y([
                z$("default")
            ]))
        ] : t.a ? [
            z$("All")
        ] : [
            z$("Ignore")
        ]));
    }), sj = y([
        0,
        1
    ]), fj = function(n) {
        return A2(sd, v, A2(Af, function(n) {
            return n.eu;
        }, n.Z));
    }, lj = function(n) {
        switch(n.$){
            case 1:
                return A2(Z$, y([
                    F$("ui icon circle notch loading")
                ]), v);
            case 3:
                return A2(Z$, y([
                    F$("ui icon check")
                ]), v);
            case 2:
                return A2(Z$, y([
                    F$("ui icon times")
                ]), v);
            default:
                return A2(Z$, y([
                    F$("ui icon")
                ]), v);
        }
    }, dj = F2(function(n, e) {
        return A2(R$, y([
            F$("ui segment")
        ]), y([
            A2(Pk, v, y([
                z$("Personal notification settings")
            ])),
            A2(ik, v, y([
                z$("These settings only apply to you. They override your "),
                A2(U$, y([
                    Gw(nc)
                ]), y([
                    z$("default notification settings")
                ])),
                z$(".")
            ])),
            A2(R$, y([
                F$("ui stackable grid")
            ]), y([
                A2(R$, y([
                    F$("row")
                ]), y([
                    A2(R$, y([
                        F$("ten wide column")
                    ]), y([
                        A2(R$, y([
                            F$("ui labeled input fluid")
                        ]), y([
                            A2(R$, y([
                                F$("ui label primary"),
                                A2(ew, "width", "11em")
                            ]), y([
                                z$("Email "),
                                lj(n.b8)
                            ])),
                            A5(Pw, Y$({
                                h8: A2(tt, yt, A2(Gr, A2(ao, mt, function(n) {
                                    return n.el;
                                }), fj(n))),
                                iE: "default-email",
                                jf: rj,
                                ji: aj
                            }), {
                                io: n.dm,
                                jE: A2(uc, function(n) {
                                    return n.gu;
                                }, A2(th, n, e))
                            }, R$, y([
                                F$("fluid"),
                                X$(y([
                                    d("loading", iy(n.Z))
                                ]))
                            ]), cj(!1))
                        ]))
                    ]))
                ])),
                A2(R$, y([
                    F$("ten wide column")
                ]), y([
                    A2(R$, y([
                        F$("ui labeled input fluid")
                    ]), y([
                        A2(R$, y([
                            F$("ui label primary"),
                            A2(ew, "width", "11em")
                        ]), y([
                            z$("Events "),
                            lj(n.b9)
                        ])),
                        A5(Pw, Y$({
                            h8: A2(tt, yt, A2(Gr, mt, sj)),
                            iE: "default-level",
                            jf: ij,
                            ji: uj
                        }), {
                            io: n.$7,
                            jE: A2(uc, function(n) {
                                return n.gv;
                            }, A2(th, n, e))
                        }, R$, y([
                            F$("fluid"),
                            X$(y([
                                d("loading", iy(n.Z))
                            ]))
                        ]), oj)
                    ]))
                ]))
            ]))
        ]));
    }), bj = F4(function(n, e, t, r) {
        return A2(R$, v, y([
            A2(dj, e, t),
            function() {
                switch(r.$){
                    case 2:
                        return 3 === r.a.$ && 403 === r.a.a ? A2(R$, v, v) : A2($k, n.dd, r.a);
                    case 3:
                        var t = r.a;
                        return A2(R$, y([
                            F$("ui segment")
                        ]), y([
                            A3(ej, n, e, t)
                        ]));
                    default:
                        return tj.q;
                }
            }()
        ]));
    }), hj = F2(function(n, e) {
        var t = e.cq;
        switch(t.$){
            case 3:
                var r = t.a;
                return {
                    q: A4(bj, {
                        dd: fk(n)
                    }, e, r, A2(ih, n, e)),
                    e: r.ax + " account settings"
                };
            case 2:
                var a = t.a;
                return {
                    q: A2($k, fk(n), a),
                    e: "Error"
                };
            default:
                return tj;
        }
    }), gj = {
        $: 1
    }, vj = {
        $: 0
    }, pj = 18e4, mj = F2(function(n, e) {
        var t = e.g7;
        if (t.$) {
            var r = e.f5;
            if (1 === r.$) return vj;
            var a = r.a;
            return e.ev ? s(n - a, pj) > 0 ? {
                $: 3,
                a: a
            } : gj : function(n) {
                return {
                    $: 2,
                    a: n
                };
            }(a);
        }
        return {
            $: 4,
            a: a = t.a
        };
    }), yj = F2(function(n, e) {
        return 1 === A2(mj, n, e).$;
    }), $j = k, wj = $j(function(n) {
        return -n.eT;
    }), kj = F2(function(n, e) {
        return h(e, {
            cE: n
        });
    }), Cj = F2(function(n, e) {
        return h(e, {
            cO: n
        });
    }), xj = {
        cx: !1,
        cB: !1,
        cE: yt,
        cO: yt,
        c2: !1,
        iD: yt,
        b2: yt,
        du: yt,
        dE: 3,
        dM: !1
    }, jj = F3(function(n, e, t) {
        var r, a, i, c = y([
            z$(t)
        ]);
        return A2(n, qc(y([
            y([
                F$("ui label"),
                X$(y([
                    d("image", !u(e.b2, yt)),
                    d("basic", e.cx),
                    d("tag", e.dM),
                    d("horizontal", e.c2),
                    d("circular", e.cB)
                ])),
                Qw(e.dE)
            ]),
            function() {
                var n = e.du;
                if (n.$) return v;
                switch(n.a){
                    case 0:
                        return y([
                            F$("pointing")
                        ]);
                    case 1:
                        return y([
                            F$("pointing below")
                        ]);
                    case 2:
                        return y([
                            F$("left pointing")
                        ]);
                    default:
                        return y([
                            F$("right pointing")
                        ]);
                }
            }(),
            (i = e.cE, i.$ ? v : y([
                dk(i.a)
            ]))
        ])), qc(y([
            (a = e.b2, a.$ ? v : y([
                A2(Fw, y([
                    Rw(a.a)
                ]), v)
            ])),
            (r = e.iD, r.$ ? v : y([
                A2(hk, gk, r.a)
            ])),
            c,
            function() {
                var n = e.cO;
                if (n.$) return v;
                var t = n.a;
                return y([
                    A2(R$, y([
                        F$("detail")
                    ]), y([
                        z$(t)
                    ]))
                ]);
            }()
        ])));
    }), qj = jj(R$), Sj = function(n) {
        return 0 > n ? -n : n;
    }, Ij = F2(function(n, e) {
        var t = Sj(n - e) / 1e3 | 0, r = t / 60 | 0, a = t / 3600 | 0, i = t / 86400 | 0;
        return 2 > i ? 2 > a ? 2 > r ? 1 > r ? 2 > t ? "a second" : "seconds" : "a minute" : Ct(r) + " minutes" : Ct(a) + " hours" : Ct(i) + " days";
    }), Tj = F2(function(n, e) {
        var t = function(e) {
            return mt("for " + A2(Ij, n, e));
        }, r = A2(mj, n, e);
        switch(r.$){
            case 0:
                return A2(qj, xj, "Waiting to connect");
            case 1:
                return A2(qj, A2(kj, mt(4), xj), "Online");
            case 3:
                var a = r.a;
                return A2(qj, A2(kj, mt(2), A2(Cj, t(a), xj)), "No connection");
            case 2:
                return a = r.a, A2(qj, A2(kj, mt(0), A2(Cj, t(a), xj)), "Shut down");
            default:
                return a = r.a, A2(qj, A2(kj, mt(6), A2(Cj, t(a), xj)), "Revoked");
        }
    }), Aj = Kn("dd"), Ej = Kn("dl"), Nj = Kn("dt"), Lj = function(n) {
        return y([
            A2(Ej, v, A2(Sc, function(n) {
                var e = n.a, t = n.b;
                return y([
                    A2(Nj, v, y([
                        A2(Xw, y([
                            F$("ui blue text")
                        ]), y([
                            A2(Uk, v, y([
                                z$(e)
                            ]))
                        ]))
                    ])),
                    A2(Aj, v, Pj(t))
                ]);
            }, ut(n)))
        ]);
    }, Pj = function(n) {
        var e, t = A2(ja, ta, n);
        if (t.$) {
            var r = A2(ja, Bo, n);
            if (r.$) {
                var a = A2(ja, aa, n);
                if (a.$) {
                    var i = A2(ja, Ca(Ia), n);
                    if (i.$) {
                        var u = A2(ja, {
                            $: 4,
                            b: Ia
                        }, n);
                        return y(u.$ ? [
                            A2(Uk, v, y([
                                z$(A2(kt, 2, n))
                            ]))
                        ] : (e = u.a, o = A3(at, tt, v, e)).b ? [
                            A2(Xk, v, A2(Gr, function(n) {
                                return A2(Qk, v, Pj(n));
                            }, o))
                        ] : [
                            A2(Z$, v, y([
                                z$("(empty list)")
                            ]))
                        ]);
                    }
                    return Lj(i.a);
                }
                return y(a.a ? [
                    A2(Xw, y([
                        F$("ui violet text")
                    ]), y([
                        A2(Uk, v, y([
                            z$("true")
                        ]))
                    ]))
                ] : [
                    A2(Xw, y([
                        F$("ui violet text")
                    ]), y([
                        A2(Uk, v, y([
                            z$("false")
                        ]))
                    ]))
                ]);
            }
            var c = r.a;
            return y([
                A2(Xw, y([
                    F$("ui teal text")
                ]), y([
                    A2(Uk, v, y([
                        z$(Ct(c))
                    ]))
                ]))
            ]);
        }
        var o, s = t.a;
        return y([
            A2(Xw, y([
                F$("ui brown text")
            ]), y([
                A2(Uk, v, y([
                    z$(s)
                ]))
            ]))
        ]);
    }, Dj = F2(function(n, e) {
        return A2(R$, y([
            F$("ui segment")
        ]), y([
            A2(ck, v, y([
                z$("Agent")
            ])),
            A2(Dk, y([
                F$("ui very basic stackable table")
            ]), y([
                A2(Ok, v, y([
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Hostname")
                        ])),
                        A2(Gk, v, y([
                            A2(Uk, v, y([
                                z$(e.fL)
                            ]))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Status")
                        ])),
                        A2(Gk, v, y([
                            A2(Tj, n, e)
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Id")
                        ])),
                        A2(Gk, v, y([
                            A2(Uk, v, y([
                                z$(e.c)
                            ]))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Platforms")
                        ])),
                        A2(Gk, v, y([
                            A2(Xk, v, A2(Gr, function(n) {
                                return A2(Qk, v, y([
                                    A2(Uk, v, y([
                                        z$(n)
                                    ]))
                                ]));
                            }, e.gK))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("System features")
                        ])),
                        A2(Gk, v, y([
                            A2(Xk, v, A2(Gr, function(n) {
                                return A2(Qk, v, y([
                                    A2(Uk, v, y([
                                        z$(n)
                                    ]))
                                ]));
                            }, e.hs))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Substituters")
                        ])),
                        A2(Gk, v, y([
                            A2(Xk, v, A2(Gr, function(n) {
                                return A2(Qk, v, y([
                                    A2(Uk, v, y([
                                        z$(n)
                                    ]))
                                ]));
                            }, e.hr))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Push+pull caches")
                        ])),
                        A2(Gk, v, y([
                            A2(Xk, v, A2(Gr, function(n) {
                                return A2(Qk, v, y([
                                    A2(Uk, v, y([
                                        z$(n)
                                    ]))
                                ]));
                            }, e.gU))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Concurrency")
                        ])),
                        A2(Gk, v, y([
                            A2(Uk, v, y([
                                z$(Ct(e.eR))
                            ]))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Agent version")
                        ])),
                        A2(Gk, v, y([
                            A2(Uk, v, y([
                                z$(e.a0)
                            ]))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Nix version")
                        ])),
                        A2(Gk, v, y([
                            A2(Uk, v, y([
                                z$(e.gr)
                            ]))
                        ]))
                    ])),
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Labels")
                        ])),
                        A2(Gk, v, Lj(e.f4))
                    ]))
                ]))
            ]))
        ]));
    }), Oj = F2(function(n, e) {
        var t = e.aB;
        if (3 === t.$) {
            if (t.a.b) {
                var r = t.a;
                return A2(R$, v, A2(Gr, Dj(n), wj(A2(nl, yj(n), r))));
            }
            return A2(R$, v, v);
        }
        return A2(R$, v, v);
    }), Gj = F2(function(n, e) {
        var t = d(e, n);
        n: for(;;){
            e: for(;;){
                t: for(;;){
                    r: for(;;)switch(t.a.$){
                        case 3:
                            switch(t.b.$){
                                case 3:
                                    return Fs((0, t.a.a)(t.b.a));
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    return Bs;
                            }
                        case 2:
                            return Rs(t.a.a);
                        case 1:
                            if (2 === t.b.$) break n;
                            break e;
                        default:
                            switch(t.b.$){
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    break r;
                            }
                    }
                    return Bs;
                }
                return Qr;
            }
            return Qr;
        }
        return Rs(t.b.a);
    }), _j = F2(function(n, e) {
        return A2(Gj, e, A2(Af, F2(function(n, e) {
            return d(n, e);
        }), n));
    }), Fj = F2(function(n, e) {
        var t = function(e) {
            return A2(Rk, v, y([
                A2(Gk, v, y([
                    z$(A2(Ij, n, e.eT))
                ])),
                A2(Gk, v, A2(Gr, function(n) {
                    return A2(Xw, y([
                        F$("ui label black")
                    ]), y([
                        z$(n)
                    ]));
                }, e.gK)),
                A2(Gk, v, A2(Gr, function(n) {
                    return A2(Xw, y([
                        F$("ui label black")
                    ]), y([
                        z$(n)
                    ]));
                }, e.hs)),
                A2(Gk, v, y([
                    z$(e.a0)
                ])),
                A2(Gk, v, y([
                    z$(e.gr)
                ])),
                A2(Gk, v, v)
            ]));
        }, r = function() {
            var n = A2(Af, function(n) {
                return n.b;
            }, A2(_j, e.cq, e.aB));
            switch(n.$){
                case 2:
                    return z$("Oops, we could not load the agent this time.");
                case 3:
                    if (n.a.b) {
                        var r = n.a;
                        return A2(R$, v, y([
                            A2(ck, v, y([
                                z$("Installation history")
                            ])),
                            A2(ik, v, y([
                                z$("Your agent derives a unique token from the cluster join token, which is saved in the "),
                                A2(Uk, v, y([
                                    z$("session.key")
                                ])),
                                z$(" file. When you re-create this token, an entry appears here.")
                            ])),
                            A2(Dk, y([
                                F$("ui unstackable very basic table")
                            ]), y([
                                A2(Fk, v, y([
                                    A2(_k, v, y([
                                        z$("Registered since")
                                    ])),
                                    A2(_k, v, y([
                                        z$("Platforms")
                                    ])),
                                    A2(_k, v, y([
                                        z$("Features")
                                    ])),
                                    A2(_k, v, y([
                                        z$("Agent version")
                                    ])),
                                    A2(_k, v, y([
                                        z$("Nix version")
                                    ]))
                                ])),
                                A2(Ok, v, A2(Gr, t, wj(r)))
                            ]))
                        ]));
                    }
                    return A2(R$, v, y([
                        A2(ck, v, y([
                            z$("No data")
                        ])),
                        A2(ik, v, y([
                            z$("No agent has reported in with the hostname " + e.ci.fL + ". You may want to look at some system logs if you expected an agent to show up with that name.")
                        ]))
                    ]));
                case 1:
                    return A2(R$, y([
                        A2(ew, "position", "relative"),
                        A2(ew, "min-height", "6em")
                    ]), y([
                        A2(R$, y([
                            F$("ui active loader")
                        ]), v),
                        A2(R$, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "padding-top", "4.5em")
                        ]), y([
                            z$("Loading agent sessions")
                        ]))
                    ]));
                default:
                    return A2(Xw, v, v);
            }
        }();
        return A2(R$, y([
            F$("ui segment")
        ]), y([
            r
        ]));
    }), Rj = F2(function(n, e) {
        return {
            q: A2(R$, v, y([
                A2(Oj, n.ig, e),
                A2(Fj, n.ig, e)
            ])),
            e: "Agent " + e.ci.fL
        };
    }), Bj = function(n) {
        switch(n.$){
            case 1:
                return "Timeout exceeded";
            case 2:
                return "Network error";
            case 3:
                return "HTTP Error " + Ct(n.a) + " ";
            case 4:
                return "Unexpected response from api: " + n.a;
            default:
                return "Malformed url: " + n.a;
        }
    }, Hj = function(n) {
        return 2 === n.$ ? A2(pk, mk, y([
            z$("HTTP request failed: " + Bj(n.a))
        ])) : z$("");
    }, Vj = F2(function(n, e) {
        return A2(Xn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), ne(e));
    }), zj = Vj, Uj = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Wj = Kn("form"), Kj = F2(function(n, e) {
        return A2(Wj, qc(y([
            n.cv,
            y([
                F$("ui form"),
                X$(y([
                    d("error", n.e9)
                ]))
            ])
        ])), e);
    }), Zj = {
        cv: v,
        e9: !1
    }, Yj = {
        cv: v,
        e9: !1,
        c0: !1,
        d$: !1,
        b3: !1,
        dh: !1,
        dE: 3,
        ed: !1
    }, Mj = function(n) {
        var e = n.b3, t = n.dE, r = n.c0, a = n.ed, i = n.e9, u = n.dh, c = n.cv, o = n.d$;
        return A2(R$, y([
            F$("ui input"),
            X$(y([
                d("focus", o),
                d("loading", u),
                d("error", i),
                d("transparent", a),
                d("inverted", e),
                d("fluid", r)
            ])),
            Qw(t)
        ]), y([
            A2(Ew, c, v)
        ]));
    }, Jj = function(n) {
        return d(n, !0);
    }, Qj = F2(function(n, e) {
        return A2(uw, n, {
            $: 1,
            a: e
        });
    }), Xj = A2(qx, y([
        "target",
        "value"
    ]), ta), nq = function(n) {
        return A2(Qj, "input", A2(lr, Jj, A2(lr, n, Xj)));
    }, eq = F2(function(n, e) {
        return h(e, {
            cv: n
        });
    }), tq = {
        hW: !1,
        h$: yt,
        cv: v,
        cx: !1,
        ii: !1,
        be: yt,
        c$: yt,
        c0: !1,
        aK: yt,
        iD: yt,
        c4: 0,
        b3: !1,
        dh: !1,
        dE: 3
    }, rq = function(n) {
        return F$(function() {
            switch(n){
                case 0:
                    return "top attached";
                case 1:
                    return "middle attached";
                default:
                    return "bottom attached";
            }
        }());
    }, aq = function(n) {
        return !n.b;
    }, iq = F3(function(n, e, t) {
        var r, a, i = !u(e.iD, yt) && !aq(t), c = qc(y([
            (r = e.iD, r.$ ? v : y([
                A2(hk, gk, r.a)
            ])),
            t
        ]));
        return A2(n, qc(y([
            e.cv,
            y([
                F$("ui button"),
                X$(y([
                    d("basic", e.cx),
                    d("inverted", e.b3),
                    d("loading", e.dh),
                    d("fluid", e.c0),
                    d("inverted", e.b3),
                    d("right", i && 1 === e.c4),
                    d("labeled", i),
                    d("icon", !u(e.iD, yt)),
                    d("active", e.hW),
                    d("disabled", e.ii)
                ])),
                Qw(e.dE)
            ]),
            (a = e.h$, 1 === a.$ ? v : y([
                rq(a.a)
            ])),
            function() {
                var n = e.be;
                if (1 === n.$) return v;
                switch(n.a){
                    case 0:
                        return y([
                            F$("primary")
                        ]);
                    case 1:
                        return y([
                            F$("secondary")
                        ]);
                    default:
                        return y([
                            F$("negative")
                        ]);
                }
            }(),
            1 === e.c$.$ ? v : y([
                F$("right floated")
            ]),
            function() {
                var n = e.aK;
                if (1 === n.$) return v;
                var t = n.a.ep;
                return qc(y([
                    y([
                        F$("animated")
                    ]),
                    function() {
                        switch(t){
                            case 0:
                                return v;
                            case 1:
                                return y([
                                    F$("vertical")
                                ]);
                            default:
                                return y([
                                    F$("fade")
                                ]);
                        }
                    }()
                ]));
            }(),
            y([
                Cx(e.ii)
            ])
        ])), function() {
            var n = e.aK;
            if (1 === n.$) return c;
            var t = n.a;
            return y([
                A2(R$, y([
                    F$("visible content")
                ]), c),
                A2(R$, y([
                    F$("hidden content")
                ]), t.aK)
            ]);
        }());
    }), uq = iq(U$), cq = function(n) {
        return A2(uq, A2(eq, y([
            Nw(n)
        ]), h(tq, {
            be: mt(0)
        })), y([
            z$("Start a month of free trial"),
            A2(Z$, y([
                F$("ui arrow alternate circle right icon")
            ]), v)
        ]));
    }, oq = function(n) {
        var e, t = Yj;
        return A2(R$, y([
            A2(ew, "margin-top", "40px")
        ]), y([
            A2(R$, y([
                F$("ui large top attached header")
            ]), y([
                z$("Add new billing entity")
            ])),
            A2(R$, y([
                F$("ui attached segment")
            ]), y([
                A2(Kj, Zj, y([
                    A2(R$, y([
                        F$("inline field")
                    ]), y([
                        A2(jx, v, y([
                            z$("Name (organization or company)")
                        ])),
                        Mj(h(t, {
                            cv: y([
                                nq(Uj)
                            ])
                        }))
                    ])),
                    cq((e = {
                        k: n.n,
                        gM: n.cq.c
                    }, {
                        $: 1,
                        a: e
                    }))
                ]))
            ]))
        ]));
    }, sq = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), fq = F2(function(n, e) {
        return A2(R$, v, y([
            z$(e.k),
            A2(Xw, y([
                A2(ew, "margin", "10px")
            ]), v),
            cq(A2(sq, e.c, n.cq.c))
        ]));
    }), lq = function(n) {
        var e, t = n.cb;
        switch(t.$){
            case 1:
                return A2(R$, y([
                    F$("ui loader active text inline centered")
                ]), y([
                    z$("Loading organizations")
                ]));
            case 0:
                return A2(R$, v, v);
            case 2:
                return z$(Bj(t.a));
            default:
                return t.a.b ? (e = t.a, A2(R$, y([
                    A2(ew, "margin-top", "40px")
                ]), y([
                    A2(R$, y([
                        F$("ui large top attached header")
                    ]), y([
                        z$("Add to an existing billing entity")
                    ])),
                    A2(R$, y([
                        F$("ui attached segment")
                    ]), A2(Gr, fq(n), e))
                ]))) : z$("");
        }
    }, dq = A2(ik, v, y([
        z$("Your subscription has been activated.")
    ])), bq = {
        eY: yt,
        ix: mt({
            h2: !1,
            jQ: !1
        }),
        jC: !0,
        jI: !1
    }, hq = Ye, gq = hq(bq), vq = A2(gq, y([
        A2(ew, "margin-bottom", "20px")
    ]), "\n  Free trial lasts **for a month** and requires **no credit card**.\n\n  After you subscribe you will be charged **29 EUR / active user / month**.\n\n  An active user is a collaborator of a billed account who is a committer or pusher on a job.\n  "), pq = function(n) {
        var e = function(e) {
            var t = function(n) {
                var t;
                return A2(U$, y([
                    F$("ui button primary " + n),
                    Nw((t = e, {
                        $: 5,
                        a: t
                    })),
                    A2(zj, "data-theme", "none")
                ]), y([
                    z$("Subscribe")
                ]));
            }, r = n.gG;
            switch(r.$){
                case 0:
                    return t("");
                case 1:
                    return t("loading");
                case 3:
                    return t("disabled");
                default:
                    var a = r.a;
                    return A2(R$, v, y([
                        t(""),
                        A2(Kk, v, y([
                            z$(Bj(a))
                        ]))
                    ]));
            }
        }, t = A2(R$, v, y([
            A2(R$, y([
                F$("ui segment")
            ]), y([
                vq
            ])),
            lq(n),
            oq(n)
        ]));
        if (n.dJ) return dq;
        var r = n.cq.gA;
        if (1 === r.$) return t;
        var a = r.a;
        switch(a.ey){
            case 0:
                return t;
            case 1:
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    vq,
                    Wx(a),
                    e(a)
                ]));
            case 2:
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    Wx(a),
                    function(n) {
                        var e = n.hn;
                        if (1 === e.$) return z$("");
                        var t = e.a;
                        return A2(U$, y([
                            F$("ui button red"),
                            Ow(t)
                        ]), y([
                            z$("Cancel")
                        ]));
                    }(a),
                    function(n) {
                        var e = n.hq;
                        if (1 === e.$) return z$("");
                        var t = e.a;
                        return A2(U$, y([
                            F$("ui button primary"),
                            Ow(t)
                        ]), y([
                            z$("Update")
                        ]));
                    }(a)
                ]));
            case 3:
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    Wx(a),
                    e(a)
                ]));
            default:
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    Wx(a)
                ]));
        }
    }, mq = function(n) {
        return A2(R$, v, g(y([
            Hj(A2(_j, n.cb, A2(_j, n.bP, n.cF))),
            pq(n)
        ]), function(n) {
            if (3 === n.$) {
                var e = n.a;
                return y([
                    A2(R$, y([
                        F$("ui segment")
                    ]), y([
                        A2(Pk, v, y([
                            z$("Active Users")
                        ])),
                        A2(ik, v, y([
                            z$((a = e.gq, a.$ ? "Based on the past month's usage." : "So far, until the end of the payment term on " + zx(a.a) + "."))
                        ])),
                        (t = e.ej, r = A2(Gr, function(n) {
                            return A2(Rk, v, y([
                                A2(Gk, v, y([
                                    A2(Hw, n, 30),
                                    z$(n.k)
                                ])),
                                A2(Gk, v, y([
                                    z$(n.hf + "/" + n.ax)
                                ]))
                            ]));
                        }, t), A2(Dk, y([
                            F$("ui unstackable table")
                        ]), y([
                            A2(Fk, v, y([
                                A2(Rk, y([
                                    F$("left aligned")
                                ]), y([
                                    A2(_k, v, y([
                                        z$("Name")
                                    ])),
                                    A2(_k, v, y([
                                        z$("Handle")
                                    ]))
                                ]))
                            ])),
                            A2(Ok, v, r)
                        ])))
                    ]))
                ]);
            }
            var t, r, a;
            return v;
        }(n.cz)));
    }, yq = F2(function(n, e) {
        return {
            q: mq(e),
            e: "Billing"
        };
    }), $q = {
        $: 2
    }, wq = {
        $: 1
    }, kq = {
        $: 0
    }, Cq = F2(function(n, e) {
        var t = e.bO;
        return A2(R$, y([
            F$("ui checkbox"),
            X$(y([
                d("checked", t)
            ])),
            Nw(n.jb)
        ]), y([
            A2(Ew, y([
                Lw("checkbox"),
                kx(t),
                F$("hidden")
            ]), v),
            A2(jx, v, Rl(A2(Zi, z$, n.N)))
        ]));
    }), xq = F2(function(n, e) {
        return h(e, {
            N: mt(n)
        });
    }), jq = vk(v), qq = function(n) {
        switch(n.$){
            case 1:
                return A2(R$, y([
                    F$("ui placeholder")
                ]), y([
                    A2(R$, y([
                        F$("line")
                    ]), v)
                ]));
            case 2:
                return A2($k, !0, n.a);
            case 3:
                var e = n.a;
                return A2(ik, v, y([
                    z$("The referrer claims to be described as "),
                    A2(Uk, v, y([
                        z$(e.v)
                    ])),
                    z$(".")
                ]));
            default:
                return A2(R$, v, v);
        }
    }, Sq = function(n) {
        var e;
        return A2(R$, y([
            F$("ui raised yellow segment")
        ]), y([
            A2(ik, v, y([
                z$("You've followed a link from some referrer to authorize access to your account.")
            ])),
            qq(n.cw),
            A2(Cq, A2(xq, "I trust the referrer to perform operations on Hercules CI on my behalf.", (e = {
                jb: kq
            }, {
                N: yt,
                jb: e.jb
            })), n),
            A2(R$, y([
                F$("ui segment basic")
            ]), y([
                A2(TC, y([
                    F$("ui button positive"),
                    Cx(!(n.bO && u(n.a7, Bs))),
                    Nw($q)
                ]), y([
                    z$("Authorize")
                ])),
                A2(TC, y([
                    F$("ui button"),
                    Nw(wq)
                ]), y([
                    z$("Cancel")
                ]))
            ])),
            function() {
                var e = n.a7;
                switch(e.$){
                    case 2:
                        return A2($k, !0, e.a);
                    case 3:
                        return A2(jq, mk, y([
                            z$("Done! You may close this tab or "),
                            A2(U$, y([
                                Gw(ec)
                            ]), y([
                                z$("review your CLI token list.")
                            ]))
                        ]));
                    default:
                        return A2(R$, v, v);
                }
            }()
        ]));
    }, Iq = F2(function(n, e) {
        return {
            q: Sq(e),
            e: "CLI Authorization"
        };
    }), Tq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Aq = F2(function(n, e) {
        return y([
            A2(ew, "cursor", "pointer"),
            Nw(n(e))
        ]);
    }), Eq = function(n) {
        var e = F2(function(n, e) {
            return A2(R$, y([
                F$("ui label basic black")
            ]), y([
                A2(Z$, y([
                    F$("icon " + n)
                ]), v),
                z$(e)
            ]));
        }), t = function(n) {
            var e = A2(jt, "/", n);
            n: for(; e.b && e.b.b;)switch(e.b.a){
                case "heads":
                    return mt({
                        $: 0,
                        a: A2(xt, "/", e.b.b)
                    });
                case "tags":
                    return mt({
                        $: 1,
                        a: A2(xt, "/", e.b.b)
                    });
                default:
                    break n;
            }
            return yt;
        }(n.dF.dw);
        return t.$ ? A2(Xw, v, v) : A2(e, t.a.$ ? "icon tag" : "code branch", t.a.a);
    }, Nq = y([
        F$("ui image middle aligned rounded"),
        A2(ew, "margin-right", "10px")
    ]), Lq = Xn("d"), Pq = F3(function(n, e, t) {
        return 1 > s(yr(t), n) ? t : g(A2(xr, n - yr(e), t), e);
    }), Dq = Xn("fill"), Oq = Wn("http://www.w3.org/2000/svg"), Gq = Oq("path"), _q = Oq("svg"), Fq = Xn("viewBox"), Rq = F2(function(n, e) {
        var t, r = Ow(e.dF.f9), a = (t = e.dF.eQ).$ ? A2(Xw, A2(tt, A2(ew, "display", "inline-block"), Nq), y([
            A2(_q, y([
                Fq("0 0 640 512"),
                A2(zj, "focusable", "false"),
                A2(zj, "aria-hidden", "true"),
                Bw(25)
            ]), y([
                A2(Gq, y([
                    Dq("currentColor"),
                    Lq("M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z")
                ]), v)
            ]))
        ])) : A2(Hw, t.a, 25), i = y([
            a,
            z$(" "),
            z$(A3(Pq, 72, "...", e.dF.bl))
        ]), u = y([
            wk(e.dF.fx)
        ]);
        return n ? A2(Xw, u, i) : A2(U$, A2(tt, r, u), g(i, y([
            z$(" "),
            Jx
        ])));
    }), Bq = F2(function(n, e) {
        var t = F2(function(n, e) {
            return n > 0 ? Ct(n) + (e + " ") : "";
        }), r = Sj(n - e) / 1e3 | 0, a = r % 86400 / 3600 | 0, i = r % 3600 / 60 | 0, u = r % 60;
        return A2(t, r / 86400 | 0, "d") + (A2(t, a, "h") + (A2(t, i, "m") + (Ct(u) + "s")));
    }), Hq = function(n) {
        var e = n.e8;
        if (1 === e.$) return A2(Xw, v, v);
        var t = e.a;
        return A2(Xw, v, y([
            A2(Z$, y([
                F$("icon clock")
            ]), v),
            z$(A2(Bq, n.dH, t))
        ]));
    }, Vq = F2(function(n, e) {
        return A2(U$, y([
            Ow(n)
        ]), g(e, y([
            Jx
        ])));
    }), zq = F2(function(n, e) {
        return A2(Z$, A2(tt, F$("ui icon"), A2(tt, F$(n), e)), v);
    }), Uq = d(zq("sun outline loading"), "building"), Wq = d(xk, "cancelled"), Kq = d(zq("blue rocket"), "running effects"), Zq = d(zq("snowflake blue loading"), "evaluating"), Yq = d(zq("red times circle"), "failed"), Mq = function(n) {
        return A2(sd, !1, A2(Af, aq, n));
    }, Jq = d(zq("spinner loading"), "queued"), Qq = d(zq("green check circle"), "succeeded"), Xq = F2(function(n, e) {
        if (Mq(n)) return d(zq("yellow exclamation circle"), "Agent is not running yet");
        if (e.fW) return Wq;
        switch(e.f$){
            case 0:
                return Jq;
            case 1:
                return Zq;
            case 2:
                return Uq;
            case 3:
                return Kq;
            default:
                switch(e.f0){
                    case 0:
                        return Uq;
                    case 1:
                        return Yq;
                    default:
                        return Qq;
                }
        }
    }), nS = F2(function(n, e) {
        var t = A2(Xq, n, e), r = t.b;
        return (0, t.a)(y([
            F$("big"),
            wk(r)
        ]));
    }), eS = F2(function(n, e) {
        var t = e.hy;
        if (1 === t.$) return 0;
        var r = (n - t.a) / 864e5 | 0;
        return s(r, 30) > 0 ? 0 : 30 - r;
    }), tS = F2(function(n, e) {
        return !A2(eS, n, e);
    }), rS = vk(y([
        F$("warning")
    ])), aS = function(n) {
        return A2(rS, mk, y([
            A2(U$, y([
                n
            ]), y([
                z$("Enable a month of free trial")
            ])),
            z$(" to start building your private repositories.")
        ]));
    }, iS = F3(function(n, e, t) {
        if (t.ar) return yt;
        var r = Vx(e), a = e.gA;
        if (1 === a.$) return mt(aS(r));
        var i = a.a;
        switch(i.ey){
            case 0:
                return mt(aS(r));
            case 3:
                return mt(function(n) {
                    return A2(rS, mk, y([
                        A2(U$, y([
                            n
                        ]), y([
                            z$("Re-activate your subscription")
                        ])),
                        z$(" to build your private repositories.")
                    ]));
                }(r));
            case 1:
                return A2(tS, n, i) ? mt(function(n) {
                    return A2(rS, mk, y([
                        z$("Your free trial expired. "),
                        A2(U$, y([
                            n
                        ]), y([
                            z$("Activate your subscription")
                        ])),
                        z$(" to build your private repositories.")
                    ]));
                }(r)) : yt;
            default:
                return yt;
        }
    }), uS = F2(function(n, e) {
        return A2(Li, 1e3, e);
    }), cS = F2(function(n, e) {
        return A3(cC, n, "0", Ct(e));
    }), oS = F2(function(n, e) {
        var t;
        return A2(Xw, y([
            wk("Created at " + (t = n.dH, A2(cS, 4, A2(mC, $C, t)) + "-" + A2(cS, 2, function(n) {
                switch(n){
                    case 0:
                        return 1;
                    case 1:
                        return 2;
                    case 2:
                        return 3;
                    case 3:
                        return 4;
                    case 4:
                        return 5;
                    case 5:
                        return 6;
                    case 6:
                        return 7;
                    case 7:
                        return 8;
                    case 8:
                        return 9;
                    case 9:
                        return 10;
                    case 10:
                        return 11;
                    default:
                        return 12;
                }
            }(A2(vC, $C, t))) + "-" + A2(cS, 2, A2(bC, $C, t)) + "T" + A2(cS, 2, A2(hC, $C, t)) + ":" + A2(cS, 2, A2(gC, $C, t)) + ":" + A2(cS, 2, A2(pC, $C, t)) + "." + A2(cS, 3, A2(uS, $C, t)) + "Z"))
        ]), y([
            A2(Z$, y([
                F$("icon calendar alternate outline")
            ]), v),
            z$(A2(Ij, e, n.dH)),
            z$(" ago")
        ]));
    }), sS = A2(Xw, y([
        A2(ew, "border-radius", "100%"),
        A2(ew, "text-align", "center"),
        A2(ew, "vertical-align", "middle"),
        A2(ew, "display", "inline-block"),
        A2(ew, "border", ".12em solid currentColor"),
        A2(ew, "font-size", "90%"),
        A2(ew, "width", "1.3em"),
        A2(ew, "height", "1.3em"),
        A2(ew, "margin", "0 .75em -0.12em -0.12em")
    ]), y([
        z$(":=")
    ])), fS = A2(Z$, y([
        F$("ui icon calendar alternate outline")
    ]), v), lS = function(n) {
        switch(n.f1){
            case 0:
                return A2(R$, y([
                    F$("ui basic grey label"),
                    wk("herculesCI.*"),
                    A2(ew, "white-space", "nowrap")
                ]), y([
                    A2(Z$, y([
                        F$("ui icon snowflake")
                    ]), v),
                    z$("config")
                ]));
            case 1:
                return z$("");
            case 2:
                var e = n.f_;
                if (1 === e.$) return z$("");
                var t = e.a;
                return A2(R$, y([
                    F$("ui label blue"),
                    wk("herculesCI.onPush." + t),
                    A2(ew, "white-space", "nowrap")
                ]), y([
                    sS,
                    z$(t)
                ]));
            default:
                var r = n.f_;
                return 1 === r.$ ? z$("") : (t = r.a, A2(R$, y([
                    F$("ui label purple"),
                    wk("herculesCI.onSchedule." + t),
                    A2(ew, "white-space", "nowrap")
                ]), y([
                    fS,
                    z$(t)
                ])));
        }
    }, dS = F5(function(n, e, t, r, a) {
        var i = r.a, u = r.b, c = r.c, o = 7 - It(a), s = function() {
            if (1 === c.$) return y([
                A2(Gk, y([
                    Wk(o)
                ]), y([
                    z$("Push a commit "),
                    A2(Vq, "https://docs.hercules-ci.com/hercules-ci/getting-started/repository", y([
                        z$("with a Nix file")
                    ])),
                    z$(" to start the first job.")
                ]))
            ]);
            var r = c.a, a = function(e) {
                return A2(U$, y([
                    Gw(Yu({
                        cq: i.ax,
                        ab: e,
                        br: u.ax,
                        dC: n.dC
                    }))
                ]), y([
                    z$("#" + Ct(e))
                ]));
            }, s = function() {
                var n = r.g2;
                if (1 === n.$) return y([
                    A2(Rq, 1, r)
                ]);
                var e = n.a;
                return y([
                    z$("Retry of "),
                    a(e)
                ]);
            }(), f = A2(Aq, Tq, Yu({
                cq: i.ax,
                ab: r.ab,
                br: u.ax,
                dC: n.dC
            }));
            return y([
                A2(Gk, f, y([
                    A2(nS, t, r)
                ])),
                A2(Gk, f, y([
                    A2(R$, v, y([
                        a(r.ab)
                    ])),
                    A2(R$, v, y([
                        lS(r)
                    ]))
                ])),
                A2(Gk, f, y([
                    Hq(r)
                ])),
                A2(Gk, f, y([
                    A2(oS, r, e)
                ])),
                A2(Gk, f, y([
                    Eq(r)
                ])),
                A2(Gk, f, s)
            ]);
        }(), f = function() {
            var n = A3(iS, e, i, u);
            if (n.$) return s;
            var t = n.a;
            return y([
                A2(Gk, y([
                    Wk(o)
                ]), y([
                    t
                ]))
            ]);
        }();
        return A2(Rk, v, g(a, f));
    }), bS = F3(function(n, e, t) {
        var r, a = t.br, i = tc({
            cq: e.cq.ax,
            gC: yt,
            br: a.ax,
            dC: e.dC
        }), u = A2(Gk, A2(Aq, Tq, i), y([
            A2(U$, y([
                Gw(i)
            ]), y([
                A2(Xw, y([
                    F$("ui large text")
                ]), y([
                    z$(a.k)
                ]))
            ]))
        ])), c = (r = t.df).b ? mt(r.a) : yt;
        return A5(dS, e, n, e.a1, b(e.cq, a, c), y([
            u
        ]));
    }), hS = F3(function(n, e, t) {
        var r = t.b ? A2(Gr, A2(bS, n, e), t) : y([
            A2(ik, v, y([
                z$("We could not find any installed repositories in this account. You may need to add more repositories, and we can only show repositories you have access to.")
            ]))
        ]);
        return A2(R$, y([
            F$("ui bottom attached segment")
        ]), y([
            A2(Dk, y([
                F$("ui very basic selectable table")
            ]), y([
                A2(Ok, v, r)
            ]))
        ]));
    }), gS = {
        $: 3
    }, vS = F3(function(n, e, t) {
        switch(e.$){
            case 2:
                return z$("Oops, we could not load the " + n + ". " + Bj(e.a));
            case 3:
                return t(e.a);
            case 1:
                return A2(R$, y([
                    F$("ui loader active inline text")
                ]), y([
                    z$("Loading the " + n)
                ]));
            default:
                return z$("");
        }
    }), pS = Kn("textarea"), mS = function(n) {
        var e = function(n) {
            return A2(R$, v, y([
                A2(pS, y([
                    F$("ui message ignored"),
                    A2(Xn, "rows", Ct(5)),
                    A2(ew, "width", "100%")
                ]), y([
                    z$(n.bz)
                ])),
                A2(Kk, v, y([
                    z$("Save this token in a cluster-join-token.key file.")
                ]))
            ]));
        };
        return A2(R$, v, y([
            z$("A cluster join token is a secret key required for agent to be granted access to start building."),
            A2(R$, v, y([
                A2(TC, y([
                    F$("ui primary button huge"),
                    Nw(gS),
                    A2(ew, "margin", "30px")
                ]), y([
                    z$("Generate join token")
                ]))
            ])),
            A3(vS, "token", n.cu, e)
        ]));
    }, yS = Kn("b"), $S = Kn("ol"), wS = Kn("pre"), kS = A2(R$, v, y([
        A2(R$, y([
            F$("admonitionblock warning")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Warning")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nAlthough a single agent works with empty "),
                        A2(Uk, v, y([
                            z$("{}")
                        ])),
                        z$(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("On "),
                A2(U$, y([
                    Ow("https://cachix.org")
                ]), y([
                    z$("Cachix")
                ])),
                z$(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" file, replacing all placeholders:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("title")
            ]), y([
                z$("binary-caches.json")
            ])),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-json"),
                        A2(zj, "data-lang", "json")
                    ]), y([
                        z$('{ "mycache": '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(1)")
                        ])),
                        z$('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(2)")
                        ])),
                        z$('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(3)")
                        ])),
                        z$('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(4)")
                        ])),
                        z$("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("colist arabic")
        ]), y([
            A2($S, v, y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("The name of the Cachix cache; for example the "),
                        A2(Uk, v, y([
                            z$("mycache")
                        ])),
                        z$(" part from "),
                        A2(Uk, v, y([
                            z$("mycache.cachix.org")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(U$, y([
                            Ow("https://cachix.org/")
                        ]), y([
                            z$("Cachix Getting started instructions, step 3")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Uk, v, y([
                            z$("https://mycache.cachix.org")
                        ])),
                        z$(").")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Uk, v, y([
                            z$("~/.config/cachix/cachix.dhall")
                        ])),
                        z$(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Uk, v, y([
                            z$("cachix.dhall")
                        ])),
                        z$(".")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nFor more detail, see "),
                        A2(U$, y([
                            Ow("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), y([
                            z$("The "),
                            A2(Uk, v, y([
                                z$("binary-caches.json")
                            ])),
                            z$(" format")
                        ])),
                        z$(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ]))
    ])), CS = function(n) {
        return y([
            A2(ik, v, y([
                z$("We start by gathering the required credentials and configuration into a fresh working directory.")
            ])),
            A2(Pk, v, y([
                z$("Cluster join token")
            ])),
            mS(n),
            A2(ik, v, y([
                z$("Copy the token into a plain text file "),
                A2(Uk, v, y([
                    z$("cluster-join-token.key")
                ])),
                z$(". We recommend to protect this file like a password.")
            ])),
            A2(Pk, v, y([
                z$("Binary cache configuration")
            ])),
            kS
        ]);
    }, xS = F2(function(n, e) {
        return n ? y([
            e
        ]) : v;
    }), jS = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), qS = F2(function(n, e) {
        return y([
            A2(ew, "cursor", "pointer"),
            Nw(A2(jS, n, e))
        ]);
    }), SS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Create a folder called mycompany-agents with a file:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("title")
            ]), y([
                z$("network.nix")
            ])),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-nix"),
                        A2(zj, "data-lang", "nix")
                    ]), y([
                        z$('let\n  hercules-ci-agent =\n      builtins.fetchTarball "https://github.com/hercules-ci/hercules-ci-agent/archive/stable.tar.gz";\nin\n{\n  network.description = "Hercules CI agents";\n\n  agent = {\n    imports = [\n      (hercules-ci-agent + "/module.nix")\n    ];\n\n    services.hercules-ci-agent.enable = true;\n    services.hercules-ci-agent.concurrentTasks = 4; # Number of jobs to run\n    deployment.keys."cluster-join-token.key".keyFile = ./cluster-join-token.key;\n    deployment.keys."binary-caches.json".keyFile = ./binary-caches.json;\n  };\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), IS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Save "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" on the target machine and install it by running:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("$ sudo install \\\n    -o hercules-ci-agent  \\\n    -m 0600 \\\n    binary-caches.json \\\n    /var/lib/hercules-ci-agent/secrets/binary-caches.json")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("And activate via:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("$ sudo ./result/bin/darwin-installer")
                    ]))
                ]))
            ]))
        ]))
    ])), TS = A2(R$, v, y([
        A2(R$, y([
            F$("admonitionblock warning")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Warning")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nAlthough a single agent works with empty "),
                        A2(Uk, v, y([
                            z$("{}")
                        ])),
                        z$(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("On "),
                A2(U$, y([
                    Ow("https://cachix.org")
                ]), y([
                    z$("Cachix")
                ])),
                z$(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" file, replacing all placeholders:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("title")
            ]), y([
                z$("binary-caches.json")
            ])),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-json"),
                        A2(zj, "data-lang", "json")
                    ]), y([
                        z$('{ "mycache": '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(1)")
                        ])),
                        z$('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(2)")
                        ])),
                        z$('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(3)")
                        ])),
                        z$('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(4)")
                        ])),
                        z$("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("colist arabic")
        ]), y([
            A2($S, v, y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("The name of the Cachix cache; for example the "),
                        A2(Uk, v, y([
                            z$("mycache")
                        ])),
                        z$(" part from "),
                        A2(Uk, v, y([
                            z$("mycache.cachix.org")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(U$, y([
                            Ow("https://cachix.org/")
                        ]), y([
                            z$("Cachix Getting started instructions, step 3")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Uk, v, y([
                            z$("https://mycache.cachix.org")
                        ])),
                        z$(").")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Uk, v, y([
                            z$("~/.config/cachix/cachix.dhall")
                        ])),
                        z$(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Uk, v, y([
                            z$("cachix.dhall")
                        ])),
                        z$(".")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nFor more detail, see "),
                        A2(U$, y([
                            Ow("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), y([
                            z$("The "),
                            A2(Uk, v, y([
                                z$("binary-caches.json")
                            ])),
                            z$(" format")
                        ])),
                        z$(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("To specify "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" via NixOps:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-nix"),
                        A2(zj, "data-lang", "nix")
                    ]), y([
                        z$('services.hercules-ci-agent.enable = true;\ndeployment.keys."binary-caches.json".keyFile = ./binary-caches.json;')
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nWe're working on "),
                        A2(U$, y([
                            Ow("https://cachix.org")
                        ]), y([
                            z$("Cachix")
                        ])),
                        z$(" to be able to restrict "),
                        A2(Uk, v, y([
                            z$("authToken")
                        ])),
                        z$("\nto only reading one private cache. "),
                        A2(U$, y([
                            Ow("https://github.com/cachix/feedback/issues/7")
                        ]), y([
                            z$("Subscribe to the issue to get notified")
                        ])),
                        z$("\nwhen the token should be replaced.\n")
                    ]))
                ]))
            ]))
        ]))
    ])), AS = A2(R$, v, y([
        A2(R$, y([
            F$("admonitionblock warning")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Warning")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nEvaluation "),
                        A2(U$, y([
                            Ow("https://github.com/hercules-ci/support/issues/24")
                        ]), y([
                            z$("currently")
                        ])),
                        z$(" requires an "),
                        A2(Uk, v, y([
                            z$("x86_64-linux")
                        ])),
                        z$(" machine to be in your build cluster!\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        A2(R$, y([
                            F$("paragraph")
                        ]), y([
                            A2(ik, v, y([
                                z$("To avoid compiling the agent for hours you can use our binary cache to speed it up:")
                            ]))
                        ])),
                        A2(R$, y([
                            F$("listingblock")
                        ]), y([
                            A2(R$, y([
                                F$("content")
                            ]), y([
                                A2(wS, y([
                                    F$("highlight")
                                ]), y([
                                    A2(Uk, y([
                                        F$("language-shell"),
                                        A2(zj, "data-lang", "shell")
                                    ]), y([
                                        z$("$ nix-env -iA cachix -f https://cachix.org/api/v1/install\n$ cachix use hercules-ci")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("On macOS run:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("[root@mac]# sh <(curl https://nixos.org/nix/install) --daemon\n[root@mac]# source /nix/var/nix/profiles/default/etc/profile.d/nix-daemon.sh\n\n[root@mac]# nix-build https://github.com/hercules-ci/nix-darwin/archive/hercules-ci-agent.tar.gz -A installer\n[root@mac]# ./result/bin/darwin-installer")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("When asked for editing the "),
                A2(Uk, v, y([
                    z$("darwin-configuration.nix")
                ])),
                z$(" add:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-nix"),
                        A2(zj, "data-lang", "nix")
                    ]), y([
                        z$("services.nix-daemon.enable = true;\nservices.hercules-ci-agent.enable = true;")
                    ]))
                ]))
            ]))
        ]))
    ])), ES = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Save the token to a new file "),
                A2(Uk, v, y([
                    z$("cluster-join-token.key")
                ])),
                z$(" on the target machine and run:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("$ sudo install \\\n    -o hercules-ci-agent  \\\n    -m 0600 \\\n    cluster-join-token.key \\\n    /var/lib/hercules-ci-agent/secrets/cluster-join-token.key\n$ rm cluster-join-token.key")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                A2(Uk, v, y([
                    z$("tail -f /var/log/hercules-ci-agent.log")
                ])),
                z$(" to see what is going on with your agent.")
            ]))
        ]))
    ])), NS = A2(R$, v, y([
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        A2(R$, y([
                            F$("paragraph")
                        ]), y([
                            A2(ik, v, y([
                                z$("To avoid compiling the agent for hours you can use our binary cache to speed it up:")
                            ]))
                        ])),
                        A2(R$, y([
                            F$("listingblock")
                        ]), y([
                            A2(R$, y([
                                F$("content")
                            ]), y([
                                A2(wS, y([
                                    F$("highlight")
                                ]), y([
                                    A2(Uk, y([
                                        F$("language-shell"),
                                        A2(zj, "data-lang", "shell")
                                    ]), y([
                                        z$("$ nix-env -iA cachix -f https://cachix.org/api/v1/install\n$ cachix use hercules-ci")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Deploy using:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("$ nix-shell -p nixops -I nixpkgs=http://nixos.org/channels/nixos-19.09/nixexprs.tar.xz\n$ nixops create -d my-agent ./hercules-ci-agents.nix ./hercules-ci-agents-target.nix\n$ nixops deploy -d my-agent")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("The agent will start working as soon as the deployment has succeeded and builds are queued.")
            ]))
        ]))
    ])), LS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Active your configuration with")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("[root@my-agent-host]# nixos-rebuild switch")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("This creates the "),
                A2(Uk, v, y([
                    z$("hercules-ci-agent")
                ])),
                z$(" user. If you haven't set the file permissions yet:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("[root@my-agent-host]# chown -R hercules-ci-agent /var/lib/hercules-ci-agent\n[root@my-agent-host]# chmod o-rwx /var/lib/hercules-ci-agent/secrets")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("The log should indicate "),
                A2(Uk, v, y([
                    z$("Agent online")
                ])),
                z$(".")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-shell"),
                        A2(zj, "data-lang", "shell")
                    ]), y([
                        z$("[root@my-agent-host]# journalctl -u hercules-ci-agent.service\n[...]\nNov 06 22:35:36 my-agent-host hercules-ci-agent[1305]: [2019-11-06 22:35:36][][Info][agent-machine-1][PID 1305][ThreadId 22][agent-version:0.6.1][main:Hercules.Agent hercules-ci-agent/Hercules/Agent.hs:73:8] Agent online.")
                    ]))
                ]))
            ]))
        ]))
    ])), PS = A2(R$, v, y([
        A2(R$, y([
            F$("admonitionblock warning")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Warning")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nAlthough a single agent works with empty "),
                        A2(Uk, v, y([
                            z$("{}")
                        ])),
                        z$(" binary cache configuration,\nwe highly recommend setting up a cache from the start.\nRunning without a cache will break some features and will cause unexpectedly long build times\ndue to eventual garbage collection.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("On "),
                A2(U$, y([
                    Ow("https://cachix.org")
                ]), y([
                    z$("Cachix")
                ])),
                z$(" you can create a binary cache. After you complete the process, gather the keys into a "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" file, replacing all placeholders:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("title")
            ]), y([
                z$("binary-caches.json")
            ])),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-json"),
                        A2(zj, "data-lang", "json")
                    ]), y([
                        z$('{ "mycache": '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(1)")
                        ])),
                        z$('\n    { "kind": "CachixCache"\n    , "authToken": "eyJhaf23GH53a.bc23BUSI.9q3048hWHh" '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(2)")
                        ])),
                        z$('\n    , "publicKeys": ["mycache.cachix.org-1:EjBSHzF6VmDnzqlldGXbi0RM3HdjfTU3yDRi9Pd0jTY="] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(3)")
                        ])),
                        z$('\n    , "signingKeys": ["uAhqM3jG..."] '),
                        A2(yS, y([
                            F$("conum")
                        ]), y([
                            z$("(4)")
                        ])),
                        z$("\n    }\n}")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("colist arabic")
        ]), y([
            A2($S, v, y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("The name of the Cachix cache; for example the "),
                        A2(Uk, v, y([
                            z$("mycache")
                        ])),
                        z$(" part from "),
                        A2(Uk, v, y([
                            z$("mycache.cachix.org")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("Optional; only required for private binary caches. You may retrieve this from the "),
                        A2(U$, y([
                            Ow("https://cachix.org/")
                        ]), y([
                            z$("Cachix Getting started instructions, step 3")
                        ])),
                        z$(".")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$('The public part of the signing key. Look for "Public Key" on your cache page (example page: '),
                        A2(Uk, v, y([
                            z$("https://mycache.cachix.org")
                        ])),
                        z$(").")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("A cache-specific secret key to sign store paths. You can find it in "),
                        A2(Uk, v, y([
                            z$("~/.config/cachix/cachix.dhall")
                        ])),
                        z$(" or your key backup after following the setup instructions on cachix.org. Make sure you copy the right key if you have multiple in your "),
                        A2(Uk, v, y([
                            z$("cachix.dhall")
                        ])),
                        z$(".")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("admonitionblock note")
        ]), y([
            A2(Dk, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        F$("icon")
                    ]), y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$("Note")
                        ]))
                    ])),
                    A2(Gk, y([
                        F$("content")
                    ]), y([
                        z$("\nFor more detail, see "),
                        A2(U$, y([
                            Ow("https://docs.hercules-ci.com/hercules-ci/reference/binary-caches-json/")
                        ]), y([
                            z$("The "),
                            A2(Uk, v, y([
                                z$("binary-caches.json")
                            ])),
                            z$(" format")
                        ])),
                        z$(" in the Reference.\n")
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Copy or move the "),
                A2(Uk, v, y([
                    z$("binary-caches.json")
                ])),
                z$(" file into "),
                A2(Uk, v, y([
                    z$("/var/lib/hercules-ci-agent/secrets/")
                ])),
                z$(".")
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Make sure that "),
                A2(Uk, v, y([
                    z$("/var/lib/hercules-ci-agent/secrets")
                ])),
                z$(" and its contents can only be read by "),
                A2(Uk, v, y([
                    z$("hercules-ci-agent")
                ])),
                z$(".")
            ]))
        ]))
    ])), DS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Add this configuration to "),
                A2(Uk, v, y([
                    z$("/etc/nixos/configuration.nix")
                ])),
                z$(":")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-nix"),
                        A2(zj, "data-lang", "nix")
                    ]), y([
                        z$('{\n  imports = [\n    ( builtins.fetchTarball "https://github.com/hercules-ci/hercules-ci-agent/archive/stable.tar.gz"\n      + "/module.nix"\n    )\n  ];\n\n  services.hercules-ci-agent.enable = true;\n  services.hercules-ci-agent.concurrentTasks = 4; # Number of jobs to run\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), OS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("The goal of this step is to make sure everything is set up correctly.")
            ]))
        ])),
        A2(R$, y([
            F$("olist loweralpha")
        ]), y([
            A2($S, y([
                F$("loweralpha")
            ]), y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("If you are familiar with Nix, "),
                        A2(U$, y([
                            Ow("https://docs.hercules-ci.com/hercules-ci/getting-started/repository/")
                        ]), y([
                            z$("set up your own git repository")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("Otherwise "),
                        A2(U$, y([
                            Ow("https://docs.hercules-ci.com/hercules-ci/getting-started/minimal-repository/")
                        ]), y([
                            z$("verify your agent setup with a minimal git repository")
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ])), GS = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Choose between backends. NixOps can deploy to:")
            ]))
        ])),
        A2(R$, y([
            F$("ulist")
        ]), y([
            A2(Xk, v, y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#sec-deploying-to-physical-nixos")
                        ]), y([
                            z$("Any existing NixOS machine")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#sec-deploying-to-ec2")
                        ]), y([
                            z$("Amazon EC2")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#sec-deploying-to-gce")
                        ]), y([
                            z$("Google Cloud Engine")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#sec-deploying-to-azure")
                        ]), y([
                            z$("Microsoft Azure")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#idm140737318355376")
                        ]), y([
                            z$("Hetzner")
                        ]))
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        A2(U$, y([
                            Ow("https://nixos.org/nixops/manual/#sec-deploying-to-digital-ocean")
                        ]), y([
                            z$("Digital Ocean")
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("An example physical specification:")
            ]))
        ])),
        A2(R$, y([
            F$("listingblock")
        ]), y([
            A2(R$, y([
                F$("title")
            ]), y([
                z$("hercules-ci-agents-target.nix")
            ])),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(wS, y([
                    F$("highlight")
                ]), y([
                    A2(Uk, y([
                        F$("language-nix"),
                        A2(zj, "data-lang", "nix")
                    ]), y([
                        z$('{\n  agent = {\n    deployment.targetHost = "10.0.0.42"; # Your agent\'s IP address running NixOS\n  };\n}')
                    ]))
                ]))
            ]))
        ]))
    ])), _S = A2(R$, v, y([
        A2(R$, y([
            F$("paragraph")
        ]), y([
            A2(ik, v, y([
                z$("Terraform supports a wide range of cloud providers.\nTo facilitate deployment with this tool, we provide terraform modules.")
            ]))
        ])),
        A2(R$, y([
            F$("olist loweralpha")
        ]), y([
            A2($S, y([
                F$("loweralpha")
            ]), y([
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("If you already have a workflow for terraform deployments, the "),
                        A2(U$, y([
                            Ow("https://github.com/hercules-ci/terraform-hercules-ci#readme")
                        ]), y([
                            z$("terraform modules")
                        ])),
                        z$(" are your starting point.")
                    ]))
                ])),
                A2(Qk, v, y([
                    A2(ik, v, y([
                        z$("If you are using AWS and/or this is your first terraform deployment, we provide an "),
                        A2(U$, y([
                            Ow("https://github.com/hercules-ci/example-deploy-agent-terraform-aws#readme")
                        ]), y([
                            z$("AWS example deployment project")
                        ])),
                        z$(" that you can adapt.")
                    ]))
                ]))
            ]))
        ]))
    ])), FS = F2(function(n, e) {
        return A2(qS, tl(e), Vu({
            cq: n.cq.ax,
            dC: n.dC,
            bw: e
        }));
    }), RS = F2(function(n, e) {
        for(;;){
            var t = d(e.G, e.C);
            n: for(;;)switch(t.a){
                case 0:
                    var r = h(e, {
                        C: mt(2),
                        G: 4
                    }), a = h(e, {
                        C: mt(4),
                        G: 4
                    }), i = h(e, {
                        C: mt(1),
                        G: 4
                    }), c = h(e, {
                        C: mt(3),
                        G: 1
                    }), o = r, s = h(e, {
                        C: mt(0),
                        G: 1
                    });
                    return y([
                        A2(ik, v, y([
                            z$("Pick a recommended deployment method:")
                        ])),
                        A2(R$, y([
                            F$("ui borderless stackable two item menu fluid"),
                            A2(ew, "position", "relative")
                        ]), y([
                            A2(R$, A2(tt, F$("link item"), g(A2(xS, u(e.C, s.C), F$("active")), A2(FS, n, s))), y([
                                A2(Z$, y([
                                    F$("ui icon massive apple"),
                                    A2(ew, "margin", "0.214em !important")
                                ]), v),
                                A2(R$, y([
                                    F$("ui blue"),
                                    A2(ew, "display", "inline-block"),
                                    A2(ew, "vertical-align", "middle")
                                ]), y([
                                    A2(Xw, y([
                                        F$("ui text big")
                                    ]), y([
                                        z$("macOS")
                                    ])),
                                    A2(ik, y([
                                        F$("ui text")
                                    ]), y([
                                        z$("via nix-darwin")
                                    ]))
                                ]))
                            ])),
                            A2(R$, y([
                                F$("ui vertical divider")
                            ]), y([
                                z$("or")
                            ])),
                            A2(R$, A2(tt, F$("link item"), g(A2(xS, u(e.C, o.C), F$("active")), A2(FS, n, o))), y([
                                A2(Z$, y([
                                    F$("ui icon massive linux")
                                ]), v),
                                A2(R$, y([
                                    F$("ui blue"),
                                    A2(ew, "display", "inline-block"),
                                    A2(ew, "vertical-align", "middle")
                                ]), y([
                                    A2(Xw, y([
                                        F$("ui text big")
                                    ]), y([
                                        z$("Linux")
                                    ])),
                                    A2(ik, y([
                                        F$("ui text")
                                    ]), y([
                                        z$("via Terraform")
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2(ik, v, y([
                            z$("or choose from all methods:")
                        ])),
                        A2(Xk, v, y([
                            A2(Qk, v, y([
                                z$("Deploy with "),
                                A2(U$, A2(FS, n, r), y([
                                    z$("Terraform")
                                ]))
                            ])),
                            A2(Qk, v, y([
                                z$("Deploy with "),
                                A2(U$, A2(FS, n, i), y([
                                    z$("NixOps")
                                ]))
                            ])),
                            A2(Qk, v, y([
                                z$("Install with "),
                                A2(U$, A2(qS, tl(s), Vu({
                                    cq: n.cq.ax,
                                    dC: n.dC,
                                    bw: s
                                })), y([
                                    z$("nix-darwin")
                                ]))
                            ])),
                            A2(Qk, v, y([
                                z$("Install with "),
                                A2(U$, A2(qS, tl(a), Vu({
                                    cq: n.cq.ax,
                                    dC: n.dC,
                                    bw: a
                                })), y([
                                    z$("NixOS")
                                ]))
                            ])),
                            A2(Qk, v, y([
                                z$("Install manually with "),
                                A2(U$, A2(qS, tl(c), Vu({
                                    cq: n.cq.ax,
                                    dC: n.dC,
                                    bw: c
                                })), y([
                                    z$("configuration file")
                                ]))
                            ]))
                        ]))
                    ]);
                case 2:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 0:
                            return y([
                                TS,
                                IS
                            ]);
                        case 1:
                            return y([
                                TS
                            ]);
                        case 4:
                            return y([
                                PS
                            ]);
                        default:
                            break n;
                    }
                case 3:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 1:
                            return y([
                                mS(n),
                                z$("Copy the token into a plain text file "),
                                A2(Uk, v, y([
                                    z$("cluster-join-token.key")
                                ])),
                                z$(" in the same directory. Protect this file like a password.")
                            ]);
                        case 4:
                            return y([
                                mS(n),
                                z$("Move the token into "),
                                A2(Uk, v, y([
                                    z$("/var/lib/hercules-ci-agent/secrets/cluster-join-token.key")
                                ])),
                                z$(". Protect this file like a password.")
                            ]);
                        default:
                            break n;
                    }
                case 5:
                    if (t.b.$ || 1 !== t.b.a) break n;
                    return y([
                        GS
                    ]);
                case 4:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 1:
                            return y([
                                SS
                            ]);
                        case 4:
                            return y([
                                DS
                            ]);
                        case 2:
                            return CS(n);
                        default:
                            break n;
                    }
                case 1:
                    if (t.b.$) break n;
                    switch(t.b.a){
                        case 0:
                            return y([
                                AS,
                                mS(n),
                                ES
                            ]);
                        case 1:
                            return y([
                                NS
                            ]);
                        case 2:
                            return y([
                                _S
                            ]);
                        case 3:
                            return g(CS(n), y([
                                A2(Pk, v, y([
                                    z$("Config file")
                                ])),
                                A2(ik, v, y([
                                    z$("Install and configure the agent as documented in "),
                                    A2(Vq, "https://docs.hercules-ci.com/hercules-ci/getting-started/deploy/manual/", y([
                                        z$("the manual")
                                    ])),
                                    z$(".")
                                ]))
                            ]));
                        default:
                            return y([
                                LS
                            ]);
                    }
                default:
                    return y([
                        OS
                    ]);
            }
            e = h(e, {
                G: 0
            });
        }
    }), BS = F3(function(n, e, t) {
        var r = e.cv, a = e.hW, i = e.ic, u = e.e, c = e.iD;
        return A2(n, g(y([
            F$("step"),
            X$(y([
                d("completed", i),
                d("active", a)
            ]))
        ]), r), qc(y([
            1 === c.$ ? v : y([
                A2(hk, gk, c.a)
            ]),
            y([
                A2(R$, y([
                    F$("content")
                ]), function() {
                    if (1 === u.$) return t;
                    var n = u.a;
                    return y([
                        A2(R$, y([
                            F$("title")
                        ]), y([
                            z$(n)
                        ])),
                        A2(R$, y([
                            F$("description")
                        ]), t)
                    ]);
                }())
            ])
        ])));
    }), HS = F2(function(n, e) {
        return A3(BS, U$, n, e);
    }), VS = F2(function(n, e) {
        var t;
        return A2(R$, qc(y([
            y([
                F$("ui steps"),
                X$(y([
                    d("ordered", n.jp),
                    d("vertical", n.jX)
                ]))
            ]),
            (t = n.h$, 1 === t.$ ? v : y([
                rq(t.a)
            ])),
            function() {
                var e = n.jN;
                if (1 === e.$) return v;
                var t = e.a;
                return y([
                    F$(function() {
                        switch(t){
                            case 0:
                                return "one";
                            case 1:
                                return "two";
                            case 2:
                                return "three";
                            case 3:
                                return "four";
                            case 4:
                                return "five";
                            case 5:
                                return "six";
                            case 6:
                                return "seven";
                            default:
                                return "eight";
                        }
                    }())
                ]);
            }()
        ])), A2(Gr, function(n) {
            return n;
        }, e));
    }), zS = F2(function(n, e) {
        var t = F4(function(t, r, a, i) {
            return A2(HS, {
                hW: u(e.G, i.G),
                cv: g(A2(qS, tl(i), Vu({
                    cq: n.cq.ax,
                    dC: n.dC,
                    bw: i
                })), t),
                ic: !1,
                iD: yt,
                e: mt(r)
            }, y([
                z$(a)
            ]));
        }), r = t(v), a = A3(r, "Deploy", "Using NixOps", h(e, {
            G: 1
        })), i = A3(r, "Install", "Using NixOS", h(e, {
            G: 1
        })), c = A3(r, "Choose Deployment", "", h(e, {
            G: 0
        })), o = A3(r, "Choose target", "Pick between AWS, Azure, GCE, ...", h(e, {
            G: 5
        })), s = A3(r, "Configure", "Gather credentials", h(e, {
            G: 4
        })), f = A3(r, "Deploy", "Using Terraform", h(e, {
            G: 1
        })), l = A3(r, "Build a Project", "", h(e, {
            G: 6
        })), b = F2(function(n, r) {
            return A4(t, y([
                F$("disabled")
            ]), n, r, e);
        }), p = A3(r, "Install", "Using a config file", h(e, {
            G: 1
        })), m = A3(r, "Generate a token", "Secret to join your account", h(e, {
            G: 3
        })), $ = A2(b, "Build a Project", ""), w = A2(b, "Deploy", ""), k = A2(b, "Configure", ""), C = A3(r, "Deploy", "Using nix-darwin", h(e, {
            G: 1
        })), x = {
            h$: mt(0),
            jp: !0,
            jN: mt(6),
            jX: !1
        }, j = A3(r, "Binary Caches", "Share binaries between machines", h(e, {
            G: 2
        })), q = A3(r, "Bootstrap", "Configure your agent", h(e, {
            G: 4
        })), S = d(e.G, e.C);
        if (S.b.$) return y([
            A2(ck, v, y([
                z$("Agent Setup: Pick an Operating System")
            ])),
            A2(VS, x, y([
                c,
                k,
                w,
                $
            ]))
        ]);
        switch(S.b.a){
            case 0:
                return y([
                    A2(ck, v, y([
                        z$("Deploying an agent on macOS")
                    ])),
                    A2(VS, x, y([
                        c,
                        C,
                        j,
                        l
                    ]))
                ]);
            case 2:
                return y([
                    A2(ck, v, y([
                        z$("Deploying an agent using Terraform")
                    ])),
                    A2(VS, x, y([
                        c,
                        s,
                        f,
                        l
                    ]))
                ]);
            case 1:
                return y([
                    A2(ck, v, y([
                        z$("Deploying an agent using NixOps")
                    ])),
                    A2(VS, x, y([
                        c,
                        q,
                        j,
                        o,
                        m,
                        a,
                        l
                    ]))
                ]);
            case 4:
                return y([
                    A2(ck, v, y([
                        z$("Install an agent on NixOS")
                    ])),
                    A2(VS, x, y([
                        c,
                        q,
                        j,
                        m,
                        i,
                        l
                    ]))
                ]);
            default:
                return y([
                    A2(ck, v, y([
                        z$("Install an agent manually")
                    ])),
                    A2(VS, x, y([
                        c,
                        p,
                        l
                    ]))
                ]);
        }
    }), US = F2(function(n, e) {
        return A2(R$, y([
            F$("ui bottom attached segment")
        ]), y([
            A2(R$, v, g(A2(zS, n, e), y([
                A2(R$, y([
                    F$("ui adoc"),
                    A2(ew, "margin", "30px 0")
                ]), A2(RS, n, e))
            ]))),
            A2(R$, y([
                F$("ui secondary segment")
            ]), y([
                A2(Z$, y([
                    F$("icon envelope")
                ]), v),
                z$("Contact "),
                A2(U$, y([
                    Ow("mailto:help@hercules-ci.com")
                ]), y([
                    z$("help@hercules-ci.com")
                ])),
                z$(" if you need help setting up an agent.")
            ]))
        ]));
    }), WS = F4(function(n, e, t, r) {
        return A3(du, e, function(e) {
            return mt(e.$ ? t : A2(n, e.a, t));
        }, r);
    }), KS = F3(function(n, e, t) {
        return A3(St, F2(function(t, r) {
            return A4(WS, n, e(t), t, r);
        }), va, t);
    }), ZS = C, YS = Kn("tfoot"), MS = function(n) {
        return A2(Xw, y([
            F$("ui label black")
        ]), y([
            z$(n)
        ]));
    }, JS = function(n) {
        return A2(Xw, y([
            F$("ui label blue")
        ]), y([
            z$(n)
        ]));
    }, QS = F3(function(n, e, t) {
        var r = function(t) {
            var r, a = Bu({
                cq: e.cq.ax,
                fL: t.fL,
                dC: e.dC
            });
            return A2(Rk, y([
                Nw((r = a, {
                    $: 6,
                    a: r
                }))
            ]), y([
                A2(Gk, v, y([
                    A2(U$, y([
                        Gw(a)
                    ]), y([
                        z$(t.fL)
                    ]))
                ])),
                A2(Gk, v, y([
                    A2(Tj, n, t)
                ])),
                A2(Gk, v, y([
                    z$(A2(Ij, n, t.eT))
                ])),
                A2(Gk, v, A2(Gr, MS, t.gK)),
                A2(Gk, v, A2(Gr, JS, t.hs)),
                A2(Gk, v, y([
                    z$(t.a0)
                ])),
                A2(Gk, v, y([
                    z$(t.gr)
                ]))
            ]));
        }, a = y([
            A2(_k, v, y([
                z$("Hostname")
            ])),
            A2(_k, v, y([
                z$("Status")
            ])),
            A2(_k, v, y([
                z$("Registered since")
            ])),
            A2(_k, v, y([
                z$("Platforms")
            ])),
            A2(_k, v, y([
                z$("Features")
            ])),
            A2(_k, v, y([
                z$("Agent version")
            ])),
            A2(_k, v, y([
                z$("Nix version")
            ]))
        ]), i = F2(function(n, e) {
            var t = n.f5;
            if (1 === t.$) return 2;
            var r = t.a, a = e.f5;
            if (1 === a.$) return 0;
            var i = a.a;
            return s(Sj(r - i), pj) > 0 ? A2(ya, i, r) : 1;
        });
        return A2(Dk, y([
            F$("ui unstackable table bottom attached")
        ]), y([
            A2(Fk, v, y([
                A2(Rk, y([
                    F$("center aligned")
                ]), a)
            ])),
            A2(Ok, v, A2(Gr, r, A2(ZS, i, t))),
            A2(YS, v, y([
                A2(Rk, v, y([
                    A2(_k, y([
                        Wk(It(a))
                    ]), y([
                        A2(U$, A2(tt, F$("ui right floated primary labeled icon button"), A2(qS, ll, Hu({
                            cq: e.cq.ax,
                            dC: e.dC
                        }))), y([
                            A2(Z$, y([
                                F$("ui icon plus")
                            ]), v),
                            z$("Set up an agent")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), XS = F2(function(n, e) {
        var t = n.dd, r = n.ig, a = e.a1;
        switch(a.$){
            case 2:
                return A2($k, t, a.a);
            case 3:
                var i = a.a;
                return i.b ? A3(QS, r, e, cd(A3(KS, F2(function(n, e) {
                    return s(A2(la, 0, A2(Zi, sC, n.f5)), A2(la, 0, A2(Zi, sC, e.f5))) > 0 ? n : e;
                }), function(n) {
                    return d(n.fL, n.eM);
                }, i))) : A2(US, e, fl);
            case 1:
                return A2(R$, y([
                    F$("ui bottom attached segment"),
                    A2(ew, "min-height", "20em")
                ]), y([
                    A2(R$, y([
                        F$("ui loader active massive text")
                    ]), y([
                        z$("Loading agents")
                    ]))
                ]));
            default:
                return A2(R$, y([
                    F$("ui bottom attached segment")
                ]), v);
        }
    }), nI = function(n) {
        switch(n.$){
            case 0:
                return 1;
            case 1:
            case 2:
                return 2;
            default:
                return 3;
        }
    }, eI = function(n) {
        switch(n.$){
            case 0:
                return A2(Xw, v, v);
            case 1:
                return A2(Z$, y([
                    F$("icon circle notch loading")
                ]), v);
            case 3:
                return A2(Z$, y(n.a.b ? [
                    F$("icon blue server")
                ] : [
                    F$("icon yellow exclamation circle"),
                    wk("No agents running yet")
                ]), v);
            default:
                return A2(Z$, y([
                    F$("ui icon sad")
                ]), v);
        }
    }, tI = F2(function(n, e) {
        return A2(U$, y([
            Gw(bm(e))
        ]), y([
            A2(Hw, e, n),
            z$(e.k)
        ]));
    }), rI = function(n) {
        var e, t = (e = Ru({
            cq: n.cq.ax,
            dC: n.cq.hf
        }), y([
            A2(R$, y([
                F$("ui item header")
            ]), y([
                A2(U$, y([
                    Gw(e)
                ]), y([
                    A2(Z$, y([
                        F$("ui icon wrench")
                    ]), v),
                    z$("Settings")
                ]))
            ]))
        ])), r = function(e) {
            return u(nI(n.eb), nI(e)) ? "ui item active header" : "ui item header";
        }, a = 1 === n.ef ? A2(R$, y([
            F$("ui item header")
        ]), y([
            A2(tI, 40, n.cq)
        ])) : A2(Xw, v, v);
        return A2(R$, y([
            F$("ui top attached stackable tabular small menu")
        ]), y([
            a,
            A2(R$, y([
                F$("right menu")
            ]), g(t, y([
                A2(R$, A2(tt, F$(r(ul)), A2(qS, ul, Gu({
                    cq: n.cq.ax,
                    dC: n.dC
                }))), y([
                    A2(Z$, y([
                        F$("icon book")
                    ]), v),
                    z$("Repositories")
                ])),
                A2(R$, A2(tt, F$(r(ol)), A2(qS, rl, _u({
                    cq: n.cq.ax,
                    ia: 0,
                    dC: n.dC
                }))), y([
                    A2(Z$, y([
                        F$("icon tasks")
                    ]), v),
                    z$("Tasks")
                ])),
                A2(R$, A2(tt, F$(r(rl)), A2(qS, rl, zu({
                    cq: n.cq.ax,
                    dC: n.dC
                }))), y([
                    eI(n.a1),
                    z$("Agents")
                ]))
            ])))
        ]));
    }, aI = F2(function(n, e) {
        return A2(R$, v, y([
            A2(R$, y([
                F$("ui container"),
                A2(ew, "margin-top", "60px")
            ]), y([
                rI(n),
                e
            ]))
        ]));
    }), iI = y([
        A2(_k, y([
            F$("two wide")
        ]), y([
            z$("Type")
        ])),
        A2(_k, y([
            F$("four wide")
        ]), y([
            z$("Task")
        ])),
        A2(_k, y([
            F$("two wide")
        ]), y([
            z$("Status")
        ])),
        A2(_k, y([
            F$("three wide")
        ]), y([
            z$("Planned")
        ])),
        A2(_k, y([
            F$("two wide")
        ]), y([
            z$("System")
        ])),
        A2(_k, y([
            F$("three wide")
        ]), y([
            z$("Agent")
        ]))
    ]), uI = Wk(It(iI)), cI = function(n) {
        return n ? 1 : 0;
    }, oI = F3(function(n, e, t) {
        return Fu({
            cq: n.cq.ax,
            eZ: !1,
            a9: e,
            dC: n.dC,
            eb: cI(t),
            dS: yt
        });
    }), sI = B, fI = function(n) {
        var e = _t(A2(jt, "/", n));
        if (e.b) {
            if (e.b.b) {
                var t = e.a, r = A2(sI, "-", t);
                if (r.b) {
                    var a = r.a;
                    return A2(Xw, y([
                        wk(n)
                    ]), y([
                        A2(Uk, v, y([
                            A2(Xw, y([
                                A2(ew, "display", "inline-flex"),
                                A2(ew, "width", "3.7em"),
                                A2(ew, "margin-right", "-0.1em"),
                                A2(ew, "text-overflow", "ellipsis"),
                                A2(ew, "overflow", "hidden")
                            ]), y([
                                A2(R$, y([
                                    A2(ew, "overflow", "hidden"),
                                    A2(ew, "text-overflow", "ellipsis")
                                ]), y([
                                    z$(A3($r, 0, a, t))
                                ]))
                            ]))
                        ])),
                        A2(Xw, v, y([
                            z$(A3($r, a, yr(t), t))
                        ]))
                    ]));
                }
                return z$(n);
            }
            return z$(e.a);
        }
        return z$("");
    }, lI = F3(function(n, e, t) {
        return A2(U$, y([
            Gw(A3(oI, n, e, t))
        ]), y([
            fI(e)
        ]));
    }), dI = F2(function(n, e) {
        var t = e.a$;
        if (1 === t.$) return e.bw ? z$("(Redacted)") : A2(Xw, y([
            F$("ui disabled text")
        ]), y([
            z$("Unassigned")
        ]));
        var r = t.a;
        return A2(U$, y([
            Gw(Bu({
                cq: n.cq.ax,
                fL: r,
                dC: n.dC
            }))
        ]), y([
            z$(r)
        ]));
    }), bI = function(n) {
        switch(n){
            case 0:
                return z$("Ready");
            case 1:
                return z$("Dispatched");
            case 2:
                return z$("Cancelling");
            default:
                return z$("Resetting");
        }
    }, hI = F6(function(n, e, t, r, a, i) {
        return A2(Rk, v, y([
            A2(Gk, v, y([
                z$(r)
            ])),
            A2(Gk, v, a),
            A2(Gk, v, y([
                bI(t.bw)
            ])),
            A2(Gk, v, y([
                A2(wC, n, t.I)
            ])),
            A2(Gk, v, i),
            A2(Gk, v, y([
                A2(dI, e, t)
            ]))
        ]));
    }), gI = F3(function(n, e, t) {
        var r;
        return A6(hI, n, e, t, "Build", y(1 === (r = t.a9).$ ? [
            z$("(Private)")
        ] : [
            A3(lI, e, r.a, t.bw)
        ]), y([
            MS(t.dL)
        ]));
    }), vI = F2(function(n, e) {
        return Ju({
            cq: n.br.bn.n,
            a2: e,
            ab: n.ab,
            br: n.br.n,
            dC: n.br.bn.dC.n,
            eb: 1
        });
    }), pI = function(n) {
        var e = n.et, t = n.as;
        return A2(U$, y([
            Gw(A2(vI, t, e))
        ]), y([
            z$(t.br.n + "#" + Ct(t.ab) + " / " + _l(e))
        ]));
    }, mI = F3(function(n, e, t) {
        var r;
        return A6(hI, n, e, t, "Effect", y(1 === (r = t.cS).$ ? [
            z$("(Private)")
        ] : [
            pI(r.a)
        ]), y([
            MS(t.dL)
        ]));
    }), yI = function(n) {
        return Yu({
            cq: n.br.bn.n,
            ab: n.ab,
            br: n.br.n,
            dC: n.br.bn.dC.n
        });
    }, $I = F3(function(n, e, t) {
        var r, a;
        return A6(hI, n, e, t, "Evaluation", y(1 === (a = t.as).$ ? [
            z$("(Private)")
        ] : [
            (r = a.a, A2(U$, y([
                Gw(yI(r))
            ]), y([
                z$(r.br.n + "#" + Ct(r.ab))
            ])))
        ]), v);
    }), wI = F3(function(n, e, t) {
        var r = t.ff;
        if (r.$) {
            var a = t.eE;
            if (a.$) {
                var i = t.cS;
                return i.$ ? A2(Rk, v, y([
                    A2(Gk, v, y([
                        z$("Unknown")
                    ]))
                ])) : A3(mI, n, e, i.a);
            }
            return A3(gI, n, e, a.a);
        }
        return A3($I, n, e, r.a);
    }), kI = F2(function(n, e) {
        var t = e.dN;
        switch(t.$){
            case 3:
                var r = t.a;
                return aq(r.bh) ? y([
                    A2(Rk, v, y([
                        A2(Gk, y([
                            uI,
                            F$("center aligned disabled"),
                            A2(ew, "user-select", "none"),
                            A2(ew, "padding-top", "8.5ex")
                        ]), y([
                            A2(Xw, y([
                                F$("ui text large")
                            ]), y([
                                A2(Z$, y([
                                    F$("ui icon check"),
                                    A2(ew, "margin-right", ".5em")
                                ]), v),
                                z$("idle")
                            ]))
                        ]))
                    ]))
                ]) : g(A2(Gr, A2(wI, n, e), r.bh), r.dl ? y([
                    A2(Gk, y([
                        uI,
                        F$("center aligned"),
                        A2(ew, "padding-top", "10ex"),
                        A2(ew, "padding-bottom", "10ex")
                    ]), y([
                        A2(R$, y([
                            F$("ui info message")
                        ]), y([
                            z$("List truncated; further tasks not shown.")
                        ]))
                    ]))
                ]) : v);
            case 1:
                return y([
                    A2(Rk, v, y([
                        A2(Gk, y([
                            uI
                        ]), y([
                            A2(R$, y([
                                F$("ui loader active inline text centered")
                            ]), y([
                                z$("Loading tasks")
                            ]))
                        ]))
                    ]))
                ]);
            case 2:
                var a = t.a;
                return y([
                    A2(Rk, v, y([
                        A2(Gk, y([
                            uI
                        ]), y([
                            z$("Failed to load tasks: " + Bj(a))
                        ]))
                    ]))
                ]);
            default:
                return v;
        }
    }), CI = F2(function(n, e) {
        return A2(R$, y([
            F$("ui bottom attached segment"),
            A2(ew, "min-height", "100ex")
        ]), y([
            A2(Dk, y([
                F$("ui very basic table")
            ]), y([
                A2(Fk, y([
                    A2(ew, "height", "4ex")
                ]), y([
                    A2(Rk, v, iI)
                ])),
                A2(Ok, v, A2(kI, n, e))
            ]))
        ]));
    }), xI = F3(function(n, e, t) {
        var r = n.jS, a = n.dd, i = n.ig, u = function() {
            switch(e.eb.$){
                case 1:
                case 2:
                    return "Agents";
                case 0:
                    return "Projects";
                default:
                    return "Tasks";
            }
        }(), c = function() {
            var n = e.eb;
            switch(n.$){
                case 1:
                    return A2(XS, {
                        ig: i,
                        dd: a
                    }, e);
                case 2:
                    return A2(US, e, n.a);
                case 0:
                    return A3(hS, i, e, t);
                default:
                    return A2(CI, r, e);
            }
        }();
        return {
            q: A2(aI, e, c),
            e: u + " for " + e.cq.k
        };
    }), jI = F3(function(n, e, t) {
        return A3(xI, {
            ig: n.ig,
            dd: fk(n),
            jS: n.jS
        }, e, t);
    }), qI = F3(function(n, e, t) {
        var r = t.a, a = t.b, i = A2(au, r, n.hV);
        return 1 === i.$ ? A2(Xw, v, v) : A2(H$, function(n) {
            return Ms({
                bF: r,
                bG: n
            });
        }, A3(jI, e, i.a, a).q);
    }), SI = A2(R$, v, y([
        A2(ck, v, y([
            z$("Welcome to Hercules CI.")
        ])),
        A2(ik, v, y([
            z$("We did not find any projects for you. Perhaps you could install Hercules CI on your repository accounts?")
        ]))
    ])), II = F2(function(n, e) {
        var t = n.gY, r = n.fu, a = n.dd, i = e.aR;
        switch(i.$){
            case 1:
                return A2(Z$, y([
                    F$("ui loader active massive text")
                ]), y([
                    z$("Loading your projects")
                ]));
            case 3:
                var u = i.a, c = e.bD;
                if (c.$) {
                    var o = c.a, s = A2(au, o.c, u);
                    return A2(R$, v, y(1 === s.$ ? [
                        t(d(o.c, v))
                    ] : [
                        t(d(o.c, s.a))
                    ]));
                }
                return A2(R$, v, A2(tt, p$(u) ? SI : A2(R$, v, A2(Gr, t, nf(u))), function(n) {
                    return n.dd ? A2(Sc, function(n) {
                        return A2(Gr, function(n) {
                            return A2(R$, y([
                                F$("ui placeholder segment"),
                                A2(ew, "margin-top", "5em"),
                                A2(ew, "margin-bottom", "5em")
                            ]), y([
                                A2(R$, v, y([
                                    A2(ik, y([
                                        A2(ew, "text-align", "center")
                                    ]), y([
                                        z$("Add more GitHub accounts")
                                    ])),
                                    A2(U$, y([
                                        Ow(n),
                                        F$("ui big labeled icon primary button")
                                    ]), y([
                                        A2(Z$, y([
                                            F$("plus icon")
                                        ]), v),
                                        z$("Install")
                                    ]))
                                ]))
                            ]));
                        }, Rl(n.gm));
                    }, n.fu) : v;
                }({
                    fu: r,
                    dd: a
                })));
            case 0:
                return A2(Xw, v, v);
            default:
                var f = i.a;
                return A2(R$, y([
                    F$("ui container")
                ]), y([
                    A2($k, a, f)
                ]));
        }
    }), TI = F2(function(n, e) {
        return {
            q: A2(II, {
                fu: n.h9.fu,
                dd: fk(n),
                gY: A2(qI, e, n)
            }, e),
            e: "Dashboard"
        };
    }), AI = {
        $: 2
    }, EI = {
        $: 5
    }, NI = Kn("h2"), LI = F3(function(n, e, t) {
        return A2(R$, y([
            F$("ui sixteen column centered stackable grid")
        ]), y([
            A2(R$, y([
                F$("four wide column")
            ]), n),
            A2(R$, y([
                F$("eight wide column centered")
            ]), y([
                A2(R$, y([
                    F$("column")
                ]), y([
                    A2(R$, y([
                        F$("ui padded basic segment")
                    ]), e)
                ]))
            ])),
            A2(R$, y([
                F$("four wide column")
            ]), t)
        ]));
    }), PI = function(n) {
        return A2(R$, y([
            F$("ui two column centered stackable grid")
        ]), y([
            A2(R$, y([
                F$("two column centered row")
            ]), y([
                A2(R$, y([
                    F$("column")
                ]), y([
                    A2(R$, y([
                        F$("ui padded basic segment")
                    ]), n)
                ]))
            ]))
        ]));
    }, DI = function(n) {
        return !A2(Yk, function(n) {
            return "webhook_noTestMessageReceived" === n;
        }, n.fc);
    }, OI = function(n) {
        var e = n.ac;
        return 3 === e.$ ? A2(nl, DI, e.a.fe) : v;
    }, GI = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), _I = Zj, FI = Yj, RI = F2(function(n, e) {
        var t = n.fG, r = n.fe, a = n.cv, i = n.f3, u = n.c;
        return A2(R$, g(y([
            F$("field"),
            X$(y([
                d("error", t)
            ])),
            A2(ew, "position", "relative")
        ]), a), g(y([
            A2(jx, y([
                xx(u)
            ]), y([
                z$(i)
            ])),
            A2(R$, v, A2(Gr, function(n) {
                return A2(R$, y([
                    F$("ui right aligned floating pointing below label")
                ]), y([
                    z$(n)
                ]));
            }, r))
        ]), e));
    }), BI = F2(function(n, e) {
        return A2(Yk, function(e) {
            return u(e, n);
        }, e);
    }), HI = _$("value"), VI = F2(function(n) {
        var e = OI(n), t = function(n) {
            return A2(Gr, function(n) {
                return n.bl;
            }, A2(nl, function(e) {
                return A2(BI, n, e.fc);
            }, e));
        };
        return A2(Kj, _I, y([
            A2(ik, v, y([
                z$("Please set the forge name as desired. These names can not be changed afterwards.")
            ])),
            A2(RI, {
                cv: y([
                    F$("required field")
                ]),
                fe: t("input_name"),
                fG: !u(t("input_name"), v),
                c: "forge_name",
                f3: "Name (URLs, API, command line)"
            }, y([
                Mj(h(FI, {
                    cv: y([
                        vx("forge_name"),
                        HI(n.n),
                        nq(GI(0))
                    ])
                }))
            ])),
            A2(RI, {
                cv: y([
                    F$("required field")
                ]),
                fe: t("input_displayName"),
                fG: !u(t("input_displayName"), v),
                c: "forge_display_name",
                f3: "Display Name (Dashboard)"
            }, y([
                Mj(h(FI, {
                    cv: y([
                        vx("forge_display_name"),
                        HI(n.k),
                        nq(GI(1))
                    ])
                }))
            ]))
        ]));
    }), zI = F3(function(n, e, t) {
        return A2(pk, mk, A3(yk, n, e, t));
    }), UI = F2(function(n, e) {
        var t, r, a = function(n) {
            var e = n.ac;
            if (3 === e.$) {
                var t = e.a;
                return A2(nl, A2(bc, DI, Ii), t.fe);
            }
            return v;
        }(e), i = 3 === (t = e.ac).$ && A2(Ep, e, t.a) && u(OI(e), v), c = !i, o = Ek(e.aq).a, s = Ek(e.bU), f = s.a, l = s.b, b = g(A2(Gr, $k(n.dd), Lk(y([
            f
        ]))), g(A2(Gr, function(e) {
            return A3(zI, n.dd, e, y([
                z$(" "),
                A2(U$, y([
                    Nw(EI)
                ]), y([
                    z$("Retry")
                ]))
            ]));
        }, Lk(y([
            o
        ]))), g(ch(l) ? y([
            A2(R$, y([
                F$("ui message info")
            ]), y([
                z$("Installation deleted. "),
                A2(U$, y([
                    Gw(Zu({}))
                ]), y([
                    z$("Go back")
                ]))
            ]))
        ]) : v, A2(Gr, function(n) {
            return A2(R$, y([
                F$("ui message warning")
            ]), y([
                z$(n.bl)
            ]));
        }, a))));
        return A2(R$, y([
            F$("ui stacked segments")
        ]), y([
            A2(R$, y([
                F$("ui segment")
            ]), y([
                A2(R$, y([
                    F$("ui basic segment")
                ]), b),
                A3(LI, v, y([
                    A2(NI, v, y([
                        z$("Connect GitLab and Hercules CI")
                    ])),
                    (r = e.ac, 3 === r.$ ? A2(VI, e, r.a) : A2(R$, y([
                        F$("ui placeholder")
                    ]), y([
                        A2(R$, y([
                            F$("line")
                        ]), v)
                    ])))
                ]), y([
                    A2(R$, y([
                        F$("ui basic padded segment"),
                        A2(ew, "position", "relative"),
                        A2(ew, "float", "right")
                    ]), y([
                        A2(Gx, {
                            cv: y([
                                F$("ui button yellow"),
                                Cx(iy(l) || ch(l))
                            ]),
                            eO: AI,
                            eP: l
                        }, y([
                            z$("Cancel")
                        ]))
                    ]))
                ]))
            ])),
            A2(R$, y([
                F$("ui segment")
            ]), y([
                PI(y([
                    A2(ik, v, y([
                        z$("Next, finalize the installation by logging in and becoming the initial forge administrator.")
                    ])),
                    A2(U$, g(y([
                        F$("ui orange button"),
                        X$(y([
                            d("orange", i),
                            d("disabled", c)
                        ])),
                        Cx(c)
                    ]), i ? y([
                        Ow("/api/auth/gitlab/start/" + e.ci.c8 + "?redirect=/install/gitlab/continue/" + e.ci.c8)
                    ]) : v), y([
                        A2(Z$, y([
                            F$("ui icon gitlab")
                        ]), v),
                        z$("Sign in")
                    ]))
                ]))
            ]))
        ]));
    }), WI = A2(R$, y([
        F$("ui stacked segments")
    ]), y([
        A2(R$, y([
            F$("ui segment")
        ]), y([
            A3(LI, v, y([
                A2(NI, v, y([
                    z$("OAuth Setup Done")
                ])),
                A2(ik, v, y([
                    z$("Go to "),
                    A2(U$, y([
                        Gw(Wu)
                    ]), y([
                        z$("dashboard")
                    ]))
                ]))
            ]), v)
        ]))
    ])), KI = F2(function(n, e) {
        return A2(Yk, function(n) {
            return u(n.c, e.ci.c8);
        }, n.fu) ? WI : A2(UI, n, e);
    }), ZI = F2(function(n, e) {
        var t = {
            fu: n.h9.fu,
            dd: fk(n)
        };
        return {
            q: A2(KI, t, e),
            e: "Installing GitLab"
        };
    }), YI = function(n) {
        var e = n.c7;
        return 3 === e.$ ? A2(Gr, function(n) {
            return function(n) {
                return A2(R$, y([
                    F$("ui message warning")
                ]), y([
                    A2(R$, y([
                        F$("header")
                    ]), y([
                        z$("Another GitLab installation is in progress")
                    ])),
                    A2(R$, v, y([
                        z$("You may choosey to "),
                        A2(U$, y([
                            Gw(Ku({
                                c8: n.c
                            }))
                        ]), y([
                            z$("Resume installation")
                        ])),
                        z$(' of the in progress installation of "'),
                        A2(U$, y([
                            Gw(Ku({
                                c8: n.c
                            }))
                        ]), y([
                            z$(n.k)
                        ])),
                        z$('" instead.')
                    ]))
                ]));
            }(n);
        }, e.a.bh) : v;
    }, MI = {
        $: 2
    }, JI = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), QI = function(n) {
        return d(n, !0);
    }, XI = iq(TC), nT = tq, eT = Zj, tT = Yj, rT = function(n) {
        var e = n.c6;
        switch(e.$){
            case 0:
            case 2:
                return !0;
            case 1:
                return !1;
            default:
                return 1 === e.a.$;
        }
    }, aT = F2(function(n, e) {
        return A2(uw, n, {
            $: 2,
            a: e
        });
    }), iT = function(n) {
        var e, t = function(n) {
            return y([
                nq(JI(n))
            ]);
        }, r = 1 === (e = om(n)).$ ? Mp(e.a) : v, a = F4(function(e, t, a, i) {
            var c;
            return A2(R$, g(y([
                F$("field"),
                X$(y([
                    d("error", (c = t, n.aA && A2(Yk, function(n) {
                        return u(n.a, c);
                    }, r)))
                ])),
                A2(ew, "position", "relative")
            ]), a), g(y([
                A2(jx, y([
                    xx(e)
                ]), y([
                    z$(t)
                ])),
                A2(R$, v, n.aA ? A2(Gr, function(n) {
                    var e = n.b;
                    return A2(R$, y([
                        F$("ui right aligned floating pointing below label")
                    ]), y([
                        z$(e)
                    ]));
                }, A2(nl, function(n) {
                    return u(n.a, t);
                }, r)) : v)
            ]), i));
        }), i = A2(ao, Cx, Ii), c = i(rT(n) && (!n.aA || u(r, v))), o = i(rT(n)), s = n.aA && !u(r, v);
        return A2(Kj, eT, g(y([
            A4(a, "gitlab_url", "GitLab URL", y([
                F$("required field")
            ]), y([
                Mj(h(tT, {
                    cv: g(y([
                        vx("gitlab_url"),
                        HI(n.c1),
                        o
                    ]), t(0))
                }))
            ])),
            A4(a, "gitlab_admin_username", "GitLab Admin Username", y([
                F$("required field")
            ]), y([
                Mj(h(tT, {
                    cv: g(y([
                        vx("gitlab_admin_username"),
                        HI(n.aW),
                        o
                    ]), t(1))
                }))
            ])),
            A4(a, "gitlab_admin_password", "GitLab Admin Password", y([
                F$("required field")
            ]), y([
                Mj(h(tT, {
                    cv: g(y([
                        vx("gitlab_admin_password"),
                        Lw("password"),
                        HI(n.aQ),
                        o
                    ]), t(2))
                }))
            ])),
            A2(XI, h(nT, {
                cv: y([
                    X$(y([
                        d("primary", !s),
                        d("red", s)
                    ])),
                    c,
                    A2(aT, "submit", A2(lr, QI, br(MI))),
                    A2(aT, "click", A2(lr, QI, br(MI)))
                ]),
                ii: s
            }), y([
                z$("Submit")
            ]))
        ]), u(r, v) ? y([
            A2(R$, v, v)
        ]) : y([
            A2(R$, y([
                F$("ui padded basic segment")
            ]), A2(Gr, function(n) {
                var e = n.a;
                return A2(R$, y([
                    F$("ui message error")
                ]), y([
                    z$("Please correct: "),
                    z$(e)
                ]));
            }, r))
        ])));
    }, uT = mk, cT = function(n) {
        n: for(;;)switch(n.$){
            case 2:
                return A2($k, !0, n.a);
            case 3:
                if (1 === n.a.$) {
                    var e = n.a.a;
                    return A2(pk, h(uT, {
                        iy: mt("Hercules CI could not connect to GitLab")
                    }), y([
                        A2(Xw, y([
                            A2(ew, "white-space", "pre-line")
                        ]), y([
                            z$(e)
                        ]))
                    ]));
                }
                break n;
            default:
                break n;
        }
        return A2(R$, v, v);
    }, oT = function(n) {
        return A2(R$, y([
            F$("ui stacked segments")
        ]), y([
            A2(R$, y([
                F$("ui segment")
            ]), y([
                PI(y([
                    A2(NI, v, y([
                        z$("Connect GitLab and Hercules CI")
                    ])),
                    A2(R$, y([
                        F$("ui padded basic segment")
                    ]), YI(n)),
                    A2(ik, v, y([
                        z$("For this process, you need an Administrator account on the GitLab instance. By submitting the form, Hercules CI will:")
                    ])),
                    A2($S, v, y([
                        A2(Qk, v, y([
                            z$("Log in to GitLab,")
                        ])),
                        A2(Qk, v, y([
                            z$("Create an instance-wide GitLab OAuth application for Hercules CI,")
                        ])),
                        A2(Qk, v, y([
                            z$("Configure itself to connect to the GitLab instance,")
                        ])),
                        A2(Qk, v, y([
                            z$("Forget the credentials you submitted.")
                        ]))
                    ]))
                ]))
            ])),
            A2(R$, y([
                F$("ui segment")
            ]), y([
                PI(y([
                    iT(n),
                    cT(n.c6)
                ]))
            ])),
            A2(R$, y([
                F$("ui segment secondary")
            ]), y([
                PI(y([
                    A2(NI, v, y([
                        A2(Z$, y([
                            F$("info circle icon primary")
                        ]), v),
                        z$("Why do I need to enter my GitLab password?")
                    ])),
                    A2(ik, v, y([
                        z$("Many online services allow you to authenticate via other services securely, without sharing a password. This is achieved with a special authorization page and a communication protocol between such services called OAuth.")
                    ])),
                    A2(ik, v, y([
                        z$("However, your GitLab and your Hercules CI have not been configured to talk to each other yet.")
                    ])),
                    A2(ik, v, y([
                        z$("After this initial setup, GitLab will be able to authorize logins into Hercules CI using OAuth, and Hercules CI will not ask to share a password again.")
                    ]))
                ]))
            ]))
        ]));
    }, sT = F2(function(n, e) {
        return {
            q: oT(e),
            e: "Install on GitLab"
        };
    }), fT = A2(ik, v, y([
        A2(Z$, y([
            F$("ui huge grey icon circle notch loading")
        ]), v)
    ])), lT = F2(function(n, e) {
        return function(n) {
            return {
                q: A2(R$, y([
                    F$("ui placeholder segment"),
                    A2(ew, "text-align", "center"),
                    A2(ew, "height", "70%")
                ]), y([
                    A2(ik, v, function() {
                        var e = function(n) {
                            var e = n.aU.ie;
                            return 3 === e.$ ? e.a.cq : yt;
                        }(n);
                        if (e.$) return y([
                            z$("Waiting for the changes to your account installation to be processed...")
                        ]);
                        var t = e.a;
                        return y([
                            z$("Waiting for the changes to "),
                            A2(Hw, t, 30),
                            z$(t.ax + " to be processed...")
                        ]);
                    }()),
                    function() {
                        var e = n.aU.ie;
                        switch(e.$){
                            case 2:
                                return 3 === e.a.$ && 404 === e.a.a ? fT : A2($k, !0, e.a);
                            case 3:
                                return fm(e.a) ? fT : A2(Xw, v, v);
                            default:
                                return fT;
                        }
                    }()
                ])),
                e: "Account update progress"
            };
        }(e);
    }), dT = F2(function(n, e) {
        var t = d(n, e);
        n: for(;;)if (1 === t.b) switch(t.a.$){
            case 13:
            case 15:
                return Mu({
                    cq: (r = t.a.a).cq,
                    ew: yt,
                    ab: r.ab,
                    br: r.br,
                    dC: r.dC
                });
            default:
                break n;
        }
        else switch(t.a.$){
            case 13:
                return Yu(r = t.a.a);
            case 15:
                var r;
                return Yu({
                    cq: (r = t.a.a).cq,
                    ab: r.ab,
                    br: r.br,
                    dC: r.dC
                });
            default:
                break n;
        }
        return n;
    }), bT = F3(function(n, e, t) {
        var r = function(e) {
            return Gw(A2(dT, n, e));
        }, a = function(n) {
            switch(n.$){
                case 13:
                    return mt(0);
                case 15:
                    return mt(1);
                default:
                    return yt;
            }
        }(n), i = function(n) {
            return y([
                F$("item"),
                r(n),
                X$(y([
                    d("active", u(a, mt(n)))
                ]))
            ]);
        };
        return A2(tt, A2(R$, y([
            F$("ui big top attached tabular menu")
        ]), y([
            A2(R$, y([
                F$("right menu")
            ]), y([
                A2(U$, i(0), y([
                    z$("Job")
                ])),
                A2(U$, i(1), y([
                    z$("Compare")
                ]))
            ]))
        ])), e ? t : y([
            A2(R$, y([
                F$("ui bottom attached segment")
            ]), t)
        ]));
    }), hT = F4(function(n, e, t, r) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/evaluation/log/raw", y([
            d("jobId", n)
        ]), y([
            d("logId", mt(e)),
            d("iMin", A2(Zi, Ct, t)),
            d("verbosity", A2(Zi, sy, r))
        ]), v, yt, ta);
    }), gT = function(n) {
        return {
            $: 17,
            a: n
        };
    }, vT = function(n) {
        return {
            $: 21,
            a: n
        };
    }, pT = function(n) {
        return {
            $: 18,
            a: n
        };
    }, mT = F3(function(n, e, t) {
        var r = n.dd, a = n.im, i = 0 !== t.fj;
        return y([
            A2(Pk, v, y([
                z$("Evaluation Log")
            ])),
            A2(R$, y([
                F$("ui fitted segment"),
                A2(ew, "min-height", "15em")
            ]), A2(Ax, {
                c: "evaluation_log",
                ja: vT,
                jc: pT,
                je: gT
            }, {
                im: a,
                dd: r,
                iI: e.aF,
                iN: A2(Af, function(n) {
                    return h(n, {
                        e6: n.e6 || i
                    });
                }, e.ak),
                jn: e.b$,
                aT: e.b0,
                jW: mt(e.aG)
            }))
        ]);
    }), yT = F4(function(n, e, t, r) {
        var a = n.hZ, i = r.fi;
        if (i.$) return v;
        var u = i.a;
        return A3(mT, {
            im: function(n) {
                return IC(A2(_o, a, A4(hT, t.c, u, yt, mt(n))));
            },
            dd: n.dd
        }, e, t);
    }), $T = function(n) {
        return rC({
            cq: mt(n.cq),
            br: mt(n.br),
            dC: n.dC
        });
    }, wT = F2(function(n, e) {
        var t = n.ig, r = e.as.ie;
        switch(r.$){
            case 2:
                return A2(ck, v, y([
                    z$(Bj(r.a))
                ]));
            case 3:
                var a = r.a, i = a.b, u = a.c, c = A2(Rk, v, y([
                    A2(_k, y([
                        F$("ui three wide")
                    ]), y([
                        z$("Source")
                    ])),
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        Eq(i),
                        A2(Xw, y([
                            A2(ew, "margin-right", "1em")
                        ]), v),
                        A2(Rq, 0, i)
                    ]))
                ])), o = A2(Rk, v, y([
                    A2(_k, y([
                        F$("ui three wide")
                    ]), y([
                        z$("Git rev")
                    ])),
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Uk, v, y([
                            z$(i.dF.g6)
                        ]))
                    ]))
                ])), s = function() {
                    var n = i.g2;
                    if (1 === n.$) return v;
                    var t = n.a, r = e.ci;
                    return y([
                        A2(Rk, v, y([
                            A2(_k, v, y([
                                z$("Rerun of job")
                            ])),
                            A2(Gk, y([
                                Wk(2)
                            ]), y([
                                A2($T, r, h(r, {
                                    ab: t
                                }))
                            ]))
                        ]))
                    ]);
                }(), f = function() {
                    switch(i.f1){
                        case 1:
                            return v;
                        case 0:
                            return y([
                                A2(Rk, v, y([
                                    A2(_k, v, y([
                                        z$("Job type")
                                    ])),
                                    A2(Gk, y([
                                        Wk(2)
                                    ]), y([
                                        z$("Config")
                                    ]))
                                ]))
                            ]);
                        case 2:
                            return y([
                                A2(Rk, v, y([
                                    A2(_k, v, y([
                                        z$("Event handler")
                                    ])),
                                    A2(Gk, y([
                                        Wk(2)
                                    ]), y([
                                        A2(Uk, v, y([
                                            z$("onPush."),
                                            z$(A2(la, "", i.f_))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        default:
                            return y([
                                A2(Rk, v, y([
                                    A2(_k, v, y([
                                        z$("Event handler")
                                    ])),
                                    A2(Gk, y([
                                        Wk(2)
                                    ]), y([
                                        A2(Uk, v, y([
                                            z$("onSchedule."),
                                            z$(A2(la, "", i.f_))
                                        ]))
                                    ]))
                                ]))
                            ]);
                    }
                }(), l = function(n) {
                    return A2(Uk, v, function() {
                        var e = n.fy;
                        if (1 === e.$) return v;
                        var t, r, a = e.a;
                        return g(1 === (t = a.gZ).$ ? v : y([
                            z$(t.a.n),
                            z$(" / ")
                        ]), y([
                            z$(a.dw),
                            z$(" @ "),
                            (function() {
                                var n = a.fJ;
                                if (1 === n.$) return z$;
                                var e = n.a;
                                return function(n) {
                                    return A2(Vq, e, y([
                                        z$(n)
                                    ]));
                                };
                            })()((r = A2(g$, 7, gc(a.g5)), $(r).join("")))
                        ]));
                    }());
                }, d = A2(Nt, F2(function(n, e) {
                    var t = e.a, r = e.b;
                    return A2(Rk, v, y([
                        A2(_k, v, n ? v : y([
                            z$("Extra inputs")
                        ])),
                        A2(Gk, y([
                            F$("ui two wide")
                        ]), y([
                            A2(Kk, v, y([
                                A2(Uk, v, y([
                                    z$(t)
                                ]))
                            ]))
                        ])),
                        A2(Gk, v, y([
                            l(r)
                        ]))
                    ]));
                }), ut(i.fn)), b = function() {
                    var n = u.a_;
                    if ("" === n) return v;
                    var e = n;
                    return y([
                        A2(Rk, v, y([
                            A2(_k, v, y([
                                z$("Evaluating agent")
                            ])),
                            A2(Gk, y([
                                Wk(2)
                            ]), y([
                                A2(Uk, v, y([
                                    z$(e)
                                ]))
                            ]))
                        ]))
                    ]);
                }();
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    A2(Dk, y([
                        F$("ui very basic table")
                    ]), y([
                        A2(Ok, v, A2(tt, c, A2(tt, o, g(f, g(d, g(s, g(y([
                            A2(Rk, v, y([
                                A2(_k, v, y([
                                    z$("Duration (incl. queue)")
                                ])),
                                A2(Gk, y([
                                    Wk(2)
                                ]), y([
                                    Hq(i)
                                ]))
                            ])),
                            A2(Rk, v, y([
                                A2(_k, v, y([
                                    z$("Created")
                                ])),
                                A2(Gk, y([
                                    Wk(2)
                                ]), y([
                                    A2(oS, i, t)
                                ]))
                            ]))
                        ]), b)))))))
                    ]))
                ]));
            case 1:
                return A2(R$, y([
                    F$("ui segment")
                ]), y([
                    A2(R$, y([
                        F$("ui placeholder")
                    ]), y([
                        A2(R$, y([
                            F$("line")
                        ]), v),
                        A2(R$, y([
                            F$("line")
                        ]), v),
                        A2(R$, y([
                            F$("line")
                        ]), v)
                    ]))
                ]));
            default:
                return A2(R$, v, v);
        }
    }), kT = F2(function(n, e) {
        var t = e.gA;
        if (1 === t.$) return z$("");
        var r = t.a;
        return 1 === r.ey ? A2(rS, mk, y([
            z$("Your free trial expires in " + Ct(A2(eS, n, r)) + " days. "),
            A2(U$, y([
                Vx(e)
            ]), y([
                z$("Subscribe")
            ])),
            z$(".")
        ])) : z$("");
    }), CT = F2(function(n, e) {
        return A3(Qo, wa, e, n);
    }), xT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jT = function(n) {
        return {
            $: 7,
            a: n
        };
    }, qT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ST = F2(function(n, e) {
        return !A2(au, n, e).$;
    }), IT = F2(function(n, e) {
        return A2(ST, n, e);
    }), TT = F2(function(n, e) {
        var t = A2(IT, e.bp, n.aa) ? d("down", jT(e)) : d("right", qT(e)), r = t.a, a = t.b;
        return A2(TC, y([
            F$("ui basic button"),
            Nw(a)
        ]), y([
            A2(Z$, y([
                F$("ui icon black chevron " + r),
                A2(ew, "margin", "0 3px 0 0")
            ]), v),
            z$("Cause")
        ]));
    }), AT = F2(function(n, e) {
        var t = A2(IT, e.bp, n.aa) ? d("down", jT(e)) : d("right", qT(e)), r = t.a, a = t.b;
        return A2(TC, y([
            F$("ui basic button"),
            Nw(a)
        ]), y([
            A2(Z$, y([
                F$("ui icon black chevron " + r),
                A2(ew, "margin", "0 3px 0 0")
            ]), v),
            z$("Show trace")
        ]));
    }), ET = Kn("br"), NT = Kn("em"), LT = function(n) {
        return A2(Rk, v, y([
            A2(Gk, y([
                F$("center aligned")
            ]), y([
                n.V
            ])),
            A2(Gk, v, y([
                n.a2
            ])),
            A2(Gk, n.ee, y([
                n.bC
            ])),
            A2(Gk, y([
                F$("right aligned"),
                A2(ew, "vertical-align", "top")
            ]), y([
                n.cs
            ]))
        ]));
    }, PT = F2(function(n, e) {
        switch(n){
            case 0:
                return qk(e);
            case 1:
                return function(n) {
                    var e = 5 === n ? "Build succeeded but was expected to fail. If build success is desirable, remove the mustFail attribute to avoid regressions." : jk(n);
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        default:
                            return qk(n);
                        case 5:
                            return A2(R$, y([
                                A2(ew, "width", "6em")
                            ]), y([
                                A2(kk, "check red circle", e),
                                A2(kk, "red times", e)
                            ]));
                        case 3:
                            return A2(kk, "times green circle", e);
                    }
                }(e);
            case 2:
                return function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        default:
                            return qk(n);
                        case 5:
                            return A2(R$, y([
                                A2(ew, "width", "6em")
                            ]), y([
                                A2(kk, "check yellow circle", "Successful but ignored"),
                                A2(kk, "yellow exclamation triangle", "This attribute does not contribute towards regression avoidance.")
                            ]));
                        case 3:
                            return A2(kk, "times yellow circle", "Failed but ignored");
                    }
                }(e);
            default:
                return function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        default:
                            return qk(n);
                        case 5:
                            return A2(kk, "check green circle outline", "Dependencies successful. The derivation itself is not meant to be built.");
                    }
                }(e);
        }
    }), DT = F2(function(n, e) {
        var t = function(n) {
            switch(n.dU){
                case 4:
                    return Ju({
                        cq: n.cq,
                        a2: n.et,
                        ab: n.ab,
                        br: n.br,
                        dC: n.dC,
                        eb: 1
                    });
                case 3:
                    return Fu({
                        cq: n.cq,
                        eZ: !0,
                        a9: n.a8.a9,
                        dC: n.dC,
                        eb: 0,
                        dS: n.dS
                    });
                default:
                    return Fu({
                        cq: n.cq,
                        eZ: !1,
                        a9: n.a8.a9,
                        dC: n.dC,
                        eb: Bk(n.a8.V),
                        dS: n.dS
                    });
            }
        }(n);
        return LT({
            cs: e,
            a2: n.a2,
            V: A2(PT, n.dU, n.a8.V),
            bC: 4 === n.dU ? z$("Effect specification") : A2(U$, y([
                Gw(t)
            ]), y([
                fI(n.a8.a9)
            ])),
            ee: y([
                Nw(n.i0(t)),
                A2(ew, "cursor", "pointer")
            ])
        });
    }), OT = F2(function(n, e) {
        return A2(dl, function(n) {
            return u(mt(n.a8.a9), e.fa);
        }, n.fg);
    }), GT = A2(Z$, y([
        F$("icon large rotated clockwise level up alt"),
        A2(ew, "display", "block")
    ]), v), _T = F2(function(n, e) {
        var t = Ju({
            cq: n.H,
            a2: e.bp,
            ab: n.au,
            br: n.br,
            dC: n.dD,
            eb: 1
        });
        return A2(U$, y([
            Gw(t),
            F$("ui icon button basic"),
            Nw(xT(t))
        ]), y([
            A2(Z$, y([
                F$("icon info blue")
            ]), v)
        ]));
    }), FT = F2(function(n, e) {
        var t;
        return Fu({
            cq: n.H,
            eZ: !0,
            a9: e,
            dC: n.dD,
            eb: 0,
            dS: (t = n.as.ie, 3 === t.$ ? mt(t.a.b.c) : yt)
        });
    }), RT = F2(function(n, e) {
        var t = A2(FT, n, e.a9);
        return A2(U$, y([
            Gw(t),
            F$("ui icon button basic"),
            Nw(xT(t))
        ]), y([
            A2(Z$, y([
                F$("icon info blue")
            ]), v)
        ]));
    }), BT = F3(function(n, e, t) {
        var r;
        return Fu({
            cq: n.H,
            eZ: !1,
            a9: e,
            dC: n.dD,
            eb: Bk(t),
            dS: (r = n.as.ie, 3 === r.$ ? mt(r.a.b.c) : yt)
        });
    }), HT = F2(function(n, e) {
        var t = A3(BT, n, e.a9, e.V);
        return A2(U$, y([
            Gw(t),
            F$("ui icon button basic"),
            Nw(xT(t))
        ]), y([
            A2(Z$, y([
                F$("icon info blue")
            ]), v)
        ]));
    }), VT = F2(function(n, e) {
        return A2(la, A2(Xw, v, v), A2(Zi, e, n.a6));
    }), zT = F3(function(n, e, t) {
        return A2(VT, e, function(e) {
            var r;
            return A2(TC, g(y([
                F$("ui button primary"),
                Nw((r = {
                    bF: e.c,
                    a9: t.a9
                }, {
                    $: 8,
                    a: r
                }))
            ]), g(A2(xS, n, F$("icon")), A2(xS, n, wk("Rebuild")))), A2(tt, A2(Z$, A2(tt, F$("icon redo alternative"), A2(xS, !n, F$("ui"))), v), A2(xS, !n, z$("Rebuild"))));
        });
    }), UT = F3(function(n, e, t) {
        switch(t.V){
            case 0:
            case 1:
            case 2:
            case 5:
                return v;
            default:
                return y([
                    A3(zT, n, e, t)
                ]);
        }
    }), WT = F3(function(n, e, t) {
        switch(e.W){
            case 4:
                return y([
                    A2(_T, n, e)
                ]);
            case 3:
                return y([
                    A2(RT, n, t)
                ]);
            default:
                switch(t.V){
                    case 0:
                    case 1:
                    case 2:
                    case 5:
                    case 3:
                    case 6:
                        return g(A3(UT, !1, n, t), y([
                            A2(HT, n, t)
                        ]));
                    default:
                        return A2(tt, A2(TT, n, e), g(A3(UT, !0, n, t), y([
                            A2(HT, n, t)
                        ])));
                }
        }
    }), KT = function(n) {
        return n.b ? z$(_l(n)) : A2(Z$, v, y([
            z$("expression root")
        ]));
    }, ZT = function(n) {
        var e = n.bC.gx;
        return 1 === e.$ ? A2(kk, "attention red circle", "Evaluation failed") : A2(PT, n.W, e.a.V);
    }, YT = R$(y([
        F$("ui buttons small")
    ])), MT = A2(Rk, v, y([
        A2(Gk, y([
            Wk(4)
        ]), y([
            z$("No dependencies are in a failed state now. Use [Rebuild] or [Re-run effects and failures] to resume the job.")
        ]))
    ])), JT = F2(function(n, e) {
        var t = F2(function(e, t) {
            var r = t.a, a = t.b;
            return n(e) ? d(A2(tt, e, r), a) : d(r, A2(tt, e, a));
        });
        return A3(Or, t, d(v, v), e);
    }), QT = F4(function(n, e, t, r) {
        var a = function() {
            var r = n.aH.ie;
            switch(r.$){
                case 2:
                    return y([
                        z$("Failure loading derivations. Try again?")
                    ]);
                case 0:
                    return y([
                        z$("Failed derivations weren't asked for yet")
                    ]);
                case 1:
                    return y([
                        A2(R$, y([
                            F$("ui loader active text inline centered")
                        ]), y([
                            z$("Loading derivations")
                        ]))
                    ]);
                default:
                    var a = r.a, i = function(n) {
                        var e = A2(au, n, a);
                        if (1 === e.$) return v;
                        var t = e.a, r = t.a, u = A2(JT, function(n) {
                            return 3 === n.a.V;
                        }, A2(gu, function(n) {
                            return A2(au, n, a);
                        }, t.b)), c = u.a, o = u.b;
                        return 3 === r.V ? y([
                            d(r, v)
                        ]) : g(c, A2(Sc, function(n) {
                            return i(n.a.a9);
                        }, o));
                    };
                    return A2(Gr, function(t) {
                        var r = t.a;
                        return A2(DT, {
                            cq: n.H,
                            a2: GT,
                            et: v,
                            dU: 0,
                            a8: r,
                            ab: n.au,
                            i0: xT,
                            br: n.br,
                            dC: n.dD,
                            dS: A2(Zi, function(n) {
                                return n.c;
                            }, ay(n))
                        }, YT(A3(WT, n, e, r)));
                    }, i(t.a9));
            }
        }();
        return A2(IT, e.bp, n.aa) ? aq(a) ? y([
            r
        ]) : a : v;
    }), XT = F3(function(n, e, t) {
        var r = function(n) {
            var e = n.a, r = n.b;
            return A2(tt, LT({
                cs: n.c,
                a2: KT(t.bp),
                V: ZT(t),
                bC: e,
                ee: v
            }), r);
        }, a = d(t.bC.e9, t.bC.gx);
        if (a.a.$) {
            if (a.b.$) return v;
            var i = a.b.a;
            return A2(tt, A2(DT, {
                cq: n.H,
                a2: KT(t.bp),
                et: t.bp,
                dU: t.W,
                a8: i,
                ab: n.au,
                i0: xT,
                br: n.br,
                dC: n.dD,
                dS: A2(Zi, function(n) {
                    return n.c;
                }, ay(n))
            }, YT(A3(WT, n, t, i))), A4(QT, n, t, i, MT));
        }
        var u = a.a.a, c = function(n) {
            return jv(n.fi);
        }(e), o = F2(function(e, r) {
            return A2(Uk, y([
                A2(ew, "white-space", "pre-wrap")
            ]), A2(tt, A2(Z$, y([
                F$("attention red icon")
            ]), v), g(A2(lx, PC, e).eK, g(function(n) {
                return c && A2(mr, "nix::ExecError", n) && A2(mr, "failed with exit code", n) ? y([
                    A2(ET, v, v),
                    A2(Z$, y([
                        F$("info circle icon")
                    ]), v),
                    z$("Diagnostic output from the failed program is captured in the "),
                    z$("evaluation log below"),
                    z$(".")
                ]) : v;
            }(e), function() {
                if (r.$) return v;
                var e = r.a;
                return A2(IT, t.bp, n.aa) && "" !== e ? A2(tt, A2(R$, v, y([
                    A2(NT, v, y([
                        z$("\nEvaluation trace:\n")
                    ]))
                ])), A2(lx, PC, e).eK) : v;
            }()))));
        }), s = u.fd;
        if (s.$ || "BuildException" !== s.a) return (!u.hx.$ && A2(IT, t.bp, n.aa) ? function(n) {
            var e, r = n.a, a = n.b;
            return A2(tt, (e = {
                cs: n.c,
                a2: KT(t.bp),
                V: ZT(t),
                bC: r,
                ee: v
            }, A2(Rk, v, y([
                A2(Gk, y([
                    F$("center aligned")
                ]), y([
                    e.V
                ])),
                A2(Gk, y([
                    Wk(2)
                ]), y([
                    A2(R$, y([
                        F$("ui basic horizontally fitted segment")
                    ]), y([
                        e.a2
                    ])),
                    A2(R$, y([
                        F$("ui basic horizontally fitted segment")
                    ]), y([
                        e.bC
                    ]))
                ])),
                A2(Gk, y([
                    F$("right aligned"),
                    A2(ew, "vertical-align", "top")
                ]), y([
                    e.cs
                ]))
            ]))), a);
        } : r)(b(A2(o, u.fb, u.hx), v, (l = u.hx).$ || "" === l.a ? A2(Xw, v, v) : A2(AT, n, t)));
        var f = A2(OT, e, u);
        if (f.$) return r(b(A2(o, "Build failure reported without derivation path.", yt), v, A2(Xw, v, v)));
        var l, h = f.a, p = {
            cq: n.H,
            a2: GT,
            et: v,
            dU: 0,
            a8: h.a8,
            ab: n.au,
            i0: xT,
            br: n.br,
            dC: n.dD,
            dS: A2(Zi, function(n) {
                return n.c;
            }, ay(n))
        }, m = A2(DT, p, YT(A3(WT, n, t, h.a8)));
        return r(b(A2(o, "Evaluation-time build failure. Message: " + u.fb, u.hx), A4(QT, n, t, h.a8, m), A2(TT, n, t)));
    }), nA = A2(Pk, v, y([
        z$("Attributes")
    ])), eA = {
        $: 13
    }, tA = Ck(v), rA = F2(function(n, e) {
        return A2(xS, u(A2(Zi, function(n) {
            return n.bk;
        }, ay(n)), mt(!0)), A2(Gx, {
            cv: y([
                F$("fluid yellow")
            ]),
            eO: eA,
            eP: e
        }, y([
            tA(v),
            z$("Cancel")
        ])));
    }), aA = A2(bc, ut, Gr(function(n) {
        return {
            a9: n.a,
            V: n.b
        };
    })), iA = F3(function(n, e, t) {
        return A2(U$, y([
            Gw(A3(BT, n, e, t))
        ]), y([
            z$(e)
        ]));
    }), uA = F2(function(n, e) {
        var t = A2(Gr, function(e) {
            return A2(Rk, v, y([
                A2(Gk, y([
                    F$("center aligned")
                ]), y([
                    qk(e.V)
                ])),
                A2(Gk, v, y([
                    A3(iA, n, e.a9, e.V)
                ])),
                A2(Gk, y([
                    F$("center aligned")
                ]), y([
                    YT(g(A3(UT, !1, n, e), y([
                        A2(HT, n, e)
                    ])))
                ]))
            ]));
        }, e);
        return y([
            A2(Dk, y([
                F$("ui unstackable table")
            ]), y([
                A2(Fk, v, y([
                    A2(Rk, y([
                        F$("center aligned")
                    ]), y([
                        A2(_k, y([
                            F$("one wide")
                        ]), y([
                            z$("Status")
                        ])),
                        A2(_k, y([
                            F$("eleven wide")
                        ]), y([
                            z$("Derivation")
                        ])),
                        A2(_k, y([
                            F$("three wide")
                        ]), y([
                            z$("Actions")
                        ]))
                    ]))
                ])),
                A2(Ok, v, t)
            ]))
        ]);
    }), cA = F2(function(n, e) {
        var t = F2(function(n, e) {
            return n ? e : v;
        }), r = e.e4, a = e.e3, i = function(n) {
            switch(n.V){
                case 0:
                case 1:
                case 3:
                case 4:
                case 5:
                default:
                    return !1;
                case 2:
                    return !0;
            }
        }, u = function(n) {
            switch(n.V){
                case 0:
                case 1:
                case 2:
                case 4:
                case 5:
                default:
                    return !1;
                case 3:
                    return !0;
            }
        }, c = aA(e.e_), o = A2(nl, i, c), s = A2(nl, u, c);
        return g(A2(t, r > 0 || !aq(o), A2(tt, A2(Pk, v, y([
            z$("Build progress")
        ])), g(A2(t, !aq(e.hz), y([
            A2(R$, y([
                F$("ui icon warning message")
            ]), y([
                A2(Z$, y([
                    F$("notched exclamation icon")
                ]), v),
                A2(R$, y([
                    F$("content")
                ]), y([
                    A2(R$, y([
                        F$("header")
                    ]), y([
                        z$("No agent available for some derivations")
                    ])),
                    A2(Xk, v, A2(Gr, function(n) {
                        return A2(Qk, v, function(n) {
                            var e = n.bs;
                            if (e.b) {
                                var t = e.a, r = e.b;
                                return g(y([
                                    z$("No agent for platform "),
                                    A2(Uk, v, y([
                                        z$(n.bq)
                                    ])),
                                    z$(" and system features ")
                                ]), A2(tt, A2(Uk, v, y([
                                    z$(t)
                                ])), A2(Sc, function(n) {
                                    return y([
                                        z$(", "),
                                        A2(Uk, v, y([
                                            z$(n)
                                        ]))
                                    ]);
                                }, r)));
                            }
                            return y([
                                z$("No agent for platform "),
                                A2(Uk, v, y([
                                    z$(n.bq)
                                ]))
                            ]);
                        }(n));
                    }, e.hz)),
                    A2(ik, v, y([
                        z$("Please make sure your agent configurations are correct, deployed and started. Alternatively, you may cancel this job to save computation.")
                    ]))
                ]))
            ]))
        ])), g(A2(t, r > 0, y([
            A2(ik, v, y([
                z$(Ct(r) + " derivations waiting for dependency or agent to become available.")
            ]))
        ])), aq(o) ? y([
            A2(ik, v, y([
                z$("Not currently building any derivations for this job.")
            ]))
        ]) : A2(uA, n, o))))), A2(t, !aq(s) || a > 0, A2(tt, A2(Pk, v, y([
            z$("Build failures")
        ])), g(A2(t, !aq(s), A2(uA, n, s)), A2(t, a > 0, y([
            A2(ik, v, y([
                z$(Ct(a) + " derivations were not built due to failed dependencies")
            ]))
        ]))))));
    }), oA = function(n) {
        return n.W ? A2(R$, y([
            F$("ui warning message")
        ]), y([
            A2(ik, v, y([
                A2(Z$, y([
                    F$("attention icon")
                ]), v),
                z$(n.bl)
            ]))
        ])) : A2(R$, y([
            F$("ui error message")
        ]), y([
            A2(ik, v, y([
                A2(Z$, y([
                    F$("attention red circle icon")
                ]), v),
                z$(n.bl)
            ]))
        ]));
    }, sA = F2(function(n, e) {
        return A2(Z$, y([
            F$("ui icon big " + n),
            wk(e)
        ]), v);
    }), fA = F3(function(n, e, t) {
        return y([
            LT({
                cs: YT(y([
                    A2(HT, n, t.bC)
                ])),
                a2: KT(t.bp),
                V: function() {
                    if (e.fW) return xk(y([
                        F$("big"),
                        wk("Evaluation cancelled")
                    ]));
                    switch(t.bC.V){
                        case 2:
                            return A2(sA, "sun outline loading", "Building");
                        case 1:
                            return A2(sA, "spinner loading", "Waiting");
                        case 0:
                            return A2(sA, "", "Not planned");
                        default:
                            return A2(Xw, v, v);
                    }
                }(),
                bC: A2(Z$, v, y([
                    z$("import from derivation")
                ])),
                ee: v
            })
        ]);
    }), lA = function(n) {
        return A2(nl, function() {
            switch(n.a8.V){
                case 0:
                case 1:
                case 2:
                    return !0;
                default:
                    return !1;
            }
        }, y([
            LT({
                cs: A2(Xw, v, v),
                a2: A2(Z$, v, y([
                    z$("import from derivation")
                ])),
                V: qk(n.a8.V),
                bC: z$(n.a8.a9),
                ee: v
            })
        ]));
    }, dA = A2(ao, A2(cC, 2, "0"), Ct), bA = function(n) {
        return A2(xt, ", ", A2(Gr, function(e) {
            return dA(e) + ":" + dA(n.gj);
        }, n.fM)) + " UTC " + function(n) {
            var e = function(n) {
                switch(n){
                    case 0:
                        return "Monday";
                    case 1:
                        return "Tuesday";
                    case 2:
                        return "Wednesday";
                    case 3:
                        return "Thursday";
                    case 4:
                        return "Friday";
                    case 5:
                        return "Saturday";
                    default:
                        return "Sunday";
                }
            }, t = function(n) {
                return A2(xt, ", ", A2(Gr, e, n));
            }, r = function(n) {
                return A2(xt, ", ", A2(Gr, Ct, n));
            }, a = d(n.eW, n.eV);
            if (1 === a.a.$) return 1 === a.b.$ ? "every day" : "on each " + r(a.b.a) + " of the month";
            if (a.b.$) return "on each " + t(i = a.a.a);
            if (a.a.a.b && !a.a.a.b.b && a.b.a.b && 1 === a.b.a.a && a.b.a.b.b && 2 === a.b.a.b.a && a.b.a.b.b.b && 3 === a.b.a.b.b.a && a.b.a.b.b.b.b && 4 === a.b.a.b.b.b.a && a.b.a.b.b.b.b.b && 5 === a.b.a.b.b.b.b.a && a.b.a.b.b.b.b.b.b && 6 === a.b.a.b.b.b.b.b.a && a.b.a.b.b.b.b.b.b.b && 7 === a.b.a.b.b.b.b.b.b.a && !a.b.a.b.b.b.b.b.b.b.b) return "on the first " + e(a.a.a.a) + " of the month";
            var i = a.a.a;
            return "on each " + r(a.b.a) + " of the month that is also a " + t(i);
        }(n);
    }, hA = function(n) {
        var e = n.d_, t = n.dV, r = n.n, a = n.N;
        return A2(R$, y([
            F$("ui segment")
        ]), y([
            A2(R$, y([
                F$("ui stackable sixteen column grid")
            ]), A2(tt, A2(R$, y([
                F$("row")
            ]), y([
                A2(R$, y([
                    F$("three wide column"),
                    A2(ew, "height", "5ex"),
                    A2(ew, "vertical-align", "middle")
                ]), y([
                    A2(ik, v, a)
                ])),
                A2(R$, y([
                    F$("five wide column")
                ]), y([
                    A2(ik, y([
                        F$("ui large text")
                    ]), y([
                        A2(Uk, v, r)
                    ]))
                ])),
                A2(R$, y([
                    F$("eight wide column")
                ]), y([
                    A2(ik, v, t)
                ]))
            ])), A2(Gr, R$(y([
                F$("row")
            ])), e)))
        ]));
    }, gA = F2(function(n, e) {
        return n ? e : v;
    }), vA = F3(function(n, e, t) {
        var r;
        return A2(gA, u(A2(Zi, function(n) {
            return n.gd;
        }, ay(n)), mt(!0)), y([
            A2(Gx, {
                cv: y([
                    F$("primary")
                ]),
                eO: (r = e, {
                    $: 15,
                    a: r
                }),
                eP: t
            }, y([
                A2(Z$, y([
                    F$("ui icon play small")
                ]), v),
                z$("Run this")
            ])),
            A2(Z$, y([
                F$("ui icon grey info circle"),
                wk("This will run the job on the current commit, so that you can test it without merging it into the default branch.\nIt does not run with extra privileges that may have been granted to jobs on the default branch.\nThe branch metadata passed to the Nix expression is accurate, but many effects may ignore this contextual information and run the same regardless of the branch.")
            ]), v)
        ]));
    }), pA = F3(function(n, e, t) {
        var r = A2(Sc, function(e) {
            var r = e.a, a = e.b;
            return y([
                hA({
                    dV: A3(vA, n, r, t),
                    d_: y([
                        y([
                            A2(R$, y([
                                F$("ui basic segment")
                            ]), y(a.gb ? [
                                A2(ik, v, y([
                                    z$("Runs at " + bA(a.hP))
                                ]))
                            ] : [
                                A2(ik, v, y([
                                    z$("This is a new scheduled job. To enable it, merge it into the default branch.")
                                ])),
                                A2(ik, v, y([
                                    z$("When merged, will run at " + bA(a.hP))
                                ]))
                            ]))
                        ])
                    ]),
                    N: y([
                        A2(Xw, y([
                            F$("ui ribbon label purple"),
                            wk("herculesCI.onSchedule." + r),
                            A2(ew, "white-space", "nowrap")
                        ]), y([
                            fS,
                            z$(" onSchedule")
                        ]))
                    ]),
                    n: y([
                        z$(r)
                    ])
                })
            ]);
        }, ut(e.gz)), a = A2(Sc, function(n) {
            var e = n.a;
            return y([
                hA({
                    dV: v,
                    d_: v,
                    N: y([
                        A2(Xw, y([
                            F$("ui ribbon label blue"),
                            wk("herculesCI.onPush." + e),
                            A2(ew, "white-space", "nowrap")
                        ]), y([
                            sS,
                            z$(" onPush")
                        ]))
                    ]),
                    n: y([
                        z$(e)
                    ])
                })
            ]);
        }, ut(e.gy));
        return A2(tt, A2(Pk, v, y([
            z$("Declared Jobs")
        ])), g(a, r));
    }), mA = F3(function(n, e, t) {
        var r = n.dd, a = e.at;
        switch(a.$){
            case 3:
                var i = a.a;
                return function(n) {
                    return p$(n.gy) && p$(n.gz);
                }(i) && function(n) {
                    var e = n.as.ie;
                    return 3 === e.$ && !!e.a.b.fj;
                }(e) ? y([
                    A2(R$, y([
                        F$("ui info message")
                    ]), y([
                        A2(R$, y([
                            F$("header")
                        ]), y([
                            z$("Empty configuration")
                        ])),
                        A2(ik, v, y([
                            z$("The repository does not declare any onPush or onSchedule jobs. Nothing will be done.")
                        ]))
                    ]))
                ]) : A3(pA, e, i, t);
            case 2:
                return y([
                    A2($k, r, a.a)
                ]);
            case 0:
                return v;
            default:
                return y([
                    A2(R$, y([
                        F$("ui placeholder")
                    ]), y([
                        A2(R$, y([
                            F$("line")
                        ]), v)
                    ]))
                ]);
        }
    }), yA = LT({
        cs: A2(Xw, v, v),
        a2: A2(Xw, v, v),
        V: A2(Z$, y([
            F$("ui icon big spinner loading"),
            wk("Evaluating")
        ]), v),
        bC: A2(Xw, v, v),
        ee: v
    }), $A = F2(function(n, e) {
        return n ? A2(U$, y([
            Gw(zu({
                cq: e.H,
                dC: e.dD
            }))
        ]), y([
            z$("View or create agents")
        ])) : z$("You don't have permission to view or create agents. Contact your organization administrator if more agents are needed.");
    }), wA = F2(function(n, e) {
        var t = e.as.ie;
        return 3 === t.$ ? t.a.b.f$ ? v : y([
            A2(R$, y([
                F$("ui positive message")
            ]), y([
                A2(R$, y([
                    F$("header")
                ]), y([
                    z$("Job is queued")
                ])),
                z$("This job is queued and will be evaluated when either"),
                A2(Xk, v, y([
                    A2(Qk, v, y([
                        z$("an x86_64-linux agent is added,")
                    ])),
                    A2(Qk, v, y([
                        z$("or an existing agent finishes its tasks.")
                    ]))
                ])),
                A2($A, n, e)
            ]))
        ]) : v;
    }), kA = {
        $: 11
    }, CA = F2(function(n, e) {
        return A2(xS, u(A2(Zi, function(n) {
            return n.gd;
        }, ay(n)), mt(!0)), A2(Gx, {
            cv: y([
                F$("primary fluid")
            ]),
            eO: kA,
            eP: e
        }, y([
            A2(Z$, y([
                F$("ui icon redo alternative")
            ]), v),
            z$("Re-run effects and failures")
        ])));
    }), xA = function(n) {
        switch(n){
            case 0:
            case 1:
                return "disabled";
            case 2:
                return "active";
            default:
                return "";
        }
    }, jA = F4(function(n, e, t, r) {
        return A2(R$, y([
            F$("step"),
            F$(n)
        ]), y([
            A2(Z$, y([
                F$(e)
            ]), v),
            A2(R$, y([
                F$("content")
            ]), y([
                A2(R$, y([
                    F$("title")
                ]), t),
                A2(R$, y([
                    F$("description")
                ]), r)
            ]))
        ]));
    }), qA = function(n) {
        if (n.fW) return A4(jA, "disabled", "icon sun outline", y([
            z$("Build")
        ]), y([
            z$("cancelled")
        ]));
        var e = n.f$;
        switch(e){
            case 0:
            case 1:
                return A4(jA, "disabled", "icon sun outline", y([
                    z$("Build")
                ]), v);
            default:
                var t = e;
                switch(n.cN){
                    case 0:
                        return A4(jA, xA(t), "icon sun outline loading", y([
                            z$("Build")
                        ]), y([
                            z$("building derivations")
                        ]));
                    case 1:
                        return A4(jA, xA(t), "icon sun outline red", y([
                            z$("Build")
                        ]), y([
                            z$("build failed")
                        ]));
                    default:
                        return A4(jA, xA(t), "icon sun outline green", y([
                            z$("Build")
                        ]), y([
                            z$("successful")
                        ]));
                }
        }
    }, SA = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return "disabled";
            case 3:
                return "active";
            default:
                return "";
        }
    }, IA = y([
        z$("Effects"),
        A2(R$, y([
            F$("floating ui small yellow label")
        ]), y([
            z$("BETA")
        ]))
    ]), TA = F2(function(n, e) {
        if (e.fW) return A4(jA, "disabled", "icon rocket", IA, y([
            z$("cancelled")
        ]));
        var t = e.f$;
        switch(t){
            case 0:
            case 1:
                return A4(jA, "disabled", "icon rocket", IA, v);
            case 2:
                return A4(jA, "disabled", "icon rocket", IA, y([
                    z$("awaiting build")
                ]));
            default:
                var r = t;
                switch(e.e7){
                    case 0:
                        return 3 === r ? A4(jA, SA(r), "icon rocket blue", IA, y([
                            z$("running effects")
                        ])) : A4(jA, SA(r), "icon rocket grey", IA, y([
                            z$("none")
                        ]));
                    case 1:
                        return A4(jA, SA(r), "icon rocket red", IA, y([
                            z$("failed")
                        ]));
                    default:
                        var a = n.as.ie;
                        return 3 === a.$ && It(A2(nl, function(n) {
                            return 4 === n.W;
                        }, a.a.c.cv)) > 0 ? A4(jA, SA(r), "icon rocket green", IA, y([
                            z$("successful")
                        ])) : A4(jA, SA(r), "icon rocket grey", IA, y([
                            z$("none")
                        ]));
                }
        }
    }), AA = function(n) {
        switch(n){
            case 0:
                return "disabled";
            case 1:
                return "active";
            default:
                return "";
        }
    }, EA = function(n) {
        if (n.fW) return A4(jA, "disabled", "icon snowflake", y([
            z$("Evaluation")
        ]), y([
            z$("cancelled")
        ]));
        var e = n.f$;
        if (!e) return A4(jA, "disabled", "icon snowflake", y([
            z$("Evaluation")
        ]), y([
            z$("needs agent")
        ]));
        var t = e;
        switch(n.fj){
            case 0:
                return A4(jA, AA(t), "icon snowflake blue loading", y([
                    z$("Evaluation")
                ]), y([
                    z$("evaluating expressions")
                ]));
            case 1:
                return A4(jA, AA(t), "icon snowflake red", y([
                    z$("Evaluation")
                ]), y([
                    z$("error in expressions")
                ]));
            default:
                return A4(jA, AA(t), "icon snowflake green", y([
                    z$("Evaluation")
                ]), y([
                    z$("successful")
                ]));
        }
    }, NA = F2(function(n, e) {
        return A2(R$, y([
            F$("ui steps")
        ]), y([
            EA(e),
            qA(e),
            A2(TA, n, e)
        ]));
    }), LA = F2(function(n, e) {
        var t = n.hZ, r = n.fD, a = n.dd, i = n.ig, u = A2(Sc, function(n) {
            return A2(g$, 1, g(A2(Sc, lA, _t(n.c.fg)), y([
                yA
            ])));
        }, A2(nl, function(n) {
            var e = n.b;
            return !e.fj && !e.fW;
        }, Rl(fd(e.as.ie)))), c = Ek(e.bu), o = c.a, s = c.b, f = Ek(e.bt), l = f.a, b = f.b, h = Ek(e.as.ie), p = h.a, m = h.b, $ = Ek(e.bM), w = $.a, k = $.b, C = A2(Gr, $k(a), Lk(y([
            l,
            o,
            w,
            p
        ]))), x = function() {
            var n = e.as.ie;
            if (3 === n.$) {
                var t = n.a.b;
                return y([
                    A2(R$, y([
                        F$("ui bottom attached segment"),
                        A2(ew, "display", "flex"),
                        A2(ew, "justify-content", "space-between"),
                        A2(ew, "align-items", "center")
                    ]), y([
                        A2(NA, e, t),
                        A2(R$, y([
                            A2(ew, "display", "flex"),
                            A2(ew, "flex-direction", "column"),
                            A2(ew, "gap", "0.5em")
                        ]), g(A2(CA, e, b), A2(rA, e, k)))
                    ]))
                ]);
            }
            return v;
        }(), j = g(x, g(C, g(A2(la, v, A2(Zi, function(n) {
            return y([
                A2(kT, i, n)
            ]);
        }, e.a6)), A2(tt, A2(wT, {
            ig: i
        }, e), function(n) {
            switch(n.$){
                case 2:
                case 1:
                case 0:
                    return v;
                default:
                    return A2(Gr, oA, n.a.c.gh);
            }
        }(m))))), q = function() {
            switch(m.$){
                case 2:
                default:
                    return v;
                case 3:
                    var n = m.a, c = n.a, o = n.b, f = n.c, l = function() {
                        var n, t = ka(A2(Gr, function(n) {
                            return d(n.bp, A3(XT, e, f, n));
                        }, f.cv)), r = ka(A2(Gr, function(n) {
                            return d(n.bp, A3(fA, e, o, n));
                        }, f.fP));
                        return n = qc(cd(A2(CT, t, r))), y([
                            nA,
                            A2(Dk, y([
                                F$("ui unstackable shadowed table")
                            ]), y([
                                A2(Fk, v, y([
                                    A2(Rk, y([
                                        F$("center aligned")
                                    ]), y([
                                        A2(_k, y([
                                            F$("one wide")
                                        ]), y([
                                            z$("Status")
                                        ])),
                                        A2(_k, y([
                                            F$("six wide")
                                        ]), y([
                                            z$("Attribute")
                                        ])),
                                        A2(_k, y([
                                            F$("five wide")
                                        ]), y([
                                            z$("Derivation")
                                        ])),
                                        A2(_k, y([
                                            F$("three wide")
                                        ]), y([
                                            z$("Actions")
                                        ]))
                                    ]))
                                ])),
                                A2(Ok, v, g(n, u))
                            ]))
                        ]);
                    }, b = d(A2(uc, function(n) {
                        return A3(iS, i, n, c);
                    }, e.a6), f.cv);
                    return b.a.$ ? g(j, g(A2(cA, e, f), b.b.b ? g(l(), A4(yT, {
                        hZ: t,
                        dd: a
                    }, e, o, f)) : g(A3(mA, {
                        dd: a
                    }, e, s), g(A2(wA, r, e), g(function() {
                        var n = d(o.fj, o.f$);
                        switch(n.a){
                            case 0:
                                return n.b ? l() : v;
                            case 1:
                                return f.gh.b ? v : y([
                                    A2(R$, y([
                                        F$("ui warning message")
                                    ]), y([
                                        A2(R$, y([
                                            F$("header")
                                        ]), y([
                                            z$("Evaluation failed")
                                        ])),
                                        z$("Please make sure your job has at least one derivation. See also "),
                                        A2(U$, y([
                                            Ow("https://docs.hercules-ci.com/hercules-ci/troubleshooting/#why-is-my-attribute-not-in-eval")
                                        ]), y([
                                            z$("Why doesn\u2019t my attribute show up in the evaluation?")
                                        ]))
                                    ]))
                                ]);
                            default:
                                switch(o.f1){
                                    case 0:
                                        return v;
                                    case 1:
                                        return y([
                                            A2(Pk, v, y([
                                                A2(U$, y([
                                                    Ow("https://docs.hercules-ci.com/hercules-ci/troubleshooting/#why-is-my-attribute-not-in-eval")
                                                ]), y([
                                                    z$("Evaluation succeeded and yet produced no attributes.")
                                                ]))
                                            ]))
                                        ]);
                                    default:
                                        return y([
                                            A2(R$, y([
                                                F$("ui warning message")
                                            ]), y([
                                                A2(R$, y([
                                                    F$("header")
                                                ]), y([
                                                    z$("This job does not contain any builds or effects.")
                                                ]))
                                            ]))
                                        ]);
                                }
                        }
                    }(), A4(yT, {
                        hZ: t,
                        dd: a
                    }, e, o, f)))))) : y([
                        b.a.a
                    ]);
                case 1:
                    return y([
                        A2(R$, y([
                            F$("ui loader active massive text")
                        ]), y([
                            z$("Loading evaluation")
                        ]))
                    ]);
            }
        }();
        return q;
    }), PA = F2(function(n, e) {
        return A2(LA, {
            hZ: n.c_.hZ,
            ig: n.ig,
            fD: !u(A2(pl, n, {
                cq: e.H,
                dC: e.dD
            }), yt),
            dd: fk(n)
        }, e);
    }), DA = F2(function(n, e) {
        return A2(R$, v, y([
            A2(wT, n, e),
            A2(rS, mk, y([
                z$("Please follow the instructions to"),
                A2(U$, y([
                    Gw(Hu({
                        cq: e.H,
                        dC: e.dD
                    }))
                ]), y([
                    z$(" set up an Agent.")
                ]))
            ]))
        ]));
    }), OA = F2(function(n, e) {
        return {
            q: Mq(e.a1) ? A2(DA, {
                ig: n.ig
            }, e) : A2(R$, v, A3(bT, n.ci, !0, A2(PA, n, e))),
            e: "Job #" + Ct(e.au)
        };
    }), GA = function(n) {
        var e = d(n.bC.gx, n.bC.e9);
        if (e.b.$) {
            if (e.a.$) return A2(Xw, v, v);
            var t = e.a.a;
            return A2(Xw, v, y([
                A2(Xw, y([
                    F$("ui text small")
                ]), y([
                    ZT(n)
                ])),
                A2(Xw, y([
                    A2(ew, "user-select", "contain")
                ]), y([
                    z$(t.a9)
                ]))
            ]));
        }
        var r = e.b.a;
        return A2(Xw, v, y([
            A2(Xw, y([
                F$("ui text small")
            ]), y([
                ZT(n)
            ])),
            A2(Xw, y([
                A2(ew, "user-select", "contain")
            ]), y([
                z$(r.fb)
            ]))
        ]));
    }, _A = function(n) {
        var e = d(n.cy, n.ct);
        if (1 === e.a.$) {
            if (1 === e.b.$) return A2(Xw, v, v);
            var t = e.b.a;
            return A2(Xw, v, y([
                A2(Xw, y([
                    A2(ew, "user-select", "none")
                ]), y([
                    z$("Added: ")
                ])),
                GA(t)
            ]));
        }
        if (1 === e.b.$) return t = e.a.a, A2(Xw, v, y([
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("Removed: ")
            ])),
            GA(t)
        ]));
        t = e.a.a;
        var r = e.b.a;
        return A2(Xw, v, y([
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("Before: ")
            ])),
            GA(t),
            A2(ET, v, v),
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("After: ")
            ])),
            GA(r)
        ]));
    }, FA = function(n) {
        var e = d(n.cy, n.ct);
        if (1 === e.a.$) return 1 !== e.b.$;
        if (1 === e.b.$) return !0;
        var t = e.a.a, r = e.b.a;
        return !u(t.W, r.W) || !u(A2(Zi, function(n) {
            return n.V;
        }, t.bC.gx), A2(Zi, function(n) {
            return n.V;
        }, r.bC.gx)) || !u(A2(Zi, function(n) {
            return n.fd;
        }, t.bC.e9), A2(Zi, function(n) {
            return n.fd;
        }, r.bC.e9));
    }, RA = function(n) {
        return 1 === n.$ ? A2(kk, "", "") : ZT(n.a);
    }, BA = function(n) {
        var e = n.ct, t = n.cy;
        return A2(R$, y([
            A2(ew, "display", "block"),
            A2(ew, "height", "4ex"),
            A2(ew, "position", "relative")
        ]), y([
            A2(R$, y([
                A2(ew, "position", "absolute"),
                A2(ew, "bottom", "0px"),
                A2(ew, "right", "0px")
            ]), y([
                A2(Xw, y([
                    F$("ui text tiny")
                ]), y([
                    t
                ]))
            ])),
            e
        ]));
    }, HA = function(n) {
        return BA({
            ct: RA(n.ct),
            cy: FA(n) ? RA(n.cy) : A2(Xw, v, v)
        });
    }, VA = function(n) {
        var e = d(n.cy, n.ct);
        return 1 === e.a.$ ? F$(1 === e.b.$ ? "" : "green") : 1 === e.b.$ ? F$("red") : u(e.a.a, e.b.a) ? F$("") : F$("yellow");
    }, zA = F2(function(n, e) {
        var t, r = F2(function(n, e) {
            return A2(Z$, y([
                F$("ui icon"),
                F$(n),
                wk(e)
            ]), v);
        }), a = 1 === (t = d(n.cy, n.ct)).a.$ ? 1 === t.b.$ ? A2(r, "question", "No value") : A2(r, "plus", "Added") : 1 === t.b.$ ? A2(r, "minus", "Removed") : u(t.a.a, t.b.a) ? A2(r, "", "Unchanged") : A2(r, "pen", "Changed");
        return A2(R$, y([
            F$("ui segment"),
            VA(n),
            A2(ew, "border-top-left-radius", "0")
        ]), A2(tt, A2(Xw, y([
            F$("ui left corner label"),
            A2(ew, "top", "-0.1rem"),
            VA(n)
        ]), y([
            a
        ])), e));
    }), UA = function(n) {
        return A2(zA, n.bC, y([
            A2(R$, y([
                F$("ui grid"),
                A2(ew, "padding-left", "2em")
            ]), y([
                A2(R$, y([
                    F$("one wide column")
                ]), y([
                    HA(n.bC)
                ])),
                A2(R$, y([
                    F$("four wide column")
                ]), y([
                    A2(Kk, v, y([
                        KT(n.bp)
                    ]))
                ])),
                A2(R$, y([
                    F$("ten wide column")
                ]), y([
                    A2(R$, y([
                        F$("ui basic segment")
                    ]), y([
                        _A(n.bC)
                    ]))
                ]))
            ]))
        ]));
    }, WA = function(n) {
        return n.$ ? A2(kk, "", "") : qk(n.a);
    }, KA = function(n) {
        return BA({
            ct: WA(A2(Zi, function(n) {
                return n.a8.V;
            }, n.ct)),
            cy: WA(A2(Zi, function(n) {
                return n.a8.V;
            }, n.cy))
        });
    }, ZA = function(n) {
        return A2(Xw, v, y([
            qk(n.a8.V),
            A2(Xw, y([
                A2(ew, "user-select", "contain")
            ]), y([
                z$(n.a8.a9)
            ]))
        ]));
    }, YA = function(n) {
        return A2(Xw, v, y([
            A2(Xw, y([
                A2(ew, "user-select", "contain")
            ]), y([
                z$(n.a8.a9)
            ]))
        ]));
    }, MA = function(n) {
        var e = d(n.cy, n.ct);
        if (1 === e.a.$) {
            if (1 === e.b.$) return A2(Xw, v, v);
            var t = e.b.a;
            return A2(Xw, v, y([
                A2(Xw, y([
                    A2(ew, "user-select", "none")
                ]), y([
                    z$("Added: ")
                ])),
                YA(t)
            ]));
        }
        if (1 === e.b.$) return t = e.a.a, A2(Xw, v, y([
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("Removed: ")
            ])),
            YA(t)
        ]));
        var r = e.b.a, a = u((t = e.a.a).a8.V, r.a8.V) ? YA : ZA;
        return A2(Xw, v, y([
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("Before: ")
            ])),
            a(t),
            A2(ET, v, v),
            A2(Xw, y([
                A2(ew, "user-select", "none")
            ]), y([
                z$("After: ")
            ])),
            a(r)
        ]));
    }, JA = function(n) {
        return A2(zA, n, y([
            A2(R$, y([
                F$("ui grid"),
                A2(ew, "padding-left", "2em")
            ]), y([
                A2(R$, y([
                    F$("one wide column")
                ]), y([
                    KA(n)
                ])),
                A2(R$, y([
                    F$("fourteen wide column")
                ]), y([
                    A2(R$, y([
                        F$("ui basic segment")
                    ]), y([
                        MA(n)
                    ]))
                ]))
            ]))
        ]));
    }, QA = A2(Pk, v, y([
        z$("Import From Derivation")
    ])), XA = F2(function(n, e) {
        return u(e.ex, e.en) ? y([
            A2(R$, y([
                F$("ui segment")
            ]), y([
                z$("Comparing the same job; select a different one by clicking the Compare tab.")
            ]))
        ]) : A2(tt, nA, g(function(n) {
            return aq(n.cv) ? y([
                A2(R$, y([
                    F$("ui basic segment")
                ]), y([
                    z$("No changes")
                ]))
            ]) : A2(Gr, UA, n.cv);
        }(e), A2(tt, QA, function(n) {
            return aq(n.fQ) ? y([
                A2(R$, y([
                    F$("ui basic segment")
                ]), y([
                    z$("No changes")
                ]))
            ]) : A2(Gr, JA, n.fQ);
        }(e))));
    }), nE = function(n) {
        var e = function(n) {
            var e = d(n.am, n.aj);
            if (3 === e.a.$ && 3 === e.b.$) {
                var t = e.b.a;
                return mt(Mu({
                    cq: t.dr,
                    ew: mt(e.a.a.c),
                    ab: t.ab,
                    br: t.dy,
                    dC: t.ft
                }));
            }
            return yt;
        }(n);
        return e.$ ? v : y([
            Gw(e.a)
        ]);
    }, eE = F2(function(n, e) {
        return A2(R$, y([
            F$("column")
        ]), y([
            A2(R$, y([
                F$("ui header")
            ]), y([
                z$(n)
            ])),
            A2(ET, v, v),
            A2(ET, v, v),
            A2(ik, v, y([
                z$("Commit: "),
                A2(Uk, v, y([
                    z$(e.dF.g6)
                ]))
            ])),
            A2(ET, v, v),
            A2(ET, v, v),
            A2(ik, v, y([
                A2(Uk, y([
                    A2(ew, "white-space", "pre-wrap")
                ]), y([
                    z$(e.dF.bl)
                ]))
            ]))
        ]));
    }), tE = F3(function(n, e, t) {
        return A2(R$, y([
            F$("ui two column stackable grid")
        ]), y([
            A2(R$, y([
                F$("ui vertical divider")
            ]), y([
                A2(U$, nE(n), y([
                    A2(Z$, y([
                        F$("ui icon exchange alternate"),
                        A2(ew, "margin", "0"),
                        A2(ew, "margin-top", "-1ex")
                    ]), v)
                ]))
            ])),
            A2(R$, y([
                F$("row")
            ]), y([
                A2(eE, "Current Job, #" + Ct(e.ab), e),
                A2(eE, "Baseline Job, #" + Ct(t.ab), t)
            ]))
        ]));
    }), rE = {
        $: 7
    }, aE = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iE = function(n) {
        return d(n, !0);
    }, uE = function(n) {
        var e, t, r = (e = n.b1).$ ? rE : {
            $: 5,
            a: e.a
        }, a = Ek(n.a5), i = a.a, u = a.b;
        return A2(R$, y([
            F$("ui segment bottom attached")
        ]), y([
            i.$ ? z$("") : A2($k, !0, i.a),
            A2(Pk, y([
                F$("ui header")
            ]), y([
                z$("Baseline Job")
            ])),
            A2(Wj, y([
                F$("ui form"),
                (t = r, A2(aT, "submit", A2(lr, iE, br(t))))
            ]), y([
                A2(R$, y([
                    F$("inline field")
                ]), y([
                    A2(jx, v, y([
                        z$("Job index to compare against")
                    ])),
                    A2(R$, y([
                        F$("ui action input")
                    ]), y([
                        A2(Ew, y([
                            nq(A2(ao, aE, jr))
                        ]), v),
                        A2(Gx, {
                            cv: n.b1.$ ? y([
                                Cx(!0)
                            ]) : v,
                            eO: r,
                            eP: u
                        }, y([
                            z$("Compare")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }, cE = function(n) {
        return A2(R$, y([
            F$("ui segment bottom attached")
        ]), y([
            A3(Tx, !0, "Could not load jobs", n)
        ]));
    }, oE = A2(R$, y([
        F$("ui segment bottom attached")
    ]), y([
        A2(R$, y([
            F$("ui placeholder")
        ]), y([
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v),
            A2(R$, y([
                F$("line")
            ]), v)
        ]))
    ])), sE = F2(function(n, e) {
        return A2(R$, v, A3(bT, n, !0, A2(tt, function(n) {
            var e = d(n.am, n.aj);
            n: for(;;){
                e: for(;;){
                    t: for(;;){
                        r: for(;;)switch(e.a.$){
                            case 3:
                                switch(e.b.$){
                                    case 3:
                                        var t = e.a.a, r = e.b.a;
                                        return A2(R$, y([
                                            F$("ui segment bottom attached")
                                        ]), y([
                                            A2(Xw, y([
                                                A2(ew, "display", "inline-block"),
                                                A2(ew, "max-width", "0")
                                            ]), y([
                                                A2(Xw, y([
                                                    F$("ui ribbon label green")
                                                ]), y([
                                                    A2(Z$, y([
                                                        F$("ui icon white plus")
                                                    ]), v)
                                                ]))
                                            ])),
                                            A2(Xw, y([
                                                F$("ui right ribbon label red")
                                            ]), y([
                                                A2(Z$, y([
                                                    F$("ui icon white minus")
                                                ]), v)
                                            ])),
                                            A3(tE, n, t, r)
                                        ]));
                                    case 1:
                                        break n;
                                    case 2:
                                        break t;
                                    default:
                                        break r;
                                }
                            case 1:
                                return oE;
                            case 2:
                                if (1 === e.b.$) break n;
                                break e;
                            default:
                                switch(e.b.$){
                                    case 1:
                                        break n;
                                    case 2:
                                        break t;
                                    default:
                                        break r;
                                }
                        }
                        return uE(n);
                    }
                    return cE(e.b.a);
                }
                return cE(e.a.a);
            }
            return oE;
        }(e), function(n) {
            var e = n.bV;
            return 3 === e.$ ? A2(XA, n, e.a) : y([
                Hj(e)
            ]);
        }(e))));
    }), fE = F2(function(n, e) {
        return {
            q: A2(sE, n.ci, e),
            e: "Comparing " + e.ci.br + "#" + Ct(e.ci.ab)
        };
    }), lE = function(n) {
        switch(n){
            case 0:
                return "Waiting";
            case 1:
                return "Running";
            case 4:
                return "Success";
            case 2:
                return "Failed";
            case 3:
                return "Dependency failed";
            default:
                return "Cancelled";
        }
    }, dE = {
        $: 6
    }, bE = F2(function(n, e) {
        return A2(Gr, function(n) {
            return A2(Gx, {
                cv: y([
                    F$("yellow fluid")
                ]),
                eO: dE,
                eP: e
            }, y([
                tA(v),
                z$(n)
            ]));
        }, function(n) {
            if (!n.j.bk) return v;
            switch(n.j.V){
                case 0:
                case 1:
                    return y([
                        "Cancel"
                    ]);
                default:
                    return v;
            }
        }(n));
    }), hE = F2(function(n, e) {
        return A2(Z$, y([
            F$("ui icon big " + n),
            wk(e)
        ]), v);
    }), gE = function(n) {
        switch(n){
            case 0:
                return A2(hE, "spinner loading", lE(n));
            case 1:
                return A2(hE, "sun outline loading", lE(n));
            case 4:
                return A2(hE, "check green circle", lE(n));
            case 2:
                return A2(hE, "times red circle", lE(n));
            case 3:
                return A2(hE, "times red circle outline", lE(n));
            default:
                return xk(y([
                    F$("big"),
                    wk(lE(n))
                ]));
        }
    }, vE = F3(function(n, e, t) {
        return Fu({
            cq: n.dT,
            eZ: !1,
            a9: e,
            dC: n.ci.dC,
            eb: A2(la, 0, A2(Zi, Bk, t)),
            dS: A2(Zi, function(n) {
                return n.b.c;
            }, fd(n.aN))
        });
    }), pE = F3(function(n, e, t) {
        return A2(U$, y([
            Gw(A3(vE, n, e, t))
        ]), y([
            z$(e)
        ]));
    }), mE = F2(function(n, e) {
        var t = A2(Gr, function(e) {
            var t;
            return A2(Rk, v, y([
                A2(Gk, y([
                    F$("center aligned")
                ]), y([
                    qk(e.cN)
                ])),
                A2(Gk, v, y([
                    A3(pE, n, e.a9, mt(e.cN))
                ])),
                A2(Gk, v, y([
                    (t = e.af, "out" === t ? A2(Xw, y([
                        F$("ui text grey")
                    ]), y([
                        z$(t)
                    ])) : z$(t))
                ])),
                A2(Gk, v, y([
                    z$(e.bm)
                ]))
            ]));
        }, e.j.c5);
        return A2(Dk, y([
            F$("ui unstackable table")
        ]), y([
            A2(Fk, v, y([
                A2(Rk, y([
                    F$("center aligned")
                ]), y([
                    A2(_k, y([
                        F$("one wide")
                    ]), y([
                        z$("Status")
                    ])),
                    A2(_k, y([
                        F$("six wide")
                    ]), y([
                        z$("Derivation")
                    ])),
                    A2(_k, y([
                        F$("one wide")
                    ]), y([
                        z$("Output")
                    ])),
                    A2(_k, y([
                        F$("six wide")
                    ]), y([
                        z$("Output path")
                    ]))
                ]))
            ])),
            A2(Ok, v, t)
        ]));
    }), yE = F2(function(n, e) {
        var t;
        return A2(Dk, y([
            F$("ui structured collapsing table")
        ]), y([
            A2(Ok, v, y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Kk, v, y([
                            z$("Platform")
                        ]))
                    ])),
                    A2(Gk, v, y([
                        A2(Uk, v, y([
                            z$(e.j.bq)
                        ]))
                    ]))
                ])),
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(2)
                    ]), y([
                        A2(Kk, v, y([
                            z$("Required system features")
                        ]))
                    ])),
                    A2(Gk, v, (t = e.j.bs, t.b ? A2(Jw, z$(", "), A2(Gr, function(n) {
                        return A2(Uk, v, y([
                            z$(n)
                        ]));
                    }, t)) : y([
                        A2(Z$, v, y([
                            z$("(none)")
                        ]))
                    ])))
                ]))
            ]))
        ]));
    }), $E = F2(function(n, e) {
        return y([
            A2(yE, n, e),
            A2(Pk, v, y([
                z$("Inputs")
            ])),
            A2(mE, n, e)
        ]);
    }), wE = function(n) {
        return A2(R$, y([
            F$("event")
        ]), y([
            A2(R$, y([
                F$("label")
            ]), n.N),
            A2(R$, y([
                F$("content")
            ]), A2(tt, A2(R$, y([
                F$("summary")
            ]), n.Q), A2(tt, A2(R$, y([
                F$("meta")
            ]), n.O), Rl(A2(Zi, R$(y([
                F$("extra")
            ])), n.K)))))
        ]));
    }, kE = F2(function(n, e) {
        var t = e.dO;
        if (1 === t.$) return wE({
            K: yt,
            N: y([
                A2(Z$, y([
                    F$("ui icon red circle times")
                ]), v)
            ]),
            O: y([
                A2(wC, n, e.f)
            ]),
            Q: y([
                z$("Failed")
            ])
        });
        var r = t.a;
        return wE({
            K: mt(y([
                A2(R$, y([
                    F$("ui message error")
                ]), y([
                    A2(ik, v, y([
                        z$(r)
                    ]))
                ]))
            ])),
            N: y([
                A2(Z$, y([
                    F$("ui icon red circle bolt")
                ]), v)
            ]),
            O: y([
                A2(wC, n, e.f)
            ]),
            Q: y([
                z$("Technical error")
            ])
        });
    }), CE = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), xE = F2(function(n, e) {
        return {
            $: 11,
            a: n,
            b: e
        };
    }), jE = F5(function(n, e, t, r, a) {
        return A7(ju, "GET", "/api/v1/jobs/{jobId}/effects/{attribute}/log/raw", y([
            d("jobId", n),
            d("attribute", e)
        ]), y([
            d("logId", mt(t)),
            d("iMin", A2(Zi, Ct, r)),
            d("verbosity", A2(Zi, jg, a))
        ]), v, yt, ta);
    }), qE = F4(function(n, e, t, r) {
        var a;
        return a = A2(la, Qr, A2(Zl, r.di, e.al)), A2(Ax, {
            c: r.di,
            ja: function() {
                return Ig;
            },
            jc: CE(r.di),
            je: xE(r.di)
        }, {
            im: function() {
                return IC(A2(_o, n.hZ, A5(jE, t.as.c, ku(_l(e.ci.a2)), r.di, yt, yt)));
            },
            dd: n.dd,
            iI: !0,
            iN: a,
            jn: A2(au, r.di, e.ca),
            aT: A2(la, !0, A2(au, r.di, e.aT)),
            jW: yt
        });
    }), SE = F4(function(n, e, t, r) {
        return g(A2(Gr, function(e) {
            return wE({
                K: yt,
                N: y([
                    A2(Z$, y([
                        F$("ui icon green circle check")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Succeeded")
                ])
            });
        }, Rl(r.dK)), g(A2(Gr, function(e) {
            return wE({
                K: u(t.j.hL, v) && u(t.j.hM, v) ? yt : mt(A2(tt, z$("Waiting for: "), g(A2(Jw, z$(", "), A2(Gr, function(n) {
                    return A2(U$, y([
                        Gw(Ju({
                            cq: n.as.br.bn.n,
                            a2: n.et,
                            ab: n.as.ab,
                            br: n.as.br.n,
                            dC: n.as.br.bn.dC.n,
                            eb: 1
                        }))
                    ]), y([
                        z$(n.as.br.n + "#" + Ct(n.as.ab) + "/" + _l(n.et))
                    ]));
                }, t.j.hL)), g(u(t.j.hM, v) || u(t.j.hL, v) ? v : y([
                    z$(", and jobs: ")
                ]), A2(Jw, z$(", "), A2(Gr, function(n) {
                    return A2(U$, y([
                        Gw(Yu({
                            cq: n.br.bn.n,
                            ab: n.ab,
                            br: n.br.n,
                            dC: n.br.bn.dC.n
                        }))
                    ]), y([
                        z$(n.br.n + "#" + Ct(n.ab))
                    ]));
                }, A2($j, function(n) {
                    return n.ab;
                }, t.j.hM))))))),
                N: y([
                    A2(Z$, y([
                        F$("ui icon ellipsis horizontal")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Queued")
                ])
            });
        }, Rl(r.dv)), g(A2(Gr, function(r) {
            return wE({
                K: mt(A2(tt, A2(ik, v, y([
                    z$("Agent: "),
                    A2(Uk, v, y([
                        z$(r.a_)
                    ]))
                ])), A4(qE, n, e, t, r))),
                N: y([
                    A2(Z$, y([
                        F$("ui icon sun outline")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, r.f)
                ]),
                Q: y([
                    z$("Created")
                ])
            });
        }, Rl(r.dI)), g(A2(Gr, function(e) {
            return A2(kE, n.jS, e);
        }, Rl(r.cZ)), g(A2(Gr, function(e) {
            return wE({
                K: yt,
                N: y([
                    A2(Z$, y([
                        F$("ui icon times red circle outline")
                    ]), v)
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Dependency failed")
                ])
            });
        }, Rl(r.cM)), A2(Gr, function(e) {
            return wE({
                K: yt,
                N: y([
                    xk(y([
                        A2(ew, "margin-left", "0.4rem")
                    ]))
                ]),
                O: y([
                    A2(wC, n.jS, e.f)
                ]),
                Q: y([
                    z$("Cancelled")
                ])
            });
        }, Rl(r.cA)))))));
    }), IE = F4(function(n, e, t, r) {
        return A2(R$, y([
            F$("ui feed")
        ]), A2(Sc, A3(SE, n, e, t), r));
    }), TE = F3(function(n, e, t) {
        var r = _t(t.j.cV);
        if (r.b) {
            if (r.b.b) {
                var a = r.a, i = r.b;
                return A2(tt, A2(R$, y([
                    F$("ui vertical segment")
                ]), y([
                    A4(IE, n, e, t, a)
                ])), A2(Gr, function(r) {
                    return A2(R$, y([
                        F$("ui vertical segment")
                    ]), y([
                        A2(Pk, v, y([
                            z$("Previous attempt")
                        ])),
                        A4(IE, n, e, t, r)
                    ]));
                }, i));
            }
            return y([
                A4(IE, n, e, t, r.a)
            ]);
        }
        return y([
            z$("No events / No events yet")
        ]);
    }), AE = {
        $: 4
    }, EE = F2(function(n, e) {
        return A2(Gr, function(n) {
            return A2(Gx, {
                cv: y([
                    F$("primary fluid")
                ]),
                eO: AE,
                eP: e
            }, y([
                A2(Z$, y([
                    F$("ui icon redo alternative")
                ]), v),
                z$(n)
            ]));
        }, v);
    }), NE = F4(function(n, e, t, r) {
        var a, i = Ju(h(n.ci, {
            eb: e
        }));
        return A2(R$, A2(tt, Nw({
            $: 3,
            a: e
        }), g((a = u(n.ci.eb, e), A2(nl, function() {
            return a;
        }, y([
            F$("active")
        ]))), t)), y([
            A2(U$, y([
                Gw(i)
            ]), r)
        ]));
    }), LE = F3(function(n, e, t) {
        var r = Ek(e.ch), a = r.a, i = r.b, u = A2(Gr, $k(n.dd), Lk(y([
            a
        ]))), c = Ek(e.bN).b;
        return A2(R$, v, y([
            A2(R$, y([
                A2(ew, "float", "right"),
                A2(ew, "width", "14em")
            ]), g(A2(EE, t, i), A2(bE, t, c))),
            A2(ck, y([
                F$("ui large header")
            ]), y([
                gE(t.j.V),
                z$(lE(t.j.V))
            ])),
            A2(R$, v, u),
            A2(R$, y([
                F$("ui big top attached tabular small menu")
            ]), y([
                A4(NE, e, 0, y([
                    F$("item right")
                ]), y([
                    A2(Z$, y([
                        F$("ui icon info circle black")
                    ]), v),
                    z$("Info")
                ])),
                A4(NE, e, 1, y([
                    F$("item ")
                ]), y([
                    A2(Z$, y([
                        F$("ui icon clipboard list black")
                    ]), v),
                    z$("Log")
                ]))
            ])),
            A2(R$, y([
                F$("ui bottom attached active tab segment")
            ]), e.ci.eb ? A3(TE, n, e, t) : A2($E, e, t))
        ]));
    }), PE = F2(function(n, e) {
        var t = lf(e);
        switch(t.$){
            case 3:
                return A3(LE, n, e, t.a);
            case 2:
                return A2($k, n.dd, t.a);
            default:
                return z$("Loading...");
        }
    }), DE = F2(function(n, e) {
        return {
            q: A2(PE, {
                hZ: n.c_.hZ,
                dd: fk(n),
                jS: n.jS
            }, e),
            e: e.ci.br + "#" + Ct(e.ci.ab) + " " + _l(e.ci.a2)
        };
    }), OE = A2(R$, v, y([
        z$("Redirecting...")
    ])), GE = F2(function() {
        return {
            q: OE,
            e: "Redirecting..."
        };
    }), _E = A2(R$, y([
        F$("ui segment")
    ]), y([
        A2(ck, v, y([
            z$("404 Not Found")
        ]))
    ])), FE = function(n) {
        var e, t = function() {
            switch(n.by){
                case 2:
                    return n.ck ? 0 : 1;
                case 0:
                    return n.ck ? 1 : 2;
                default:
                    return n.ck ? 2 : 0;
            }
        }(), r = function() {
            switch(n.by){
                case 0:
                    return d("sun icon", "Light");
                case 1:
                    return d("moon icon", "Dark");
                default:
                    return d("adjust icon", "Auto");
            }
        }(), a = r.a, i = r.b;
        return A2(R$, y([
            F$("ui toggle checkbox"),
            X$(y([
                d("indeterminate", 2 === n.by)
            ])),
            Nw(n.jf(t))
        ]), y([
            A2(Ew, y([
                Lw("checkbox"),
                F$("hidden"),
                vx(n.iB),
                kx(!n.by),
                A2(zj, "indeterminate", (e = 2 === n.by, e ? "true" : "false")),
                A2(aT, "click", br(d(n.jf(t), !0)))
            ]), v),
            A2(jx, y([
                xx(n.iB)
            ]), y([
                A2(Z$, y([
                    F$(a)
                ]), v),
                z$(" " + i)
            ]))
        ]));
    }, RE = function(n) {
        var e = n.ci, t = n.q, r = n.e, a = F2(function(n, t) {
            return A2(U$, y([
                X$(y([
                    d("item", !0),
                    d("active", u(e, n))
                ])),
                Gw(n)
            ]), y([
                z$(t)
            ]));
        });
        return function(n) {
            var e = n.q, t = n.gg, r = n.e;
            return {
                q: A2(R$, y([
                    F$("ui grid")
                ]), y([
                    A2(R$, y([
                        F$("four wide column")
                    ]), y([
                        A2(R$, y([
                            F$("ui vertical menu")
                        ]), t)
                    ])),
                    A2(R$, y([
                        F$("twelve wide column")
                    ]), A2(tt, A2(NI, v, y([
                        z$(r)
                    ])), e))
                ])),
                e: r
            };
        }({
            q: t,
            gg: y([
                A2(R$, y([
                    F$("header item")
                ]), y([
                    z$("Personal Settings")
                ])),
                A2(a, ec, "CLI Tokens"),
                A2(a, nc, "Notifications"),
                A2(a, Xu, "Appearance")
            ]),
            e: r
        });
    }, BE = F2(function(n) {
        return RE({
            q: y([
                A2(R$, y([
                    F$("ui segment")
                ]), y([
                    A2(Pk, v, y([
                        z$("Theme")
                    ])),
                    A2(ik, v, y([
                        z$("Choose how Hercules CI looks to you. Select a single theme, or sync with your system settings.")
                    ])),
                    A2(R$, y([
                        F$("ui info message")
                    ]), y([
                        A2(R$, y([
                            F$("header")
                        ]), y([
                            z$("Dark mode beta")
                        ])),
                        A2(ik, v, y([
                            z$("Dark mode is an opt-in beta. Auto defaults to the light theme while dark mode is in beta, intentionally disregarding the system/browser setting for the time being.")
                        ]))
                    ])),
                    A2(R$, y([
                        A2(ew, "margin-top", "1.5em")
                    ]), y([
                        FE({
                            iB: "personal-appearance-theme",
                            jf: gr,
                            ck: n.ck,
                            by: n.by
                        })
                    ]))
                ]))
            ]),
            ci: Xu,
            e: "Appearance"
        });
    }), HE = F2(function(n, e) {
        return A2(BE, n, e);
    }), VE = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), zE = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), UE = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), WE = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), KE = function(n) {
        return A2(sd, v, A2(Af, function(n) {
            return n.eu;
        }, n.Z));
    }, ZE = F2(function(n, e) {
        switch(e.$){
            case 1:
            default:
                return A2(Z$, A2(tt, F$("ui icon"), n), v);
            case 3:
                return A2(Z$, A2(tt, F$("ui icon primary check"), n), v);
            case 2:
                return A2(Z$, A2(tt, F$("ui icon red times"), n), v);
        }
    })(y([
        A2(ew, "position", "absolute"),
        A2(ew, "margin-left", "-0.7em"),
        A2(ew, "margin-top", "-0.4em"),
        A2(ew, "pointer-events", "none")
    ])), YE = function(n) {
        var e = function(n) {
            return y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(4),
                        A2(ew, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, t = y([
            A2(_k, y([
                F$("four wide")
            ]), y([
                z$("Subject")
            ])),
            A2(_k, y([
                F$("six wide")
            ]), y([
                z$("Send to")
            ])),
            A2(_k, y([
                F$("three wide")
            ]), y([
                z$("Events")
            ]))
        ]), r = function(n) {
            switch(n.$){
                case 1:
                    return y([
                        F$("loading")
                    ]);
                case 3:
                default:
                    return v;
                case 2:
                    return y([
                        F$("error")
                    ]);
            }
        }, a = function(e) {
            var t = A2(Fy, n, e.cq.c), a = {
                bF: e.cq.c
            };
            return y([
                A2(Gk, v, y([
                    A2(Hw, e.cq, 25),
                    z$(e.cq.k)
                ])),
                A2(Gk, v, y([
                    A5(Pw, Y$({
                        h8: A2(tt, yt, A2(Gr, A2(ao, mt, function(n) {
                            return n.el;
                        }), KE(n))),
                        iE: "account-email-" + e.cq.c,
                        jf: VE(a),
                        ji: UE(a)
                    }), {
                        io: t.cT,
                        jE: e.hb.gu
                    }, R$, r(t.bd), cj(!1)),
                    z$(" "),
                    ZE(t.bd)
                ])),
                A2(Gk, v, y([
                    A5(Pw, Y$({
                        h8: A2(tt, yt, A2(Gr, mt, sj)),
                        iE: "account-level-" + e.cq.c,
                        jf: zE(a),
                        ji: WE(a)
                    }), {
                        io: t.dg,
                        jE: e.hb.gv
                    }, R$, r(t.bj), oj),
                    z$(" "),
                    ZE(t.bj)
                ]))
            ]);
        }, i = function() {
            var t = n.Z;
            switch(t.$){
                case 1:
                    return e(y([
                        A2(R$, y([
                            F$("ui placeholder")
                        ]), y([
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v)
                        ]))
                    ]));
                case 3:
                    var r = t.a;
                    return u(r.cr, v) ? e(y([
                        A2(R$, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "margin", "2.5em")
                        ]), y([
                            A2(ik, v, y([
                                z$("You don't have any notification overrides.")
                            ])),
                            A2(ik, v, y([
                                z$("You can create one by visiting the account settings.")
                            ]))
                        ]))
                    ])) : A2(Gr, A2(ao, Rk(v), a), r.cr);
                default:
                    return e(y([
                        A2(R$, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "margin", "2.5em")
                        ]), y([
                            A2(ik, v, y([
                                z$("An error ocurred while retrieving your overrides.")
                            ]))
                        ]))
                    ]));
            }
        }();
        return y([
            A2(Dk, y([
                F$("ui table")
            ]), y([
                A2(Fk, v, y([
                    A2(Rk, v, t)
                ])),
                A2(Ok, v, i)
            ]))
        ]);
    }, ME = function(n) {
        return {
            $: 7,
            a: n
        };
    }, JE = function(n) {
        return {
            $: 8,
            a: n
        };
    }, QE = function(n) {
        return {
            $: 10,
            a: n
        };
    }, XE = function(n) {
        return {
            $: 11,
            a: n
        };
    }, nN = F3(function(n, e, t) {
        return A3(n, R$, v, y(1 === t.$ ? [
            A2(Z$, v, y([
                z$("please select")
            ]))
        ] : t.a ? [
            z$("All")
        ] : [
            z$("Ignore")
        ]));
    }), eN = function(n) {
        switch(n.Z.$){
            case 1:
                return y([
                    A2(R$, y([
                        F$("ui placeholder")
                    ]), y([
                        A2(R$, y([
                            F$("line")
                        ]), v),
                        A2(R$, y([
                            F$("line")
                        ]), v),
                        A2(R$, y([
                            F$("line")
                        ]), v)
                    ]))
                ]);
            case 2:
                return y([
                    z$("Failed to load")
                ]);
            default:
                return function(n) {
                    return y([
                        A2(R$, y([
                            F$("ui stackable grid")
                        ]), y([
                            A2(R$, y([
                                F$("row")
                            ]), y([
                                A2(R$, y([
                                    F$("ten wide column")
                                ]), y([
                                    A2(R$, y([
                                        F$("ui labeled input fluid")
                                    ]), y([
                                        A2(R$, y([
                                            F$("ui label primary"),
                                            A2(ew, "width", "11em")
                                        ]), y([
                                            z$("Default email "),
                                            lj(n.bS)
                                        ])),
                                        A5(Pw, Y$({
                                            h8: A2(Gr, A2(ao, mt, function(n) {
                                                return n.el;
                                            }), KE(n)),
                                            iE: "default-email",
                                            jf: ME,
                                            ji: JE
                                        }), {
                                            io: n.cH,
                                            jE: A2(uc, function(n) {
                                                return n.gu;
                                            }, A2(uc, function(n) {
                                                return n.cL;
                                            }, fd(n.Z)))
                                        }, R$, y([
                                            F$("fluid")
                                        ]), cj(!0))
                                    ]))
                                ]))
                            ])),
                            A2(R$, y([
                                F$("ten wide column")
                            ]), y([
                                A2(R$, y([
                                    F$("ui labeled input fluid")
                                ]), y([
                                    A2(R$, y([
                                        F$("ui label primary"),
                                        A2(ew, "width", "11em")
                                    ]), y([
                                        z$("Default events "),
                                        lj(n.bT)
                                    ])),
                                    A5(Pw, Y$({
                                        h8: A2(Gr, mt, sj),
                                        iE: "default-level",
                                        jf: QE,
                                        ji: XE
                                    }), {
                                        io: n.cJ,
                                        jE: A2(uc, function(n) {
                                            return n.gv;
                                        }, A2(uc, function(n) {
                                            return n.cL;
                                        }, fd(n.Z)))
                                    }, R$, y([
                                        F$("fluid")
                                    ]), nN)
                                ]))
                            ]))
                        ]))
                    ]);
                }(n);
        }
    }, tN = F2(function(n, e) {
        return function(n) {
            return RE({
                q: y([
                    A2(R$, v, y([
                        A2(R$, y([
                            F$("ui top attached segment")
                        ]), y([
                            A2(Pk, v, y([
                                z$("Defaults")
                            ]))
                        ])),
                        A2(R$, y([
                            F$("ui bottom attached segment")
                        ]), A2(tt, A2(ik, v, y([
                            z$("This email will be used for your notifications, except when a rule in the section below overrides it.")
                        ])), A2(tt, A2(ik, v, y([
                            z$('You can add more email addresses through the GitHub "secondary" email settings.')
                        ])), eN(n))))
                    ])),
                    A2(R$, v, y([
                        A2(R$, y([
                            F$("ui top attached segment")
                        ]), y([
                            A2(Pk, v, y([
                                z$("Per-account overrides")
                            ]))
                        ])),
                        A2(R$, y([
                            F$("ui bottom attached segment")
                        ]), A2(tt, A2(ik, v, y([
                            z$("These rules apply when you interact with the listed accounts.")
                        ])), A2(tt, A2(ik, v, y([
                            z$("You can configure a new override by navigating to an account's settings page.")
                        ])), YE(n))))
                    ]))
                ]),
                ci: nc,
                e: "Notification Settings"
            });
        }(e);
    }), rN = F2(function(n, e) {
        var t = n.jS, r = function(n) {
            return y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(3),
                        A2(ew, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, a = y([
            A2(_k, y([
                F$("four wide")
            ]), y([
                z$("Description")
            ])),
            A2(_k, y([
                F$("four wide")
            ]), y([
                z$("Created")
            ])),
            A2(_k, y([
                F$("four wide")
            ]), v)
        ]), i = function(n) {
            var r, a = A2(la, Bs, A2(au, n.c, e.aE));
            return y([
                A2(Gk, v, y([
                    z$(n.v)
                ])),
                A2(Gk, v, y([
                    A2(wC, t, n.I)
                ])),
                A2(Gk, v, y([
                    A2(TC, y([
                        F$("ui button negative basic"),
                        X$(y([
                            d("loading", iy(a)),
                            d("disabled", ch(a)),
                            d("negative", !ch(a))
                        ])),
                        Nw((r = n.c, {
                            $: 1,
                            a: r
                        }))
                    ]), y([
                        z$("Revoke")
                    ]))
                ]))
            ]);
        }, c = function() {
            var n = e.cC;
            switch(n.$){
                case 1:
                    return r(y([
                        A2(R$, y([
                            F$("ui placeholder")
                        ]), y([
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v)
                        ]))
                    ]));
                case 3:
                    var t = n.a;
                    return u(t.eL, v) ? r(y([
                        A2(R$, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "margin", "2.5em")
                        ]), y([
                            A2(ik, v, y([
                                z$("You don't have any CLI tokens currently.")
                            ])),
                            A2(ik, v, y([
                                z$("To grant command line access, "),
                                A2(U$, y([
                                    Ow("https://docs.hercules-ci.com/hercules-ci-effects/guide/install-the-hci-command/")
                                ]), y([
                                    z$("install "),
                                    A2(Uk, v, y([
                                        z$("hci")
                                    ]))
                                ])),
                                z$(" and use the "),
                                A2(Uk, v, y([
                                    z$("hci login")
                                ])),
                                z$(" command.")
                            ]))
                        ]))
                    ])) : A2(Gr, A2(ao, Rk(v), i), t.eL);
                default:
                    return r(y([
                        A2(R$, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "margin", "2.5em")
                        ]), y([
                            A2(ik, v, y([
                                z$("An error ocurred while retrieving your CLI token list.")
                            ]))
                        ]))
                    ]));
            }
        }();
        return y([
            A2(ik, v, y([
                z$("CLI tokens give API access to command line applications.")
            ])),
            A2(Dk, y([
                F$("ui table")
            ]), y([
                A2(Fk, v, y([
                    A2(Rk, v, a)
                ])),
                A2(Ok, v, c)
            ]))
        ]);
    }), aN = F2(function(n, e) {
        return RE({
            q: y([
                A2(R$, y([
                    F$("ui segment")
                ]), A2(rN, n, e))
            ]),
            ci: ec,
            e: "My CLI tokens"
        });
    }), iN = F2(function(n, e) {
        return A2(aN, {
            jS: n.jS
        }, e);
    }), uN = F3(function(n, e, t) {
        return {
            df: t,
            bn: n,
            br: e
        };
    }), cN = function(n) {
        return {
            $: 7,
            a: n
        };
    }, oN = {
        $: 8
    }, sN = _$("alt"), fN = F2(function(n, e) {
        return n.hZ + "/api/v1/site/" + e.dD + "/account/" + e.gB + "/project/" + e.ax + "/badge";
    }), lN = F2(function(n, e) {
        return A2(Fw, y([
            Rw(A2(fN, n, e)),
            sN("Hercules CI")
        ]), v);
    }), dN = A2(bc, A2(yu, "&", "&amp;"), A2(bc, A2(yu, '"', "&quot;"), function(n) {
        return '"' + n + '"';
    })), bN = F2(function(n, e) {
        return n.iC + "/" + e.dD + "/" + e.gB + "/" + e.ax + "/status";
    }), hN = F2(function(n, e) {
        return "<a href=" + dN(A2(bN, n, e)) + "><img src=" + dN(A2(fN, n, e)) + ' alt="Hercules CI"></a>';
    }), gN = F2(function(n, e) {
        return "![Hercules CI](" + A2(fN, n, e) + ")";
    }), vN = F2(function(n, e) {
        return "[" + A2(gN, n, e) + "](" + A2(bN, n, e) + ")";
    }), pN = F2(function(n, e) {
        return y([
            A2(ik, v, y([
                A2(U$, y([
                    Ow(A2(bN, n, e))
                ]), y([
                    A2(lN, n, e)
                ]))
            ]))
        ]);
    }), mN = function(n) {
        return A2(R$, y([
            F$("ui segment secondary")
        ]), y([
            A2(wS, y([
                A2(ew, "white-space", "pre-wrap"),
                A2(ew, "word-break", "break-word")
            ]), n)
        ]));
    }, yN = F3(function(n, e) {
        return y([
            e.ar ? A2(ik, v, y([
                z$("Add a convenient CI status badge to your "),
                A2(Kk, v, y([
                    A2(Uk, v, y([
                        z$("README.md")
                    ]))
                ])),
                z$(":")
            ])) : A2(R$, y([
                F$("ui info message")
            ]), y([
                A2(R$, y([
                    F$("header")
                ]), y([
                    z$("This project is private")
                ])),
                z$("Authentication is not possible for images on GitHub, so a badge can only be placed off the GitHub platform and "),
                A2(Uk, v, y([
                    z$("README.md")
                ])),
                z$(".")
            ])),
            mN(y([
                z$(A2(vN, n, e)),
                z$("\n")
            ])),
            A2(ik, v, y([
                z$("Alternatively, on a web page, you could use an "),
                A2(Kk, v, y([
                    z$("HTML")
                ])),
                z$(" badge: ")
            ])),
            mN(y([
                z$(A2(hN, n, e)),
                z$("\n")
            ])),
            A2(ik, v, A2(tt, z$("Preview including link:"), A2(pN, n, e)))
        ]);
    }), $N = F3(function(n, e, t) {
        return y([
            A2(R$, y([
                F$("ui accordion")
            ]), y([
                A2(R$, y([
                    F$("title"),
                    X$(y([
                        d("active", t.bB)
                    ])),
                    Nw(oN)
                ]), y([
                    A2(Z$, y([
                        F$("dropdown icon")
                    ]), v),
                    A2(lN, n, e)
                ])),
                A2(R$, y([
                    F$("content"),
                    X$(y([
                        d("active", t.bB)
                    ]))
                ]), A3(yN, n, e, t))
            ]))
        ]);
    }), wN = F2(function(n, e) {
        return A2(CT, n, e);
    }), kN = function(n) {
        var e, t, r, a = n.ci, i = 1 === (t = n.bi).$ ? 0 : A2(la, 0, (e = A2(Gr, function(n) {
            return n.ab;
        }, t.a.bh)).b ? mt(A3(St, er, e.a, e.b)) : yt), c = (i - 1) / 25 | 0, o = s(i, 25) > 0 || !u(n.ci.gC, yt), f = A2(nl, function() {
            return !o;
        }, y([
            A2(ew, "display", "none")
        ])), l = function(e) {
            return y([
                F$("item"),
                X$(y([
                    d("active", u(e, n.ci))
                ])),
                Gw(tc(e))
            ]);
        }, b = function(n) {
            return function(n) {
                return A3(St, ry, ag, n);
            }(y([
                n - 3,
                n - 2,
                n - 1,
                n,
                n + 1,
                n + 2,
                n + 3
            ]));
        }, g = A2(wN, b(A2(la, 1, n.ci.gC)), A2(wN, b(c), b(1))), p = _t((r = A2(nl, function(n) {
            return 1 > s(n, c) && n >= 1;
        }, function(n) {
            return ct(n);
        }(g)), A2($j, gr, r))), m = A2(tt, A2(U$, l(h(a, {
            gC: yt
        })), y([
            z$("Latest")
        ])), A2(Sc, function(n) {
            return A2(tt, A2(U$, l(h(a, {
                gC: mt(n)
            })), y([
                z$(Ct(n))
            ])), n > 1 && !A2(IT, n - 1, g) ? y([
                A2(R$, y([
                    F$("disabled item")
                ]), y([
                    z$("...")
                ]))
            ]) : v);
        }, p));
        return A2(R$, A2(tt, F$("ui pagination menu"), f), m);
    }, CN = F3(function(n, e, t) {
        var r = {
            df: t.df.bh,
            br: t.br
        }, a = r.br, i = u(r.df, v) ? y([
            A2(Rk, v, y([
                A2(Gk, y([
                    Wk(6),
                    F$("center aligned hci muted"),
                    A2(ew, "padding-top", "2.5em"),
                    A2(ew, "padding-bottom", "2.5em")
                ]), A2(tt, A2(ik, v, y([
                    A2(Z$, y([
                        F$("ui icon kiwi bird")
                    ]), v)
                ])), y(r.br.bf ? [
                    A2(ik, v, y([
                        z$("This project has not been built yet. Push a commit with a flake.nix, ci.nix, nix/ci.nix or default.nix.")
                    ]))
                ] : [
                    A2(ik, v, y([
                        z$("This project has not been built yet.")
                    ])),
                    A2(ik, v, y([
                        z$("Enable building this repository in Settings, then push a commit with a flake.nix, ci.nix, nix/ci.nix or default.nix.")
                    ]))
                ])))
            ]))
        ]) : v, c = t.bn, o = function(t) {
            return A2(H$, function(n) {
                return hf({
                    bF: c.c,
                    bG: n
                });
            }, A5(dS, e.ci, n, Bs, b(c, a, mt(t)), v));
        };
        return A2(R$, y([
            F$("ui container")
        ]), y([
            A2(Pk, v, y([
                z$("Latest jobs")
            ])),
            A2(Dk, y([
                F$("ui selectable padded table")
            ]), y([
                A2(Fk, v, y([
                    A2(Rk, v, y([
                        A2(_k, v, y([
                            z$("Status")
                        ])),
                        A2(_k, v, y([
                            z$("Job")
                        ])),
                        A2(_k, v, y([
                            z$("Duration")
                        ])),
                        A2(_k, v, y([
                            z$("Created")
                        ])),
                        A2(_k, v, y([
                            z$("Branch/Tag")
                        ])),
                        A2(_k, v, y([
                            z$("Version")
                        ]))
                    ]))
                ])),
                A2(Ok, v, g(i, A2(Gr, o, r.df)))
            ])),
            kN(e)
        ]));
    }), xN = {
        bf: yt
    }, jN = F2(function(n, e) {
        return Ix({
            ib: function(e) {
                return {
                    $: 5,
                    a: {
                        c: n.c,
                        gF: h(xN, {
                            bf: mt(e)
                        })
                    }
                };
            },
            iB: "enableProject",
            iY: {
                eP: e.cc,
                jt: n.bf
            },
            j_: y([
                z$("Build this repository")
            ])
        });
    }), qN = F2(function(n, e) {
        var t = e.i1, r = e.$8, a = function(n) {
            return y([
                A2(ew, "cursor", "pointer"),
                Gw(n),
                Nw(t(n))
            ]);
        }, i = v, c = function(n) {
            return u(r, n) ? "ui item active header" : "ui item header";
        };
        return A2(R$, y([
            F$("ui top attached stackable tabular small menu")
        ]), y([
            A2(R$, y([
                F$("right menu")
            ]), g(i, y([
                A2(R$, A2(tt, F$(c(0)), a(tc({
                    cq: n.cq,
                    gC: yt,
                    br: n.br,
                    dC: n.dC
                }))), y([
                    A2(Z$, y([
                        F$("icon list")
                    ]), v),
                    z$("Jobs")
                ])),
                A2(R$, A2(tt, F$(c(1)), a(rc({
                    cq: n.cq,
                    br: n.br,
                    dC: n.dC
                }))), y([
                    A2(Z$, y([
                        F$("icon outline file")
                    ]), v),
                    z$("State")
                ]))
            ])))
        ]));
    }), SN = F3(function(n, e, t) {
        return A2(R$, v, y([
            A2(qN, e.ci, {
                $8: 0,
                i1: cN
            }),
            A2(R$, y([
                F$("bottom attached ui segment")
            ]), y([
                A2(R$, y([
                    F$("ui basic segment")
                ]), A2(tt, A2(Pk, v, y([
                    z$("Settings")
                ])), A2(jN, t.br, e))),
                A2(R$, y([
                    F$("ui basic segment")
                ]), A2(tt, A2(Pk, v, y([
                    z$("Badge")
                ])), A3($N, n, t.br, e))),
                A2(R$, y([
                    F$("ui basic segment")
                ]), y([
                    A3(CN, n.ig, e, t)
                ]))
            ]))
        ]));
    }), IN = F3(function(n, e, t) {
        return A3(SN, {
            hZ: n.c_.hZ,
            ig: n.ig,
            iC: n.c_.iC
        }, e, t);
    }), TN = F2(function(n, e) {
        return {
            q: function() {
                var t = function(n) {
                    return A2(Gj, n.df, A2(Gj, n.br, A2(Af, uN, n.bn)));
                }(e);
                switch(t.$){
                    case 3:
                        return A3(IN, n, e, t.a);
                    case 2:
                        if (3 === t.a.$ && 404 === t.a.a) return fk(n) ? A2(R$, y([
                            F$("ui container")
                        ]), y([
                            A2($k, fk(n), io(404))
                        ])) : A2(R$, y([
                            F$("ui container")
                        ]), y([
                            A2(pk, mk, y([
                                z$("If this project exists, it isn't public, so you may want to sign in.")
                            ]))
                        ]));
                        var r = t.a;
                        return A2(R$, y([
                            F$("ui container")
                        ]), y([
                            A2($k, fk(n), r)
                        ]));
                    default:
                        return A2(Z$, y([
                            F$("ui loader active massive text")
                        ]), y([
                            z$("Loading...")
                        ]));
                }
            }(),
            e: "Dashboard"
        };
    }), AN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, EN = function(n) {
        return A3(yo, n.a3, y([
            "api",
            "v1",
            "projects",
            n.U,
            "state",
            n.cj,
            "data"
        ]), A2(gu, gr, v));
    }, NN = tI(25), LN = F2(function(n, e) {
        var t = F2(function(n, e) {
            return e.$ ? v : n(e.a);
        }), r = function(n) {
            return A2(bc, function(n) {
                return n.hH;
            }, A2(bc, _t, A2(bc, Ec, t(n))));
        }, a = r(function(e) {
            return y([
                A2(wC, n.jS, e.I)
            ]);
        }), i = r(A2(bc, function(n) {
            return n.dE;
        }, t(function(n) {
            return y([
                z$(Ct(n))
            ]);
        }))), u = function(n) {
            return y([
                A2(Rk, v, y([
                    A2(Gk, y([
                        Wk(6),
                        A2(ew, "vertical-align", "top")
                    ]), n)
                ]))
            ]);
        }, c = function(n) {
            return y([
                A2(Z$, y([
                    F$("ui icon file outline"),
                    A2(ew, "margin-left", "2ex"),
                    A2(ew, "margin-right", "2ex")
                ]), v),
                A2(Uk, v, y([
                    z$(n.n)
                ]))
            ]);
        }, o = r(function(n) {
            var t, r = n.hA;
            if (r.$) {
                var a = n.as;
                return a.$ ? v : y([
                    A2(U$, y([
                        Gw(Yu({
                            cq: e.ci.cq,
                            ab: (t = a.a).ab,
                            br: e.ci.br,
                            dC: e.ci.dC
                        }))
                    ]), y([
                        A2(Xw, y([
                            A2(ew, "width", "7ex"),
                            A2(ew, "display", "inline-block")
                        ]), y([
                            z$("#" + Ct(t.ab) + " ")
                        ])),
                        Eq(t)
                    ]))
                ]);
            }
            return y([
                NN(r.a)
            ]);
        }), s = y([
            A2(_k, v, y([
                z$("Name")
            ])),
            A2(_k, v, y([
                z$("Job or Uploader")
            ])),
            A2(_k, v, y([
                z$("Updated")
            ])),
            A2(_k, v, y([
                z$("Bytes")
            ])),
            A2(_k, v, y([
                z$("Hash")
            ])),
            A2(_k, v, y([
                z$("Download")
            ]))
        ]), f = r(A2(bc, function(n) {
            return n.hd;
        }, t(A2(bc, xr(10), function(n) {
            return y([
                z$(n)
            ]);
        })))), l = function() {
            var t = e.ce;
            if (3 === t.$ && t.a.b && !t.a.b.b) {
                var r = t.a.a;
                return function(e) {
                    return y([
                        A2(U$, y([
                            Ow(EN({
                                a3: n.hZ,
                                U: r.c,
                                cj: e.n
                            }))
                        ]), y([
                            A2(Z$, y([
                                F$("ui icon download")
                            ]), v)
                        ]))
                    ]);
                };
            }
            return function() {
                return v;
            };
        }(), d = function(n) {
            return y([
                A2(Gk, v, c(n)),
                A2(Gk, v, o(n)),
                A2(Gk, v, a(n)),
                A2(Gk, v, i(n)),
                A2(Gk, v, f(n)),
                A2(Gk, y([
                    A2(ew, "text-align", "center")
                ]), l(n))
            ]);
        }, b = function() {
            var n = e.bx.ie;
            switch(n.$){
                case 1:
                    return u(y([
                        A2(R$, y([
                            F$("ui placeholder")
                        ]), y([
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v),
                            A2(R$, y([
                                F$("line")
                            ]), v)
                        ]))
                    ]));
                case 3:
                    var t = n.a;
                    return p$(t.hi) ? u(y([
                        A2(ik, y([
                            A2(ew, "text-align", "center"),
                            A2(ew, "margin", "10%")
                        ]), y([
                            z$("This project does not have any state files yet. State may be created by Effects or uploaded manually with the button above.")
                        ]))
                    ])) : A2(Gr, A2(ao, Rk(v), d), cd(t.hi));
                default:
                    return v;
            }
        }();
        return A2(Dk, y([
            F$("ui celled table")
        ]), y([
            A2(Fk, v, y([
                A2(Rk, v, s)
            ])),
            A2(Ok, v, b)
        ]));
    }), PN = {
        $: 5
    }, DN = {
        $: 11
    }, ON = {
        $: 4
    }, GN = function(n) {
        return {
            $: 6,
            a: n
        };
    }, _N = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), FN = Ze, RN = A2(qx, y([
        "target",
        "files"
    ]), Ki(FN)), BN = A2(bc, cd, F2(function(n, e) {
        return !A2(Yk, A2(ao, Ii, n), e);
    })(function(n) {
        return 0 !== n.$;
    })), HN = wx("multiple"), VN = function(n) {
        return Kn(function(n) {
            return "script" == n ? "p" : n;
        }(n));
    }, zN = _$("placeholder"), UN = function(n) {
        var e = n.z;
        switch(e.$){
            case 0:
                return A2(R$, v, y([
                    A2(TC, y([
                        F$("ui button"),
                        A2(ew, "visibility", "hidden")
                    ]), v),
                    A2(jx, y([
                        F$("ui green button right floated")
                    ]), y([
                        A2(Z$, y([
                            F$("ui plus icon")
                        ]), v),
                        z$("Add files"),
                        A2(Ew, y([
                            Lw("file"),
                            A2(ew, "display", "none"),
                            HN(!0),
                            A2(cw, "change", A2(lr, GN, RN))
                        ]), v)
                    ]))
                ]));
            case 1:
                var t = e.a, r = y$(t), a = t.aI, i = t.Y, u = 1 === r.$ ? d(!0, r.a) : d(!1, va), c = u.a, o = u.b;
                return A2(R$, y([
                    F$("ui segment form")
                ]), A2(tt, A2(ik, v, y([
                    z$("Name your files to match what is expected by your Effects.")
                ])), g(A2(Nt, F2(function(e, t) {
                    var r, i, u = (r = Ec(A2(mu, e, a))).$ ? "" : l$(r.a), c = "name-" + Ct(e);
                    return A2(R$, y([
                        F$("field")
                    ]), y([
                        A2(R$, y([
                            F$("ui labeled action input")
                        ]), y([
                            A2(jx, y([
                                F$("ui right icon label"),
                                xx(c)
                            ]), y([
                                A2(Xw, y([
                                    A2(ew, "display", "inline-block"),
                                    A2(ew, "min-width", "20ex")
                                ]), y([
                                    z$(u)
                                ])),
                                A3(VN, "i", y([
                                    F$("angle right icon")
                                ]), v)
                            ])),
                            A2(U$, y([
                                F$("item"),
                                A2(ew, "position", "relative"),
                                A2(ew, "bottom", "-0.5ex")
                            ]), function() {
                                var e = A2(au, t, o);
                                if (e.$) return A2(uc, A2(bc, function(n) {
                                    return n.hi;
                                }, au(t)), fd(n.bx.ie)).$ ? v : y([
                                    A2(R$, y([
                                        F$("ui left bottom floating basic pointing label")
                                    ]), y([
                                        z$("Updates existing file")
                                    ]))
                                ]);
                                var r = e.a;
                                return y([
                                    A2(R$, y([
                                        F$("ui left bottom floating basic red pointing label")
                                    ]), y([
                                        z$(r)
                                    ]))
                                ]);
                            }()),
                            A2(Ew, y([
                                Lw("text"),
                                vx(c),
                                HI(t),
                                zN(u),
                                nq(_N(e))
                            ]), v),
                            A2(TC, y([
                                F$("ui icon button"),
                                Nw((i = e, {
                                    $: 10,
                                    a: i
                                }))
                            ]), y([
                                A3(VN, "i", y([
                                    F$("times icon")
                                ]), v)
                            ]))
                        ]))
                    ]));
                }), i), y([
                    A2(TC, y([
                        F$("ui primary button"),
                        Nw(ON),
                        Cx(c)
                    ]), y([
                        A2(Z$, y([
                            F$("ui icon upload")
                        ]), v),
                        z$("Confirm")
                    ])),
                    A2(TC, y([
                        F$("ui button right floated"),
                        Nw(PN)
                    ]), y([
                        A2(Z$, y([
                            F$("ui icon times")
                        ]), v),
                        z$("Cancel all")
                    ]))
                ]))));
            default:
                var s = e.a;
                return A2(R$, y([
                    F$("ui segment")
                ]), A2(tt, A2(ck, v, y([
                    z$("Upload")
                ])), g(A2(Gr, function(n) {
                    var e = n.a, t = n.b;
                    switch(t.$){
                        case 0:
                            var r = Ct(Ja(100 * t.a)), a = r + "%";
                            return A2(R$, y([
                                F$("ui active progress"),
                                A2(zj, "data-percent", r)
                            ]), y([
                                A2(R$, y([
                                    F$("bar"),
                                    A2(ew, "transition-duration", "300ms"),
                                    A2(ew, "display", "block"),
                                    A2(ew, "width", a)
                                ]), y([
                                    A2(R$, y([
                                        F$("progress")
                                    ]), y([
                                        z$(a)
                                    ]))
                                ])),
                                A2(R$, y([
                                    F$("label")
                                ]), y([
                                    A2(Uk, v, y([
                                        z$(e)
                                    ]))
                                ]))
                            ]));
                        case 1:
                            return A2(R$, y([
                                F$("ui progress success"),
                                A2(zj, "data-percent", "100")
                            ]), y([
                                A2(R$, y([
                                    F$("bar"),
                                    A2(ew, "transition-duration", "300ms"),
                                    A2(ew, "display", "block"),
                                    A2(ew, "width", "100%")
                                ]), y([
                                    A2(R$, y([
                                        F$("progress")
                                    ]), v)
                                ])),
                                A2(R$, y([
                                    F$("label")
                                ]), y([
                                    A2(Uk, v, y([
                                        z$(e)
                                    ])),
                                    z$(" successful")
                                ]))
                            ]));
                        default:
                            return A2(R$, y([
                                F$("ui progress error"),
                                A2(zj, "data-percent", "0")
                            ]), y([
                                A2(R$, y([
                                    F$("bar"),
                                    A2(ew, "transition-duration", "300ms"),
                                    A2(ew, "display", "block"),
                                    A2(ew, "width", "100%")
                                ]), y([
                                    A2(R$, y([
                                        F$("progress")
                                    ]), v)
                                ])),
                                A2(R$, y([
                                    F$("label")
                                ]), y([
                                    A2(Uk, v, y([
                                        z$(e)
                                    ])),
                                    z$(" failed")
                                ]))
                            ]));
                    }
                }, ut(s)), BN(s) ? y([
                    A2(R$, y([
                        F$("ui basic segment")
                    ]), y([
                        A2(TC, y([
                            F$("ui button"),
                            A2(ew, "visibility", "hidden")
                        ]), v),
                        A2(TC, y([
                            F$("ui button right floated"),
                            Nw(DN)
                        ]), y([
                            z$("Close")
                        ]))
                    ]))
                ]) : v)));
        }
    }, WN = F2(function(n, e) {
        return A2(R$, v, y([
            A2(qN, e.ci, {
                $8: 1,
                i1: AN
            }),
            A2(R$, y([
                F$("ui bottom attached segment")
            ]), y([
                A2(ik, v, y([
                    z$("State files allow your Effects to maintain information across executions, such as IP addresses of created hosts, or the NixOps state export. Effects can only access the latest version of each file.")
                ])),
                UN(e),
                A2(LN, n, e)
            ]))
        ]));
    }), KN = F2(function(n, e) {
        return {
            q: A2(WN, {
                hZ: n.c_.hZ,
                jS: n.jS
            }, e),
            e: "States"
        };
    }), ZN = A2(R$, y([
        F$("ui segment")
    ]), y([
        A2(gq, v, '\nTerms and Conditions\n====================\n\nLast updated: April 17, 2021\n\nThese Terms and Conditions ("Terms", "Terms and Conditions") govern\nyour relationship with the Hercules CI web application (the "Service")\noperated by Ensius B.V. ("us", "we", or "our"). The Service\nincludes the https://hercules-ci.com website, including any subdomains\nthereof, the Hercules CI API, Continuous Integration services and\nrelated technologies, software, content and services.\n\nPlease read these Terms and Conditions carefully before using the\nService.\n\nYour access to and use of the Service is conditioned on your acceptance\nof and compliance with these Terms. These Terms apply to all visitors,\nusers and others who access or use the Service.\n\nBy accessing or using the Service you agree to be bound by these Terms.\nIf you disagree with any part of the terms then you may not access the\nService.\n\nIf you use the Service on behalf of a legal entity, you hereby\nwarrant, represent and guarantee that you personally have the\nauthority to represent and legally bind the legal entity and all its\nmembers.\n\nSubscriptions\n-------------\n\nSome parts of the Service are billed on a subscription basis\n("Subscription(s)"). You will be billed in advance on a recurring and\nperiodic basis ("Billing Cycle"). Billing cycles are set on a monthly\nbasis.\n\nAt the end of each Billing Cycle, your Subscription will automatically\nrenew under the exact same conditions unless you cancel it or Hercules\nLabs O\xdc cancels it. You may cancel your Subscription renewal either\nthrough your online account management page or by contacting Hercules\nLabs O\xdc customer support team.\n\nA valid payment method, is required to process the payment for your\nSubscription. You shall provide our reseller, FastSpring, with accurate\nand complete billing information including full\nname, address, state, zip code, telephone number, and a valid payment\nmethod information. By submitting such payment information, you\nautomatically authorize FastSpring to charge all Subscription fees\nincurred through your account to any such payment instruments.\n\nShould automatic billing fail to occur for any reason, FastSpring may\nreattempt the automatic billing and/or contact you to alter the payment\nmethod information. You must make a successful payment within 14 days of\nthe start of the Billing Cycle.\n\n\nFee Changes\n-----------\n\nEnsius B.V., in its sole discretion and at any time, may modify the\nSubscription fees for the Subscriptions. Any Subscription fee change\nwill become effective at the end of the then-current Billing Cycle.\n\nEnsius B.V. will provide you with a reasonable prior notice of any\nchange in Subscription fees to give you an opportunity to terminate your\nSubscription before such change becomes effective.\n\nYour continued use of the Service after the Subscription fee change\ncomes into effect constitutes your agreement to pay the modified\nSubscription fee amount.\n\nRefunds\n-------\n\nPaid Subscription fees are non-refundable, except when required by law or as follows.\n\nYou are only entitled to a refund of a Subscription so long as you\nrequest the refund within 30 days of your Subscription purchase and\nyou have not requested a refund prior to the Subscription purchase.\n\nPreview\n-------\n\nYou may be invited to try certain products or product features\n("Preview Services") before we make them generally available. Preview\nServices are designated by terms such as "early access", "preview",\n"beta", "trial" or similar.\nPreview Services are not intended for production use, and can at any time be\nterminated, altered, or require payment for continued use. We may never make\na Preview Service generally available.\n\nContent\n-------\n\nOur Service allows you to post, link, store, share and otherwise make\navailable certain information, text, graphics, videos, or other material\n("Content"). You are responsible for the Content that you post to the\nService, including its legality, reliability, and appropriateness.\n\nBy posting Content to the Service, you grant us the right and license to\nuse, modify, publicly perform, publicly display, reproduce, and\ndistribute such Content on and through the Service. You retain any and\nall of your rights to any Content you submit, post or display on or\nthrough the Service and you are responsible for protecting those rights.\nYou agree that this license includes the right for us to make your\nContent available to other users of the Service, who may also use your\nContent subject to these Terms.\n\nYou represent and warrant that: (i) the Content is yours (you own it) or\nyou have the right to use it and grant us the rights and license as\nprovided in these Terms, and (ii) the posting of your Content on or\nthrough the Service does not violate the privacy rights, publicity\nrights, copyrights, contract rights or any other rights of any person.\n\nAccounts\n--------\n\nWhen you create an account with us, you must provide us information that\nis accurate, complete, and current at all times. Failure to do so\nconstitutes a breach of the Terms, which may result in immediate\ntermination of your account on our Service.\n\nYou are responsible for safeguarding the password and other authentication methods that you use to access\nthe Service and for any activities or actions under your password,\nwhether your password is with our Service or a third-party service.\n\nYou agree not to disclose your password to any third party. You must\nnotify us immediately upon becoming aware of any breach of security or\nunauthorized use of your account.\n\nCopyright Policy\n----------------\n\nWe respect the intellectual property rights of others. It is our policy\nto respond to any claim that Content posted on the Service infringes the\ncopyright or other intellectual property infringement ("Infringement")\nof any person.\n\nIf you are a copyright owner, or authorized on behalf of one, and you\nbelieve that the copyrighted work has been copied in a way that\nconstitutes copyright infringement that is taking place through the\nService, you must submit your notice in writing to the attention of\n"Copyright Infringement" of dataprotection@hercules-ci.com and include\nin your notice a detailed description of the alleged Infringement.\n\nYou may be held accountable for damages (including costs and attorneys\'\nfees) for misrepresenting that any Content is infringing your copyright.\n\nIntellectual Property\n---------------------\n\nThe Service and its original content (excluding Content provided by\nusers), features and functionality are and will remain the exclusive\nproperty of Ensius B.V. and its licensors. The Service is protected\nby copyright, trademark, and other laws of both The Netherlands and foreign\ncountries. Our trademarks and trade dress may not be used in connection\nwith any product or service without the prior written consent of\nEnsius B.V..\n\nYou may not attempt to decompile, disassemble or reverse\nengineer the Service.\n\nLinks To Other Web Sites\n------------------------\n\nOur Service may contain links to third-party web sites or services that\nare not owned or controlled by Ensius B.V..\n\nEnsius B.V. has no control over, and assumes no responsibility for,\nthe content, privacy policies, or practices of any third party web sites\nor services. You further acknowledge and agree that Ensius B.V.\nshall not be responsible or liable, directly or indirectly, for any\ndamage or loss caused or alleged to be caused by or in connection with\nuse of or reliance on any such content, goods or services available on\nor through any such web sites or services.\n\nWe strongly advise you to read the terms and conditions and privacy\npolicies of any third-party web sites or services that you visit.\n\nTermination\n-----------\n\nWe may terminate or suspend your account immediately, without prior\nnotice or liability, for any reason whatsoever, including without\nlimitation if you breach the Terms.\n\nUpon termination, your right to use the Service will immediately cease.\n\nLimitation Of Liability\n-----------------------\n\nIn no event shall Ensius B.V., nor its directors, employees,\npartners, agents, suppliers, or affiliates, be liable for any indirect,\nincidental, special, consequential or punitive damages, including\nwithout limitation, loss of profits, data, use, goodwill, or other\nintangible losses, resulting from (i) your access to or use of or\ninability to access or use the Service; (ii) any conduct or content of\nany third party on the Service; (iii) any content obtained from the\nService; and (iv) unauthorized access, use or alteration of your\ntransmissions or content, whether based on warranty, contract, tort\n(including negligence) or any other legal theory, whether or not we have\nbeen informed of the possibility of such damage, and even if a remedy\nset forth herein is found to have failed of its essential purpose.\n\nDisclaimer\n----------\n\nYour use of the Service is at your sole risk. The Service is provided on\nan "AS IS" and "AS AVAILABLE" basis. The Service is provided without\nwarranties of any kind, whether express or implied, including, but not\nlimited to, implied warranties of merchantability, fitness for a\nparticular purpose, non-infringement or course of performance.\n\nEnsius B.V. its subsidiaries, affiliates, and its licensors do not\nwarrant that a) the Service will function uninterrupted, secure or\navailable at any particular time or location; b) any errors or defects\nwill be corrected; c) the Service is free of viruses or other harmful\ncomponents; or d) the results of using the Service will meet your\nrequirements.\n\nGoverning Law\n-------------\n\nThese Terms shall be governed and construed in accordance with the laws\nof The Netherlands, without regard to its conflict of law provisions.\n\nOur failure to enforce any right or provision of these Terms will not be\nconsidered a waiver of those rights. If any provision of these Terms is\nheld to be invalid or unenforceable by a court, the remaining provisions\nof these Terms will remain in effect. These Terms constitute the entire\nagreement between us regarding our Service, and supersede and replace\nany prior agreements we might have between us regarding the Service.\n\nChanges\n-------\n\nWe reserve the right, at our sole discretion, to modify or replace these\nTerms at any time. If a revision is material we will try to provide at\nleast 30 days notice prior to any new terms taking effect. What\nconstitutes a material change will be determined at our sole discretion.\n\nBy continuing to access or use our Service after those revisions become\neffective, you agree to be bound by the revised terms. If you do not\nagree to the new terms, please stop using the Service.\n\nContact Us\n----------\n\nIf you have any questions about these Terms, please contact us.\n')
    ])), YN = F3(function(n, e, t) {
        var r = t.gC;
        switch(r.$){
            case 10:
                return {
                    aD: y([
                        A2(H$, Cs, (a = A2(Hx, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 9:
                return {
                    aD: y([
                        A2(H$, Lf, (a = A2(hj, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 2:
                return {
                    aD: y([
                        A2(H$, xs, (a = A2(Rj, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 11:
                return {
                    aD: y([
                        A2(H$, qs, (a = A2(Iq, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 0:
                return {
                    aD: y([
                        A2(H$, Ss, (a = A2(TI, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 1:
                return {
                    aD: y([
                        A2(H$, Ds, (a = A2(TN, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 3:
                return {
                    aD: y([
                        A2(H$, Os, (a = A2(KN, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 6:
                return {
                    aD: y([
                        A2(H$, Ns, (a = A2(DE, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 4:
                return {
                    aD: y([
                        A2(H$, Ps, (a = A2(OA, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 5:
                return {
                    aD: y([
                        A2(H$, Es, (a = A2(fE, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 7:
                return {
                    aD: y([
                        A2(H$, Ls, (a = A2(GE, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 8:
                return {
                    aD: y([
                        A2(H$, js, (a = A2(yq, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 13:
                return {
                    aD: y([
                        (a = {
                            q: _E,
                            e: "404 Not Found"
                        }).q
                    ]),
                    e: a.e
                };
            case 14:
                return {
                    aD: A2(ok, n.h9, r.a.gV),
                    e: "Please log in first"
                };
            case 15:
                return {
                    aD: y([
                        (a = {
                            q: ZN,
                            e: "Terms of Service"
                        }).q
                    ]),
                    e: a.e
                };
            case 12:
                return {
                    aD: v,
                    e: "Loading..."
                };
            case 16:
                return {
                    aD: y([
                        A2(H$, Mf, (a = A2(iN, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 17:
                return {
                    aD: y([
                        A2(H$, Zf, (a = A2(tN, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 18:
                return {
                    aD: y([
                        A2(H$, Wf, (a = A2(HE, e, r.a)).q)
                    ]),
                    e: a.e
                };
            case 19:
                return {
                    aD: y([
                        A2(H$, As, (a = A2(lT, n, r.a)).q)
                    ]),
                    e: a.e
                };
            case 20:
                return {
                    aD: y([
                        A2(H$, Ts, (a = A2(sT, n, r.a)).q)
                    ]),
                    e: a.e
                };
            default:
                var a;
                return {
                    aD: y([
                        A2(H$, Is, (a = A2(ZI, n, r.a)).q)
                    ]),
                    e: a.e
                };
        }
    }), MN = Kn("nav"), JN = Kn("footer"), QN = (fs = y([
        A2(U$, y([
            F$("item"),
            Ow("https://www.iubenda.com/privacy-policy/14101005")
        ]), y([
            z$("Privacy Policy")
        ])),
        A2(U$, y([
            Gw(ic),
            F$("item")
        ]), y([
            z$("Terms")
        ])),
        A2(U$, y([
            F$("item"),
            Ow("https://status.hercules-ci.com/")
        ]), y([
            z$("Service Status")
        ])),
        A2(U$, y([
            F$("item"),
            Ow("mailto:help@hercules-ci.com")
        ]), y([
            z$("Support")
        ]))
    ]), A2(JN, y([
        F$("ui inverted vertical footer segment")
    ]), y([
        A2(R$, y([
            F$("ui center aligned container")
        ]), A2(Jw, z$(" | "), fs))
    ]))), XN = {
        $: 9
    }, nL = function(n) {
        return {
            $: 11,
            a: n
        };
    }, eL = function(n) {
        var e = n.r;
        return 1 === e.$ && 14 === e.b.gC.$;
    }, tL = function(n) {
        var e, t, r, a, i;
        return A2(U$, y([
            F$("ui inverted button"),
            Gw(ac({
                gV: mt((e = n.hB, a = 1 === (t = e.jq).$ ? "" : "?" + t.a, i = 1 === (r = e.iv).$ ? "" : "#" + r.a, g(e.bp, g(a, i))))
            }))
        ]), y([
            A2(Z$, y([
                F$("icon user")
            ]), v),
            z$(" Sign in")
        ]));
    }, rL = function(n) {
        var e = n.r;
        switch(e.$){
            case 0:
                return y([
                    A2(R$, y([
                        F$("ui item")
                    ]), y([
                        A2(Z$, y([
                            F$("ui icon user large")
                        ]), v),
                        A2(Xw, y([
                            A2(zj, "style", "margin-left: 10px;")
                        ]), y([
                            A2(R$, y([
                                F$("ui inverted placeholder"),
                                A2(ew, "width", "8em")
                            ]), y([
                                A2(R$, y([
                                    F$(" line")
                                ]), v)
                            ]))
                        ]))
                    ]))
                ]);
            case 2:
                return y([
                    A2(R$, y([
                        F$("ui item")
                    ]), y([
                        A2(Xw, y([
                            A2(ew, "margin-right", "10px")
                        ]), y([
                            z$("Sign-in status unknown")
                        ])),
                        tL(n)
                    ]))
                ]);
            default:
                var t = e.a.hD;
                if (1 === t.$) {
                    var r = t.a, a = n.aZ, i = function(n) {
                        return {
                            iE: n.iE,
                            ji: n.ji,
                            cg: !1,
                            dQ: 0
                        };
                    }({
                        iE: "account",
                        ji: nL
                    });
                    return y([
                        A5(Tw, i, a, R$, y([
                            F$("item")
                        ]), y([
                            A5(Iw, i, a, R$, y([
                                F$("")
                            ]), y([
                                A5(Iw, i, a, Z$, y([
                                    F$("dropdown icon")
                                ]), v),
                                A2(Hw, r, 35),
                                A2(Xw, y([
                                    A2(ew, "margin-left", "10px")
                                ]), y([
                                    z$(r.k)
                                ]))
                            ])),
                            A5(sw, i, a, R$, v, y([
                                A3(fw, U$, y([
                                    Gw(ec)
                                ]), y([
                                    A2(Z$, y([
                                        F$("wrench icon")
                                    ]), v),
                                    z$("Settings")
                                ])),
                                A3(fw, U$, dx(XN), y([
                                    A2(Z$, y([
                                        F$("icon")
                                    ]), v),
                                    z$("Sign out")
                                ]))
                            ]))
                        ]))
                    ]);
                }
                return y([
                    A2(R$, y([
                        F$("ui item")
                    ]), eL(n) ? v : y([
                        tL(n)
                    ]))
                ]);
        }
    }, aL = function(n) {
        var e, t, r, a = g(y([
            (e = n.c_.iP, A2(Fw, y([
                Rw(e),
                A2(ew, "margin-right", "10px"),
                A2(ew, "height", "2.5em"),
                A2(ew, "object-fit", "contain")
            ]), v)),
            z$(" Hercules CI")
        ]), function() {
            var e = n.r;
            if (1 === e.$) {
                var t = e.a;
                return "Hercules CI" === t.h9.f7 ? v : y([
                    A2(R$, y([
                        A2(ew, "position", "absolute"),
                        A2(ew, "bottom", "0.5ex"),
                        A2(ew, "left", "4.8em"),
                        A2(ew, "font-weight", "normal"),
                        A2(ew, "opacity", "0.75"),
                        A2(ew, "font-size", "90%")
                    ]), y([
                        z$("for " + t.h9.f7)
                    ]))
                ]);
            }
            return v;
        }()), i = Hl(Wu), u = 1 === (t = n.r).$ ? t.a.hD.$ ? i : "/" : i;
        return r = {
            iO: A2(U$, y([
                Ow(u),
                F$("header item")
            ]), a),
            i$: y([
                A2(U$, y([
                    F$("item"),
                    Ow("https://docs.hercules-ci.com")
                ]), y([
                    z$("Docs")
                ])),
                A2(U$, y([
                    F$("item"),
                    Ow("https://blog.hercules-ci.com")
                ]), y([
                    z$("Blog")
                ]))
            ]),
            jB: rL(n)
        }, A2(R$, y([
            F$("ui container")
        ]), A2(tt, r.iO, g(r.i$, y([
            A2(R$, y([
                vx("user-menu"),
                F$("right menu")
            ]), r.jB)
        ]))));
    };
    !function(e) {
        n.Elm ? Hn(n.Elm, e) : n.Elm = e;
    }({
        Main: {
            init: (gs = {
                iG: Ro,
                jk: function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                },
                jl: function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                },
                jP: function(n) {
                    var e, t = 1 === (e = n.r).$ ? A2(ws, Vo, A2($f, e.a, e.b)) : ks;
                    return Wo(y([
                        A2($s, 3e3, Uo),
                        t,
                        Ko(Ho),
                        wf(zo)
                    ]));
                },
                jV: G$,
                jY: function(n) {
                    var e, t = function() {
                        var e = n.r;
                        switch(e.$){
                            case 0:
                                return {
                                    aD: y([
                                        A2(R$, y([
                                            F$("ui loader active massive text")
                                        ]), y([
                                            z$("Loading Hercules CI")
                                        ]))
                                    ]),
                                    e: "Loading"
                                };
                            case 1:
                                return A3(YN, e.a, {
                                    ck: n.ck,
                                    by: n.by
                                }, e.b);
                            default:
                                return {
                                    aD: y([
                                        A2($k, !0, e.a)
                                    ]),
                                    e: "Error"
                                };
                        }
                    }();
                    return {
                        aD: y([
                            (e = {
                                a4: A2(H$, Yr, A3(tk, n.r, n.ci, n.a4)),
                                q: A2(Gr, H$(Vo), t.aD),
                                iV: aL(n)
                            }, A2(R$, y([
                                vx("main")
                            ]), y([
                                A2(MN, y([
                                    F$("ui fixed inverted menu")
                                ]), y([
                                    e.iV
                                ])),
                                A2(R$, y([
                                    vx("wrap")
                                ]), y([
                                    A2(R$, y([
                                        vx("ci-content"),
                                        F$("ui main container")
                                    ]), A2(tt, A2(R$, y([
                                        A2(ew, "margin", "20px 0")
                                    ]), y([
                                        e.a4
                                    ])), e.q)),
                                    QN
                                ]))
                            ])))
                        ]),
                        e: t.e + " - Hercules CI"
                    };
                }
            }, vs = gs.jk, ps = gs.jl, ms = function() {
                ms.a(vs(Se()));
            }, je({
                d9: function(n) {
                    return ms.a = n, Ae.addEventListener("popstate", ms), 0 > Ae.navigator.userAgent.indexOf("Trident") || Ae.addEventListener("hashchange", ms), F2(function(e, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || e.target || e.hasAttribute("download"))) {
                            t.preventDefault();
                            var r = e.href, a = Se(), i = Er(r).a;
                            n(ps(i && a.gT === i.gT && a.fK === i.fK && a.gL.a === i.gL.a ? {
                                $: 0,
                                a: i
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r)));
                        }
                    });
                },
                iG: function(n) {
                    return A3(gs.iG, n, Se(), ms);
                },
                jY: gs.jY,
                jV: gs.jV,
                jP: gs.jP
            }))(A2(fr, function(n) {
                return A2(fr, function(e) {
                    return A2(fr, function(t) {
                        return A2(fr, function(r) {
                            return br({
                                hZ: r,
                                ig: t,
                                iC: e,
                                iP: n
                            });
                        }, A2(Zr, "apiURL", ta));
                    }, A2(Zr, "currentTime", Bo));
                }, A2(Zr, "htmlURL", ta));
            }, A2(Zr, "logoURL", ta)))(0)
        }
    });
}($a0b4f895e1596b3b$exports);


var $dad545c909cfec2d$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("main"),
    flags: {
        apiURL: window.location.origin,
        htmlURL: window.location.origin,
        logoURL: (0, (/*@__PURE__*/$parcel$interopDefault($b0bd1bc71fece2bf$exports))),
        currentTime: Date.now()
    }
});
(0, $5509607c007f20ee$export$1a9c72ed86da409b)($dad545c909cfec2d$var$app.ports);
$dad545c909cfec2d$var$app.ports.paddleSubscribe.subscribe(function(data) {
    Paddle.Setup({
        vendor: 49326
    });
    Paddle.Checkout.open({
        product: data.product,
        passthrough: data.passthrough,
        successCallback: $dad545c909cfec2d$var$app.ports.paddleSubscriptionSucceeded.send,
        override: data.paymentLink
    });
});


//# sourceMappingURL=index.8c4df020.js.map
